<template>
  <svg
    cache-id="1cad0781d281475dbf77513429a38ac0"
    id="edEvCAwTnKp1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 816 620"
    shape-rendering="geometricPrecision"
    text-rendering="geometricPrecision"
  >
    <defs>
      <linearGradient
        id="edEvCAwTnKp2-fill"
        x1="408.5"
        y1="0.119019"
        x2="808.973"
        y2="0.119019"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp2-fill-0" offset="0%" stop-color="#003a62" />
        <stop id="edEvCAwTnKp2-fill-1" offset="100%" stop-color="rgba(0,91,153,0)" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp11-fill"
        x1="6277.37"
        y1="1824.96"
        x2="6461.25"
        y2="1921.17"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp11-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp11-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp14-fill"
        x1="4790.68"
        y1="2873.12"
        x2="4876.59"
        y2="2873.12"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp14-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp14-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp17-fill"
        x1="4468.5"
        y1="2698.53"
        x2="4667.81"
        y2="2802.82"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp17-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp17-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp20-fill"
        x1="4369.22"
        y1="2750.24"
        x2="4568.53"
        y2="2854.53"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp20-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp20-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp54-fill"
        x1="6402.98"
        y1="1783.9"
        x2="6500.84"
        y2="1783.9"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp54-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp54-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp70-fill"
        x1="4754.12"
        y1="2739.99"
        x2="4754.12"
        y2="2855.9"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp70-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp70-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp74-fill"
        x1="5263.44"
        y1="2458.33"
        x2="5263.44"
        y2="2542.73"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp74-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp74-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp75-fill"
        x1="5279.41"
        y1="2439.9"
        x2="5279.41"
        y2="2531.56"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp75-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp75-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp76-fill"
        x1="4991.87"
        y1="2330.64"
        x2="5266.44"
        y2="2474.29"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp76-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp76-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp78-fill"
        x1="5291.5"
        y1="2536.58"
        x2="5291.5"
        y2="2558.01"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp78-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp78-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp80-fill"
        x1="5257.76"
        y1="2512.64"
        x2="5282.61"
        y2="2512.64"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp80-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp80-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp82-fill"
        x1="5222.37"
        y1="2512.06"
        x2="5222.37"
        y2="2576.45"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp82-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp82-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp83-fill"
        x1="3032.58"
        y1="3520.9"
        x2="3213.24"
        y2="3615.42"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp83-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp83-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp85-fill"
        x1="5238.34"
        y1="2493.63"
        x2="5238.34"
        y2="2565.27"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp85-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp85-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp86-fill"
        x1="5197.56"
        y1="2537.22"
        x2="5197.56"
        y2="2590.47"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp86-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp86-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp89-fill"
        x1="4917.24"
        y1="2473.28"
        x2="5191.81"
        y2="2616.93"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp89-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp89-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp90-fill"
        x1="2967.95"
        y1="3608.34"
        x2="3112.98"
        y2="3684.23"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp90-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp90-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp93-fill"
        x1="5165"
        y1="2527.33"
        x2="5165"
        y2="2612.43"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp93-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp93-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp94-fill"
        x1="4965.08"
        y1="2381.84"
        x2="5239.65"
        y2="2525.49"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp94-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp94-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp95-fill"
        x1="3583.04"
        y1="3214.4"
        x2="3765.72"
        y2="3309.98"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp95-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp95-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp96-fill"
        x1="3531.81"
        y1="3245.49"
        x2="3714.49"
        y2="3341.07"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp96-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp96-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp98-fill"
        x1="3097.16"
        y1="3676.25"
        x2="3242.19"
        y2="3752.14"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp98-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp98-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp100-fill"
        x1="3685.51"
        y1="3152.21"
        x2="3868.19"
        y2="3247.8"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp100-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp100-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp104-fill"
        x1="3193.3"
        y1="3566.76"
        x2="3375.98"
        y2="3662.35"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp104-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp104-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp107-fill"
        x1="3778.16"
        y1="3232.97"
        x2="3960.85"
        y2="3328.55"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp107-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp107-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp109-fill"
        x1="3634.27"
        y1="3183.3"
        x2="3816.96"
        y2="3278.89"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp109-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp109-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp116-fill"
        x1="3715.64"
        y1="3345.97"
        x2="3816.1"
        y2="3398.53"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp116-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp116-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp120-fill"
        x1="3646.71"
        y1="3342.71"
        x2="3807.78"
        y2="3426.99"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp120-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp120-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp124-fill"
        x1="4497.81"
        y1="2823.24"
        x2="4680.49"
        y2="2918.83"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp124-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp124-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp125-fill"
        x1="5913.21"
        y1="2095.13"
        x2="5913.28"
        y2="2095.13"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp125-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp125-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp128-fill"
        x1="4446.57"
        y1="2854.33"
        x2="4629.26"
        y2="2949.92"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp128-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp128-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp131-fill"
        x1="4395.42"
        y1="2884.86"
        x2="4578.1"
        y2="2980.45"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp131-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp131-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp134-fill"
        x1="4343.3"
        y1="2913.3"
        x2="4525.98"
        y2="3008.89"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp134-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp134-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp137-fill"
        x1="4276.14"
        y1="2807.12"
        x2="4475.45"
        y2="2911.41"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp137-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp137-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp141-fill"
        x1="4611.72"
        y1="2887.28"
        x2="4794.4"
        y2="2982.87"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp141-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp141-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp144-fill"
        x1="4560.49"
        y1="2918.37"
        x2="4743.17"
        y2="3013.96"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp144-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp144-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp150-fill"
        x1="-92.7662"
        y1="318.5383"
        x2="158.7773"
        y2="36.2636"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp150-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp150-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp152-fill"
        x1="-22.1959"
        y1="379.2065"
        x2="228.2993"
        y2="98.1073"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp152-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp152-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp156-fill"
        x1="-0.1265"
        y1="236.9704"
        x2="155.7228"
        y2="153.0954"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp156-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp156-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp161-fill"
        x1="55.6069"
        y1="246.729"
        x2="94.3017"
        y2="246.729"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp161-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp161-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp163-fill"
        x1="-50.1524"
        y1="354.1206"
        x2="200.2082"
        y2="73.1728"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp163-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp163-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp166-fill"
        x1="266.011"
        y1="25.9798"
        x2="166.961"
        y2="222.4887"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp166-fill-0" offset="65.79%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp166-fill-1" offset="94.58%" stop-color="#0075b8" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp167-fill"
        x1="215.1581"
        y1="0.2278"
        x2="81.0922"
        y2="266.207"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp167-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp167-fill-1" offset="53.65%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp167-fill-2" offset="100%" stop-color="#0075b8" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp168-fill"
        x1="218.4344"
        y1="18.5498"
        x2="193.4963"
        y2="68.0257"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp168-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp168-fill-1" offset="53.65%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp168-fill-2" offset="100%" stop-color="#0075b8" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp169-fill"
        x1="-0.1265"
        y1="236.9704"
        x2="155.7228"
        y2="153.0954"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp169-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp169-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp170-fill"
        x1="279.9568"
        y1="32.8795"
        x2="145.8178"
        y2="299.0035"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp170-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp170-fill-1" offset="53.65%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp170-fill-2" offset="100%" stop-color="#0075b8" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp173-fill"
        x1="55.6069"
        y1="246.729"
        x2="94.3017"
        y2="246.729"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp173-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp173-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp175-fill"
        x1="-50.1543"
        y1="354.1189"
        x2="200.2063"
        y2="73.1711"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp175-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp175-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp176-fill"
        x1="242.1819"
        y1="13.6232"
        x2="107.8188"
        y2="280.1917"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp176-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp176-fill-1" offset="53.65%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp176-fill-2" offset="100%" stop-color="#0075b8" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp177-fill"
        x1="263.028"
        y1="26.212"
        x2="136.9754"
        y2="276.2927"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp177-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp177-fill-1" offset="53.65%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp177-fill-2" offset="100%" stop-color="#0075b8" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp181-fill"
        x1="4509.33"
        y1="2948.9"
        x2="4692.01"
        y2="3044.49"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp181-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp181-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp184-fill"
        x1="4457.21"
        y1="2977.34"
        x2="4639.9"
        y2="3072.93"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp184-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp184-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp188-fill"
        x1="4926.71"
        y1="2455.18"
        x2="5201.27"
        y2="2598.84"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp188-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp188-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp190-fill"
        x1="4137.41"
        y1="3087.93"
        x2="4554.91"
        y2="3058.09"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp190-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp190-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp191-fill"
        x1="3939.04"
        y1="3192.18"
        x2="4400.42"
        y2="3159.2"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp191-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp191-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp192-fill"
        x1="4099.93"
        y1="3080.17"
        x2="4126.08"
        y2="3080.17"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp192-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp192-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp193-fill"
        x1="3969.01"
        y1="3177.87"
        x2="4056.66"
        y2="3121.57"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp193-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp193-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp194-fill"
        x1="4149.15"
        y1="3115.34"
        x2="4149.15"
        y2="3151.83"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp194-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp194-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp195-fill"
        x1="4051.12"
        y1="3115.34"
        x2="4051.12"
        y2="3185.9"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp195-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp195-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp196-fill"
        x1="4003.66"
        y1="3226.7"
        x2="4075.44"
        y2="3154.91"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp196-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp196-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp198-fill"
        x1="4133.55"
        y1="3099.17"
        x2="4133.55"
        y2="3157.74"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp198-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp198-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp199-fill"
        x1="4057.13"
        y1="3099.17"
        x2="4057.13"
        y2="3183.09"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp199-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp199-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp200-fill"
        x1="3993.07"
        y1="3215.34"
        x2="4080.73"
        y2="3159.04"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp200-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp200-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp202-fill"
        x1="4126.96"
        y1="3079.86"
        x2="4126.96"
        y2="3145.15"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp202-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp202-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp203-fill"
        x1="4057.13"
        y1="3079.86"
        x2="4057.13"
        y2="3163.78"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp203-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp203-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp204-fill"
        x1="3984.84"
        y1="3202.52"
        x2="4072.5"
        y2="3146.23"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp204-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp204-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp206-fill"
        x1="3465.14"
        y1="3576.02"
        x2="3832.4"
        y2="3549.76"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp206-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp206-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp207-fill"
        x1="3652.83"
        y1="3491.91"
        x2="3652.83"
        y2="3526.68"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp207-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp207-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp209-fill"
        x1="3415.58"
        y1="3657.21"
        x2="3657"
        y2="3415.79"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp209-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp209-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp210-fill"
        x1="3652.83"
        y1="3491.91"
        x2="3652.83"
        y2="3521.75"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp210-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp210-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp211-fill"
        x1="3665.71"
        y1="3532.91"
        x2="3665.71"
        y2="3541.18"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp211-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp211-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp213-fill"
        x1="3687.26"
        y1="3528.49"
        x2="3687.26"
        y2="3532.01"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp213-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp213-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp214-fill"
        x1="3678.26"
        y1="3528.49"
        x2="3678.26"
        y2="3541.18"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp214-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp214-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp215-fill"
        x1="3670.25"
        y1="3538.23"
        x2="3670.25"
        y2="3541.75"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp215-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp215-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp217-fill"
        x1="3688.24"
        y1="3529.8"
        x2="3688.24"
        y2="3532.58"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp217-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp217-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp218-fill"
        x1="3679.25"
        y1="3529.8"
        x2="3679.25"
        y2="3541.75"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp218-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp218-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp219-fill"
        x1="3671.23"
        y1="3539.54"
        x2="3671.23"
        y2="3542.32"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp219-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp219-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp221-fill"
        x1="3689.23"
        y1="3531.11"
        x2="3689.23"
        y2="3533.15"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp221-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp221-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp222-fill"
        x1="3680.23"
        y1="3531.11"
        x2="3680.23"
        y2="3542.32"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp222-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp222-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp223-fill"
        x1="3672.22"
        y1="3540.84"
        x2="3672.22"
        y2="3542.89"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp223-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp223-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp225-fill"
        x1="3690.21"
        y1="3532.41"
        x2="3690.21"
        y2="3533.72"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp225-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp225-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp226-fill"
        x1="3681.22"
        y1="3532.41"
        x2="3681.22"
        y2="3542.89"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp226-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp226-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp227-fill"
        x1="3673.2"
        y1="3542.15"
        x2="3673.2"
        y2="3543.45"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp227-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp227-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp229-fill"
        x1="3663.4"
        y1="3449.94"
        x2="3663.4"
        y2="3519.66"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp229-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp229-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp230-fill"
        x1="3652.93"
        y1="3455.87"
        x2="3652.93"
        y2="3521.86"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp230-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp230-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp231-fill"
        x1="3642.39"
        y1="3462.07"
        x2="3642.39"
        y2="3531.79"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp231-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp231-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp232-fill"
        x1="3628.96"
        y1="3462.07"
        x2="3628.96"
        y2="3525.93"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp232-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp232-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp233-fill"
        x1="3634.03"
        y1="3466.89"
        x2="3634.03"
        y2="3536.62"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp233-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp233-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp240-fill"
        x1="3637.66"
        y1="3505.91"
        x2="3637.66"
        y2="3540.85"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp240-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp240-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp241-fill"
        x1="3562.13"
        y1="3505.91"
        x2="3562.13"
        y2="3587.7"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp241-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp241-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp242-fill"
        x1="3579.61"
        y1="3505.91"
        x2="3579.61"
        y2="3593.12"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp242-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp242-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp243-fill"
        x1="3642.46"
        y1="3461.63"
        x2="3642.46"
        y2="3531.63"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp243-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp243-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp244-fill"
        x1="3562.13"
        y1="3461.63"
        x2="3562.13"
        y2="3572.94"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp244-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp244-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp245-fill"
        x1="3543.15"
        y1="3507.76"
        x2="3543.15"
        y2="3533.21"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp245-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp245-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp246-fill"
        x1="3515.79"
        y1="3507.76"
        x2="3515.79"
        y2="3528.67"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp246-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp246-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp247-fill"
        x1="3420.86"
        y1="3662.5"
        x2="3662.28"
        y2="3421.08"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp247-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp247-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp249-fill"
        x1="3422.35"
        y1="3663.98"
        x2="3663.77"
        y2="3422.56"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp249-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp249-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp250-fill"
        x1="3348.09"
        y1="3589.7"
        x2="3589.5"
        y2="3348.29"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp250-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp250-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp251-fill"
        x1="3358.45"
        y1="3600.07"
        x2="3599.86"
        y2="3358.66"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp251-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp251-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp254-fill"
        x1="3976.58"
        y1="3189.65"
        x2="4064.23"
        y2="3133.35"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp254-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp254-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp256-fill"
        x1="4115.11"
        y1="3041.22"
        x2="4115.11"
        y2="3111.62"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp256-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp256-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp257-fill"
        x1="4057.13"
        y1="3041.22"
        x2="4057.13"
        y2="3125.14"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp257-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp257-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp258-fill"
        x1="3965.44"
        y1="3172.3"
        x2="4053.09"
        y2="3116"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp258-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp258-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp261-fill"
        x1="4041.14"
        y1="3081.72"
        x2="4073.48"
        y2="3100.39"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp261-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp261-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp262-fill"
        x1="4020.35"
        y1="3089.45"
        x2="4038.18"
        y2="3099.74"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp262-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp262-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp263-fill"
        x1="3974.81"
        y1="3186.9"
        x2="4062.47"
        y2="3130.61"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp263-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp263-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp265-fill"
        x1="4172.99"
        y1="3045.54"
        x2="4199.13"
        y2="3045.54"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp265-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp265-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp266-fill"
        x1="4099.84"
        y1="3088.84"
        x2="4256.55"
        y2="3006.3"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp266-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp266-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp267-fill"
        x1="4334.18"
        y1="3006.17"
        x2="4334.18"
        y2="3047.35"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp267-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp267-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp268-fill"
        x1="4240.2"
        y1="3006.17"
        x2="4240.2"
        y2="3076.73"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp268-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp268-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp270-fill"
        x1="4173.38"
        y1="3137.09"
        x2="4285.93"
        y2="3019.35"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp270-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp270-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp272-fill"
        x1="4328.26"
        y1="2992.5"
        x2="4328.26"
        y2="3046.93"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp272-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp272-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp273-fill"
        x1="4241.9"
        y1="2992.5"
        x2="4241.9"
        y2="3076.42"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp273-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp273-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp276-fill"
        x1="4121.69"
        y1="3130.33"
        x2="4278.4"
        y2="3047.79"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp276-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp276-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp278-fill"
        x1="4329.25"
        y1="2973.18"
        x2="4329.25"
        y2="3028.76"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp278-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp278-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp279-fill"
        x1="4241.9"
        y1="2973.18"
        x2="4241.9"
        y2="3057.1"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp279-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp279-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp280-fill"
        x1="4113.42"
        y1="3114.63"
        x2="4270.13"
        y2="3032.09"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp280-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp280-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp281-fill"
        x1="3579.64"
        y1="3483.32"
        x2="3763.52"
        y2="3579.52"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp281-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp281-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp283-fill"
        x1="4104.86"
        y1="3098.39"
        x2="4261.57"
        y2="3015.85"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp283-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp283-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp285-fill"
        x1="4325.61"
        y1="2934.55"
        x2="4325.61"
        y2="2985.92"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp285-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp285-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp286-fill"
        x1="4084.78"
        y1="3060.25"
        x2="4241.49"
        y2="2977.71"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp286-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp286-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp287-fill"
        x1="4097.58"
        y1="3084.55"
        x2="4254.29"
        y2="3002.01"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp287-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp287-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp289-fill"
        x1="4147.43"
        y1="3112.3"
        x2="4259.99"
        y2="2994.55"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp289-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp289-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp291-fill"
        x1="3531.6"
        y1="3511.48"
        x2="3715.47"
        y2="3607.69"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp291-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp291-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp293-fill"
        x1="2930.59"
        y1="3727.11"
        x2="3114.46"
        y2="3823.31"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp293-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp293-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp296-fill"
        x1="2879.57"
        y1="3754.31"
        x2="3063.45"
        y2="3850.52"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp296-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp296-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp299-fill"
        x1="2828.57"
        y1="3781.52"
        x2="3012.44"
        y2="3877.73"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp299-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp299-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp304-fill"
        x1="3515.1"
        y1="3532.04"
        x2="3649.57"
        y2="3602.4"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp304-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp304-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp305-fill"
        x1="3471.2"
        y1="3580.91"
        x2="3605.67"
        y2="3651.27"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp305-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp305-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp311-fill"
        x1="3323.35"
        y1="3629.12"
        x2="3507.22"
        y2="3725.32"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp311-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp311-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp314-fill"
        x1="3202.46"
        y1="3693.18"
        x2="3383.12"
        y2="3787.71"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp314-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp314-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp317-fill"
        x1="3117.45"
        y1="3740.79"
        x2="3298.11"
        y2="3835.31"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp317-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp317-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp320-fill"
        x1="3191.56"
        y1="3736.01"
        x2="3305.92"
        y2="3795.85"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp320-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp320-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp323-fill"
        x1="2991.61"
        y1="3810.5"
        x2="3172.27"
        y2="3905.03"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp323-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp323-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp326-fill"
        x1="6231.68"
        y1="1849.24"
        x2="6415.56"
        y2="1945.45"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp326-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp326-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp329-fill"
        x1="6136.38"
        y1="1904.95"
        x2="6317.04"
        y2="1999.48"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp329-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp329-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp332-fill"
        x1="6051.37"
        y1="1952.56"
        x2="6232.03"
        y2="2047.08"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp332-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp332-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp335-fill"
        x1="6125.48"
        y1="1947.78"
        x2="6239.84"
        y2="2007.62"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp335-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp335-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp338-fill"
        x1="5925.53"
        y1="2022.28"
        x2="6106.19"
        y2="2116.8"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp338-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp338-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp343-fill"
        x1="5665.73"
        y1="2166.46"
        x2="5849.6"
        y2="2262.66"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp343-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp343-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp346-fill"
        x1="4241.56"
        y1="2885.8"
        x2="4376.04"
        y2="2956.16"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp346-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp346-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp349-fill"
        x1="4285"
        y1="2837.55"
        x2="4419.47"
        y2="2907.91"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp349-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp349-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp352-fill"
        x1="3675.73"
        y1="3426.99"
        x2="3859.6"
        y2="3523.2"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp352-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp352-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp355-fill"
        x1="3627.68"
        y1="3455.15"
        x2="3811.56"
        y2="3551.36"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp355-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp355-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp359-fill"
        x1="6129.02"
        y1="1774.37"
        x2="6312.9"
        y2="1870.58"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp359-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp359-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp362-fill"
        x1="6066.11"
        y1="1808.38"
        x2="6249.98"
        y2="1904.58"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp362-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp362-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp365-fill"
        x1="6003.19"
        y1="1842.38"
        x2="6187.07"
        y2="1938.59"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp365-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp365-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp368-fill"
        x1="5868.14"
        y1="2113.9"
        x2="5996.8"
        y2="2181.22"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp368-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp368-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp372-fill"
        x1="6551.03"
        y1="1538.31"
        x2="6731.69"
        y2="1632.83"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp372-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp372-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp375-fill"
        x1="6625.14"
        y1="1533.53"
        x2="6739.5"
        y2="1593.37"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp375-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp375-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp379-fill"
        x1="6317.02"
        y1="1889.41"
        x2="6536.08"
        y2="2004.02"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp379-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp379-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp382-fill"
        x1="6893.23"
        y1="1693.29"
        x2="7004.64"
        y2="1751.59"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp382-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp382-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp385-fill"
        x1="6832.97"
        y1="1727.94"
        x2="6944.38"
        y2="1786.24"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp385-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp385-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp388-fill"
        x1="6772.7"
        y1="1762.59"
        x2="6884.11"
        y2="1820.88"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp388-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp388-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp391-fill"
        x1="6712.44"
        y1="1797.24"
        x2="6823.85"
        y2="1855.53"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp391-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp391-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp394-fill"
        x1="6550.29"
        y1="1866.04"
        x2="6680.22"
        y2="1934.02"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp394-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp394-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp397-fill"
        x1="6641.04"
        y1="1605.83"
        x2="6821.7"
        y2="1700.35"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp397-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp397-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp400-fill"
        x1="6521.3"
        y1="1677.1"
        x2="6701.96"
        y2="1771.63"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp400-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp400-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp403-fill"
        x1="6428.2"
        y1="1605.02"
        x2="6608.86"
        y2="1699.55"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp403-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp403-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp409-fill"
        x1="3878.81"
        y1="3338.31"
        x2="4039.89"
        y2="3422.59"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp409-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp409-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp412-fill"
        x1="3925.04"
        y1="3318.07"
        x2="4048.65"
        y2="3382.74"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp412-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp412-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp415-fill"
        x1="3718.28"
        y1="3380.68"
        x2="3917.59"
        y2="3484.96"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp415-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp415-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp423-fill"
        x1="4221.61"
        y1="3118.52"
        x2="4405.49"
        y2="3214.73"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp423-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp423-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp426-fill"
        x1="4173.57"
        y1="3146.68"
        x2="4357.45"
        y2="3242.89"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp426-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp426-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp429-fill"
        x1="4125.53"
        y1="3174.84"
        x2="4309.4"
        y2="3271.05"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp429-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp429-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp432-fill"
        x1="4286.14"
        y1="3055.38"
        x2="4485.45"
        y2="3159.66"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp432-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp432-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp435-fill"
        x1="5544.83"
        y1="2230.52"
        x2="5725.49"
        y2="2325.04"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp435-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp435-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp438-fill"
        x1="5459.82"
        y1="2278.12"
        x2="5640.48"
        y2="2372.65"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp438-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp438-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp441-fill"
        x1="5533.93"
        y1="2273.35"
        x2="5648.3"
        y2="2333.19"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp441-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp441-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp444-fill"
        x1="5261.76"
        y1="2266.22"
        x2="5442.42"
        y2="2360.75"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp444-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp444-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp447-fill"
        x1="5335.87"
        y1="2261.45"
        x2="5450.24"
        y2="2321.28"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp447-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp447-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp450-fill"
        x1="5333.99"
        y1="2347.84"
        x2="5514.65"
        y2="2442.37"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp450-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp450-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp457-fill"
        x1="2665.6"
        y1="4049.92"
        x2="2241.49"
        y2="4214.88"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp457-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp457-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp458-fill"
        x1="2454.58"
        y1="4074.27"
        x2="2606.29"
        y2="4074.27"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp458-fill-0" offset="0%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp458-fill-1" offset="100%" stop-color="#1a75b4" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp459-fill"
        x1="2493.59"
        y1="4200.14"
        x2="2649.25"
        y2="4078.1"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp459-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp459-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp461-fill"
        x1="2571.21"
        y1="4157.82"
        x2="2558.78"
        y2="4165"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp461-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp461-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp462-fill"
        x1="2553.88"
        y1="4152.6"
        x2="2567.44"
        y2="4152.6"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp462-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp462-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp463-fill"
        x1="2566.69"
        y1="4159.92"
        x2="2580.16"
        y2="4159.92"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp463-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp463-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp464-fill"
        x1="2551.41"
        y1="4141.67"
        x2="2557.31"
        y2="4141.67"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp464-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp464-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp465-fill"
        x1="2572.01"
        y1="4153.56"
        x2="2577.91"
        y2="4153.56"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp465-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp465-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp468-fill"
        x1="2504.11"
        y1="4213.56"
        x2="2659.77"
        y2="4091.52"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp468-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp468-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp473-fill"
        x1="2455.34"
        y1="4151.35"
        x2="2611"
        y2="4029.31"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp473-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp473-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp484-fill"
        x1="2586.4"
        y1="3782.5"
        x2="2769.08"
        y2="3878.08"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp484-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp484-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp488-fill"
        x1="2528.4"
        y1="3817.5"
        x2="2711.08"
        y2="3913.08"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp488-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp488-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp492-fill"
        x1="2438.4"
        y1="3869.5"
        x2="2621.08"
        y2="3965.08"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp492-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp492-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp500-fill"
        x1="2696.13"
        y1="3851.5"
        x2="2878.81"
        y2="3947.08"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp500-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp500-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp504-fill"
        x1="2638.13"
        y1="3886.5"
        x2="2820.81"
        y2="3982.08"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp504-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp504-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp508-fill"
        x1="2548.13"
        y1="3938.5"
        x2="2730.81"
        y2="4034.08"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp508-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp508-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp516-fill"
        x1="2811.4"
        y1="3915.5"
        x2="2994.08"
        y2="4011.08"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp516-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp516-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp520-fill"
        x1="2753.4"
        y1="3950.5"
        x2="2936.08"
        y2="4046.08"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp520-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp520-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp524-fill"
        x1="2663.4"
        y1="4002.5"
        x2="2846.08"
        y2="4098.08"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp524-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp524-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp528-fill"
        x1="4081.22"
        y1="3262.73"
        x2="4188.01"
        y2="3318.6"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp528-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp528-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp531-fill"
        x1="5777.43"
        y1="2234.34"
        x2="5961.3"
        y2="2330.55"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp531-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp531-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp535-fill"
        x1="5963.14"
        y1="2210.2"
        x2="6074.55"
        y2="2268.49"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp535-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp535-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp540-fill"
        x1="6226.32"
        y1="1979.29"
        x2="6410.19"
        y2="2075.5"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp540-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp540-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp543-fill"
        x1="6178.28"
        y1="2007.45"
        x2="6362.15"
        y2="2103.66"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp543-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp543-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp546-fill"
        x1="6130.24"
        y1="2035.61"
        x2="6314.11"
        y2="2131.82"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp546-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp546-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp549-fill"
        x1="6051.85"
        y1="2108.96"
        x2="6212.93"
        y2="2193.24"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp549-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp549-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp552-fill"
        x1="6098.08"
        y1="2088.72"
        x2="6221.69"
        y2="2153.39"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp552-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp552-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp555-fill"
        x1="4761.96"
        y1="2548.56"
        x2="4942.62"
        y2="2643.09"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp555-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp555-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp558-fill"
        x1="4836.07"
        y1="2543.79"
        x2="4950.44"
        y2="2603.62"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp558-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp558-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp561-fill"
        x1="4636.13"
        y1="2618.28"
        x2="4816.79"
        y2="2712.81"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp561-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp561-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp567-fill"
        x1="4824.28"
        y1="2639.82"
        x2="5004.94"
        y2="2734.34"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp567-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp567-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp573-fill"
        x1="4992.05"
        y1="2676.64"
        x2="5172.71"
        y2="2771.17"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp573-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp573-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp576-fill"
        x1="5066.16"
        y1="2671.87"
        x2="5180.53"
        y2="2731.7"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp576-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp576-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp579-fill"
        x1="4866.22"
        y1="2746.36"
        x2="5046.88"
        y2="2840.88"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp579-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp579-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp582-fill"
        x1="4859.47"
        y1="2681.22"
        x2="4859.47"
        y2="2796.03"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp582-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp582-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp583-fill"
        x1="4865.83"
        y1="2683.92"
        x2="4865.83"
        y2="2796.79"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp583-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp583-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp584-fill"
        x1="4868.12"
        y1="2686.11"
        x2="4868.12"
        y2="2801.82"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp584-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp584-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp585-fill"
        x1="4859.98"
        y1="2685.35"
        x2="4859.98"
        y2="2804.87"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp585-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp585-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp586-fill"
        x1="4869.41"
        y1="2691.14"
        x2="4869.41"
        y2="2804.87"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp586-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp586-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp588-fill"
        x1="4862.72"
        y1="2683.93"
        x2="4862.72"
        y2="2809.44"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp588-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp588-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp589-fill"
        x1="4832.63"
        y1="2683.93"
        x2="4832.63"
        y2="2814.51"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp589-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp589-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp590-fill"
        x1="4828.25"
        y1="2703.83"
        x2="4828.25"
        y2="2829.34"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp590-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp590-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp592-fill"
        x1="4803.83"
        y1="2698.67"
        x2="4803.83"
        y2="2814.51"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp592-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp592-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp593-fill"
        x1="4779.41"
        y1="2698.67"
        x2="4779.41"
        y2="2815.99"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp593-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp593-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp594-fill"
        x1="4995.86"
        y1="2586.44"
        x2="4699.77"
        y2="2838"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp594-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp594-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp595-fill"
        x1="4802.55"
        y1="2712.03"
        x2="4802.55"
        y2="2829.34"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp595-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp595-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp597-fill"
        x1="4834.79"
        y1="2691.53"
        x2="4834.79"
        y2="2836.89"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp597-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp597-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp598-fill"
        x1="4802.55"
        y1="2691.53"
        x2="4802.55"
        y2="2829.34"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp598-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp598-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp599-fill"
        x1="5012.6"
        y1="2606.14"
        x2="4716.51"
        y2="2857.7"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp599-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp599-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp601-fill"
        x1="4867.65"
        y1="2734.41"
        x2="4867.65"
        y2="2852.45"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp601-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp601-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp602-fill"
        x1="4841.32"
        y1="2734.41"
        x2="4841.32"
        y2="2851.73"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp602-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp602-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp603-fill"
        x1="4866.33"
        y1="2865.16"
        x2="4866.33"
        y2="2879.62"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp603-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp603-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp604-fill"
        x1="4862.04"
        y1="2865.16"
        x2="4862.04"
        y2="2876.15"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp604-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp604-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp605-fill"
        x1="4865.05"
        y1="2865.9"
        x2="4865.05"
        y2="2880.36"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp605-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp605-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp606-fill"
        x1="4869.33"
        y1="2869.37"
        x2="4869.33"
        y2="2880.36"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp606-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp606-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp607-fill"
        x1="4865.69"
        y1="2865.16"
        x2="4865.69"
        y2="2870.11"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp607-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp607-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp608-fill"
        x1="4846.29"
        y1="2876.73"
        x2="4846.29"
        y2="2891.19"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp608-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp608-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp609-fill"
        x1="4842"
        y1="2876.73"
        x2="4842"
        y2="2887.72"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp609-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp609-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp610-fill"
        x1="5079.8"
        y1="2685.22"
        x2="4783.7"
        y2="2936.79"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp610-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp610-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp611-fill"
        x1="4849.3"
        y1="2880.94"
        x2="4849.3"
        y2="2891.93"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp611-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp611-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp612-fill"
        x1="4845.65"
        y1="2876.73"
        x2="4845.65"
        y2="2881.68"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp612-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp612-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp613-fill"
        x1="4802.55"
        y1="2718.67"
        x2="4802.55"
        y2="2844.18"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp613-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp613-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp614-fill"
        x1="4772.46"
        y1="2718.67"
        x2="4772.46"
        y2="2849.24"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp614-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp614-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp615-fill"
        x1="5006.4"
        y1="2598.85"
        x2="4710.31"
        y2="2850.41"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp615-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp615-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp619-fill"
        x1="4765.35"
        y1="2739.99"
        x2="4765.35"
        y2="2859.5"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp619-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp619-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp620-fill"
        x1="5004.27"
        y1="2596.34"
        x2="4708.18"
        y2="2847.89"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp620-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp620-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp622-fill"
        x1="4827.97"
        y1="2835.9"
        x2="4827.97"
        y2="2864.59"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp622-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp622-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp623-fill"
        x1="4801.33"
        y1="2835.9"
        x2="4801.33"
        y2="2858.46"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp623-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp623-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp624-fill"
        x1="4833.28"
        y1="2854.35"
        x2="4833.28"
        y2="2876.9"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp624-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp624-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp625-fill"
        x1="4817.31"
        y1="2835.9"
        x2="4817.31"
        y2="2866.65"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp625-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp625-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp626-fill"
        x1="4844.29"
        y1="2825.65"
        x2="4844.29"
        y2="2873.2"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp626-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp626-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp627-fill"
        x1="4801.33"
        y1="2825.65"
        x2="4801.33"
        y2="2848.21"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp627-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp627-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp629-fill"
        x1="5568.99"
        y1="2344.33"
        x2="5751.67"
        y2="2439.92"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp629-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp629-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp631-fill"
        x1="5517.76"
        y1="2375.42"
        x2="5700.44"
        y2="2471.01"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp631-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp631-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp635-fill"
        x1="5466.6"
        y1="2405.95"
        x2="5649.28"
        y2="2501.54"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp635-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp635-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp636-fill"
        x1="5413.78"
        y1="2433.74"
        x2="5596.46"
        y2="2529.32"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp636-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp636-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp641-fill"
        x1="5729.39"
        y1="2262.5"
        x2="5913.26"
        y2="2358.71"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp641-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp641-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp643-fill"
        x1="5681.35"
        y1="2290.66"
        x2="5865.22"
        y2="2386.87"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp643-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp643-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp646-fill"
        x1="5178.46"
        y1="2313.82"
        x2="5359.12"
        y2="2408.35"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp646-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp646-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp649-fill"
        x1="5252.57"
        y1="2309.05"
        x2="5366.93"
        y2="2368.89"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp649-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp649-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp656-fill"
        x1="1810.16"
        y1="4370.96"
        x2="1994.03"
        y2="4467.17"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp656-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp656-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp681-fill"
        x1="1935.76"
        y1="4329.9"
        x2="2033.63"
        y2="4329.9"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp681-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp681-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp684-fill"
        x1="2214.78"
        y1="4125.16"
        x2="1984.66"
        y2="4454.81"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp684-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp684-fill-1" offset="53.65%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp684-fill-2" offset="100%" stop-color="#0075b8" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp686-fill"
        x1="1602.15"
        y1="4500.26"
        x2="1474.19"
        y2="4667.77"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp686-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp686-fill-1" offset="30.3%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp686-fill-2" offset="52.73%" stop-color="#0075b8" />
        <stop id="edEvCAwTnKp686-fill-3" offset="78.79%" stop-color="#003455" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp687-fill"
        x1="1618.22"
        y1="4512.54"
        x2="1490.27"
        y2="4680.04"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp687-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp687-fill-1" offset="30.3%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp687-fill-2" offset="52.73%" stop-color="#0075b8" />
        <stop id="edEvCAwTnKp687-fill-3" offset="78.79%" stop-color="#003455" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp688-fill"
        x1="1640.39"
        y1="4529.47"
        x2="1512.43"
        y2="4696.98"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp688-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp688-fill-1" offset="30.3%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp688-fill-2" offset="52.73%" stop-color="#0075b8" />
        <stop id="edEvCAwTnKp688-fill-3" offset="78.79%" stop-color="#003455" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp689-fill"
        x1="1586.93"
        y1="4488.64"
        x2="1458.97"
        y2="4656.14"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp689-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp689-fill-1" offset="30.3%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp689-fill-2" offset="52.73%" stop-color="#0075b8" />
        <stop id="edEvCAwTnKp689-fill-3" offset="78.79%" stop-color="#003455" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp691-fill"
        x1="1569.61"
        y1="4475.41"
        x2="1441.66"
        y2="4642.91"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp691-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp691-fill-1" offset="30.3%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp691-fill-2" offset="52.73%" stop-color="#0075b8" />
        <stop id="edEvCAwTnKp691-fill-3" offset="78.79%" stop-color="#003455" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp692-fill"
        x1="1619.96"
        y1="4513.87"
        x2="1492"
        y2="4681.37"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp692-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp692-fill-1" offset="30.3%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp692-fill-2" offset="52.73%" stop-color="#0075b8" />
        <stop id="edEvCAwTnKp692-fill-3" offset="78.79%" stop-color="#003455" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp694-fill"
        x1="1551.04"
        y1="4461.22"
        x2="1423.08"
        y2="4628.73"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp694-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp694-fill-1" offset="30.3%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp694-fill-2" offset="52.73%" stop-color="#0075b8" />
        <stop id="edEvCAwTnKp694-fill-3" offset="78.79%" stop-color="#003455" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp695-fill"
        x1="1576.29"
        y1="4480.51"
        x2="1448.33"
        y2="4648.02"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp695-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp695-fill-1" offset="30.3%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp695-fill-2" offset="52.73%" stop-color="#0075b8" />
        <stop id="edEvCAwTnKp695-fill-3" offset="78.79%" stop-color="#003455" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp696-fill"
        x1="1605.98"
        y1="4503.19"
        x2="1478.02"
        y2="4670.69"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp696-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp696-fill-1" offset="30.3%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp696-fill-2" offset="52.73%" stop-color="#0075b8" />
        <stop id="edEvCAwTnKp696-fill-3" offset="78.79%" stop-color="#003455" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp697-fill"
        x1="1625.67"
        y1="4518.23"
        x2="1497.71"
        y2="4685.73"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp697-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp697-fill-1" offset="30.3%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp697-fill-2" offset="52.73%" stop-color="#0075b8" />
        <stop id="edEvCAwTnKp697-fill-3" offset="78.79%" stop-color="#003455" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp699-fill"
        x1="1451.05"
        y1="4570.04"
        x2="1326.37"
        y2="4754.8"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp699-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp699-fill-1" offset="30.3%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp699-fill-2" offset="52.73%" stop-color="#0075b8" />
        <stop id="edEvCAwTnKp699-fill-3" offset="78.79%" stop-color="#003455" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp701-fill"
        x1="1438.85"
        y1="4561.81"
        x2="1314.18"
        y2="4746.57"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp701-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp701-fill-1" offset="30.3%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp701-fill-2" offset="52.73%" stop-color="#0075b8" />
        <stop id="edEvCAwTnKp701-fill-3" offset="78.79%" stop-color="#003455" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp702-fill"
        x1="1459.94"
        y1="4576.04"
        x2="1335.26"
        y2="4760.79"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp702-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp702-fill-1" offset="30.3%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp702-fill-2" offset="52.73%" stop-color="#0075b8" />
        <stop id="edEvCAwTnKp702-fill-3" offset="78.79%" stop-color="#003455" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp704-fill"
        x1="1438.56"
        y1="4561.62"
        x2="1313.88"
        y2="4746.36"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp704-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp704-fill-1" offset="30.3%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp704-fill-2" offset="52.73%" stop-color="#0075b8" />
        <stop id="edEvCAwTnKp704-fill-3" offset="78.79%" stop-color="#003455" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp705-fill"
        x1="1461.88"
        y1="4577.35"
        x2="1337.2"
        y2="4762.1"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp705-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp705-fill-1" offset="30.3%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp705-fill-2" offset="52.73%" stop-color="#0075b8" />
        <stop id="edEvCAwTnKp705-fill-3" offset="78.79%" stop-color="#003455" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp706-fill"
        x1="1445.99"
        y1="4641.13"
        x2="1446.07"
        y2="4641.13"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp706-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp706-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp707-fill"
        x1="1469.51"
        y1="4600.44"
        x2="1401.27"
        y2="4774.15"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp707-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp707-fill-1" offset="53.65%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp707-fill-2" offset="100%" stop-color="#0075b8" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp709-fill"
        x1="1764.47"
        y1="4395.24"
        x2="1948.34"
        y2="4491.45"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp709-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp709-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp712-fill"
        x1="1669.16"
        y1="4450.95"
        x2="1849.82"
        y2="4545.48"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp712-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp712-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp715-fill"
        x1="1584.15"
        y1="4498.56"
        x2="1764.81"
        y2="4593.08"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp715-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp715-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp718-fill"
        x1="1658.26"
        y1="4493.78"
        x2="1772.63"
        y2="4553.62"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp718-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp718-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp721-fill"
        x1="1458.32"
        y1="4568.28"
        x2="1638.98"
        y2="4662.8"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp721-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp721-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp726-fill"
        x1="1198.51"
        y1="4712.46"
        x2="1382.39"
        y2="4808.66"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp726-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp726-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp729-fill"
        x1="1661.81"
        y1="4320.37"
        x2="1845.68"
        y2="4416.58"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp729-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp729-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp732-fill"
        x1="1598.89"
        y1="4354.38"
        x2="1782.77"
        y2="4450.58"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp732-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp732-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp735-fill"
        x1="1535.98"
        y1="4388.38"
        x2="1719.85"
        y2="4484.59"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp735-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp735-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp738-fill"
        x1="1400.93"
        y1="4659.9"
        x2="1529.59"
        y2="4727.22"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp738-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp738-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp742-fill"
        x1="2083.81"
        y1="4084.31"
        x2="2264.47"
        y2="4178.83"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp742-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp742-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp745-fill"
        x1="2157.92"
        y1="4079.53"
        x2="2272.29"
        y2="4139.37"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp745-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp745-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp748-fill"
        x1="1849.81"
        y1="4435.41"
        x2="2068.86"
        y2="4550.02"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp748-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp748-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp751-fill"
        x1="2426.01"
        y1="4239.29"
        x2="2537.43"
        y2="4297.59"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp751-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp751-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp752-fill"
        x1="2365.75"
        y1="4273.94"
        x2="2477.16"
        y2="4332.24"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp752-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp752-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp755-fill"
        x1="2305.49"
        y1="4308.59"
        x2="2416.9"
        y2="4366.88"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp755-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp755-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp758-fill"
        x1="2245.23"
        y1="4343.24"
        x2="2356.64"
        y2="4401.53"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp758-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp758-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp761-fill"
        x1="2083.08"
        y1="4412.04"
        x2="2213.01"
        y2="4480.02"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp761-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp761-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp764-fill"
        x1="2173.83"
        y1="4151.83"
        x2="2354.49"
        y2="4246.35"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp764-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp764-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp767-fill"
        x1="2054.08"
        y1="4223.1"
        x2="2234.74"
        y2="4317.63"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp767-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp767-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp770-fill"
        x1="1960.98"
        y1="4151.02"
        x2="2141.64"
        y2="4245.55"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp770-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp770-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp777-fill"
        x1="1310.21"
        y1="4780.34"
        x2="1494.09"
        y2="4876.55"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp777-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp777-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp781-fill"
        x1="1495.92"
        y1="4756.2"
        x2="1607.34"
        y2="4814.49"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp781-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp781-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp784-fill"
        x1="1759.1"
        y1="4525.29"
        x2="1942.98"
        y2="4621.5"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp784-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp784-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp787-fill"
        x1="1711.06"
        y1="4553.45"
        x2="1894.94"
        y2="4649.66"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp787-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp787-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp790-fill"
        x1="1663.02"
        y1="4581.61"
        x2="1846.9"
        y2="4677.82"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp790-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp790-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp793-fill"
        x1="1584.64"
        y1="4654.96"
        x2="1745.71"
        y2="4739.24"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp793-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp793-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp796-fill"
        x1="1630.87"
        y1="4634.72"
        x2="1754.47"
        y2="4699.39"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp796-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp796-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp810-fill"
        x1="7500.8"
        y1="975.386"
        x2="7681.46"
        y2="1069.91"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp810-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp810-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp813-fill"
        x1="7436.16"
        y1="1062.83"
        x2="7581.19"
        y2="1138.72"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp813-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp813-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp816-fill"
        x1="8051.26"
        y1="668.886"
        x2="8233.94"
        y2="764.469"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp816-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp816-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp818-fill"
        x1="8000.02"
        y1="699.976"
        x2="8182.71"
        y2="795.559"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp818-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp818-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp820-fill"
        x1="7565.38"
        y1="1130.74"
        x2="7710.41"
        y2="1206.63"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp820-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp820-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp823-fill"
        x1="7661.52"
        y1="1021.25"
        x2="7844.2"
        y2="1116.84"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp823-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp823-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp830-fill"
        x1="-92.7662"
        y1="318.5383"
        x2="158.7773"
        y2="36.2636"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp830-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp830-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp832-fill"
        x1="-22.1959"
        y1="379.2065"
        x2="228.2993"
        y2="98.1073"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp832-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp832-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp836-fill"
        x1="-0.1265"
        y1="236.9704"
        x2="155.7228"
        y2="153.0954"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp836-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp836-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp841-fill"
        x1="55.6069"
        y1="246.729"
        x2="94.3017"
        y2="246.729"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp841-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp841-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp843-fill"
        x1="-50.1524"
        y1="354.1206"
        x2="200.2082"
        y2="73.1728"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp843-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp843-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp845-fill"
        x1="7933.35"
        y1="1030.51"
        x2="8300.62"
        y2="1004.25"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp845-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp845-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp846-fill"
        x1="8121.05"
        y1="946.399"
        x2="8121.05"
        y2="981.172"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp846-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp846-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp848-fill"
        x1="7883.79"
        y1="1111.7"
        x2="8125.21"
        y2="870.28"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp848-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp848-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp849-fill"
        x1="8051.51"
        y1="1083.43"
        x2="8242.12"
        y2="853.637"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp849-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp849-fill-1" offset="53.65%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp849-fill-2" offset="100%" stop-color="#0075b8" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp850-fill"
        x1="8121.05"
        y1="946.399"
        x2="8121.05"
        y2="976.235"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp850-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp850-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp851-fill"
        x1="8133.92"
        y1="987.397"
        x2="8133.92"
        y2="995.673"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp851-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp851-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp852-fill"
        x1="8061.34"
        y1="1091.6"
        x2="8251.96"
        y2="861.795"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp852-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp852-fill-1" offset="53.65%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp852-fill-2" offset="100%" stop-color="#0075b8" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp854-fill"
        x1="8155.47"
        y1="982.984"
        x2="8155.47"
        y2="986.504"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp854-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp854-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp855-fill"
        x1="8146.48"
        y1="982.984"
        x2="8146.48"
        y2="995.672"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp855-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp855-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp856-fill"
        x1="8138.46"
        y1="992.72"
        x2="8138.46"
        y2="996.24"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp856-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp856-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp857-fill"
        x1="8062.39"
        y1="1092.46"
        x2="8253"
        y2="862.665"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp857-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp857-fill-1" offset="53.65%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp857-fill-2" offset="100%" stop-color="#0075b8" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp859-fill"
        x1="8156.46"
        y1="984.29"
        x2="8156.46"
        y2="987.071"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp859-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp859-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp860-fill"
        x1="8147.46"
        y1="984.29"
        x2="8147.46"
        y2="996.24"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp860-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp860-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp861-fill"
        x1="8139.45"
        y1="994.026"
        x2="8139.45"
        y2="996.808"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp861-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp861-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp862-fill"
        x1="8063.43"
        y1="1093.32"
        x2="8254.04"
        y2="863.529"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp862-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp862-fill-1" offset="53.65%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp862-fill-2" offset="100%" stop-color="#0075b8" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp864-fill"
        x1="8157.44"
        y1="985.595"
        x2="8157.44"
        y2="987.639"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp864-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp864-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp865-fill"
        x1="8148.45"
        y1="985.595"
        x2="8148.45"
        y2="996.808"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp865-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp865-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp866-fill"
        x1="8140.43"
        y1="995.332"
        x2="8140.43"
        y2="997.376"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp866-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp866-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp867-fill"
        x1="8064.48"
        y1="1094.19"
        x2="8255.09"
        y2="864.394"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp867-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp867-fill-1" offset="53.65%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp867-fill-2" offset="100%" stop-color="#0075b8" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp869-fill"
        x1="8158.43"
        y1="986.901"
        x2="8158.43"
        y2="988.208"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp869-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp869-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp870-fill"
        x1="8149.43"
        y1="986.901"
        x2="8149.43"
        y2="997.376"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp870-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp870-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp872-fill"
        x1="8141.42"
        y1="996.637"
        x2="8141.42"
        y2="997.944"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp872-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp872-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp873-fill"
        x1="8065.52"
        y1="1095.06"
        x2="8256.13"
        y2="865.256"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp873-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp873-fill-1" offset="53.65%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp873-fill-2" offset="100%" stop-color="#0075b8" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp875-fill"
        x1="8058.85"
        y1="1089.52"
        x2="8249.46"
        y2="859.729"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp875-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp875-fill-1" offset="53.65%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp875-fill-2" offset="100%" stop-color="#0075b8" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp876-fill"
        x1="8131.61"
        y1="904.429"
        x2="8131.61"
        y2="974.152"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp876-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp876-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp877-fill"
        x1="8036.89"
        y1="1071.31"
        x2="8227.5"
        y2="841.512"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp877-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp877-fill-1" offset="53.65%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp877-fill-2" offset="100%" stop-color="#0075b8" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp878-fill"
        x1="8121.15"
        y1="910.356"
        x2="8121.15"
        y2="976.353"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp878-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp878-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp879-fill"
        x1="8031.26"
        y1="1066.64"
        x2="8221.87"
        y2="836.841"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp879-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp879-fill-1" offset="53.65%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp879-fill-2" offset="100%" stop-color="#0075b8" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp880-fill"
        x1="8110.61"
        y1="916.558"
        x2="8110.61"
        y2="986.281"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp880-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp880-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp881-fill"
        x1="8097.17"
        y1="916.558"
        x2="8097.17"
        y2="980.42"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp881-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp881-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp882-fill"
        x1="8102.25"
        y1="921.383"
        x2="8102.25"
        y2="991.106"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp882-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp882-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp883-fill"
        x1="8028.47"
        y1="1064.32"
        x2="8219.08"
        y2="834.524"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp883-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp883-fill-1" offset="53.65%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp883-fill-2" offset="100%" stop-color="#0075b8" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp890-fill"
        x1="8105.87"
        y1="960.4"
        x2="8105.87"
        y2="995.339"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp890-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp890-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp891-fill"
        x1="8030.35"
        y1="960.4"
        x2="8030.35"
        y2="1042.19"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp891-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp891-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp892-fill"
        x1="8029.23"
        y1="1064.96"
        x2="8219.84"
        y2="835.161"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp892-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp892-fill-1" offset="53.65%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp892-fill-2" offset="100%" stop-color="#0075b8" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp893-fill"
        x1="8047.82"
        y1="960.4"
        x2="8047.82"
        y2="1047.61"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp893-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp893-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp894-fill"
        x1="8110.68"
        y1="916.121"
        x2="8110.68"
        y2="986.124"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp894-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp894-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp895-fill"
        x1="8030.35"
        y1="916.121"
        x2="8030.35"
        y2="1027.43"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp895-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp895-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp896-fill"
        x1="8023.14"
        y1="1059.9"
        x2="8213.75"
        y2="830.108"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp896-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp896-fill-1" offset="53.65%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp896-fill-2" offset="100%" stop-color="#0075b8" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp897-fill"
        x1="8011.36"
        y1="962.252"
        x2="8011.36"
        y2="987.697"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp897-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp897-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp898-fill"
        x1="7984"
        y1="962.252"
        x2="7984"
        y2="983.155"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp898-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp898-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp899-fill"
        x1="7889.08"
        y1="1116.99"
        x2="8130.5"
        y2="875.567"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp899-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp899-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp901-fill"
        x1="7890.57"
        y1="1118.47"
        x2="8131.98"
        y2="877.055"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp901-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp901-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp902-fill"
        x1="7816.3"
        y1="1044.19"
        x2="8057.71"
        y2="802.783"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp902-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp902-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp903-fill"
        x1="7826.67"
        y1="1054.56"
        x2="8068.08"
        y2="813.152"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp903-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp903-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp904-fill"
        x1="7935.87"
        y1="987.516"
        x2="8126.48"
        y2="757.72"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp904-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp904-fill-1" offset="53.65%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp904-fill-2" offset="100%" stop-color="#0075b8" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp908-fill"
        x1="8047.86"
        y1="937.807"
        x2="8231.73"
        y2="1034.01"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp908-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp908-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp910-fill"
        x1="7999.82"
        y1="965.97"
        x2="8183.69"
        y2="1062.18"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp910-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp910-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp912-fill"
        x1="7398.8"
        y1="1181.6"
        x2="7582.68"
        y2="1277.8"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp912-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp912-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp915-fill"
        x1="7347.79"
        y1="1208.8"
        x2="7531.66"
        y2="1305.01"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp915-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp915-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp918-fill"
        x1="7296.78"
        y1="1236.01"
        x2="7480.65"
        y2="1332.22"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp918-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp918-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp923-fill"
        x1="7983.31"
        y1="986.527"
        x2="8117.78"
        y2="1056.89"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp923-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp923-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp924-fill"
        x1="7939.41"
        y1="1035.4"
        x2="8073.88"
        y2="1105.76"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp924-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp924-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp930-fill"
        x1="7791.57"
        y1="1083.61"
        x2="7975.44"
        y2="1179.81"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp930-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp930-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp933-fill"
        x1="7670.67"
        y1="1147.67"
        x2="7851.33"
        y2="1242.2"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp933-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp933-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp936-fill"
        x1="7585.66"
        y1="1195.28"
        x2="7766.32"
        y2="1289.8"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp936-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp936-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp939-fill"
        x1="7659.77"
        y1="1190.5"
        x2="7774.14"
        y2="1250.34"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp939-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp939-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp942-fill"
        x1="7459.83"
        y1="1264.99"
        x2="7640.49"
        y2="1359.52"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp942-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp942-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp949-fill"
        x1="7133.82"
        y1="1504.41"
        x2="6709.7"
        y2="1669.37"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp949-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp949-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp950-fill"
        x1="6922.79"
        y1="1528.76"
        x2="7074.51"
        y2="1528.76"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp950-fill-0" offset="0%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp950-fill-1" offset="100%" stop-color="#1a75b4" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp951-fill"
        x1="6861.98"
        y1="1502.52"
        x2="6922.79"
        y2="1502.52"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp951-fill-0" offset="0%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp951-fill-1" offset="100%" stop-color="#1a75b4" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp952-fill"
        x1="6961.8"
        y1="1654.63"
        x2="7117.46"
        y2="1532.59"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp952-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp952-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp953-fill"
        x1="6861.98"
        y1="1535.16"
        x2="7074.51"
        y2="1535.16"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp953-fill-0" offset="0%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp953-fill-1" offset="100%" stop-color="#1a75b4" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp955-fill"
        x1="7039.42"
        y1="1612.31"
        x2="7026.99"
        y2="1619.49"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp955-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp955-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp956-fill"
        x1="7022.09"
        y1="1607.09"
        x2="7035.66"
        y2="1607.09"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp956-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp956-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp957-fill"
        x1="7034.9"
        y1="1614.41"
        x2="7048.38"
        y2="1614.41"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp957-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp957-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp958-fill"
        x1="7019.63"
        y1="1596.16"
        x2="7025.53"
        y2="1596.16"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp958-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp958-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp959-fill"
        x1="7040.22"
        y1="1608.05"
        x2="7046.12"
        y2="1608.05"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp959-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp959-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp962-fill"
        x1="6972.32"
        y1="1668.05"
        x2="7127.98"
        y2="1546.01"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp962-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp962-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp967-fill"
        x1="6923.55"
        y1="1605.84"
        x2="7079.21"
        y2="1483.8"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp967-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp967-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp974-fill"
        x1="7054.61"
        y1="1236.99"
        x2="7237.3"
        y2="1332.57"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp974-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp974-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp978-fill"
        x1="6996.61"
        y1="1271.99"
        x2="7179.3"
        y2="1367.57"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp978-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp978-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp982-fill"
        x1="6906.61"
        y1="1323.99"
        x2="7089.3"
        y2="1419.57"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp982-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp982-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp990-fill"
        x1="7164.34"
        y1="1305.99"
        x2="7347.03"
        y2="1401.57"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp990-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp990-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp994-fill"
        x1="7106.35"
        y1="1340.99"
        x2="7289.03"
        y2="1436.57"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp994-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp994-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp998-fill"
        x1="7016.35"
        y1="1392.99"
        x2="7199.03"
        y2="1488.57"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp998-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp998-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1006-fill"
        x1="7279.61"
        y1="1369.99"
        x2="7462.3"
        y2="1465.57"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1006-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp1006-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1010-fill"
        x1="7221.61"
        y1="1404.99"
        x2="7404.3"
        y2="1500.57"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1010-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp1010-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1014-fill"
        x1="7131.61"
        y1="1456.99"
        x2="7314.3"
        y2="1552.57"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1014-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp1014-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1027-fill"
        x1="3583.29"
        y1="3628.94"
        x2="3773.91"
        y2="3399.15"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1027-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp1027-fill-1" offset="53.65%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp1027-fill-2" offset="100%" stop-color="#0075b8" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1028-fill"
        x1="3590.64"
        y1="3635.03"
        x2="3781.25"
        y2="3405.24"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1028-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp1028-fill-1" offset="53.65%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp1028-fill-2" offset="100%" stop-color="#0075b8" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1029-fill"
        x1="3568.67"
        y1="3616.82"
        x2="3759.28"
        y2="3387.02"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1029-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp1029-fill-1" offset="53.65%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp1029-fill-2" offset="100%" stop-color="#0075b8" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1030-fill"
        x1="3563.04"
        y1="3612.15"
        x2="3753.65"
        y2="3382.35"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1030-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp1030-fill-1" offset="53.65%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp1030-fill-2" offset="100%" stop-color="#0075b8" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1031-fill"
        x1="3561.02"
        y1="3610.47"
        x2="3751.63"
        y2="3380.67"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1031-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp1031-fill-1" offset="53.65%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp1031-fill-2" offset="100%" stop-color="#0075b8" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1032-fill"
        x1="3554.93"
        y1="3605.41"
        x2="3745.54"
        y2="3375.62"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1032-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp1032-fill-1" offset="53.65%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp1032-fill-2" offset="100%" stop-color="#0075b8" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1033-fill"
        x1="3688.51"
        y1="3530.25"
        x2="3662.9"
        y2="3544.84"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1033-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp1033-fill-1" offset="53.6458%" stop-color="#e0e0e0" />
        <stop id="edEvCAwTnKp1033-fill-2" offset="100%" stop-color="#1774b4" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1034-fill"
        x1="3560.25"
        y1="3609.83"
        x2="3750.86"
        y2="3380.03"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1034-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp1034-fill-1" offset="53.65%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp1034-fill-2" offset="100%" stop-color="#0075b8" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1037-fill"
        x1="3467.65"
        y1="3533.03"
        x2="3658.27"
        y2="3303.23"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1037-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp1037-fill-1" offset="53.65%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp1037-fill-2" offset="100%" stop-color="#0075b8" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1042-fill"
        x1="5040.8"
        y1="2639.33"
        x2="4744.71"
        y2="2890.89"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1042-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp1042-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1046-fill"
        x1="5059.22"
        y1="2661.02"
        x2="4763.13"
        y2="2912.58"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1046-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp1046-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1049-fill"
        x1="4901.81"
        y1="2673.6"
        x2="4804.92"
        y2="2875.2"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1049-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp1049-fill-1" offset="53.65%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp1049-fill-2" offset="100%" stop-color="#0075b8" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1050-fill"
        x1="4895.32"
        y1="2670.48"
        x2="4798.42"
        y2="2872.08"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1050-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp1050-fill-1" offset="53.65%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp1050-fill-2" offset="100%" stop-color="#0075b8" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1051-fill"
        x1="5040.8"
        y1="2639.33"
        x2="4744.71"
        y2="2890.89"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1051-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp1051-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1052-fill"
        x1="4927.29"
        y1="2685.84"
        x2="4830.4"
        y2="2887.45"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1052-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp1052-fill-1" offset="53.65%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp1052-fill-2" offset="100%" stop-color="#0075b8" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1054-fill"
        x1="4866.49"
        y1="2656.62"
        x2="4769.6"
        y2="2858.23"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1054-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp1054-fill-1" offset="53.65%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp1054-fill-2" offset="100%" stop-color="#0075b8" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1055-fill"
        x1="5059.22"
        y1="2661.02"
        x2="4763.13"
        y2="2912.58"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1055-fill-0" offset="0%" stop-color="#005289" />
        <stop id="edEvCAwTnKp1055-fill-1" offset="100%" stop-color="#142b44" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1056-fill"
        x1="4951"
        y1="2697.24"
        x2="4854.1"
        y2="2898.84"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1056-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp1056-fill-1" offset="53.65%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp1056-fill-2" offset="100%" stop-color="#0075b8" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1070-fill"
        x1="5392.79"
        y1="2439.55"
        x2="5256.78"
        y2="2680.12"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1070-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp1070-fill-1" offset="53.65%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp1070-fill-2" offset="100%" stop-color="#0075b8" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1071-fill"
        x1="5385.56"
        y1="2435.47"
        x2="5249.56"
        y2="2676.03"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1071-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp1071-fill-1" offset="53.65%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp1071-fill-2" offset="100%" stop-color="#0075b8" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1072-fill"
        x1="5377.88"
        y1="2431.13"
        x2="5241.87"
        y2="2671.69"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1072-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp1072-fill-1" offset="53.65%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp1072-fill-2" offset="100%" stop-color="#0075b8" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1073-fill"
        x1="5350.38"
        y1="2415.58"
        x2="5214.38"
        y2="2656.14"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1073-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp1073-fill-1" offset="53.65%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp1073-fill-2" offset="100%" stop-color="#0075b8" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1074-fill"
        x1="5362.98"
        y1="2422.7"
        x2="5226.97"
        y2="2663.26"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1074-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp1074-fill-1" offset="53.65%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp1074-fill-2" offset="100%" stop-color="#0075b8" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1075-fill"
        x1="5349.97"
        y1="2415.35"
        x2="5213.96"
        y2="2655.91"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1075-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp1075-fill-1" offset="53.65%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp1075-fill-2" offset="100%" stop-color="#0075b8" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1076-fill"
        x1="5336.52"
        y1="2407.74"
        x2="5200.52"
        y2="2648.31"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1076-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp1076-fill-1" offset="53.65%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp1076-fill-2" offset="100%" stop-color="#0075b8" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1077-fill"
        x1="5355.75"
        y1="2418.61"
        x2="5219.75"
        y2="2659.18"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1077-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp1077-fill-1" offset="53.65%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp1077-fill-2" offset="100%" stop-color="#0075b8" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1079-fill"
        x1="5328.89"
        y1="2403.42"
        x2="5192.88"
        y2="2643.99"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1079-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp1079-fill-1" offset="53.65%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp1079-fill-2" offset="100%" stop-color="#0075b8" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1094-fill"
        x1="4187.31"
        y1="3027.62"
        x2="4097.76"
        y2="3253.18"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1094-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp1094-fill-1" offset="53.65%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp1094-fill-2" offset="100%" stop-color="#0075b8" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1095-fill"
        x1="4170.49"
        y1="3020.95"
        x2="4080.94"
        y2="3246.5"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1095-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp1095-fill-1" offset="53.65%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp1095-fill-2" offset="100%" stop-color="#0075b8" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1096-fill"
        x1="4160.38"
        y1="3016.94"
        x2="4070.84"
        y2="3242.49"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1096-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp1096-fill-1" offset="53.65%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp1096-fill-2" offset="100%" stop-color="#0075b8" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1097-fill"
        x1="4149.38"
        y1="3012.57"
        x2="4059.84"
        y2="3238.13"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1097-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp1097-fill-1" offset="53.65%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp1097-fill-2" offset="100%" stop-color="#0075b8" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1098-fill"
        x1="4133.9"
        y1="3006.42"
        x2="4044.36"
        y2="3231.98"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1098-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp1098-fill-1" offset="53.65%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp1098-fill-2" offset="100%" stop-color="#0075b8" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1099-fill"
        x1="4101.36"
        y1="2993.51"
        x2="4011.82"
        y2="3219.06"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1099-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp1099-fill-1" offset="53.65%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp1099-fill-2" offset="100%" stop-color="#0075b8" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1100-fill"
        x1="4381.25"
        y1="2952.81"
        x2="4280.53"
        y2="3124.53"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1100-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp1100-fill-1" offset="53.65%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp1100-fill-2" offset="100%" stop-color="#0075b8" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1101-fill"
        x1="4373.94"
        y1="2948.52"
        x2="4273.22"
        y2="3120.24"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1101-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp1101-fill-1" offset="53.65%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp1101-fill-2" offset="100%" stop-color="#0075b8" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1102-fill"
        x1="4369.17"
        y1="2945.73"
        x2="4268.45"
        y2="3117.45"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1102-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp1102-fill-1" offset="53.65%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp1102-fill-2" offset="100%" stop-color="#0075b8" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1103-fill"
        x1="4363.14"
        y1="2942.19"
        x2="4262.42"
        y2="3113.91"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1103-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp1103-fill-1" offset="53.65%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp1103-fill-2" offset="100%" stop-color="#0075b8" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1104-fill"
        x1="4348.98"
        y1="2933.89"
        x2="4248.26"
        y2="3105.6"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1104-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp1104-fill-1" offset="53.65%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp1104-fill-2" offset="100%" stop-color="#0075b8" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1105-fill"
        x1="4339.07"
        y1="2928.07"
        x2="4238.35"
        y2="3099.79"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1105-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp1105-fill-1" offset="53.65%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp1105-fill-2" offset="100%" stop-color="#0075b8" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1108-fill"
        x1="6069.2"
        y1="1954"
        x2="5941.24"
        y2="2121.5"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1108-fill-0" offset="0%" stop-color="#1674b4" />
        <stop id="edEvCAwTnKp1108-fill-1" offset="30.3%" stop-color="#1674b4" />
        <stop id="edEvCAwTnKp1108-fill-2" offset="52.73%" stop-color="#0075b8" />
        <stop id="edEvCAwTnKp1108-fill-3" offset="78.79%" stop-color="#003455" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1109-fill"
        x1="6085.27"
        y1="1966.28"
        x2="5957.32"
        y2="2133.78"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1109-fill-0" offset="0%" stop-color="#1674b4" />
        <stop id="edEvCAwTnKp1109-fill-1" offset="30.3%" stop-color="#1674b4" />
        <stop id="edEvCAwTnKp1109-fill-2" offset="52.73%" stop-color="#0075b8" />
        <stop id="edEvCAwTnKp1109-fill-3" offset="78.79%" stop-color="#003455" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1110-fill"
        x1="6107.44"
        y1="1983.21"
        x2="5979.48"
        y2="2150.71"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1110-fill-0" offset="0%" stop-color="#1674b4" />
        <stop id="edEvCAwTnKp1110-fill-1" offset="30.3%" stop-color="#1674b4" />
        <stop id="edEvCAwTnKp1110-fill-2" offset="52.73%" stop-color="#0075b8" />
        <stop id="edEvCAwTnKp1110-fill-3" offset="78.79%" stop-color="#003455" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1111-fill"
        x1="6053.97"
        y1="1942.37"
        x2="5926.02"
        y2="2109.88"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1111-fill-0" offset="0%" stop-color="#1674b4" />
        <stop id="edEvCAwTnKp1111-fill-1" offset="30.3%" stop-color="#1674b4" />
        <stop id="edEvCAwTnKp1111-fill-2" offset="52.73%" stop-color="#0075b8" />
        <stop id="edEvCAwTnKp1111-fill-3" offset="78.79%" stop-color="#003455" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1113-fill"
        x1="6036.66"
        y1="1929.15"
        x2="5908.71"
        y2="2096.65"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1113-fill-0" offset="0%" stop-color="#1674b4" />
        <stop id="edEvCAwTnKp1113-fill-1" offset="30.3%" stop-color="#1674b4" />
        <stop id="edEvCAwTnKp1113-fill-2" offset="52.73%" stop-color="#0075b8" />
        <stop id="edEvCAwTnKp1113-fill-3" offset="78.79%" stop-color="#003455" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1114-fill"
        x1="6087"
        y1="1967.6"
        x2="5959.05"
        y2="2135.11"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1114-fill-0" offset="0%" stop-color="#1674b4" />
        <stop id="edEvCAwTnKp1114-fill-1" offset="30.3%" stop-color="#1674b4" />
        <stop id="edEvCAwTnKp1114-fill-2" offset="52.73%" stop-color="#0075b8" />
        <stop id="edEvCAwTnKp1114-fill-3" offset="78.79%" stop-color="#003455" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1116-fill"
        x1="6018.09"
        y1="1914.96"
        x2="5890.13"
        y2="2082.46"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1116-fill-0" offset="0%" stop-color="#1674b4" />
        <stop id="edEvCAwTnKp1116-fill-1" offset="30.3%" stop-color="#1674b4" />
        <stop id="edEvCAwTnKp1116-fill-2" offset="52.73%" stop-color="#0075b8" />
        <stop id="edEvCAwTnKp1116-fill-3" offset="78.79%" stop-color="#003455" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1117-fill"
        x1="6043.34"
        y1="1934.25"
        x2="5915.38"
        y2="2101.75"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1117-fill-0" offset="0%" stop-color="#1674b4" />
        <stop id="edEvCAwTnKp1117-fill-1" offset="30.3%" stop-color="#1674b4" />
        <stop id="edEvCAwTnKp1117-fill-2" offset="52.73%" stop-color="#0075b8" />
        <stop id="edEvCAwTnKp1117-fill-3" offset="78.79%" stop-color="#003455" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1118-fill"
        x1="6073.03"
        y1="1956.92"
        x2="5945.07"
        y2="2124.43"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1118-fill-0" offset="0%" stop-color="#1674b4" />
        <stop id="edEvCAwTnKp1118-fill-1" offset="30.3%" stop-color="#1674b4" />
        <stop id="edEvCAwTnKp1118-fill-2" offset="52.73%" stop-color="#0075b8" />
        <stop id="edEvCAwTnKp1118-fill-3" offset="78.79%" stop-color="#003455" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1119-fill"
        x1="6092.72"
        y1="1971.97"
        x2="5964.76"
        y2="2139.47"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1119-fill-0" offset="0%" stop-color="#1674b4" />
        <stop id="edEvCAwTnKp1119-fill-1" offset="30.3%" stop-color="#1674b4" />
        <stop id="edEvCAwTnKp1119-fill-2" offset="52.73%" stop-color="#0075b8" />
        <stop id="edEvCAwTnKp1119-fill-3" offset="78.79%" stop-color="#003455" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1122-fill"
        x1="5899.66"
        y1="2011.34"
        x2="5774.98"
        y2="2196.09"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1122-fill-0" offset="0%" stop-color="#1674b4" />
        <stop id="edEvCAwTnKp1122-fill-1" offset="30.3%" stop-color="#1674b4" />
        <stop id="edEvCAwTnKp1122-fill-2" offset="52.73%" stop-color="#0075b8" />
        <stop id="edEvCAwTnKp1122-fill-3" offset="78.79%" stop-color="#003455" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1123-fill"
        x1="5918.1"
        y1="2023.78"
        x2="5793.42"
        y2="2208.53"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1123-fill-0" offset="0%" stop-color="#1674b4" />
        <stop id="edEvCAwTnKp1123-fill-1" offset="30.3%" stop-color="#1674b4" />
        <stop id="edEvCAwTnKp1123-fill-2" offset="52.73%" stop-color="#0075b8" />
        <stop id="edEvCAwTnKp1123-fill-3" offset="78.79%" stop-color="#003455" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1125-fill"
        x1="5905.9"
        y1="2015.55"
        x2="5781.22"
        y2="2200.3"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1125-fill-0" offset="0%" stop-color="#1674b4" />
        <stop id="edEvCAwTnKp1125-fill-1" offset="30.3%" stop-color="#1674b4" />
        <stop id="edEvCAwTnKp1125-fill-2" offset="52.73%" stop-color="#0075b8" />
        <stop id="edEvCAwTnKp1125-fill-3" offset="78.79%" stop-color="#003455" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1126-fill"
        x1="5926.99"
        y1="2029.78"
        x2="5802.31"
        y2="2214.53"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1126-fill-0" offset="0%" stop-color="#1674b4" />
        <stop id="edEvCAwTnKp1126-fill-1" offset="30.3%" stop-color="#1674b4" />
        <stop id="edEvCAwTnKp1126-fill-2" offset="52.73%" stop-color="#0075b8" />
        <stop id="edEvCAwTnKp1126-fill-3" offset="78.79%" stop-color="#003455" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1128-fill"
        x1="5905.61"
        y1="2015.35"
        x2="5780.93"
        y2="2200.1"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1128-fill-0" offset="0%" stop-color="#1674b4" />
        <stop id="edEvCAwTnKp1128-fill-1" offset="30.3%" stop-color="#1674b4" />
        <stop id="edEvCAwTnKp1128-fill-2" offset="52.73%" stop-color="#0075b8" />
        <stop id="edEvCAwTnKp1128-fill-3" offset="78.79%" stop-color="#003455" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1129-fill"
        x1="5897.84"
        y1="2010.11"
        x2="5773.16"
        y2="2194.86"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1129-fill-0" offset="0%" stop-color="#1674b4" />
        <stop id="edEvCAwTnKp1129-fill-1" offset="30.3%" stop-color="#1674b4" />
        <stop id="edEvCAwTnKp1129-fill-2" offset="52.73%" stop-color="#0075b8" />
        <stop id="edEvCAwTnKp1129-fill-3" offset="78.79%" stop-color="#003455" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1130-fill"
        x1="5928.92"
        y1="2031.09"
        x2="5804.24"
        y2="2215.84"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1130-fill-0" offset="0%" stop-color="#1674b4" />
        <stop id="edEvCAwTnKp1130-fill-1" offset="30.3%" stop-color="#1674b4" />
        <stop id="edEvCAwTnKp1130-fill-2" offset="52.73%" stop-color="#0075b8" />
        <stop id="edEvCAwTnKp1130-fill-3" offset="78.79%" stop-color="#003455" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1134-fill"
        x1="5740.5"
        y1="2180.57"
        x2="5656.65"
        y2="2268.13"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1134-fill-0" offset="0%" stop-color="#1674b4" />
        <stop id="edEvCAwTnKp1134-fill-1" offset="30.3%" stop-color="#1674b4" />
        <stop id="edEvCAwTnKp1134-fill-2" offset="52.73%" stop-color="#0075b8" />
        <stop id="edEvCAwTnKp1134-fill-3" offset="78.79%" stop-color="#003455" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1135-fill"
        x1="5754.1"
        y1="2193.58"
        x2="5670.25"
        y2="2281.15"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1135-fill-0" offset="0%" stop-color="#1674b4" />
        <stop id="edEvCAwTnKp1135-fill-1" offset="30.3%" stop-color="#1674b4" />
        <stop id="edEvCAwTnKp1135-fill-2" offset="52.73%" stop-color="#0075b8" />
        <stop id="edEvCAwTnKp1135-fill-3" offset="78.79%" stop-color="#003455" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1136-fill"
        x1="5770.86"
        y1="2209.64"
        x2="5687.01"
        y2="2297.2"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1136-fill-0" offset="0%" stop-color="#1674b4" />
        <stop id="edEvCAwTnKp1136-fill-1" offset="30.3%" stop-color="#1674b4" />
        <stop id="edEvCAwTnKp1136-fill-2" offset="52.73%" stop-color="#0075b8" />
        <stop id="edEvCAwTnKp1136-fill-3" offset="78.79%" stop-color="#003455" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1137-fill"
        x1="5726.68"
        y1="2167.33"
        x2="5642.83"
        y2="2254.89"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1137-fill-0" offset="0%" stop-color="#1674b4" />
        <stop id="edEvCAwTnKp1137-fill-1" offset="30.3%" stop-color="#1674b4" />
        <stop id="edEvCAwTnKp1137-fill-2" offset="52.73%" stop-color="#0075b8" />
        <stop id="edEvCAwTnKp1137-fill-3" offset="78.79%" stop-color="#003455" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1139-fill"
        x1="5728.78"
        y1="2169.34"
        x2="5644.93"
        y2="2256.9"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1139-fill-0" offset="0%" stop-color="#1674b4" />
        <stop id="edEvCAwTnKp1139-fill-1" offset="30.3%" stop-color="#1674b4" />
        <stop id="edEvCAwTnKp1139-fill-2" offset="52.73%" stop-color="#0075b8" />
        <stop id="edEvCAwTnKp1139-fill-3" offset="78.79%" stop-color="#003455" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1140-fill"
        x1="5714.68"
        y1="2155.84"
        x2="5630.83"
        y2="2243.41"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1140-fill-0" offset="0%" stop-color="#1674b4" />
        <stop id="edEvCAwTnKp1140-fill-1" offset="30.3%" stop-color="#1674b4" />
        <stop id="edEvCAwTnKp1140-fill-2" offset="52.73%" stop-color="#0075b8" />
        <stop id="edEvCAwTnKp1140-fill-3" offset="78.79%" stop-color="#003455" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1142-fill"
        x1="5716.17"
        y1="2157.26"
        x2="5632.32"
        y2="2244.83"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1142-fill-0" offset="0%" stop-color="#1674b4" />
        <stop id="edEvCAwTnKp1142-fill-1" offset="30.3%" stop-color="#1674b4" />
        <stop id="edEvCAwTnKp1142-fill-2" offset="52.73%" stop-color="#0075b8" />
        <stop id="edEvCAwTnKp1142-fill-3" offset="78.79%" stop-color="#003455" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1143-fill"
        x1="5705.22"
        y1="2146.78"
        x2="5621.37"
        y2="2234.35"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1143-fill-0" offset="0%" stop-color="#1674b4" />
        <stop id="edEvCAwTnKp1143-fill-1" offset="30.3%" stop-color="#1674b4" />
        <stop id="edEvCAwTnKp1143-fill-2" offset="52.73%" stop-color="#0075b8" />
        <stop id="edEvCAwTnKp1143-fill-3" offset="78.79%" stop-color="#003455" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1144-fill"
        x1="5732.55"
        y1="2172.95"
        x2="5648.7"
        y2="2260.52"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1144-fill-0" offset="0%" stop-color="#1674b4" />
        <stop id="edEvCAwTnKp1144-fill-1" offset="30.3%" stop-color="#1674b4" />
        <stop id="edEvCAwTnKp1144-fill-2" offset="52.73%" stop-color="#0075b8" />
        <stop id="edEvCAwTnKp1144-fill-3" offset="78.79%" stop-color="#003455" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1148-fill"
        x1="6069.36"
        y1="1954.26"
        x2="5941.41"
        y2="2121.77"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1148-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp1148-fill-1" offset="30.3%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp1148-fill-2" offset="52.73%" stop-color="#0075b8" />
        <stop id="edEvCAwTnKp1148-fill-3" offset="78.79%" stop-color="#003455" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1149-fill"
        x1="6085.43"
        y1="1966.54"
        x2="5957.48"
        y2="2134.04"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1149-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp1149-fill-1" offset="30.3%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp1149-fill-2" offset="52.73%" stop-color="#0075b8" />
        <stop id="edEvCAwTnKp1149-fill-3" offset="78.79%" stop-color="#003455" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1150-fill"
        x1="6107.6"
        y1="1983.47"
        x2="5979.65"
        y2="2150.98"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1150-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp1150-fill-1" offset="30.3%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp1150-fill-2" offset="52.73%" stop-color="#0075b8" />
        <stop id="edEvCAwTnKp1150-fill-3" offset="78.79%" stop-color="#003455" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1151-fill"
        x1="6054.14"
        y1="1942.64"
        x2="5926.19"
        y2="2110.14"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1151-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp1151-fill-1" offset="30.3%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp1151-fill-2" offset="52.73%" stop-color="#0075b8" />
        <stop id="edEvCAwTnKp1151-fill-3" offset="78.79%" stop-color="#003455" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1153-fill"
        x1="6036.83"
        y1="1929.41"
        x2="5908.87"
        y2="2096.91"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1153-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp1153-fill-1" offset="30.3%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp1153-fill-2" offset="52.73%" stop-color="#0075b8" />
        <stop id="edEvCAwTnKp1153-fill-3" offset="78.79%" stop-color="#003455" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1154-fill"
        x1="6087.17"
        y1="1967.87"
        x2="5959.22"
        y2="2135.37"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1154-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp1154-fill-1" offset="30.3%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp1154-fill-2" offset="52.73%" stop-color="#0075b8" />
        <stop id="edEvCAwTnKp1154-fill-3" offset="78.79%" stop-color="#003455" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1156-fill"
        x1="6018.25"
        y1="1915.22"
        x2="5890.3"
        y2="2082.73"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1156-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp1156-fill-1" offset="30.3%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp1156-fill-2" offset="52.73%" stop-color="#0075b8" />
        <stop id="edEvCAwTnKp1156-fill-3" offset="78.79%" stop-color="#003455" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1157-fill"
        x1="6043.51"
        y1="1934.51"
        x2="5915.55"
        y2="2102.02"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1157-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp1157-fill-1" offset="30.3%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp1157-fill-2" offset="52.73%" stop-color="#0075b8" />
        <stop id="edEvCAwTnKp1157-fill-3" offset="78.79%" stop-color="#003455" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1158-fill"
        x1="6073.19"
        y1="1957.19"
        x2="5945.24"
        y2="2124.69"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1158-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp1158-fill-1" offset="30.3%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp1158-fill-2" offset="52.73%" stop-color="#0075b8" />
        <stop id="edEvCAwTnKp1158-fill-3" offset="78.79%" stop-color="#003455" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1159-fill"
        x1="6092.88"
        y1="1972.23"
        x2="5964.93"
        y2="2139.73"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1159-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp1159-fill-1" offset="30.3%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp1159-fill-2" offset="52.73%" stop-color="#0075b8" />
        <stop id="edEvCAwTnKp1159-fill-3" offset="78.79%" stop-color="#003455" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1162-fill"
        x1="5918.27"
        y1="2024.04"
        x2="5793.59"
        y2="2208.8"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1162-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp1162-fill-1" offset="30.3%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp1162-fill-2" offset="52.73%" stop-color="#0075b8" />
        <stop id="edEvCAwTnKp1162-fill-3" offset="78.79%" stop-color="#003455" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1164-fill"
        x1="5906.07"
        y1="2015.81"
        x2="5781.39"
        y2="2200.57"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1164-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp1164-fill-1" offset="30.3%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp1164-fill-2" offset="52.73%" stop-color="#0075b8" />
        <stop id="edEvCAwTnKp1164-fill-3" offset="78.79%" stop-color="#003455" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1165-fill"
        x1="5927.15"
        y1="2030.04"
        x2="5802.47"
        y2="2214.79"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1165-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp1165-fill-1" offset="30.3%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp1165-fill-2" offset="52.73%" stop-color="#0075b8" />
        <stop id="edEvCAwTnKp1165-fill-3" offset="78.79%" stop-color="#003455" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1167-fill"
        x1="5905.77"
        y1="2015.62"
        x2="5781.1"
        y2="2200.36"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1167-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp1167-fill-1" offset="30.3%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp1167-fill-2" offset="52.73%" stop-color="#0075b8" />
        <stop id="edEvCAwTnKp1167-fill-3" offset="78.79%" stop-color="#003455" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1168-fill"
        x1="5929.09"
        y1="2031.35"
        x2="5804.41"
        y2="2216.1"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1168-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp1168-fill-1" offset="30.3%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp1168-fill-2" offset="52.73%" stop-color="#0075b8" />
        <stop id="edEvCAwTnKp1168-fill-3" offset="78.79%" stop-color="#003455" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1169-fill"
        x1="5936.73"
        y1="2054.44"
        x2="5868.49"
        y2="2228.15"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1169-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp1169-fill-1" offset="53.65%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp1169-fill-2" offset="100%" stop-color="#0075b8" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1171-fill"
        x1="5899.83"
        y1="2011.6"
        x2="5775.15"
        y2="2196.36"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1171-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp1171-fill-1" offset="30.3%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp1171-fill-2" offset="52.73%" stop-color="#0075b8" />
        <stop id="edEvCAwTnKp1171-fill-3" offset="78.79%" stop-color="#003455" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1172-fill"
        x1="5898.01"
        y1="2010.37"
        x2="5773.33"
        y2="2195.12"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1172-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp1172-fill-1" offset="30.3%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp1172-fill-2" offset="52.73%" stop-color="#0075b8" />
        <stop id="edEvCAwTnKp1172-fill-3" offset="78.79%" stop-color="#003455" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1174-fill"
        x1="5740.67"
        y1="2180.83"
        x2="5656.82"
        y2="2268.39"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1174-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp1174-fill-1" offset="30.3%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp1174-fill-2" offset="52.73%" stop-color="#0075b8" />
        <stop id="edEvCAwTnKp1174-fill-3" offset="78.79%" stop-color="#003455" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1175-fill"
        x1="5754.26"
        y1="2193.85"
        x2="5670.41"
        y2="2281.41"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1175-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp1175-fill-1" offset="30.3%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp1175-fill-2" offset="52.73%" stop-color="#0075b8" />
        <stop id="edEvCAwTnKp1175-fill-3" offset="78.79%" stop-color="#003455" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1176-fill"
        x1="5771.03"
        y1="2209.9"
        x2="5687.18"
        y2="2297.46"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1176-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp1176-fill-1" offset="30.3%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp1176-fill-2" offset="52.73%" stop-color="#0075b8" />
        <stop id="edEvCAwTnKp1176-fill-3" offset="78.79%" stop-color="#003455" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1177-fill"
        x1="5726.84"
        y1="2167.59"
        x2="5642.99"
        y2="2255.16"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1177-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp1177-fill-1" offset="30.3%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp1177-fill-2" offset="52.73%" stop-color="#0075b8" />
        <stop id="edEvCAwTnKp1177-fill-3" offset="78.79%" stop-color="#003455" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1179-fill"
        x1="5728.94"
        y1="2169.6"
        x2="5645.09"
        y2="2257.17"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1179-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp1179-fill-1" offset="30.3%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp1179-fill-2" offset="52.73%" stop-color="#0075b8" />
        <stop id="edEvCAwTnKp1179-fill-3" offset="78.79%" stop-color="#003455" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1180-fill"
        x1="5714.85"
        y1="2156.11"
        x2="5631"
        y2="2243.67"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1180-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp1180-fill-1" offset="30.3%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp1180-fill-2" offset="52.73%" stop-color="#0075b8" />
        <stop id="edEvCAwTnKp1180-fill-3" offset="78.79%" stop-color="#003455" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1182-fill"
        x1="5716.33"
        y1="2157.53"
        x2="5632.49"
        y2="2245.09"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1182-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp1182-fill-1" offset="30.3%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp1182-fill-2" offset="52.73%" stop-color="#0075b8" />
        <stop id="edEvCAwTnKp1182-fill-3" offset="78.79%" stop-color="#003455" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1183-fill"
        x1="5705.39"
        y1="2147.05"
        x2="5621.54"
        y2="2234.61"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1183-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp1183-fill-1" offset="30.3%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp1183-fill-2" offset="52.73%" stop-color="#0075b8" />
        <stop id="edEvCAwTnKp1183-fill-3" offset="78.79%" stop-color="#003455" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1184-fill"
        x1="5732.72"
        y1="2173.22"
        x2="5648.87"
        y2="2260.78"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1184-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp1184-fill-1" offset="30.3%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp1184-fill-2" offset="52.73%" stop-color="#0075b8" />
        <stop id="edEvCAwTnKp1184-fill-3" offset="78.79%" stop-color="#003455" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1187-fill"
        x1="6682"
        y1="1579.16"
        x2="6451.87"
        y2="1908.81"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1187-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp1187-fill-1" offset="53.65%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp1187-fill-2" offset="100%" stop-color="#0075b8" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1193-fill"
        x1="6928.76"
        y1="1554.28"
        x2="7007.72"
        y2="1637.78"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1193-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp1193-fill-1" offset="49.09%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp1193-fill-2" offset="100%" stop-color="#1a75b4" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1194-fill"
        x1="6936.59"
        y1="1546.87"
        x2="7015.55"
        y2="1630.37"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1194-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp1194-fill-1" offset="49.09%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp1194-fill-2" offset="100%" stop-color="#1a75b4" />
      </linearGradient>
      <linearGradient
        id="edEvCAwTnKp1195-fill"
        x1="6954.09"
        y1="1530.32"
        x2="7033.06"
        y2="1613.82"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0 0)"
      >
        <stop id="edEvCAwTnKp1195-fill-0" offset="0%" stop-color="#fff" />
        <stop id="edEvCAwTnKp1195-fill-1" offset="49.09%" stop-color="#e0dfe0" />
        <stop id="edEvCAwTnKp1195-fill-2" offset="100%" stop-color="#1a75b4" />
      </linearGradient>
    </defs>
    <path
      d="M817,0.119019L0,488h817v-487.880981Z"
      transform="translate(0 132)"
      fill="url(#edEvCAwTnKp2-fill)"
    />
    <g id="edEvCAwTnKp3" transform="translate(-2181-3526)">
      <path
        d="M3765.4,3501.07l-434.05,20.62v3.5c0,2.73,1.81,5.46,5.42,7.55l179.15,103.06c7.23,4.17,18.93,4.17,26.16,0l217.9-123.67c3.62-2.08,5.42-4.82,5.42-7.55v-3.51Z"
        fill="#1674b4"
      />
      <path
        d="M5019.67,2917.05l-295.66-55.8v3.5c0,2.73,1.81,5.46,5.42,7.55l176.48,103.01c7.23,4.17,18.93,4.17,26.16,0l82.18-47.2c3.62-2.08,5.42-4.81,5.42-7.55v-3.51Z"
        fill="#1674b4"
      />
      <path
        d="M4932.08,2971.75l82.17-47.2c7.23-4.16,7.24-10.93.01-15.1L4837.8,2806.44c-7.22-4.17-18.94-4.17-26.16,0l-82.2,47.19c-7.23,4.17-7.23,10.94,0,15.11l176.48,103.01c7.22,4.17,18.93,4.17,26.16,0Z"
        fill="#005289"
      />
      <path
        d="M6531.78,1929.93l-628.47,263.58v3.5c0,2.73,1.8,5.46,5.42,7.55l62.82,36.27c7.22,4.17,18.93,4.17,26.16,0l528.65-299.84c3.62-2.08,5.42-4.82,5.42-7.55v-3.51Z"
        fill="#1674b4"
      />
      <path
        d="M6639.72,1996.64l-238.7-14.99v3.5c0,2.72,1.81,5.46,5.42,7.55l112.34,68.43c7.22,4.17,18.93,4.17,26.16,0l89.36-53.42c3.61-2.09,5.42-4.82,5.42-7.56v-3.51Z"
        fill="#1674b4"
      />
      <path
        d="M6544.95,2057.57l89.35-53.43c7.23-4.16,7.23-10.93,0-15.1l-112.31-68.43c-7.22-4.17-18.94-4.17-26.16-.01l-89.38,53.43c-7.22,4.17-7.23,10.93,0,15.11l112.33,68.43c7.22,4.17,18.94,4.17,26.17,0Z"
        fill="#005289"
      />
      <path
        d="M5997.71,2238.08l528.65-299.84c7.23-4.17,7.23-10.93.01-15.1l-62.8-36.28c-7.22-4.17-18.94-4.17-26.16,0L5908.74,2186.7c-7.23,4.17-7.24,10.93-.01,15.1l62.83,36.28c7.21,4.16,18.93,4.16,26.15,0Z"
        fill="#005289"
      />
      <path
        d="M6416.46,1886.76l69.6,40.71v17.66l-69.6-40.72v-17.65Z"
        fill="url(#edEvCAwTnKp11-fill)"
      />
      <path d="M6486.06,1927.47l34.18-19.53v17.66l-34.18,19.53v-17.66Z" fill="#1674b4" />
      <path
        d="M6416.46,1886.76l34.18-19.53l69.6,40.71-34.18,19.53-69.6-40.71Z"
        fill="#005289"
      />
      <path
        d="M4790.68,2860.63l21.31-12.31l64.6,37.3-21.31,12.31-64.6-37.3Z"
        fill="url(#edEvCAwTnKp14-fill)"
      />
      <path
        d="M4797.49,2785.28l-469.19,172.5v3.49c0,2.73,1.81,5.47,5.42,7.55l62.83,36.27c7.22,4.17,18.93,4.17,26.15,0l369.37-208.75c3.61-2.08,5.42-4.82,5.42-7.55v-3.51Z"
        fill="#1674b4"
      />
      <path
        d="M4422.71,3001.54l369.36-208.76c7.23-4.16,7.23-10.93.01-15.1l-62.8-36.27c-7.22-4.17-18.94-4.18-26.16-.01l-369.39,208.76c-7.22,4.17-7.23,10.93,0,15.1l62.82,36.28c7.22,4.16,18.93,4.16,26.16,0Z"
        fill="#005289"
      />
      <path
        d="M4622.18,2759.94l69.6,40.71v33.72l-69.6-40.71v-33.72Z"
        fill="url(#edEvCAwTnKp17-fill)"
      />
      <path d="M4691.78,2800.65l60.88-35.44v33.72l-60.88,35.44v-33.72Z" fill="#1674b4" />
      <path
        d="M4622.18,2759.94l60.88-35.45l69.6,40.72-60.88,35.44-69.6-40.71Z"
        fill="#005289"
      />
      <path
        d="M4522.9,2811.64l69.6,40.72v33.72l-69.6-40.72v-33.72Z"
        fill="url(#edEvCAwTnKp20-fill)"
      />
      <path
        d="M6797.07,1909.02l-162.69,31.19v3.49c0,2.73,1.8,5.47,5.41,7.56l36.35,22.25c7.22,4.17,18.92,4.17,26.15,0l89.36-53.42c3.62-2.09,5.42-4.82,5.42-7.56v-3.51Z"
        fill="#1674b4"
      />
      <path
        d="M6702.3,1969.95l89.35-53.42c7.23-4.17,7.23-10.93.01-15.1l-36.32-22.26c-7.22-4.17-18.94-4.17-26.16,0l-89.38,53.42c-7.22,4.17-7.23,10.94,0,15.11l36.34,22.25c7.22,4.17,18.93,4.17,26.16,0Z"
        fill="#005289"
      />
      <path
        d="M7093.64,1741.31L6782.02,1851.5v3.49c0,2.73,1.8,5.47,5.42,7.56l36.34,22.25c7.22,4.17,18.92,4.17,26.15,0l238.3-132.42c3.61-2.09,5.42-4.82,5.42-7.56l-.01-3.51Z"
        fill="#1674b4"
      />
      <path
        d="M6849.94,1881.24l238.28-132.43c7.23-4.16,7.24-10.93.01-15.1l-36.32-22.25c-7.22-4.17-18.93-4.18-26.16-.01l-238.31,132.43c-7.22,4.17-7.23,10.93,0,15.1l36.34,22.26c7.22,4.17,18.93,4.17,26.16,0Z"
        fill="#005289"
      />
      <path d="M4592.5,2852.36l60.88-35.44v33.72l-60.88,35.44v-33.72Z" fill="#1674b4" />
      <path
        d="M4522.9,2811.64l60.88-35.44l69.6,40.72-60.88,35.44-69.6-40.72Z"
        fill="#005289"
      />
      <path
        d="M6405.58,1870.65l-327.5,93.16v3.49c0,2.73,1.8,5.47,5.42,7.55l62.82,36.27c7.22,4.17,18.93,4.17,26.16,0l227.68-129.4c3.61-2.09,5.42-4.82,5.42-7.56v-3.51Z"
        fill="#1674b4"
      />
      <path
        d="M6172.49,2007.57l227.67-129.42c7.23-4.16,7.23-10.93.01-15.1l-62.8-36.27c-7.22-4.17-18.94-4.17-26.16-.01L6083.5,1956.19c-7.22,4.17-7.23,10.93,0,15.1l62.83,36.28c7.21,4.16,18.93,4.16,26.16,0Z"
        fill="#005289"
      />
      <path
        d="M6860.44,1613.82l-327.5,93.16v3.49c0,2.73,1.81,5.47,5.42,7.56l62.82,36.27c7.23,4.16,18.93,4.16,26.16,0l227.68-129.41c3.62-2.09,5.42-4.82,5.42-7.56v-3.51Z"
        fill="#1674b4"
      />
      <path
        d="M6627.35,1750.74l227.68-129.41c7.22-4.17,7.23-10.94,0-15.11l-62.8-36.27c-7.22-4.17-18.93-4.17-26.16,0l-227.7,129.41c-7.22,4.17-7.23,10.93,0,15.1l62.82,36.28c7.22,4.16,18.93,4.16,26.16,0Z"
        fill="#005289"
      />
      <path
        d="M6992.47,1691.42l-348.41,82.63v3.5c0,2.72,1.81,5.46,5.42,7.55l83.73,46.79c7.23,4.17,18.93,4.17,26.16,0l227.68-129.41c3.62-2.08,5.42-4.81,5.42-7.55v-3.51Z"
        fill="#1674b4"
      />
      <path
        d="M3374.94,3591.74l-327.5,93.16v3.5c0,2.73,1.8,5.46,5.42,7.55l62.82,36.27c7.22,4.17,18.93,4.17,26.16,0l227.68-129.41c3.62-2.08,5.42-4.82,5.42-7.55v-3.52Z"
        fill="#1674b4"
      />
      <path
        d="M3141.84,3728.66l227.68-129.41c7.23-4.17,7.23-10.93.01-15.1l-62.81-36.28c-7.22-4.17-18.93-4.17-26.16,0l-227.7,129.41c-7.22,4.17-7.23,10.94,0,15.11l62.82,36.27c7.22,4.17,18.94,4.17,26.16,0Z"
        fill="#005289"
      />
      <path
        d="M6759.38,1828.34l227.68-129.42c7.22-4.16,7.23-10.93,0-15.1l-83.71-46.8c-7.22-4.17-18.93-4.17-26.16,0l-227.7,129.41c-7.22,4.17-7.23,10.94,0,15.11l83.73,46.8c7.22,4.16,18.93,4.16,26.16,0Z"
        fill="#005289"
      />
      <path
        d="M3960.93,3258.51l-327.5,93.16v3.49c0,2.73,1.81,5.47,5.42,7.55l62.82,36.27c7.23,4.17,18.93,4.17,26.16,0l227.68-129.4c3.62-2.09,5.42-4.82,5.42-7.56v-3.51Z"
        fill="#1674b4"
      />
      <path
        d="M3727.84,3395.43l227.67-129.41c7.23-4.17,7.24-10.94.01-15.11l-62.8-36.27c-7.22-4.17-18.94-4.17-26.16-.01l-227.7,129.42c-7.23,4.17-7.23,10.93,0,15.1l62.82,36.28c7.22,4.16,18.93,4.16,26.16,0Z"
        fill="#005289"
      />
      <path
        d="M6113.78,2036.16l-536.37,211.15v3.49c0,2.73,1.81,5.46,5.42,7.55l62.83,36.27c7.22,4.17,18.93,4.17,26.15,0l436.56-247.39c3.61-2.09,5.41-4.82,5.41-7.56v-3.51Z"
        fill="#1674b4"
      />
      <path
        d="M5671.82,2291.07l436.55-247.4c7.22-4.17,7.23-10.93,0-15.1l-62.8-36.28c-7.22-4.17-18.93-4.17-26.16,0l-436.57,247.4c-7.22,4.16-7.23,10.93,0,15.1l62.82,36.28c7.22,4.16,18.93,4.16,26.16,0Z"
        fill="#005289"
      />
      <path
        d="M4070.59,3327.36l-327.5,93.16v3.5c0,2.72,1.8,5.46,5.42,7.55l62.82,36.27c7.22,4.17,18.93,4.17,26.16,0l227.68-129.41c3.62-2.09,5.42-4.82,5.42-7.55v-3.52Z"
        fill="#1674b4"
      />
      <path
        d="M6707.87,1856.4l-335.53-60.2v3.49c0,2.73,1.8,5.47,5.42,7.56l201.22,114.38c7.23,4.17,18.93,4.17,26.16,0l97.31-54.16c3.62-2.09,5.42-4.82,5.42-7.56v-3.51v0Z"
        fill="#1674b4"
      />
      <path
        d="M3837.49,3464.28l227.68-129.41c7.23-4.17,7.23-10.93.01-15.1l-62.81-36.28c-7.22-4.17-18.93-4.17-26.16,0l-227.7,129.41c-7.22,4.17-7.23,10.94,0,15.11l62.83,36.27c7.21,4.17,18.93,4.17,26.15,0Z"
        fill="#005289"
      />
      <path
        d="M6605.15,1918.08l97.3-54.18c7.23-4.16,7.23-10.93.01-15.1l-201.21-114.14c-7.22-4.18-18.93-4.18-26.16-.01l-97.33,53.93c-7.22,4.17-7.23,10.93,0,15.1l201.23,114.39c7.22,4.17,18.93,4.17,26.16.01Z"
        fill="#005289"
      />
      <path
        d="M5620.02,2316.14l-327.5,93.16v3.49c0,2.73,1.8,5.47,5.42,7.55l62.82,36.28c7.22,4.16,18.93,4.16,26.15,0l227.69-129.41c3.61-2.09,5.42-4.82,5.42-7.56v-3.51Z"
        fill="#1674b4"
      />
      <g>
        <path d="M6490.95,1725.72l-52.97-30.58v80.6l52.97,30.59v-80.61Z" fill="#005289" />
        <path d="M6437.98,1695.14l-35,20.2v80.61l35-20.21v-80.6Z" fill="#005289" />
      </g>
      <path d="M6455.95,1745.93l35-20.21v80.61l-35,20.2v-80.6Z" fill="#005289" />
      <g>
        <path
          d="M6402.98,1715.34l35-20.2l52.97,30.58-35,20.21-52.97-30.59Z"
          fill="#005289"
        />
      </g>
      <path d="M6581.71,1709.03l-35-20.21v96.73l35,20.21v-96.73Z" fill="#005289" />
      <path d="M6546.71,1688.82l-45.87,26.49v96.73l45.87-26.49v-96.73Z" fill="#005289" />
      <path d="M6500.84,1715.31l-9.89-5.71v96.73l9.89,5.71v-96.73Z" fill="#005289" />
      <path d="M6490.95,1709.6l-35,20.21v96.72l35-20.2v-96.73Z" fill="#005289" />
      <path
        d="M6465.84,1735.52l-9.89-5.71v16.12l-52.97-30.59v80.61l52.97,30.58l9.89,5.71l35,20.21v-96.73l-35-20.2Z"
        fill="url(#edEvCAwTnKp54-fill)"
      />
      <path
        d="M6500.84,1755.72l35-20.2l45.87-26.49v96.73l-45.87,26.48-35,20.21v-96.73Z"
        fill="#1674b4"
      />
      <path
        d="M6455.95,1729.81l35-20.21l9.89,5.71l45.87-26.49l35,20.21-45.87,26.49-35,20.2-35-20.2-9.89-5.71Z"
        fill="#005289"
      />
      <path
        d="M5386.92,2453.06l227.68-129.41c7.23-4.17,7.23-10.94.01-15.11l-62.81-36.27c-7.22-4.17-18.93-4.17-26.16,0l-227.7,129.41c-7.22,4.17-7.23,10.93,0,15.1l62.82,36.28c7.22,4.16,18.94,4.16,26.16,0Z"
        fill="#005289"
      />
      <path
        d="M4486.19,3091.71l-563.73,95.61v3.49c0,2.73,1.81,5.47,5.42,7.55l177.77,101.83c7.23,4.17,18.93,4.17,26.16,0l348.97-197.41c3.61-2.09,5.41-4.82,5.41-7.56v-3.51Z"
        fill="#1674b4"
      />
      <path
        d="M3542.09,3632.25l217.89-123.68c7.23-4.16,7.23-10.93.01-15.1l-179.13-103.06c-7.22-4.17-18.94-4.18-26.16-.01l-217.92,123.67c-7.23,4.17-7.23,10.94,0,15.11l179.15,103.06c7.22,4.17,18.93,4.17,26.16.01Z"
        fill="#005289"
      />
      <path
        d="M3487.14,3659.46l-327.5,93.16v3.49c0,2.73,1.81,5.47,5.42,7.56l62.82,36.27c7.23,4.16,18.93,4.16,26.16,0l227.68-129.41c3.62-2.09,5.42-4.82,5.42-7.56v-3.51Z"
        fill="#1674b4"
      />
      <path
        d="M3254.05,3796.38l227.68-129.41c7.23-4.17,7.23-10.94,0-15.11l-62.8-36.27c-7.22-4.17-18.93-4.17-26.16-.01L3165.07,3745c-7.22,4.17-7.23,10.93,0,15.1l62.82,36.28c7.22,4.16,18.93,4.16,26.16,0Z"
        fill="#005289"
      />
      <path
        d="M3202.38,3821.26l-264.37,55.43v3.49c0,2.73,1.8,5.47,5.42,7.56l62.82,36.27c7.22,4.16,18.93,4.16,26.16,0l164.55-91.69c3.61-2.08,5.42-4.82,5.42-7.55v-3.51v0Z"
        fill="#1674b4"
      />
      <path
        d="M3032.42,3920.45l164.54-91.69c7.23-4.16,7.23-10.93.01-15.1l-62.81-36.27c-7.22-4.17-18.93-4.18-26.16-.01l-164.57,91.69c-7.22,4.17-7.23,10.93,0,15.1l62.83,36.28c7.21,4.17,18.93,4.17,26.16,0Z"
        fill="#005289"
      />
      <path
        d="M4131.82,3296.63l348.95-197.42c7.23-4.16,7.24-10.93.01-15.1l-177.75-101.83c-7.22-4.17-18.94-4.17-26.16,0L3927.89,3179.7c-7.23,4.17-7.23,10.93,0,15.1l177.77,101.83c7.22,4.17,18.93,4.17,26.16,0Z"
        fill="#005289"
      />
      <g>
        <path
          d="M5073.47,2627.75l-327.5,93.16v3.49c0,2.73,1.81,5.47,5.42,7.56l62.82,36.27c7.23,4.16,18.93,4.16,26.16,0l227.68-129.41c3.62-2.09,5.42-4.82,5.42-7.56v-3.51Z"
          fill="#1674b4"
        />
        <path
          d="M4840.38,2764.67l227.68-129.41c7.22-4.17,7.23-10.93,0-15.11l-62.8-36.27c-7.22-4.17-18.93-4.17-26.16,0l-227.7,129.41c-7.22,4.17-7.23,10.93,0,15.1l62.82,36.28c7.22,4.16,18.93,4.16,26.16,0Z"
          fill="#005289"
        />
      </g>
      <path
        d="M5566.35,2608.93l-542.2-45.78v3.49c0,2.73,1.81,5.47,5.42,7.56l292.91,166.45c7.23,4.17,18.93,4.17,26.16,0L5560.94,2620c3.61-2.09,5.42-4.82,5.42-7.56l-.01-3.51Z"
        fill="#1674b4"
      />
      <path
        d="M5348.65,2737.1l212.29-120.66c7.23-4.17,7.23-10.93,0-15.11l-292.89-166.45c-7.22-4.18-18.93-4.18-26.16-.01l-212.31,120.66c-7.23,4.17-7.23,10.93-.01,15.1l292.92,166.46c7.22,4.17,18.93,4.17,26.16.01Z"
        fill="#005289"
      />
      <path
        d="M4757.69,2739.99l-5.78,3.33c-.91.53-1.37,1.22-1.37,1.91v110.67c0-.69.46-1.37,1.37-1.9l5.78-3.34v-110.67Z"
        fill="url(#edEvCAwTnKp70-fill)"
      />
      <path d="M4334.29,2943.58l-26.76-15.45v12.88l26.76,15.45v-12.88Z" fill="#005289" />
      <path d="M4307.54,2928.13l-24.5,14.14v12.88l24.5-14.14v-12.88Z" fill="#005289" />
      <path
        d="M4283.04,2942.27l24.5-14.14l26.76,15.45-24.5,14.14-26.76-15.45Z"
        fill="#005289"
      />
      <path
        d="M5200.03,2458.33l126.83,73.23v11.17l-126.83-73.23v-11.17Z"
        fill="url(#edEvCAwTnKp74-fill)"
      />
      <path
        d="M5200.03,2458.33l31.93-18.43l126.83,73.22-31.93,18.44-126.83-73.23Z"
        fill="url(#edEvCAwTnKp75-fill)"
      />
      <path
        d="M5200.03,2413.65l131.55,75.94v44.69l-131.55-75.95v-44.68Z"
        fill="url(#edEvCAwTnKp76-fill)"
      />
      <path
        d="M5200.03,2413.65l31.93-18.44l131.55,75.95-31.93,18.43-131.55-75.94Z"
        fill="#005289"
      />
      <path
        d="M5282.61,2536.58l17.78,10.26v11.17l-17.78-10.26v-11.17Z"
        fill="url(#edEvCAwTnKp78-fill)"
      />
      <path
        d="M5282.61,2536.58l26.47-15.29l17.78,10.27-26.47,15.28-17.78-10.26Z"
        fill="#005289"
      />
      <path
        d="M5257.76,2477.54l24.85,14.35v55.86l-24.85-14.35v-55.86Z"
        fill="url(#edEvCAwTnKp80-fill)"
      />
      <path
        d="M5257.76,2477.54l26.25-15.16l24.86,14.35-26.26,15.16-24.85-14.35Z"
        fill="#005289"
      />
      <path
        d="M5176.29,2512.06l92.17,53.22v11.17l-92.17-53.22v-11.17Z"
        fill="url(#edEvCAwTnKp82-fill)"
      />
      <path
        d="M3172.42,3575.52l62.01,36.47v33.06l-62.01-36.47v-33.06Z"
        fill="url(#edEvCAwTnKp83-fill)"
      />
      <path
        d="M3234.44,3611.99l102.62-59.74v33.06l-102.62,59.74v-33.06Z"
        fill="#1674b4"
      />
      <path
        d="M5176.29,2512.06l31.93-18.43l92.17,53.21-31.93,18.44-92.17-53.22Z"
        fill="url(#edEvCAwTnKp85-fill)"
      />
      <path
        d="M5147.41,2537.22l100.3,42.08v11.17l-100.3-42.07v-11.18Z"
        fill="url(#edEvCAwTnKp86-fill)"
      />
      <path
        d="M5147.41,2537.22l33.38-22.56l87.67,50.62-20.75,14.02-100.3-42.08Z"
        fill="#005289"
      />
      <path
        d="M3172.42,3575.52l102.62-59.74l62.02,36.47-102.63,59.74-62.01-36.47Z"
        fill="#005289"
      />
      <path
        d="M5082.18,2560.42l124,52.01v11.18l-124-52.02v-11.17Z"
        fill="url(#edEvCAwTnKp89-fill)"
      />
      <path
        d="M3078.05,3656.31l54.1,31.64v15.95l-54.1-31.64v-15.95Z"
        fill="url(#edEvCAwTnKp90-fill)"
      />
      <path
        d="M3132.15,3687.95l102.62-59.74v15.95l-102.62,59.74v-15.95Z"
        fill="#1674b4"
      />
      <path
        d="M3078.05,3656.31l102.63-59.74l54.09,31.64-102.62,59.74-54.1-31.64Z"
        fill="#005289"
      />
      <path
        d="M5082.18,2560.42l41.64-33.09l124,52.01-41.64,33.09-124-52.01Z"
        fill="url(#edEvCAwTnKp93-fill)"
      />
      <path
        d="M5176.29,2467.38l96.88,55.93v44.69l-96.88-55.94v-44.68Z"
        fill="url(#edEvCAwTnKp94-fill)"
      />
      <path
        d="M3726.7,3265.33l58.2,34.22v44.69l-58.2-34.22v-44.69Z"
        fill="url(#edEvCAwTnKp95-fill)"
      />
      <path
        d="M3675.46,3296.42l58.21,34.22v44.69l-58.21-34.22v-44.69Z"
        fill="url(#edEvCAwTnKp96-fill)"
      />
      <path
        d="M3675.46,3296.42l31.93-18.43l58.21,34.22-31.93,18.43-58.21-34.22Z"
        fill="#005289"
      />
      <path
        d="M3207.27,3724.22l54.09,31.64v15.94l-54.09-31.64v-15.94Z"
        fill="url(#edEvCAwTnKp98-fill)"
      />
      <path d="M3261.36,3755.3l102.62-59.74v15.94l-102.62,59.74v-15.94Z" fill="#1674b4" />
      <path
        d="M3829.16,3203.15l58.21,34.22v44.69l-58.21-34.22v-44.69Z"
        fill="url(#edEvCAwTnKp100-fill)"
      />
      <path d="M3887.37,3237.37l31.93-18.43v44.68l-31.93,18.44v-44.69Z" fill="#1674b4" />
      <path
        d="M3207.27,3724.22l102.62-59.74l54.09,31.64-102.62,59.74-54.09-31.64Z"
        fill="#005289"
      />
      <path
        d="M3829.16,3203.15l31.94-18.44l58.2,34.23-31.93,18.43-58.21-34.22Z"
        fill="#005289"
      />
      <path
        d="M3336.96,3617.7l58.2,34.22v44.69l-58.2-34.22v-44.69Z"
        fill="url(#edEvCAwTnKp104-fill)"
      />
      <path d="M3395.16,3651.92l31.94-18.43v44.68l-31.94,18.44v-44.69Z" fill="#1674b4" />
      <path
        d="M3336.96,3617.7l31.93-18.44l58.2,34.23-31.93,18.43-58.2-34.22Z"
        fill="#005289"
      />
      <path
        d="M3921.82,3283.9l58.2,34.23v44.68l-58.2-34.22v-44.69Z"
        fill="url(#edEvCAwTnKp107-fill)"
      />
      <path
        d="M3921.82,3283.9l31.93-18.43l58.2,34.22-31.93,18.44-58.2-34.23Z"
        fill="#005289"
      />
      <path
        d="M3777.93,3234.24l58.2,34.22v44.69l-58.2-34.22v-44.69Z"
        fill="url(#edEvCAwTnKp109-fill)"
      />
      <path
        d="M3726.7,3265.33l31.93-18.43l58.2,34.22-31.93,18.43-58.2-34.22Z"
        transform="translate(0 0.47)"
        fill="#005289"
      />
      <path d="M3836.13,3268.46l31.94-18.43v44.68l-31.94,18.44v-44.69Z" fill="#1674b4" />
      <path
        d="M3777.93,3234.24l31.93-18.44l58.21,34.23-31.94,18.43-58.2-34.22Z"
        fill="#005289"
      />
      <path d="M3784.9,3299.55l31.93-18.43v44.68l-31.93,18.44v-44.69Z" fill="#1674b4" />
      <path d="M3733.67,3330.64l31.93-18.43v44.69l-31.93,18.43v-44.69Z" fill="#1674b4" />
      <path
        d="M3769.93,3394.2l61.67-35.37l58.2,34.23-61.66,35.37-58.21-34.23Z"
        fill="#005289"
      />
      <path
        d="M3792.49,3378.08l36.3,21.35v13.84l-36.3-21.34v-13.85Z"
        fill="url(#edEvCAwTnKp116-fill)"
      />
      <path d="M3828.79,3399.43l38.46-22.06v13.84l-38.46,22.06v-13.84Z" fill="#1674b4" />
      <path
        d="M3792.49,3378.08l38.46-22.05l36.3,21.34-38.46,22.06-36.3-21.35Z"
        fill="#005289"
      />
      <path d="M3980.02,3318.13l31.93-18.44v44.69l-31.93,18.43v-44.68Z" fill="#1674b4" />
      <path
        d="M3769.93,3394.2l58.21,34.23v22.19l-58.21-34.22v-22.2Z"
        fill="url(#edEvCAwTnKp120-fill)"
      />
      <path d="M3828.14,3428.43l61.67-35.37v22.19l-61.67,35.37v-22.19Z" fill="#1674b4" />
      <path
        d="M4773.23,2929.54l-327.5,93.16v3.49c0,2.73,1.8,5.47,5.42,7.55l62.82,36.27c7.22,4.17,18.93,4.17,26.16,0l227.68-129.4c3.62-2.09,5.42-4.82,5.42-7.56v-3.51Z"
        fill="#1674b4"
      />
      <path
        d="M4540.14,3066.46l227.67-129.42c7.23-4.16,7.23-10.93.01-15.1l-62.8-36.27c-7.22-4.17-18.94-4.17-26.16-.01l-227.71,129.42c-7.22,4.17-7.23,10.93,0,15.1l62.83,36.28c7.21,4.16,18.93,4.16,26.16,0Z"
        fill="#005289"
      />
      <path
        d="M4641.46,2874.18l58.21,34.22v44.69l-58.21-34.22v-44.69Z"
        fill="url(#edEvCAwTnKp124-fill)"
      />
      <path
        d="M5913.21,2091.59l.07.04v7.05l-.07-.04v-7.05Z"
        fill="url(#edEvCAwTnKp125-fill)"
      />
      <path d="M4699.67,2908.4l31.93-18.43v44.68l-31.93,18.44v-44.69Z" fill="#1674b4" />
      <path
        d="M4641.46,2874.18l31.93-18.44l58.21,34.23-31.93,18.43-58.21-34.22Z"
        fill="#005289"
      />
      <path
        d="M4590.23,2905.27l58.2,34.22v44.69l-58.2-34.22v-44.69Z"
        fill="url(#edEvCAwTnKp128-fill)"
      />
      <path d="M4648.43,2939.49l31.93-18.43v44.68l-31.93,18.44v-44.69Z" fill="#1674b4" />
      <path
        d="M4590.23,2905.27l31.93-18.44l58.2,34.23-31.93,18.43-58.2-34.22Z"
        fill="#005289"
      />
      <path
        d="M4539.07,2935.8l58.21,34.22v44.69l-58.21-34.23v-44.68Z"
        fill="url(#edEvCAwTnKp131-fill)"
      />
      <path d="M4597.28,2970.18l31.93-18.43v44.68l-31.93,18.44v-44.69Z" fill="#1674b4" />
      <path
        d="M4539.07,2935.8l31.94-18.44l58.2,34.23-31.93,18.43-58.21-34.22Z"
        fill="#005289"
      />
      <path
        d="M4486.96,2964.24l58.2,34.22v44.69l-58.2-34.23v-44.68Z"
        fill="url(#edEvCAwTnKp134-fill)"
      />
      <path d="M4545.16,2998.46l31.93-18.44v44.69l-31.93,18.44v-44.69Z" fill="#1674b4" />
      <path
        d="M4486.96,2964.24l31.93-18.44l58.2,34.22-31.93,18.44-58.2-34.22Z"
        fill="#005289"
      />
      <path
        d="M4429.82,2868.52l69.61,40.72v33.72l-69.61-40.72v-33.72Z"
        fill="url(#edEvCAwTnKp137-fill)"
      />
      <path d="M4499.42,2909.24l60.88-35.45v33.73l-60.88,35.44v-33.72Z" fill="#1674b4" />
      <path
        d="M4887.14,2993.58l-327.5,93.16v3.49c0,2.73,1.81,5.47,5.42,7.55l62.82,36.27c7.23,4.17,18.93,4.17,26.16,0l227.68-129.4c3.62-2.09,5.42-4.82,5.42-7.56v-3.51Z"
        fill="#1674b4"
      />
      <path
        d="M4654.05,3130.5l227.67-129.42c7.23-4.16,7.23-10.93.01-15.1l-62.8-36.27c-7.22-4.17-18.94-4.17-26.16-.01l-227.7,129.42c-7.23,4.17-7.23,10.93,0,15.1l62.82,36.28c7.22,4.16,18.93,4.16,26.16,0Z"
        fill="#005289"
      />
      <path
        d="M4755.38,2938.22l58.2,34.22v44.69l-58.2-34.22v-44.69Z"
        fill="url(#edEvCAwTnKp141-fill)"
      />
      <path d="M4813.58,2972.44l31.93-18.43v44.68l-31.93,18.44v-44.69Z" fill="#1674b4" />
      <path
        d="M4755.38,2938.22l31.93-18.44l58.2,34.23-31.93,18.43-58.2-34.22Z"
        fill="#005289"
      />
      <path
        d="M4704.14,2969.31l58.21,34.22v44.69L4704.14,3014v-44.69Z"
        fill="url(#edEvCAwTnKp144-fill)"
      />
      <g transform="translate(2824.865 3532.04025)">
        <g>
          <path
            d="M262.9,218.2L0.4,274.2v3.5c0,2.7,1.8,5.5,5.4,7.6l62.8,36.3c7.2,4.2,18.9,4.2,26.2,0l162.7-92.2c3.6-2.1,5.4-4.8,5.4-7.6v-3.6Z"
            fill="#1674b4"
          />
          <path
            d="M94.8,317.9l162.6-92.2c7.2-4.2,7.2-10.9,0-15.1l-62.8-36.3c-7.2-4.2-18.9-4.2-26.2,0L5.9,266.5c-7.2,4.2-7.2,10.9,0,15.1l62.8,36.3c7.2,4.2,18.9,4.2,26.1,0Z"
            fill="#005289"
          />
          <path d="M132.9,32.4L181.2,4.5l41.2,23.8L173.9,56l-41-23.6Z" fill="#005289" />
          <path
            d="M136.7,24.3l37.1,22.3v9.4L136.7,34.6v-10.3Z"
            fill="url(#edEvCAwTnKp150-fill)"
          />
          <path d="M136.7,24.3L180.5,0.6l36.8,21.2-43.4,24.8-37.2-22.3Z" fill="#005289" />
          <path
            d="M39.9,241.7L111.4,283v14.2L39.9,255.9v-14.2Z"
            fill="url(#edEvCAwTnKp152-fill)"
          />
          <path d="M111.4,283l109.8-63.4v14.2L111.4,297.2v-14.2Z" fill="#1674b4" />
          <path d="M217.3,31.2l5.2-3l7.2,153.6-7.2,21.7-5.2,2.7v-175Z" fill="#1674b4" />
          <path d="M173.9,46.6l43.4-24.8v10.5L173.9,56v-9.4Z" fill="#1674b4" />
          <path
            d="M197.1,33.3l8.9,5.5v184.7l-8.9-5.1v-185.1Z"
            fill="url(#edEvCAwTnKp156-fill)"
          />
          <path d="M206,38.8l11.3-6.5v185.1L206,210.8v-172Z" fill="#1674b4" />
          <path d="M197.1,33.3l11.1-6.4l9.1,5.3L206,38.8l-8.9-5.5Z" fill="#005289" />
          <path
            d="M39.9,241.7l109.8-63.4l71.5,41.3L111.4,283L39.9,241.7Z"
            fill="#005289"
          />
          <g>
            <path
              d="M55.6,237.7c0,1,.7,2,2,2.8l16.2,9.3c2.7,1.5,7,1.5,9.6,0l8.9-5.1c1.3-.8,2-1.8,2-2.8v4.7c0,1-.7,2-2,2.8l-8.9,5.1c-2.7,1.5-7,1.5-9.6,0l-16.2-9.3c-1.3-.8-2-1.8-2-2.8v-4.7Z"
              fill="url(#edEvCAwTnKp161-fill)"
            />
            <path
              d="M55.6,237.7c0-1,.7-2,2-2.8l8.9-5.1c2.7-1.5,7-1.5,9.6,0l16.2,9.3c1.3.8,2,1.8,2,2.8s-.7,2-2,2.8l-8.9,5.1c-2.7,1.5-7,1.5-9.6,0l-16.2-9.3c-1.3-.8-2-1.8-2-2.8Z"
              fill="#005289"
            />
          </g>
          <path
            d="M132.9,32.4l41,23.6v163L133,195.1v-162.7Z"
            fill="url(#edEvCAwTnKp163-fill)"
          />
          <path d="M173.9,46.6v172.4l23.2-13.3v-158.8-4-9.6L173.9,46.6Z" fill="#1674b4" />
        </g>
        <g id="edEvCAwTnKp165" opacity="0">
          <path
            d="M217.3,31.2l5.2-3l7.2,153.6-7.2,21.7-5.2,2.7v-175Z"
            fill="url(#edEvCAwTnKp166-fill)"
          />
          <path
            d="M173.9,46.6l43.4-24.8v9.7L173.9,56v-9.4Z"
            fill="url(#edEvCAwTnKp167-fill)"
          />
          <path d="M208.4,26.9l8.9-5.2v10.5l-8.9-5.3Z" fill="url(#edEvCAwTnKp168-fill)" />
          <path
            d="M197.1,33.3l8.9,5.5v184.7l-8.9-5.1v-185.1Z"
            fill="url(#edEvCAwTnKp169-fill)"
          />
          <path
            d="M111.4,283l109.8-63.4v14.2L111.4,297.2v-14.2Z"
            fill="url(#edEvCAwTnKp170-fill)"
          />
          <path
            d="M39.9,241.7l109.8-63.4l71.5,41.3L111.4,283L39.9,241.7Z"
            fill="#005289"
          />
          <g>
            <path
              d="M55.6,237.7c0,1,.7,2,2,2.8l16.2,9.3c2.7,1.5,7,1.5,9.6,0l8.9-5.1c1.3-.8,2-1.8,2-2.8v4.7c0,1-.7,2-2,2.8l-8.9,5.1c-2.7,1.5-7,1.5-9.6,0l-16.2-9.3c-1.3-.8-2-1.8-2-2.8v-4.7Z"
              fill="url(#edEvCAwTnKp173-fill)"
            />
            <path
              d="M55.6,237.7c0-1,.7-2,2-2.8l8.9-5.1c2.7-1.5,7-1.5,9.6,0l16.2,9.3c1.3.8,2,1.8,2,2.8s-.7,2-2,2.8l-8.9,5.1c-2.7,1.5-7,1.5-9.6,0l-16.2-9.3c-1.3-.8-2-1.8-2-2.8Z"
              fill="#005289"
            />
          </g>
          <path
            d="M132.9,32.4l41,23.6v163L133,195.1v-162.7Z"
            fill="url(#edEvCAwTnKp175-fill)"
          />
          <path
            d="M173.9,46.6v9.4v4.1v158.9l23.2-13.4v-158.8-4-9.5L173.9,46.6Z"
            fill="url(#edEvCAwTnKp176-fill)"
          />
          <path
            d="M206,38.8l11.3-6.5v185.1L206,210.8v-172Z"
            fill="url(#edEvCAwTnKp177-fill)"
          />
          <path d="M195.9,32.6l10.7-6.5l10.7,6.2L206,38.8l-10.1-6.2Z" fill="#005289" />
        </g>
      </g>
      <path d="M4762.35,3003.53l31.93-18.43v44.68l-31.93,18.44v-44.69Z" fill="#1674b4" />
      <path
        d="M4704.14,2969.31l31.93-18.44l58.21,34.23-31.93,18.43-58.21-34.22Z"
        fill="#005289"
      />
      <path
        d="M4652.99,2999.84l58.2,34.22v44.69l-58.2-34.23v-44.68Z"
        fill="url(#edEvCAwTnKp181-fill)"
      />
      <path d="M4711.19,3034.22l31.93-18.43v44.68l-31.93,18.44v-44.69Z" fill="#1674b4" />
      <path
        d="M4652.99,2999.84l31.93-18.44l58.2,34.23-31.93,18.43-58.2-34.22Z"
        fill="#005289"
      />
      <path
        d="M4600.87,3028.28l58.2,34.22v44.69l-58.2-34.23v-44.68Z"
        fill="url(#edEvCAwTnKp184-fill)"
      />
      <path d="M4659.07,3062.5l31.94-18.44v44.69l-31.94,18.44v-44.69Z" fill="#1674b4" />
      <path
        d="M4600.87,3028.28l31.93-18.44l58.21,34.22-31.94,18.44-58.2-34.22Z"
        fill="#005289"
      />
      <path
        d="M4429.82,2868.52l60.88-35.44l69.61,40.71-60.88,35.45-69.61-40.72Z"
        fill="#005289"
      />
      <path
        d="M5078.26,2518.85l129.48,54.31v44.69l-129.48-54.32v-44.68Z"
        fill="url(#edEvCAwTnKp188-fill)"
      />
      <path
        d="M5078.26,2518.85l45.56-36.21l129.48,54.32-45.56,36.2-129.48-54.31Z"
        fill="#005289"
      />
      <path
        d="M4180.5,3091.08l8.28-4.79l111.13-64.16l67.46,40.19-127.93,72.51c0,0-56.65-42.43-58.94-43.75Z"
        fill="url(#edEvCAwTnKp190-fill)"
      />
      <path
        d="M3986.93,3199.53l16.77-10.24l111.13-64.17l78.17,36.36-137.17,76.84c0,0-66.61-37.47-68.9-38.79Z"
        fill="url(#edEvCAwTnKp191-fill)"
      />
      <path
        d="M4126.08,3041.28c0-4.16-5.86-7.54-13.08-7.54s-13.07,3.38-13.07,7.54v85.32c0-4.17,5.85-7.55,13.07-7.55s13.08,3.38,13.08,7.55v-85.32Z"
        fill="url(#edEvCAwTnKp192-fill)"
      />
      <path
        d="M4099.93,3041.28c0,4.17,5.85,7.55,13.07,7.55s13.08-3.38,13.08-7.55v85.32c0,4.17-5.86,7.55-13.08,7.55s-13.07-3.38-13.07-7.55v-85.32Z"
        fill="url(#edEvCAwTnKp193-fill)"
      />
      <path
        d="M4187.47,3150.22c0,0-74.35-33.56-76.65-34.88v1.61c2.3,1.32,76.65,34.88,76.65,34.88v-1.61Z"
        fill="url(#edEvCAwTnKp194-fill)"
      />
      <path
        d="M4110.83,3115.34l-8.29,4.78-111.13,64.16v1.61l111.13-64.16l8.29-4.78v-1.61Z"
        fill="url(#edEvCAwTnKp195-fill)"
      />
      <path
        d="M3991.41,3184.28l68.53,39.57v1.22l-68.53-39.57v-1.22Z"
        fill="url(#edEvCAwTnKp196-fill)"
      />
      <path
        d="M3991.41,3184.29l111.13-64.17l8.29-4.78c2.29,1.32,76.64,34.88,76.64,34.88l-127.53,73.63-68.53-39.56Z"
        fill="#005289"
      />
      <path
        d="M4154.02,3138.42l-40.94-39.25v19.32l40.94,39.25v-19.32Z"
        fill="url(#edEvCAwTnKp198-fill)"
      />
      <path
        d="M4113.08,3099.17l-111.9,64.61v19.31l111.9-64.6v-19.32Z"
        fill="url(#edEvCAwTnKp199-fill)"
      />
      <path
        d="M4001.18,3163.38L4062,3198.5v19.31l-60.82-35.11v-19.32Z"
        fill="url(#edEvCAwTnKp200-fill)"
      />
      <path
        d="M4001.18,3163.78l111.9-64.61l40.94,39.25-92.02,60.47-60.82-35.11Z"
        fill="#005289"
      />
      <path
        d="M4140.84,3125.83l-27.76-45.97v19.31l27.76,45.98v-19.32Z"
        fill="url(#edEvCAwTnKp202-fill)"
      />
      <path
        d="M4113.08,3079.86l-111.9,64.6v19.32l111.9-64.61v-19.31Z"
        fill="url(#edEvCAwTnKp203-fill)"
      />
      <path
        d="M4001.18,3144.07l62.82,36.26v19.32l-62.82-36.27v-19.31Z"
        fill="url(#edEvCAwTnKp204-fill)"
      />
      <path
        d="M4001.18,3144.46l111.9-64.6l27.76,45.97-76.84,54.89-62.82-36.26Z"
        fill="#005289"
      />
      <path
        d="M3503.67,3587.63l114.91-66.97l48.44,27.11-117.14,66.58-46.21-26.72Z"
        fill="url(#edEvCAwTnKp206-fill)"
      />
      <path
        d="M3678.67,3511.92c-.94-4.13-5.16-8.87-12.13-12.89-12.19-7.04-28.17-9.23-35.69-4.89-2.61,1.51-3.86,3.61-3.86,6v14.76c0-2.39,1.25-4.49,3.86-6c7.52-4.34,23.5-2.15,35.69,4.89c6.97,4.02,11.19,8.76,12.13,12.89v-14.76Z"
        fill="url(#edEvCAwTnKp207-fill)"
      />
      <path
        d="M3626.99,3500.14c0,4.49,4.38,10.01,12.33,14.6c6.97,4.03,15.18,6.46,22.34,7.01v14.75c-7.16-.54-15.37-2.97-22.34-7-7.95-4.59-12.33-10.11-12.33-14.6v-14.76Z"
        fill="#103250"
      />
      <path
        d="M3544.03,3381.34l149.49,86.3v59.04l-149.49-86.3v-59.04Z"
        fill="url(#edEvCAwTnKp209-fill)"
      />
      <path
        d="M3626.99,3500.14c0-2.39,1.25-4.49,3.86-6c7.52-4.34,23.5-2.15,35.69,4.89c6.97,4.02,11.19,8.76,12.13,12.89l-17.01,9.82c-7.16-.54-15.37-2.97-22.34-7-7.95-4.59-12.33-10.11-12.33-14.6Z"
        fill="url(#edEvCAwTnKp210-fill)"
      />
      <path
        d="M3661.66,3532.91l8.1,4.58v3.69l-8.1-4.68v-3.59Z"
        fill="url(#edEvCAwTnKp211-fill)"
      />
      <path
        d="M3661.66,3532.91l17.01-9.83l8.1,4.68-17.01,9.82-8.1-4.67Z"
        fill="#005289"
      />
      <path
        d="M3687.75,3529.06l-.98-.57v2.96l.98.56v-2.95Z"
        fill="url(#edEvCAwTnKp213-fill)"
      />
      <path
        d="M3686.77,3528.49l-17.01,9.74v2.95l17.01-9.73v-2.96Z"
        fill="url(#edEvCAwTnKp214-fill)"
      />
      <path
        d="M3669.76,3538.23l.98.57v2.95l-.98-.57v-2.95Z"
        fill="url(#edEvCAwTnKp215-fill)"
      />
      <path d="M3669.76,3538.23l17.01-9.74.98.57-17.01,9.74-.98-.57Z" fill="#005289" />
      <path
        d="M3688.74,3530.37l-.99-.57v2.21l.99.57v-2.21Z"
        fill="url(#edEvCAwTnKp217-fill)"
      />
      <path
        d="M3687.75,3529.8l-17.01,9.74v2.21l17.01-9.74v-2.21Z"
        fill="url(#edEvCAwTnKp218-fill)"
      />
      <path
        d="M3670.74,3539.54l.99.56v2.22l-.99-.57v-2.21Z"
        fill="url(#edEvCAwTnKp219-fill)"
      />
      <path d="M3670.74,3539.54l17.01-9.74.98.57-17,9.73-.99-.56Z" fill="#005289" />
      <path
        d="M3689.72,3531.67l-.98-.57v1.48l.98.57v-1.48Z"
        fill="url(#edEvCAwTnKp221-fill)"
      />
      <path
        d="M3688.74,3531.1l-17.01,9.74v1.48l17.01-9.74v-1.48Z"
        fill="url(#edEvCAwTnKp222-fill)"
      />
      <path
        d="M3671.73,3540.84l.98.57v1.48l-.98-.57v-1.48Z"
        fill="url(#edEvCAwTnKp223-fill)"
      />
      <path d="M3671.73,3540.84l17.01-9.74.98.57-17.01,9.74-.98-.57Z" fill="#005289" />
      <path
        d="M3690.7,3532.98l-.98-.57v.74l.98.57v-.74Z"
        fill="url(#edEvCAwTnKp225-fill)"
      />
      <path
        d="M3689.72,3532.41l-17.01,9.74v.74l17.01-9.74v-.74Z"
        fill="url(#edEvCAwTnKp226-fill)"
      />
      <path
        d="M3672.71,3542.15l.98.57v.73l-.98-.56v-.74Z"
        fill="url(#edEvCAwTnKp227-fill)"
      />
      <path d="M3672.71,3542.15l17.01-9.74.98.57-17.01,9.74-.98-.57Z" fill="#005289" />
      <path
        d="M3654.14,3449.94l18.51,10.68v59.04l-18.51-10.68v-59.04Z"
        fill="url(#edEvCAwTnKp229-fill)"
      />
      <path
        d="M3626.99,3455.87c0,4.48,4.38,10,12.33,14.6c12.2,7.04,28.18,9.23,35.69,4.89c2.62-1.51,3.86-3.62,3.86-6.01v44.28c0,2.39-1.24,4.49-3.86,6.01-7.51,4.33-23.49,2.14-35.69-4.9-7.95-4.59-12.33-10.11-12.33-14.6v-44.27Z"
        fill="url(#edEvCAwTnKp230-fill)"
      />
      <path
        d="M3651.65,3472.75l-18.51-10.68v59.04l18.51,10.68v-59.04Z"
        fill="url(#edEvCAwTnKp231-fill)"
      />
      <path
        d="M3633.14,3462.07l-8.36,4.82v59.04l8.36-4.82v-59.04Z"
        fill="url(#edEvCAwTnKp232-fill)"
      />
      <path
        d="M3624.78,3466.89l18.51,10.69v59.04l-18.51-10.69v-59.04Z"
        fill="url(#edEvCAwTnKp233-fill)"
      />
      <path d="M3658.33,3491.8l-114.3-65.98v14.76l114.3,65.98v-14.76Z" fill="#005289" />
      <path
        d="M3544.03,3425.82c0,0-18.33,26.13-24.92,61.24-2.45,13.09-3.21,27.49-3.21,40.3v14.76c0-12.81.76-27.21,3.21-40.3c6.59-35.11,24.92-61.24,24.92-61.24v-14.76Z"
        fill="#005289"
      />
      <path
        d="M3515.9,3527.36c0,20.89,2.03,37.58,2.03,37.58v14.76c0,0-2.03-16.69-2.03-37.58v-14.76Z"
        fill="#005289"
      />
      <path d="M3517.93,3564.94l6.86,3.96v14.76l-6.86-3.96v-14.76Z" fill="#005289" />
      <path d="M3524.79,3568.9l133.53-77.1v14.76l-133.53,77.1v-14.76Z" fill="#005289" />
      <path
        d="M3515.9,3527.36c0-12.81.76-27.21,3.21-40.3c6.59-35.11,24.92-61.24,24.92-61.24l114.29,65.98-133.53,77.1-6.86-3.96c0,0-2.03-16.69-2.03-37.58Z"
        fill="#005289"
      />
      <path
        d="M3655.14,3526.09l-34.96-20.18v14.76l34.96,20.18v-14.76Z"
        fill="url(#edEvCAwTnKp240-fill)"
      />
      <path
        d="M3620.18,3505.91l-116.1,67.03v14.76l116.1-67.03v-14.76Z"
        fill="url(#edEvCAwTnKp241-fill)"
      />
      <path
        d="M3504.08,3572.94l116.1-67.03l34.96,20.18-116.11,67.03-34.95-20.18Z"
        fill="url(#edEvCAwTnKp242-fill)"
      />
      <path
        d="M3664.74,3487.36l-44.56-25.73v44.28l44.56,25.72v-44.27Z"
        fill="url(#edEvCAwTnKp243-fill)"
      />
      <path
        d="M3620.18,3461.63l-116.1,67.04v44.27l116.1-67.03v-44.28Z"
        fill="url(#edEvCAwTnKp244-fill)"
      />
      <path
        d="M3558.79,3525.83l-31.29-18.07v7.38l31.29,18.07v-7.38Z"
        fill="url(#edEvCAwTnKp245-fill)"
      />
      <path
        d="M3527.5,3507.76l-23.42,13.53v7.38l23.42-13.53v-7.38Z"
        fill="url(#edEvCAwTnKp246-fill)"
      />
      <path
        d="M3535.37,3539.35l23.42-13.52v7.38l-23.42,13.52v-7.38Z"
        fill="url(#edEvCAwTnKp247-fill)"
      />
      <path
        d="M3504.08,3521.29l23.42-13.53l31.29,18.07-23.42,13.52-31.29-18.06Z"
        fill="#005289"
      />
      <path
        d="M3548.63,3554.39l-13.26-7.66v-7.38l-31.29-18.06v7.38v7.38v29.51v7.38v14.76l34.95,20.18v-14.76l9.6,5.55v-44.28Z"
        fill="url(#edEvCAwTnKp249-fill)"
      />
      <path
        d="M3551.64,3369.79l16.07,9.28v7.38l-16.07-9.28v-7.38Z"
        fill="url(#edEvCAwTnKp250-fill)"
      />
      <path
        d="M3560.12,3383.45l14.29,8.25v7.38l-14.29-8.25v-7.38Z"
        fill="url(#edEvCAwTnKp251-fill)"
      />
      <path d="M4126.4,3111.62l-13.32-51.08v19.32l13.32,51.07v-19.31Z" fill="#005289" />
      <path d="M4113.08,3060.54l-111.9,64.6v19.32l111.9-64.6v-19.32Z" fill="#005289" />
      <path
        d="M4001.18,3124.75l64.68,37.34v19.32l-64.68-37.34v-19.32Z"
        fill="url(#edEvCAwTnKp254-fill)"
      />
      <path
        d="M4001.18,3125.14l111.9-64.6l13.32,51.08-60.54,50.86-64.68-37.34Z"
        fill="#005289"
      />
      <path
        d="M4117.14,3092.3l-4.06-51.08v19.32l4.06,51.08v-19.32Z"
        fill="url(#edEvCAwTnKp256-fill)"
      />
      <path
        d="M4113.08,3041.22l-111.9,64.6v19.32l111.9-64.6v-19.32Z"
        fill="url(#edEvCAwTnKp257-fill)"
      />
      <path
        d="M4001.18,3105.82l55.53,32.06v19.32l-55.53-32.06v-19.32Z"
        fill="url(#edEvCAwTnKp258-fill)"
      />
      <path
        d="M4001.18,3105.82l111.9-64.6l4.07,51.08-60.44,45.58-55.53-32.06Z"
        fill="#005289"
      />
      <path
        d="M4113,3048.83c7.22,0,13.08-3.38,13.08-7.55c0-4.16-5.86-7.54-13.08-7.54s-13.07,3.38-13.07,7.54c0,4.17,5.85,7.55,13.07,7.55Z"
        fill="#005289"
      />
      <path
        d="M4065.3,3101.68l-26.76-15.45v12.88l26.76,15.45v-12.88Z"
        fill="url(#edEvCAwTnKp261-fill)"
      />
      <path
        d="M4038.54,3086.23l-24.5,14.14v12.88l24.5-14.14v-12.88Z"
        fill="url(#edEvCAwTnKp262-fill)"
      />
      <path
        d="M4014.04,3100.37l26.77,15.45v90.03l-26.77-15.45v-90.03Z"
        fill="url(#edEvCAwTnKp263-fill)"
      />
      <path
        d="M4014.04,3100.37l24.5-14.14l26.76,15.45-24.49,14.14-26.77-15.45Z"
        fill="#005289"
      />
      <path
        d="M4172.99,2999.11c0,4.16,5.85,7.54,13.07,7.54s13.07-3.38,13.07-7.54v85.31c0,4.17-5.85,7.55-13.07,7.55s-13.07-3.38-13.07-7.55v-85.31Z"
        fill="url(#edEvCAwTnKp265-fill)"
      />
      <path
        d="M4172.99,2999.11c0,4.16,5.85,7.54,13.07,7.54s13.07-3.38,13.07-7.54v85.31c0,4.17-5.85,7.55-13.07,7.55s-13.07-3.38-13.07-7.55v-85.31Z"
        fill="url(#edEvCAwTnKp266-fill)"
      />
      <path
        d="M4368.44,3045.74l-68.53-39.57v1.61l68.53,39.57v-1.61Z"
        fill="url(#edEvCAwTnKp267-fill)"
      />
      <path
        d="M4299.91,3006.17l-111.13,64.16-8.28,4.79v1.61l8.28-4.79l111.13-64.16v-1.61Z"
        fill="url(#edEvCAwTnKp268-fill)"
      />
      <path
        d="M3551.64,3369.79l20.87-12.05l30.36,17.53-28.46,16.43-14.29-8.25l7.59-4.38-16.07-9.28Z"
        fill="#005289"
      />
      <path
        d="M4180.5,3075.12c2.29,1.32,60.41,44.25,60.41,44.25v1.61c0,0-58.12-42.93-60.41-44.25v-1.61Z"
        fill="url(#edEvCAwTnKp270-fill)"
      />
      <path
        d="M4180.5,3075.12l8.28-4.79l111.13-64.16l68.53,39.57-127.53,73.63c0,0-58.12-42.93-60.41-44.25Z"
        fill="#005289"
      />
      <path
        d="M4358.67,3027.61l-60.82-35.11v19.31l60.82,35.12v-19.32Z"
        fill="url(#edEvCAwTnKp272-fill)"
      />
      <path
        d="M4297.85,2992.5l-111.9,64.6v19.32l111.9-64.61v-19.31Z"
        fill="url(#edEvCAwTnKp273-fill)"
      />
      <path
        d="M4027.58,3479.76l-469.18,172.5v3.49c0,2.73,1.81,5.47,5.42,7.56l62.82,36.27c7.23,4.17,18.93,4.17,26.16,0l369.36-208.75c3.62-2.09,5.42-4.82,5.42-7.56v-3.51Z"
        fill="#1674b4"
      />
      <path
        d="M3652.81,3696.02l369.35-208.75c7.23-4.17,7.23-10.93.01-15.11l-62.81-36.27c-7.22-4.17-18.93-4.17-26.16,0l-369.37,208.75c-7.23,4.17-7.23,10.93-.01,15.11l62.83,36.27c7.22,4.17,18.93,4.17,26.16,0Z"
        fill="#005289"
      />
      <path
        d="M4185.95,3057.1l67.99,23.64v19.31l-67.99-23.63v-19.32Z"
        fill="url(#edEvCAwTnKp276-fill)"
      />
      <path
        d="M4185.95,3057.1l111.9-64.6l60.82,35.11-104.73,53.13-67.99-23.64Z"
        fill="#005289"
      />
      <path
        d="M4360.66,3009.44l-62.81-36.26v19.32l62.81,36.26v-19.32Z"
        fill="url(#edEvCAwTnKp278-fill)"
      />
      <path
        d="M4297.85,2973.18l-111.9,64.6v19.32l111.9-64.6v-19.32Z"
        fill="url(#edEvCAwTnKp279-fill)"
      />
      <path
        d="M4185.95,3037.78l79.64,16.03v19.32l-79.64-16.03v-19.32Z"
        fill="url(#edEvCAwTnKp280-fill)"
      />
      <path
        d="M3718.73,3545.11l69.6,40.72v17.65l-69.6-40.71v-17.66Z"
        fill="url(#edEvCAwTnKp281-fill)"
      />
      <path
        d="M4185.95,3037.78l111.9-64.6l62.81,36.26-95.07,44.37-79.64-16.03Z"
        fill="#005289"
      />
      <path
        d="M4187.5,3018.47l86.92,7.69v19.31l-86.92-7.69v-19.31Z"
        fill="url(#edEvCAwTnKp283-fill)"
      />
      <path
        d="M4187.5,3018.47l111.89-64.61l64.68,37.34-88.1,34.96-88.47-7.69Z"
        fill="#005289"
      />
      <path
        d="M4353.37,2966.6l-55.52-32.05v19.31l55.52,32.06v-19.32Z"
        fill="url(#edEvCAwTnKp285-fill)"
      />
      <path
        d="M4172.99,2999.11c0,4.16,5.85,7.54,13.07,7.54s13.07-3.38,13.07-7.54v12.26c0,4.16-5.85,7.54-13.07,7.54s-13.07-3.38-13.07-7.54v-12.26Z"
        fill="url(#edEvCAwTnKp286-fill)"
      />
      <path
        d="M4196.85,3002.86l77.57-1.36.25,19.17-77.59-5.24-.23-12.57Z"
        fill="url(#edEvCAwTnKp287-fill)"
      />
      <path
        d="M4353.37,2966.6l-55.52-32.05-102.56,59.21c-2.37-1.36-5.63-2.2-9.23-2.2-7.22,0-13.07,3.38-13.07,7.55c0,4.16,5.85,7.54,13.07,7.54c6.99,0,9.15-1.32,11.12-3.79l77.24-1.36l78.95-34.9Z"
        fill="#005289"
      />
      <path
        d="M4283.04,2942.27l26.76,15.45v12.88l-26.76-15.45v-12.88Z"
        fill="url(#edEvCAwTnKp289-fill)"
      />
      <path
        d="M3718.73,3545.11l34.18-19.53l69.6,40.72-34.18,19.53-69.6-40.72Z"
        fill="#005289"
      />
      <path
        d="M3670.68,3573.27l69.61,40.72v17.65l-69.61-40.71v-17.66Z"
        fill="url(#edEvCAwTnKp291-fill)"
      />
      <path
        d="M3670.68,3573.27l34.19-19.53l69.6,40.72-34.18,19.53-69.61-40.72Z"
        fill="#005289"
      />
      <path
        d="M3069.67,3788.9l69.6,40.72v17.65l-69.6-40.71v-17.66Z"
        fill="url(#edEvCAwTnKp293-fill)"
      />
      <path d="M3139.27,3829.62l34.18-19.53v17.65l-34.18,19.53v-17.65Z" fill="#1674b4" />
      <path
        d="M3069.67,3788.9l34.19-19.53l69.59,40.72-34.18,19.53-69.6-40.72Z"
        fill="#005289"
      />
      <path
        d="M3018.66,3816.11l69.6,40.71v17.66l-69.6-40.72v-17.65Z"
        fill="url(#edEvCAwTnKp296-fill)"
      />
      <path d="M3088.26,3856.82l34.18-19.53v17.66l-34.18,19.53v-17.66Z" fill="#1674b4" />
      <path
        d="M3018.66,3816.11l34.18-19.53l69.6,40.71-34.18,19.53-69.6-40.71Z"
        fill="#005289"
      />
      <path
        d="M2967.65,3843.31l69.6,40.72v17.65l-69.6-40.71v-17.66Z"
        fill="url(#edEvCAwTnKp299-fill)"
      />
      <path d="M3037.25,3884.03l34.18-19.53v17.65l-34.18,19.53v-17.65Z" fill="#1674b4" />
      <path
        d="M2967.65,3843.31l34.19-19.53l69.59,40.72-34.18,19.53-69.6-40.72Z"
        fill="#005289"
      />
      <path d="M3622.31,3649.18l66.12-38.75v22.75l-66.12,38.75v-22.75Z" fill="#1674b4" />
      <path
        d="M3575.35,3621.71l66.12-38.75l46.96,27.47-66.12,38.75-46.96-27.47Z"
        fill="#005289"
      />
      <path
        d="M3618.78,3573.46l46.96,27.47v22.75l-46.96-27.47v-22.75Z"
        fill="url(#edEvCAwTnKp304-fill)"
      />
      <path
        d="M3574.88,3622.33l46.96,27.47v22.75l-46.96-27.47v-22.75Z"
        fill="url(#edEvCAwTnKp305-fill)"
      />
      <path d="M3665.74,3600.93l22.8-13.42v22.75l-22.8,13.42v-22.75Z" fill="#1674b4" />
      <path
        d="M3618.78,3573.46l22.8-13.42l46.96,27.47-22.8,13.42-46.96-27.47Z"
        fill="#005289"
      />
      <g>
        <path
          d="M3601.83,3723.26l-542.99,215.93v3.49c0,2.73,1.81,5.47,5.42,7.56l62.82,36.27c7.23,4.16,18.93,4.16,26.16,0l443.17-252.19c3.62-2.08,5.42-4.82,5.42-7.55v-3.51Z"
          fill="#1674b4"
        />
        <path
          d="M3153.25,3983.75l443.16-252.18c7.23-4.17,7.23-10.94.01-15.11l-62.8-36.27c-7.22-4.17-18.94-4.17-26.16-.01l-443.19,252.19c-7.23,4.17-7.23,10.93,0,15.11l62.82,36.27c7.22,4.17,18.93,4.17,26.16,0Z"
          fill="#005289"
        />
        <path
          d="M3462.43,3690.91l69.61,40.72v17.65l-69.61-40.71v-17.66Z"
          fill="url(#edEvCAwTnKp311-fill)"
        />
        <path
          d="M3532.04,3731.63l34.18-19.53v17.65l-34.18,19.53v-17.65Z"
          fill="#1674b4"
        />
        <path
          d="M3462.43,3690.91l34.19-19.53l69.6,40.72-34.18,19.53-69.61-40.72Z"
          fill="#005289"
        />
        <path
          d="M3342.29,3747.81l62.02,36.46v33.06l-62.02-36.46v-33.06Z"
          fill="url(#edEvCAwTnKp314-fill)"
        />
        <path
          d="M3404.31,3784.27l102.62-59.74v33.06l-102.62,59.74v-33.06Z"
          fill="#1674b4"
        />
        <path
          d="M3342.29,3747.81l102.63-59.74l62.01,36.46-102.62,59.74-62.02-36.46Z"
          fill="#005289"
        />
        <path
          d="M3257.29,3795.41l62.01,36.47v33.06l-62.01-36.47v-33.06Z"
          fill="url(#edEvCAwTnKp317-fill)"
        />
        <path d="M3319.3,3831.88l62.22-35.5v33.06l-62.22,35.5v-33.06Z" fill="#1674b4" />
        <path
          d="M3257.29,3795.41l62.21-35.49l62.02,36.46-62.22,35.5-62.01-36.47Z"
          fill="#005289"
        />
        <path
          d="M3280.08,3770.59l39.26,23.08v20.93l-39.26-23.08v-20.93Z"
          fill="url(#edEvCAwTnKp320-fill)"
        />
        <path
          d="M3319.34,3793.67l39.38-22.46v20.93l-39.38,22.46v-20.93Z"
          fill="#1674b4"
        />
        <path
          d="M3280.08,3770.59l39.38-22.47l39.26,23.09-39.38,22.46-39.26-23.08Z"
          fill="#005289"
        />
        <path
          d="M3131.45,3865.13l62.02,36.46v33.07l-62.02-36.47v-33.06Z"
          fill="url(#edEvCAwTnKp323-fill)"
        />
        <path
          d="M3193.47,3901.59l102.62-59.74v33.07l-102.62,59.74v-33.07Z"
          fill="#1674b4"
        />
        <path
          d="M3131.45,3865.13l102.62-59.74l62.02,36.46-102.62,59.74-62.02-36.46Z"
          fill="#005289"
        />
      </g>
      <path
        d="M6370.77,1911.04l69.6,40.71v17.66l-69.6-40.72v-17.65Z"
        fill="url(#edEvCAwTnKp326-fill)"
      />
      <path d="M6440.37,1951.75l34.18-19.53v17.66l-34.18,19.53v-17.66Z" fill="#1674b4" />
      <path
        d="M6370.77,1911.04l34.18-19.53l69.6,40.71-34.18,19.53-69.6-40.71Z"
        fill="#005289"
      />
      <path
        d="M6276.21,1959.58l62.02,36.46v33.06l-62.02-36.46v-33.06Z"
        fill="url(#edEvCAwTnKp329-fill)"
      />
      <path
        d="M6338.23,1996.04l102.62-59.74v33.06l-102.62,59.74v-33.06Z"
        fill="#1674b4"
      />
      <path
        d="M6276.21,1959.58l102.63-59.74l62.01,36.46-102.62,59.74-62.02-36.46Z"
        fill="#005289"
      />
      <path
        d="M6191.2,2007.19l62.02,36.46v33.06l-62.02-36.46v-33.06Z"
        fill="url(#edEvCAwTnKp332-fill)"
      />
      <path d="M6253.22,2043.65l62.22-35.49v33.06l-62.22,35.49v-33.06Z" fill="#1674b4" />
      <path
        d="M6191.2,2007.19l62.22-35.5l62.01,36.47-62.21,35.49-62.02-36.46Z"
        fill="#005289"
      />
      <path
        d="M6214,1982.36l39.26,23.09v20.92L6214,2003.29v-20.93Z"
        fill="url(#edEvCAwTnKp335-fill)"
      />
      <path d="M6253.26,2005.45l39.38-22.47v20.93l-39.38,22.46v-20.92Z" fill="#1674b4" />
      <path
        d="M6214,1982.36l39.38-22.46l39.26,23.08-39.38,22.47-39.26-23.09Z"
        fill="#005289"
      />
      <path
        d="M6065.37,2076.9l62.01,36.47v33.06l-62.01-36.46v-33.07Z"
        fill="url(#edEvCAwTnKp338-fill)"
      />
      <path
        d="M6127.38,2113.37l102.63-59.74v33.06l-102.63,59.74v-33.06Z"
        fill="#1674b4"
      />
      <path
        d="M6065.37,2076.9l102.62-59.74l62.02,36.47-102.63,59.74-62.01-36.47Z"
        fill="#005289"
      />
      <path
        d="M5950.69,2257.11l-549.48,219.42v3.49c0,2.73,1.81,5.47,5.42,7.55l62.83,36.27c7.22,4.17,18.93,4.17,26.15,0l449.66-255.66c3.62-2.09,5.42-4.82,5.42-7.56v-3.51Z"
        fill="#1674b4"
      />
      <path
        d="M5495.62,2521.09l449.65-255.67c7.23-4.17,7.23-10.93.01-15.1l-62.8-36.28c-7.22-4.17-18.94-4.17-26.16,0l-449.68,255.67c-7.22,4.17-7.23,10.93,0,15.1l62.82,36.28c7.22,4.17,18.94,4.17,26.16,0Z"
        fill="#005289"
      />
      <path
        d="M5804.81,2228.25l69.6,40.71v17.66l-69.6-40.71v-17.66Z"
        fill="url(#edEvCAwTnKp343-fill)"
      />
      <path d="M5874.41,2268.96l34.19-19.53v17.66l-34.19,19.53v-17.66Z" fill="#1674b4" />
      <path
        d="M5804.81,2228.25l34.19-19.53l69.6,40.71-34.19,19.53-69.6-40.71Z"
        fill="#005289"
      />
      <path
        d="M4345.25,2927.23l46.96,27.47v22.75l-46.96-27.47v-22.75Z"
        fill="url(#edEvCAwTnKp346-fill)"
      />
      <path d="M4392.21,2954.7l66.13-38.75v22.75l-66.13,38.75v-22.75Z" fill="#1674b4" />
      <path
        d="M4345.25,2927.23l66.13-38.75l46.96,27.47-66.13,38.75-46.96-27.47Z"
        fill="#005289"
      />
      <path
        d="M4388.69,2878.98l46.96,27.47v22.75l-46.96-27.47v-22.75Z"
        fill="url(#edEvCAwTnKp349-fill)"
      />
      <path d="M4435.65,2906.45l22.8-13.43v22.75l-22.8,13.43v-22.75Z" fill="#1674b4" />
      <path
        d="M4388.69,2878.98l22.8-13.43l46.96,27.47-22.8,13.43-46.96-27.47Z"
        fill="#005289"
      />
      <path
        d="M3814.81,3488.79l69.6,40.71v17.66l-69.6-40.72v-17.65Z"
        fill="url(#edEvCAwTnKp352-fill)"
      />
      <path d="M3884.41,3529.5l34.18-19.53v17.66l-34.18,19.53v-17.66Z" fill="#1674b4" />
      <path
        d="M3814.81,3488.79l34.19-19.53l69.59,40.71-34.18,19.53-69.6-40.71Z"
        fill="#005289"
      />
      <path
        d="M3766.77,3516.95l69.6,40.71v17.66l-69.6-40.71v-17.66Z"
        fill="url(#edEvCAwTnKp355-fill)"
      />
      <path d="M3836.37,3557.66l34.18-19.53v17.66l-34.18,19.53v-17.66Z" fill="#1674b4" />
      <path
        d="M3766.77,3516.95l34.18-19.53l69.6,40.71-34.18,19.53-69.6-40.71Z"
        fill="#005289"
      />
      <path d="M3788.33,3585.83l34.18-19.53v17.65l-34.18,19.53v-17.65Z" fill="#1674b4" />
      <path
        d="M6268.11,1836.17l69.6,40.71v17.65l-69.6-40.71v-17.65Z"
        fill="url(#edEvCAwTnKp359-fill)"
      />
      <path d="M6337.71,1876.88l34.18-19.53v17.65l-34.18,19.53v-17.65Z" fill="#1674b4" />
      <path
        d="M6268.11,1836.16l34.18-19.52l69.6,40.71-34.18,19.53-69.6-40.72Z"
        fill="#005289"
      />
      <path
        d="M6205.19,1870.17l69.6,40.72v17.65l-69.6-40.71v-17.66Z"
        fill="url(#edEvCAwTnKp362-fill)"
      />
      <path d="M6274.79,1910.89l34.19-19.54v17.66l-34.19,19.53v-17.65Z" fill="#1674b4" />
      <path
        d="M6205.19,1870.17l34.19-19.53l69.6,40.71-34.19,19.54-69.6-40.72Z"
        fill="#005289"
      />
      <path
        d="M6142.28,1904.18l69.6,40.71v17.66l-69.6-40.72v-17.65Z"
        fill="url(#edEvCAwTnKp365-fill)"
      />
      <path d="M6211.88,1944.89l34.18-19.53v17.66l-34.18,19.53v-17.66Z" fill="#1674b4" />
      <path
        d="M6142.28,1904.18l34.18-19.53l69.6,40.71-34.18,19.53-69.6-40.71Z"
        fill="#005289"
      />
      <path
        d="M5966.23,2155.67l47.16,25.99v17.8l-47.16-25.99v-17.8Z"
        fill="url(#edEvCAwTnKp368-fill)"
      />
      <path d="M6013.39,2181.66l102.63-59.74v17.8l-102.63,59.74v-17.8Z" fill="#1674b4" />
      <path
        d="M5966.23,2155.67l102.63-59.74l47.16,25.99-102.63,59.74-47.16-25.99Z"
        fill="#005289"
      />
      <g>
        <path
          d="M6690.86,1592.93l62.02,36.47v33.06L6690.86,1626v-33.07Z"
          fill="url(#edEvCAwTnKp372-fill)"
        />
        <path d="M6752.88,1629.4l62.22-35.5v33.07l-62.22,35.49v-33.06Z" fill="#1674b4" />
        <path
          d="M6690.86,1592.93l62.22-35.49l62.01,36.46-62.21,35.5-62.02-36.47Z"
          fill="#005289"
        />
        <path
          d="M6713.66,1568.11l39.26,23.09v20.92l-39.26-23.08v-20.93Z"
          fill="url(#edEvCAwTnKp375-fill)"
        />
        <path d="M6752.92,1591.2l39.38-22.47v20.93l-39.38,22.46v-20.92Z" fill="#1674b4" />
        <path
          d="M6713.66,1568.11l39.39-22.46l39.25,23.08-39.38,22.47-39.26-23.09Z"
          fill="#005289"
        />
      </g>
      <path d="M3740.29,3613.99l34.18-19.53v17.65l-34.18,19.53v-17.65Z" fill="#1674b4" />
      <path
        d="M6482.33,1963.77l83.7,52.48v15.57l-83.7-52.48v-15.57Z"
        fill="url(#edEvCAwTnKp379-fill)"
      />
      <path d="M6566.03,2016.25l63.68-38.42v15.57l-63.68,38.42v-15.57Z" fill="#1674b4" />
      <path
        d="M6482.33,1963.77l63.68-38.42l83.7,52.48-63.68,38.42-83.7-52.48Z"
        fill="#005289"
      />
      <path
        d="M6979.46,1726.98l38.25,22.49v20.39l-38.25-22.49v-20.39Z"
        fill="url(#edEvCAwTnKp382-fill)"
      />
      <path d="M7017.71,1749.47l41.83-24.19v20.39l-41.83,24.19v-20.39Z" fill="#1674b4" />
      <path
        d="M6979.46,1726.98l41.84-24.19l38.24,22.49-41.83,24.19-38.25-22.49Z"
        fill="#005289"
      />
      <path
        d="M6919.2,1761.63l38.25,22.49v20.39l-38.25-22.49v-20.39Z"
        fill="url(#edEvCAwTnKp385-fill)"
      />
      <path d="M6957.45,1784.12l41.83-24.19v20.39l-41.83,24.19v-20.39Z" fill="#1674b4" />
      <path
        d="M6919.2,1761.63l41.84-24.19l38.24,22.49-41.83,24.19-38.25-22.49Z"
        fill="#005289"
      />
      <path
        d="M6858.94,1796.28l38.24,22.49v20.39l-38.24-22.49v-20.39Z"
        fill="url(#edEvCAwTnKp388-fill)"
      />
      <path d="M6897.18,1818.77l41.84-24.19v20.39l-41.84,24.19v-20.39Z" fill="#1674b4" />
      <path
        d="M6858.94,1796.28l41.83-24.19l38.25,22.49-41.84,24.19-38.24-22.49Z"
        fill="#005289"
      />
      <path
        d="M6798.68,1830.93l38.24,22.49v20.39l-38.24-22.49v-20.39Z"
        fill="url(#edEvCAwTnKp391-fill)"
      />
      <path d="M6836.92,1853.42l41.84-24.19v20.39l-41.84,24.19v-20.39Z" fill="#1674b4" />
      <path
        d="M6798.68,1830.93l41.83-24.19l38.25,22.49-41.84,24.19-38.24-22.49Z"
        fill="#005289"
      />
      <path
        d="M6654.04,1899.25l38.25,22.49v39.67l-38.25-22.49v-39.67Z"
        fill="url(#edEvCAwTnKp394-fill)"
      />
      <path d="M6692.29,1921.74l41.83-24.19v39.67l-41.83,24.18v-39.66Z" fill="#1674b4" />
      <path
        d="M6654.04,1899.25l41.84-24.19l38.24,22.49-41.83,24.19-38.25-22.49Z"
        fill="#005289"
      />
      <path
        d="M6780.88,1660.46l62.01,36.46v33.06l-62.01-36.46v-33.06Z"
        fill="url(#edEvCAwTnKp397-fill)"
      />
      <path
        d="M6842.89,1696.92l102.63-59.74v33.06l-102.63,59.74v-33.06Z"
        fill="#1674b4"
      />
      <path
        d="M6780.88,1660.46l102.62-59.74l62.02,36.46-102.63,59.74-62.01-36.46Z"
        fill="#005289"
      />
      <path
        d="M6661.14,1731.73l62.01,36.46v33.06l-62.01-36.46v-33.06Z"
        fill="url(#edEvCAwTnKp400-fill)"
      />
      <path
        d="M6723.15,1768.19l102.63-59.74v33.06l-102.63,59.74v-33.06Z"
        fill="#1674b4"
      />
      <path
        d="M6661.14,1731.73l102.62-59.74l62.01,36.46-102.62,59.74-62.01-36.46Z"
        fill="#005289"
      />
      <path
        d="M6568.04,1659.65l62.01,36.46v33.06l-62.01-36.46v-33.06Z"
        fill="url(#edEvCAwTnKp403-fill)"
      />
      <path
        d="M6630.05,1696.11l102.62-59.74v33.06l-102.62,59.74v-33.06Z"
        fill="#1674b4"
      />
      <path
        d="M6568.04,1659.65l102.62-59.74l62.01,36.46-102.62,59.74-62.01-36.46Z"
        fill="#005289"
      />
      <g>
        <path
          d="M4186.06,3389.56l-205.37,25.46v3.5c0,2.72,1.8,5.46,5.42,7.55l62.82,36.27c7.22,4.17,18.93,4.17,26.16,0l105.55-61.71c3.62-2.09,5.42-4.82,5.42-7.56v-3.51Z"
          fill="#1674b4"
        />
        <path
          d="M4075.1,3458.78l105.54-61.72c7.23-4.16,7.23-10.93.01-15.1l-62.8-36.27c-7.22-4.17-18.94-4.17-26.16-.01l-105.57,61.72c-7.23,4.17-7.23,10.94-.01,15.11l62.83,36.27c7.22,4.17,18.93,4.17,26.16,0Z"
          fill="#005289"
        />
        <path
          d="M4002.03,3389.8l58.21,34.23v22.19L4002.03,3412v-22.2Z"
          fill="url(#edEvCAwTnKp409-fill)"
        />
        <path
          d="M4060.24,3424.03l61.67-35.37v22.19l-61.67,35.37v-22.19Z"
          fill="#1674b4"
        />
        <path
          d="M4002.03,3389.8l61.67-35.37l58.21,34.23-61.67,35.37-58.21-34.23Z"
          fill="#005289"
        />
        <path
          d="M4023.78,3349.59l36.3,21.34v37.94l-36.3-21.34v-37.94Z"
          fill="url(#edEvCAwTnKp412-fill)"
        />
        <path
          d="M4060.08,3370.93l38.46-22.06v37.94l-38.46,22.06v-37.94Z"
          fill="#1674b4"
        />
        <path
          d="M4023.78,3349.59l38.46-22.06l36.3,21.34-38.46,22.06-36.3-21.34Z"
          fill="#005289"
        />
      </g>
      <path
        d="M3871.96,3442.07l69.6,40.72v33.72l-69.6-40.71v-33.73Z"
        fill="url(#edEvCAwTnKp415-fill)"
      />
      <path d="M3941.56,3482.79l60.88-35.44v33.72l-60.88,35.44v-33.72Z" fill="#1674b4" />
      <path
        d="M3871.96,3442.07l60.88-35.44l69.6,40.72-60.88,35.44-69.6-40.72Z"
        fill="#005289"
      />
      <g>
        <path
          d="M6501.08,2077.12l-489.15,183.11v3.5c0,2.73,1.81,5.46,5.42,7.55l62.83,36.27c7.22,4.17,18.92,4.17,26.15,0l389.34-219.36c3.61-2.09,5.41-4.82,5.41-7.56v-3.51Z"
          fill="#1674b4"
        />
        <path
          d="M6106.34,2303.99l389.33-219.36c7.23-4.17,7.23-10.93,0-15.1l-62.8-36.28c-7.22-4.17-18.93-4.17-26.16,0l-389.35,219.36c-7.22,4.17-7.23,10.94,0,15.11l62.82,36.27c7.22,4.17,18.93,4.17,26.16,0Z"
          fill="#005289"
        />
      </g>
      <path
        d="M4604.53,3152.76l-452.2,162.87v3.49c0,2.73,1.81,5.47,5.42,7.55l62.82,36.27c7.23,4.17,18.93,4.17,26.16,0l352.39-199.12c3.61-2.08,5.41-4.82,5.41-7.55v-3.51Z"
        fill="#1674b4"
      />
      <path
        d="M4246.74,3359.39l352.37-199.13c7.23-4.17,7.24-10.93.01-15.1l-62.8-36.27c-7.22-4.18-18.94-4.18-26.16-.01L4157.76,3308c-7.23,4.17-7.23,10.94-.01,15.11l62.83,36.28c7.22,4.16,18.93,4.16,26.16,0Z"
        fill="#005289"
      />
      <path
        d="M4360.7,3180.32l69.6,40.71v17.65l-69.6-40.71v-17.65Z"
        fill="url(#edEvCAwTnKp423-fill)"
      />
      <path d="M4430.3,3221.03l34.18-19.53v17.65l-34.18,19.53v-17.65Z" fill="#1674b4" />
      <path
        d="M4360.7,3180.32l34.18-19.54l69.6,40.72-34.18,19.53-69.6-40.71Z"
        fill="#005289"
      />
      <path
        d="M4312.65,3208.48l69.61,40.71v17.66l-69.61-40.72v-17.65Z"
        fill="url(#edEvCAwTnKp426-fill)"
      />
      <path d="M4382.26,3249.19l34.18-19.53v17.66l-34.18,19.53v-17.66Z" fill="#1674b4" />
      <path
        d="M4312.65,3208.48l34.19-19.53l69.6,40.71-34.18,19.53-69.61-40.71Z"
        fill="#005289"
      />
      <path
        d="M4264.61,3236.64l69.6,40.71v17.66l-69.6-40.71v-17.66Z"
        fill="url(#edEvCAwTnKp429-fill)"
      />
      <path d="M4334.21,3277.35l34.19-19.53v17.66l-34.19,19.53v-17.66Z" fill="#1674b4" />
      <path
        d="M4264.61,3236.64l34.19-19.53l69.6,40.71-34.19,19.53-69.6-40.71Z"
        fill="#005289"
      />
      <path
        d="M4439.82,3116.77l69.6,40.72v33.72l-69.6-40.72v-33.72Z"
        fill="url(#edEvCAwTnKp432-fill)"
      />
      <path d="M4509.42,3157.49l60.88-35.45v33.73l-60.88,35.44v-33.72Z" fill="#1674b4" />
      <path
        d="M4439.82,3116.77l60.88-35.44l69.6,40.71-60.88,35.45-69.6-40.72Z"
        fill="#005289"
      />
      <path
        d="M5684.67,2285.15l62.02,36.46v33.06l-62.02-36.46v-33.06Z"
        fill="url(#edEvCAwTnKp435-fill)"
      />
      <path
        d="M5746.68,2321.61l102.63-59.74v33.06l-102.63,59.74v-33.06Z"
        fill="#1674b4"
      />
      <path
        d="M5684.67,2285.15l102.62-59.74l62.02,36.46-102.62,59.74-62.02-36.46Z"
        fill="#005289"
      />
      <path
        d="M5599.66,2332.75l62.02,36.46v33.06l-62.02-36.46v-33.06Z"
        fill="url(#edEvCAwTnKp438-fill)"
      />
      <path d="M5661.68,2369.21l62.21-35.49v33.06l-62.21,35.49v-33.06Z" fill="#1674b4" />
      <path
        d="M5599.66,2332.75l62.22-35.49l62.01,36.46-62.21,35.49-62.02-36.46Z"
        fill="#005289"
      />
      <path
        d="M5622.46,2307.93l39.25,23.08v20.93l-39.25-23.08v-20.93Z"
        fill="url(#edEvCAwTnKp441-fill)"
      />
      <path d="M5661.71,2331.01l39.39-22.47v20.93l-39.39,22.47v-20.93Z" fill="#1674b4" />
      <path
        d="M5622.46,2307.93l39.38-22.47l39.26,23.08-39.39,22.47-39.25-23.08Z"
        fill="#005289"
      />
      <path
        d="M5401.6,2320.85l62.01,36.46v33.06l-62.01-36.46v-33.06Z"
        fill="url(#edEvCAwTnKp444-fill)"
      />
      <path d="M5463.62,2357.31l62.21-35.49v33.06l-62.21,35.49v-33.06Z" fill="#1674b4" />
      <path
        d="M5401.6,2320.85l62.22-35.49l62.01,36.46-62.22,35.49-62.01-36.46Z"
        fill="#005289"
      />
      <path
        d="M5424.39,2296.03l39.26,23.08v20.93l-39.26-23.08v-20.93Z"
        fill="url(#edEvCAwTnKp447-fill)"
      />
      <path d="M5463.65,2319.11l39.39-22.47v20.93l-39.39,22.47v-20.93Z" fill="#1674b4" />
      <path
        d="M5424.39,2296.03l39.39-22.47l39.26,23.08-39.39,22.47-39.26-23.08Z"
        fill="#005289"
      />
      <path
        d="M5473.83,2402.47l62.01,36.46v33.06l-62.01-36.46v-33.06Z"
        fill="url(#edEvCAwTnKp450-fill)"
      />
      <path
        d="M5535.84,2438.93l102.62-59.74v33.06l-102.62,59.74v-33.06Z"
        fill="#1674b4"
      />
      <path
        d="M5473.83,2402.47l102.62-59.74l62.01,36.46-102.62,59.74-62.01-36.46Z"
        fill="#005289"
      />
      <g>
        <g>
          <path
            d="M2818.26,4173.82l-472.47-82.78v3.49c0,2.73,1.8,5.47,5.41,7.55l289.42,165.6c7.23,4.17,18.93,4.17,26.16,0l146.06-82.79c3.62-2.09,5.42-4.82,5.42-7.56v-3.51Z"
            fill="#1674b4"
          />
          <path
            d="M2666.79,4264.12l146.05-82.8c7.23-4.16,7.23-10.93.01-15.1l-289.4-165.36c-7.22-4.17-18.94-4.17-26.16,0l-146.08,82.56c-7.22,4.17-7.23,10.93,0,15.1l289.42,165.6c7.22,4.17,18.93,4.17,26.16,0Z"
            fill="#005289"
          />
          <path
            d="M2385.63,4081.49l80.5-46.47l175.73,101.45-80.5,46.48-175.73-101.46Z"
            fill="url(#edEvCAwTnKp457-fill)"
          />
          <path
            d="M2606.29,4106.91l-151.71-87.59v22.31l151.71,87.59v-22.31Z"
            fill="url(#edEvCAwTnKp458-fill)"
          />
          <path
            d="M2545.47,4142.02l60.82-35.11v22.31l-60.82,35.11v-22.31Z"
            fill="url(#edEvCAwTnKp459-fill)"
          />
          <g>
            <path
              d="M2567.06,4169.53c4.34,0,7.86-2.03,7.86-4.53c0-2.51-3.52-4.54-7.86-4.54s-7.85,2.03-7.85,4.54c0,2.5,3.51,4.53,7.85,4.53Z"
              fill="url(#edEvCAwTnKp461-fill)"
            />
          </g>
          <path
            d="M2567.39,4162.73l-7.73-22.31-5.78.67l7.72,22.31v0c.11.32.38.62.81.87c1.15.67,3.02.67,4.17,0c.73-.42.99-1,.81-1.54Z"
            fill="url(#edEvCAwTnKp462-fill)"
          />
          <path
            d="M2580.16,4153.19l-5.6-1.08-7.72,13.38v.01c-.34.59-.11,1.27.71,1.74c1.15.66,3.02.66,4.17,0c.34-.19.57-.42.71-.67v0l7.73-13.38Z"
            fill="url(#edEvCAwTnKp463-fill)"
          />
          <path
            d="M2556.45,4142.87c-1.15.67-3.02.67-4.17,0-1.16-.66-1.16-1.74,0-2.41c1.15-.66,3.02-.66,4.17,0c1.15.67,1.15,1.75,0,2.41Z"
            fill="url(#edEvCAwTnKp464-fill)"
          />
          <path
            d="M2577.04,4154.76c-1.15.67-3.02.67-4.17,0-1.15-.66-1.15-1.74,0-2.41c1.15-.66,3.02-.66,4.17,0c1.15.67,1.15,1.75,0,2.41Z"
            fill="url(#edEvCAwTnKp465-fill)"
          />
          <path
            d="M2648.28,4095.46L2472.55,3994v22.31l175.73,105.92v-26.77Z"
            fill="#005289"
          />
          <path d="M2472.55,3994l-80.5,46.48v26.77l80.5-50.94v-22.31Z" fill="#005289" />
          <path
            d="M2567.78,4141.93l80.5-46.47v26.77l-80.5,46.47v-26.77Z"
            fill="url(#edEvCAwTnKp468-fill)"
          />
          <path
            d="M2392.05,4040.48l80.5-46.48l175.73,101.46-80.5,46.47-175.73-101.45Z"
            fill="#005289"
          />
          <path
            d="M2527.66,4096.15l39.4-22.75-115.93-66.93-39.4,22.75l115.93,66.93Z"
            fill="#005289"
          />
          <path
            d="M2567.05,4073.4v-7.94l-115.92-66.92v7.93l115.92,66.93Z"
            fill="#005289"
          />
          <path
            d="M2567.06,4065.46c0,0-11.29.09-19.7,4.95-8.42,4.86-15.7,11.64-19.7,17.8l-115.93-66.92c4.01-6.17,11.29-12.95,19.7-17.81c8.42-4.86,19.7-4.94,19.7-4.94l115.93,66.92Z"
            fill="#005289"
          />
          <path
            d="M2567.06,4065.46v7.94l-39.4,22.75v-7.94c4-6.16,11.28-12.94,19.7-17.8c8.41-4.86,19.7-4.95,19.7-4.95Z"
            fill="url(#edEvCAwTnKp473-fill)"
          />
          <g>
            <path
              d="M2393.76,4054.43l151.71,87.59v22.31l-151.71-87.59v-22.31Z"
              fill="#1674b4"
            />
            <path
              d="M2392.05,4040.48l175.73,101.45v26.77l-175.73-101.45v-26.77Z"
              fill="#1674b4"
            />
            <path
              d="M2527.66,4088.21v7.94l-115.93-66.93v-7.93l115.93,66.92Z"
              fill="#1674b4"
            />
          </g>
        </g>
        <g>
          <g>
            <g>
              <path
                d="M2879.29,3876.21l-327.5,93.16v3.49c0,2.73,1.8,5.47,5.41,7.56l62.83,36.27c7.22,4.16,18.93,4.16,26.15,0l227.69-129.41c3.61-2.09,5.42-4.82,5.42-7.56v-3.51Z"
                fill="#1674b4"
              />
              <path
                d="M2646.19,4013.13l227.68-129.41c7.23-4.17,7.23-10.93,0-15.1l-62.8-36.28c-7.22-4.17-18.93-4.17-26.16,0l-227.7,129.41c-7.22,4.17-7.23,10.93,0,15.1l62.82,36.28c7.22,4.17,18.93,4.17,26.16,0Z"
                fill="#005289"
              />
            </g>
            <g>
              <path
                d="M2730.05,3833.44l58.21,34.22v44.69l-58.21-34.23v-44.68Z"
                fill="url(#edEvCAwTnKp484-fill)"
              />
              <path
                d="M2788.26,3867.66l31.93-18.44v44.69l-31.93,18.44v-44.69Z"
                fill="#1674b4"
              />
              <path
                d="M2730.05,3833.44l31.94-18.44l58.2,34.22-31.93,18.44-58.21-34.22Z"
                fill="#005289"
              />
            </g>
            <g>
              <path
                d="M2672.05,3868.44l58.21,34.22v44.68l-58.21-34.22v-44.68Z"
                fill="url(#edEvCAwTnKp488-fill)"
              />
              <path
                d="M2730.26,3902.66l31.93-18.44v44.69l-31.93,18.43v-44.68Z"
                transform="translate(0-1.402301)"
                fill="#1674b4"
              />
              <path
                d="M2672.05,3868.44l31.94-18.44l58.2,34.22-31.93,18.44-58.21-34.22Z"
                fill="#005289"
              />
            </g>
            <g>
              <path
                d="M2582.05,3920.44l58.21,34.22v44.68l-58.21-34.22v-44.68Z"
                fill="url(#edEvCAwTnKp492-fill)"
              />
              <path
                d="M2640.26,3954.66l31.93-18.44v44.69l-31.93,18.43v-44.68Z"
                fill="#1674b4"
              />
              <path
                d="M2582.05,3920.44l31.94-18.44l58.2,34.22-31.93,18.44-58.21-34.22Z"
                fill="#005289"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M2989.02,3945.21l-327.5,93.16v3.49c0,2.73,1.8,5.47,5.42,7.56l62.82,36.27c7.22,4.16,18.93,4.16,26.15,0l227.69-129.41c3.61-2.09,5.42-4.82,5.42-7.56v-3.51Z"
                fill="#1674b4"
              />
              <path
                d="M2755.92,4082.13l227.68-129.41c7.23-4.17,7.23-10.93,0-15.1l-62.8-36.28c-7.22-4.17-18.93-4.17-26.16,0l-227.7,129.41c-7.22,4.17-7.23,10.93,0,15.1l62.82,36.28c7.22,4.17,18.93,4.17,26.16,0Z"
                fill="#005289"
              />
            </g>
            <g>
              <path
                d="M2839.79,3902.44l58.2,34.22v44.69l-58.2-34.23v-44.68Z"
                fill="url(#edEvCAwTnKp500-fill)"
              />
              <path
                d="M2897.99,3936.66l31.93-18.44v44.69l-31.93,18.44v-44.69Z"
                fill="#1674b4"
              />
              <path
                d="M2839.79,3902.44l31.93-18.44l58.2,34.22-31.93,18.44-58.2-34.22Z"
                fill="#005289"
              />
            </g>
            <g>
              <path
                d="M2781.79,3937.44l58.2,34.22v44.68l-58.2-34.22v-44.68Z"
                fill="url(#edEvCAwTnKp504-fill)"
              />
              <path
                d="M2839.99,3971.66l31.93-18.44v44.69l-31.93,18.43v-44.68Z"
                fill="#1674b4"
              />
              <path
                d="M2781.79,3937.44l31.93-18.44l58.2,34.22-31.93,18.44-58.2-34.22Z"
                fill="#005289"
              />
            </g>
            <g>
              <path
                d="M2691.79,3989.44l58.2,34.22v44.68l-58.2-34.22v-44.68Z"
                fill="url(#edEvCAwTnKp508-fill)"
              />
              <path
                d="M2749.99,4023.66l31.93-18.44v44.69l-31.93,18.43v-44.68Z"
                fill="#1674b4"
              />
              <path
                d="M2691.79,3989.44l31.93-18.44l58.2,34.22-31.93,18.44-58.2-34.22Z"
                fill="#005289"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M3104.29,4009.21l-327.5,93.16v3.49c0,2.73,1.8,5.47,5.41,7.56l62.83,36.27c7.22,4.16,18.93,4.16,26.15,0l227.69-129.41c3.61-2.09,5.42-4.82,5.42-7.56v-3.51Z"
                fill="#1674b4"
              />
              <path
                d="M2871.19,4146.13l227.68-129.41c7.23-4.17,7.23-10.93,0-15.1l-62.8-36.28c-7.22-4.17-18.93-4.17-26.16,0l-227.7,129.41c-7.22,4.17-7.23,10.93,0,15.1l62.82,36.28c7.22,4.17,18.93,4.17,26.16,0Z"
                fill="#005289"
              />
            </g>
            <g>
              <path
                d="M2955.05,3966.44l58.21,34.22v44.69l-58.21-34.23v-44.68Z"
                fill="url(#edEvCAwTnKp516-fill)"
              />
              <path
                d="M3013.26,4000.66l31.93-18.44v44.69l-31.93,18.44v-44.69Z"
                fill="#1674b4"
              />
              <path
                d="M2955.05,3966.44l31.94-18.44l58.2,34.22-31.93,18.44-58.21-34.22Z"
                fill="#005289"
              />
            </g>
            <g>
              <path
                d="M2897.05,4001.44l58.21,34.22v44.68l-58.21-34.22v-44.68Z"
                fill="url(#edEvCAwTnKp520-fill)"
              />
              <path
                d="M2955.26,4035.66l31.93-18.44v44.69l-31.93,18.43v-44.68Z"
                fill="#1674b4"
              />
              <path
                d="M2897.05,4001.44l31.94-18.44l58.2,34.22-31.93,18.44-58.21-34.22Z"
                fill="#005289"
              />
            </g>
            <g>
              <path
                d="M2807.05,4053.44l58.21,34.22v44.68l-58.21-34.22v-44.68Z"
                fill="url(#edEvCAwTnKp524-fill)"
              />
              <path
                d="M2865.26,4087.66l31.93-18.44v44.69l-31.93,18.43v-44.68Z"
                fill="#1674b4"
              />
              <path
                d="M2807.05,4053.44l31.94-18.44l58.2,34.22-31.93,18.44-58.21-34.22Z"
                fill="#005289"
              />
            </g>
          </g>
        </g>
      </g>
      <path
        d="M5614.71,2583.37l444.7-251.75c7.23-4.17,7.23-10.93,0-15.1l-62.8-36.28c-7.22-4.17-18.93-4.17-26.16,0l-444.72,251.74c-7.22,4.17-7.23,10.94,0,15.11l62.82,36.28c7.22,4.16,18.93,4.16,26.16,0Z"
        fill="#005289"
      />
      <path
        d="M4163.08,3296.54l38.25,22.49v15.57l-38.25-22.49v-15.57Z"
        fill="url(#edEvCAwTnKp528-fill)"
      />
      <path d="M4201.33,3319.03l63.68-38.42v15.57l-63.68,38.42v-15.57Z" fill="#1674b4" />
      <path
        d="M4163.08,3296.54l63.68-38.42l38.25,22.49-63.68,38.42-38.25-22.49Z"
        fill="#005289"
      />
      <path
        d="M5916.51,2296.14l69.6,40.71v17.65l-69.6-40.71v-17.65Z"
        fill="url(#edEvCAwTnKp531-fill)"
      />
      <path d="M5986.12,2336.85l34.18-19.53v17.65l-34.18,19.53v-17.65Z" fill="#1674b4" />
      <path
        d="M5916.51,2296.14l34.19-19.54l69.6,40.72-34.19,19.53-69.6-40.71Z"
        fill="#005289"
      />
      <path
        d="M5868.47,2324.3l34.19-19.53l69.6,40.71-34.19,19.53-69.6-40.71Z"
        fill="#005289"
      />
      <path
        d="M6049.38,2243.89l38.24,22.48v20.39l-38.24-22.48v-20.39Z"
        fill="url(#edEvCAwTnKp535-fill)"
      />
      <path
        d="M2626.43,4287.31L2314.8,4397.5v3.49c0,2.73,1.81,5.47,5.42,7.56l36.34,22.25c7.23,4.17,18.93,4.17,26.16,0l238.29-132.42c3.62-2.09,5.42-4.82,5.42-7.56v-3.51Z"
        fill="#1674b4"
      />
      <path
        d="M2382.72,4427.24l238.29-132.43c7.23-4.16,7.23-10.93.01-15.1l-36.32-22.25c-7.22-4.17-18.94-4.18-26.16-.01l-238.31,132.43c-7.23,4.17-7.24,10.93-.01,15.1l36.34,22.26c7.22,4.17,18.94,4.17,26.16,0Z"
        fill="#005289"
      />
      <path d="M6087.62,2266.37l41.84-24.19v20.39l-41.84,24.19v-20.39Z" fill="#1674b4" />
      <path
        d="M6049.38,2243.89l41.83-24.19l38.25,22.48-41.84,24.19-38.24-22.48Z"
        fill="#005289"
      />
      <path
        d="M6365.4,2041.08l69.6,40.72v17.65l-69.6-40.71v-17.66Z"
        fill="url(#edEvCAwTnKp540-fill)"
      />
      <path d="M6435.01,2081.8l34.18-19.53v17.65l-34.18,19.53v-17.65Z" fill="#1674b4" />
      <path
        d="M6365.4,2041.08l34.19-19.53l69.6,40.72L6435,2081.8l-69.6-40.72Z"
        fill="#005289"
      />
      <path
        d="M6317.36,2069.25l69.6,40.71v17.65l-69.6-40.71v-17.65Z"
        fill="url(#edEvCAwTnKp543-fill)"
      />
      <path d="M6386.96,2109.96l34.19-19.53v17.65l-34.19,19.53v-17.65Z" fill="#1674b4" />
      <path
        d="M6317.36,2069.25l34.19-19.54l69.6,40.72-34.19,19.53-69.6-40.71Z"
        fill="#005289"
      />
      <path
        d="M6269.32,2097.41l69.6,40.71v17.66l-69.6-40.72v-17.65Z"
        fill="url(#edEvCAwTnKp546-fill)"
      />
      <path d="M6338.92,2138.12l34.19-19.53v17.66l-34.19,19.53v-17.66Z" fill="#1674b4" />
      <path
        d="M6269.32,2097.41l34.19-19.53l69.6,40.71-34.19,19.53-69.6-40.71Z"
        fill="#005289"
      />
      <path
        d="M6175.07,2160.45l58.21,34.23v22.19l-58.21-34.22v-22.2Z"
        fill="url(#edEvCAwTnKp549-fill)"
      />
      <path d="M6233.28,2194.68l61.67-35.37v22.19l-61.67,35.37v-22.19Z" fill="#1674b4" />
      <path
        d="M6175.07,2160.45l61.67-35.37l58.21,34.23-61.67,35.37-58.21-34.23Z"
        fill="#005289"
      />
      <path
        d="M6196.82,2120.23l36.3,21.35v37.94l-36.3-21.34v-37.95Z"
        fill="url(#edEvCAwTnKp552-fill)"
      />
      <path d="M6233.12,2141.58l38.46-22.06v37.94l-38.46,22.06v-37.94Z" fill="#1674b4" />
      <path
        d="M6196.82,2120.23l38.46-22.05l36.3,21.34-38.46,22.06-36.3-21.35Z"
        fill="#005289"
      />
      <path
        d="M4901.8,2603.19l62.02,36.46v33.06l-62.02-36.46v-33.06Z"
        fill="url(#edEvCAwTnKp555-fill)"
      />
      <path d="M4963.81,2639.65l62.22-35.49v33.06l-62.22,35.49v-33.06Z" fill="#1674b4" />
      <path
        d="M4901.8,2603.19l62.22-35.49l62.01,36.46-62.21,35.49-62.02-36.46Z"
        fill="#005289"
      />
      <path
        d="M4924.59,2578.37l39.26,23.08v20.93l-39.26-23.08v-20.93Z"
        fill="url(#edEvCAwTnKp558-fill)"
      />
      <path d="M4963.85,2601.45l39.39-22.47v20.93l-39.39,22.47v-20.93Z" fill="#1674b4" />
      <path
        d="M4924.59,2578.37l39.39-22.47l39.26,23.08-39.39,22.47-39.26-23.08Z"
        fill="#005289"
      />
      <path
        d="M4775.96,2672.91l62.02,36.46v33.06l-62.02-36.46v-33.06Z"
        fill="url(#edEvCAwTnKp561-fill)"
      />
      <path
        d="M4837.98,2709.37l102.62-59.74v33.06l-102.62,59.74v-33.06Z"
        fill="#1674b4"
      />
      <path
        d="M4775.96,2672.91l102.63-59.74l62.01,36.46-102.62,59.74-62.02-36.46Z"
        fill="#005289"
      />
      <g>
        <path
          d="M5189.08,2690.09l-327.5,93.16v3.49c0,2.73,1.81,5.47,5.42,7.55l62.82,36.27c7.23,4.17,18.93,4.17,26.16,0l227.69-129.4c3.61-2.09,5.41-4.82,5.41-7.56v-3.51Z"
          fill="#1674b4"
        />
        <path
          d="M4955.99,2827.01l227.68-129.41c7.23-4.17,7.23-10.94,0-15.11l-62.8-36.27c-7.22-4.17-18.93-4.17-26.16,0l-227.7,129.41c-7.22,4.17-7.23,10.93,0,15.1l62.82,36.28c7.22,4.16,18.93,4.16,26.16,0Z"
          fill="#005289"
        />
      </g>
      <path
        d="M4964.12,2694.44l62.01,36.47v33.06l-62.01-36.47v-33.06Z"
        fill="url(#edEvCAwTnKp567-fill)"
      />
      <path
        d="M5026.13,2730.91l102.63-59.74v33.06l-102.63,59.74v-33.06Z"
        fill="#1674b4"
      />
      <path
        d="M4964.12,2694.44l102.62-59.74l62.02,36.47-102.63,59.74-62.01-36.47Z"
        fill="#005289"
      />
      <g>
        <path
          d="M5303.56,2755.83l-327.5,93.16v3.49c0,2.73,1.81,5.47,5.42,7.55l62.82,36.28c7.23,4.16,18.93,4.16,26.16,0l227.68-129.41c3.62-2.09,5.42-4.82,5.42-7.56v-3.51Z"
          fill="#1674b4"
        />
        <path
          d="M5070.47,2892.75l227.67-129.41c7.23-4.17,7.24-10.93.01-15.11l-62.8-36.27c-7.22-4.17-18.94-4.17-26.16,0l-227.7,129.41c-7.22,4.17-7.23,10.93,0,15.1l62.82,36.28c7.22,4.16,18.93,4.16,26.16,0Z"
          fill="#005289"
        />
      </g>
      <path
        d="M5131.89,2731.27l62.02,36.46v33.06l-62.02-36.46v-33.06Z"
        fill="url(#edEvCAwTnKp573-fill)"
      />
      <path d="M5193.91,2767.73l62.21-35.49v33.06l-62.21,35.49v-33.06Z" fill="#1674b4" />
      <path
        d="M5131.89,2731.27l62.22-35.49l62.01,36.46-62.21,35.49-62.02-36.46Z"
        fill="#005289"
      />
      <path
        d="M5154.69,2706.45l39.25,23.08v20.93l-39.25-23.08v-20.93Z"
        fill="url(#edEvCAwTnKp576-fill)"
      />
      <path d="M5193.94,2729.53l39.39-22.47v20.93l-39.39,22.47v-20.93Z" fill="#1674b4" />
      <path
        d="M5154.69,2706.45l39.38-22.47l39.26,23.08-39.39,22.47-39.25-23.08Z"
        fill="#005289"
      />
      <path
        d="M5006.06,2800.99l62.01,36.46v33.06l-62.01-36.46v-33.06Z"
        fill="url(#edEvCAwTnKp579-fill)"
      />
      <path
        d="M5068.07,2837.45l102.62-59.74v33.06l-102.62,59.74v-33.06Z"
        fill="#1674b4"
      />
      <path
        d="M5006.06,2800.99l102.62-59.74l62.01,36.46-102.62,59.74-62.01-36.46Z"
        fill="#005289"
      />
      <path
        d="M4866.62,2683.92c0-.5-.33-1-.99-1.38l-.92-.53c-1.83-1.05-4.78-1.05-6.61,0l-5.78,3.34v110.68l5.78-3.34c1.83-1.05,4.78-1.05,6.61,0l.92.53c.66.38.99.88.99,1.38v-110.68Z"
        fill="url(#edEvCAwTnKp582-fill)"
      />
      <path
        d="M4865.04,2686.11c0-.3.2-.59.6-.82.65-.38.98-.87.98-1.37v110.68c0,.49-.33.99-.98,1.37-.4.22-.6.52-.6.82v-110.68Z"
        fill="url(#edEvCAwTnKp583-fill)"
      />
      <path
        d="M4871.19,2691.14c0-.62-.41-1.23-1.23-1.7l-4.32-2.5c-.4-.23-.6-.53-.6-.83v110.68c0,.3.2.6.6.82l4.32,2.5c.82.47,1.23,1.09,1.23,1.71v-110.68Z"
        fill="url(#edEvCAwTnKp584-fill)"
      />
      <path
        d="M4852.32,2685.35l5.06,2.92l1.55.89l8.7,5.03v110.68l-8.7-5.03-1.55-.9-5.06-2.91v-110.68Z"
        fill="url(#edEvCAwTnKp585-fill)"
      />
      <path
        d="M4867.63,2694.19l2.33-1.35c.82-.47,1.23-1.08,1.23-1.7v110.68c0,.61-.41,1.23-1.23,1.7l-2.33,1.35v-110.68Z"
        fill="url(#edEvCAwTnKp586-fill)"
      />
      <path
        d="M4852.32,2685.35l5.78-3.34c1.83-1.05,4.78-1.05,6.61,0l.92.53c.66.38.99.88.99,1.38s-.33.99-.99,1.37c-.39.23-.59.52-.59.82s.2.6.59.83l4.33,2.5c.82.47,1.23,1.08,1.23,1.7s-.41,1.23-1.23,1.7l-2.33,1.35-8.7-5.03-1.55-.89-5.06-2.92Z"
        fill="#005289"
      />
      <path
        d="M4875.57,2698.77l-25.7-14.84v110.68l25.7,14.83v-110.67Z"
        fill="url(#edEvCAwTnKp588-fill)"
      />
      <path
        d="M4849.86,2683.93l-34.46,19.9v110.68l34.46-19.9v-110.68Z"
        fill="url(#edEvCAwTnKp589-fill)"
      />
      <path
        d="M4815.4,2703.83l25.7,14.84v110.67l-25.7-14.83v-110.68Z"
        fill="url(#edEvCAwTnKp590-fill)"
      />
      <path
        d="M4815.4,2703.83l34.46-19.9l25.7,14.84-34.46,19.9-25.7-14.84Z"
        fill="#005289"
      />
      <path
        d="M4815.4,2712.03l-23.14-13.36v102.48l23.14,13.36v-102.48Z"
        fill="url(#edEvCAwTnKp592-fill)"
      />
      <path
        d="M4792.26,2698.67l-25.7,14.84v102.48l25.7-14.84v-102.48Z"
        fill="url(#edEvCAwTnKp593-fill)"
      />
      <path
        d="M4766.56,2713.51l23.14,13.36v102.47l-23.14-13.35v-102.48Z"
        fill="url(#edEvCAwTnKp594-fill)"
      />
      <path
        d="M4789.7,2726.87l25.7-14.84v102.48l-25.7,14.83v-102.47Z"
        fill="url(#edEvCAwTnKp595-fill)"
      />
      <path
        d="M4766.56,2713.51l25.7-14.84l23.14,13.36-25.7,14.84-23.14-13.36Z"
        fill="#005289"
      />
      <path
        d="M4854.17,2713.92l-38.77-22.39v122.98l38.77,22.38v-122.97Z"
        fill="url(#edEvCAwTnKp597-fill)"
      />
      <path
        d="M4815.4,2691.53l-25.7,14.84v122.97l25.7-14.83v-122.98Z"
        fill="url(#edEvCAwTnKp598-fill)"
      />
      <path
        d="M4789.7,2706.37l38.77,22.39v122.97l-38.77-22.39v-122.97Z"
        fill="url(#edEvCAwTnKp599-fill)"
      />
      <path
        d="M4789.7,2706.37l25.7-14.84l38.77,22.39-25.7,14.84-38.77-22.39Z"
        fill="#005289"
      />
      <path
        d="M4881.13,2749.98l-26.96-15.57v102.48l26.96,15.56v-102.47Z"
        fill="url(#edEvCAwTnKp601-fill)"
      />
      <path
        d="M4854.17,2734.41l-25.7,14.84v102.48l25.7-14.84v-102.48Z"
        fill="url(#edEvCAwTnKp602-fill)"
      />
      <path
        d="M4869.97,2869.37l-7.29-4.21v10.25l7.29,4.21v-10.25Z"
        fill="url(#edEvCAwTnKp603-fill)"
      />
      <path
        d="M4862.68,2865.16l-1.28.74v10.25l1.28-.74v-10.25Z"
        fill="url(#edEvCAwTnKp604-fill)"
      />
      <path
        d="M4861.4,2865.9l7.3,4.21v10.25l-7.3-4.21v-10.25Z"
        fill="url(#edEvCAwTnKp605-fill)"
      />
      <path
        d="M4868.7,2870.11l1.27-.73v10.24l-1.27.74v-10.25Z"
        fill="url(#edEvCAwTnKp606-fill)"
      />
      <path
        d="M4861.4,2865.9l1.28-.74l7.29,4.21-1.27.74-7.3-4.21Z"
        fill="url(#edEvCAwTnKp607-fill)"
      />
      <path
        d="M4849.94,2880.94l-7.3-4.21v10.25l7.3,4.21v-10.25Z"
        fill="url(#edEvCAwTnKp608-fill)"
      />
      <path
        d="M4842.64,2876.73l-1.28.74v10.25l1.28-.74v-10.25Z"
        fill="url(#edEvCAwTnKp609-fill)"
      />
      <path
        d="M4841.36,2877.47l7.3,4.21v10.25l-7.3-4.21v-10.25Z"
        fill="url(#edEvCAwTnKp610-fill)"
      />
      <path
        d="M4848.66,2881.68l1.28-.74v10.25l-1.28.74v-10.25Z"
        fill="url(#edEvCAwTnKp611-fill)"
      />
      <path
        d="M4841.36,2877.47l1.28-.74l7.3,4.21-1.28.74-7.3-4.21Z"
        fill="url(#edEvCAwTnKp612-fill)"
      />
      <path
        d="M4815.4,2733.51l-25.7-14.84v110.67l25.7,14.84v-110.67Z"
        fill="url(#edEvCAwTnKp613-fill)"
      />
      <path
        d="M4789.7,2718.67l-34.47,19.9v110.67l34.47-19.9v-110.67Z"
        fill="url(#edEvCAwTnKp614-fill)"
      />
      <path
        d="M4755.23,2738.57l25.7,14.83v110.68l-25.7-14.84v-110.67Z"
        fill="url(#edEvCAwTnKp615-fill)"
      />
      <path
        d="M4755.23,2738.57l34.47-19.9l25.7,14.84-34.47,19.89-25.7-14.83Z"
        fill="#005289"
      />
      <path d="M2550.49,4295.47l41.84-24.19v20.39l-41.84,24.19v-20.39Z" fill="#1674b4" />
      <path
        d="M2512.25,4272.98l41.83-24.19l38.25,22.49-41.84,24.19-38.24-22.49Z"
        fill="#005289"
      />
      <path
        d="M4773,2748.83l-8.7-5.03-1.56-.9-5.05-2.91v110.67l5.05,2.92l1.56.9l8.7,5.02v-110.67Z"
        fill="url(#edEvCAwTnKp619-fill)"
      />
      <path
        d="M4750.54,2745.23c0,.69.45,1.38,1.37,1.91l.92.53c1.32.76,3.45.76,4.76,0c.79-.45,2.06-.45,2.85,0l4.33,2.5c1.63.94,4.27.94,5.9,0l2.33-1.34v110.67l-2.33,1.35c-1.63.94-4.27.94-5.9,0l-4.33-2.5c-.79-.46-2.06-.46-2.85,0-1.31.76-3.44.76-4.76,0l-.92-.54c-.92-.53-1.37-1.22-1.37-1.91v-110.67Z"
        fill="url(#edEvCAwTnKp620-fill)"
      />
      <path
        d="M4750.54,2745.23c0-.69.46-1.38,1.37-1.91l5.78-3.33l5.05,2.91l1.56.9l8.7,5.03-2.33,1.34c-1.63.94-4.27.94-5.9,0l-4.33-2.5c-.79-.45-2.06-.45-2.85,0-1.31.76-3.44.76-4.76,0l-.92-.53c-.92-.53-1.37-1.22-1.37-1.91Z"
        fill="#005289"
      />
      <path
        d="M4843.94,2854.35l-31.95-18.45v10.25l31.95,18.44v-10.24Z"
        fill="url(#edEvCAwTnKp622-fill)"
      />
      <path
        d="M4811.99,2835.9l-21.31,12.31v10.25l21.31-12.31v-10.25Z"
        fill="url(#edEvCAwTnKp623-fill)"
      />
      <path
        d="M4822.62,2866.65l21.32-12.3v10.24l-21.32,12.31v-10.25Z"
        fill="url(#edEvCAwTnKp624-fill)"
      />
      <path
        d="M4790.68,2848.21l21.31-12.31l31.95,18.45-21.31,12.3-31.95-18.44Z"
        fill="url(#edEvCAwTnKp625-fill)"
      />
      <path
        d="M4876.59,2862.95l-64.6-37.3v10.25l64.6,37.3v-10.25Z"
        fill="url(#edEvCAwTnKp626-fill)"
      />
      <path
        d="M4811.99,2825.65l-21.31,12.31v10.25l21.31-12.31v-10.25Z"
        fill="url(#edEvCAwTnKp627-fill)"
      />
      <path
        d="M6064.83,2324.11l-544.52,215.5v3.49c0,2.73,1.8,5.46,5.42,7.55l62.82,36.27c7.22,4.17,18.93,4.17,26.16,0l444.7-251.74c3.61-2.09,5.42-4.82,5.42-7.56v-3.51Z"
        fill="#1674b4"
      />
      <path
        d="M5712.64,2395.27l58.21,34.22v44.69l-58.21-34.22v-44.69Z"
        fill="url(#edEvCAwTnKp629-fill)"
      />
      <path d="M5770.85,2429.49l31.93-18.43v44.68l-31.93,18.44v-44.69Z" fill="#1674b4" />
      <path
        d="M5661.41,2426.36l58.21,34.22v44.69l-58.21-34.22v-44.69Z"
        fill="url(#edEvCAwTnKp631-fill)"
      />
      <path d="M5719.62,2460.58l31.93-18.43v44.68l-31.93,18.44v-44.69Z" fill="#1674b4" />
      <path
        d="M5661.41,2426.36l31.93-18.43l58.21,34.22-31.93,18.43-58.21-34.22Z"
        fill="#005289"
      />
      <path
        d="M5712.3,2394.79l31.93-18.43l58.21,34.22-31.93,18.44-58.21-34.23Z"
        fill="#005289"
      />
      <path
        d="M5610.26,2456.89l58.2,34.22v44.69l-58.2-34.22v-44.69Z"
        fill="url(#edEvCAwTnKp635-fill)"
      />
      <path
        d="M5557.43,2484.67l58.2,34.22v44.69l-58.2-34.22v-44.69Z"
        fill="url(#edEvCAwTnKp636-fill)"
      />
      <path d="M5668.46,2491.27l31.93-18.43v44.68l-31.93,18.44v-44.69Z" fill="#1674b4" />
      <path
        d="M5610.26,2456.89l31.93-18.44l58.2,34.23-31.93,18.43-58.2-34.22Z"
        fill="#005289"
      />
      <path d="M5616.34,2519.55l31.94-18.43v44.68l-31.94,18.44v-44.69Z" fill="#1674b4" />
      <path
        d="M5558.14,2485.33l31.93-18.44l58.21,34.23-31.94,18.43-58.2-34.22Z"
        fill="#005289"
      />
      <path
        d="M5868.47,2324.3l69.6,40.71v17.66l-69.6-40.72v-17.65Z"
        fill="url(#edEvCAwTnKp641-fill)"
      />
      <path d="M5938.07,2365.01l34.19-19.53v17.66l-34.19,19.53v-17.66Z" fill="#1674b4" />
      <path
        d="M5820.43,2352.46l69.6,40.71v17.66l-69.6-40.72v-17.65Z"
        fill="url(#edEvCAwTnKp643-fill)"
      />
      <path d="M5890.03,2393.17l34.18-19.53v17.66l-34.18,19.53v-17.66Z" fill="#1674b4" />
      <path
        d="M5820.43,2352.46l34.19-19.53l69.59,40.71-34.18,19.53-69.6-40.71Z"
        fill="#005289"
      />
      <path
        d="M5318.29,2368.45l62.02,36.47v33.06l-62.02-36.47v-33.06Z"
        fill="url(#edEvCAwTnKp646-fill)"
      />
      <path d="M5380.31,2404.92l62.22-35.5v33.06l-62.22,35.5v-33.06Z" fill="#1674b4" />
      <path
        d="M5318.29,2368.45l62.22-35.49l62.02,36.46-62.22,35.5-62.02-36.47Z"
        fill="#005289"
      />
      <path
        d="M5341.09,2343.63l39.26,23.08v20.93l-39.26-23.08v-20.93Z"
        fill="url(#edEvCAwTnKp649-fill)"
      />
      <path d="M5380.35,2366.71l39.38-22.46v20.92l-39.38,22.47v-20.93Z" fill="#1674b4" />
      <path
        d="M5341.09,2343.63l39.39-22.47l39.25,23.09-39.38,22.46-39.26-23.08Z"
        fill="#005289"
      />
      <path
        d="M2064.56,4475.93l-628.47,263.58v3.5c0,2.73,1.81,5.46,5.42,7.55l62.82,36.27c7.23,4.17,18.93,4.17,26.16,0l528.66-299.84c3.61-2.08,5.42-4.82,5.42-7.55l-.01-3.51Z"
        fill="#1674b4"
      />
      <path
        d="M2172.5,4542.64l-238.69-14.99v3.5c0,2.72,1.8,5.46,5.42,7.55l112.34,68.43c7.22,4.17,18.92,4.17,26.15,0l89.36-53.42c3.62-2.09,5.42-4.82,5.42-7.56v-3.51Z"
        fill="#1674b4"
      />
      <path
        d="M2077.73,4603.57l89.35-53.43c7.23-4.16,7.23-10.93.01-15.1l-112.32-68.43c-7.22-4.17-18.93-4.17-26.16-.01l-89.37,53.43c-7.23,4.17-7.24,10.93-.01,15.11l112.34,68.43c7.22,4.17,18.93,4.17,26.16,0Z"
        fill="#005289"
      />
      <path
        d="M1530.5,4784.08l528.65-299.84c7.23-4.17,7.23-10.93,0-15.1l-62.8-36.28c-7.22-4.17-18.93-4.17-26.16,0L1441.52,4732.7c-7.22,4.17-7.23,10.93,0,15.1l62.82,36.28c7.22,4.16,18.93,4.16,26.16,0Z"
        fill="#005289"
      />
      <path
        d="M1949.24,4432.76l69.6,40.71v17.66l-69.6-40.72v-17.65Z"
        fill="url(#edEvCAwTnKp656-fill)"
      />
      <path d="M2018.84,4473.47l34.19-19.53v17.66l-34.19,19.53v-17.66Z" fill="#1674b4" />
      <path
        d="M1949.24,4432.76l34.19-19.53l69.6,40.71-34.19,19.53-69.6-40.71Z"
        fill="#005289"
      />
      <path
        d="M2329.86,4455.02l-162.7,31.19v3.49c0,2.73,1.81,5.47,5.42,7.56l36.34,22.25c7.23,4.17,18.93,4.17,26.16,0l89.36-53.42c3.61-2.09,5.42-4.82,5.42-7.56v-3.51Z"
        fill="#1674b4"
      />
      <path
        d="M2235.09,4515.95l89.35-53.42c7.23-4.17,7.23-10.93.01-15.1l-36.33-22.26c-7.22-4.17-18.93-4.17-26.16,0l-89.37,53.42c-7.23,4.17-7.23,10.94-.01,15.11l36.35,22.25c7.21,4.17,18.93,4.17,26.16,0Z"
        fill="#005289"
      />
      <path
        d="M1938.36,4416.65l-327.5,93.16v3.49c0,2.73,1.81,5.47,5.42,7.55l62.82,36.27c7.23,4.17,18.93,4.17,26.16,0l227.68-129.4c3.62-2.09,5.42-4.82,5.42-7.56v-3.51Z"
        fill="#1674b4"
      />
      <path
        d="M1705.27,4553.57l227.68-129.41c7.22-4.17,7.23-10.94,0-15.11l-62.8-36.27c-7.22-4.17-18.93-4.17-26.16-.01l-227.7,129.42c-7.22,4.17-7.23,10.93,0,15.1l62.82,36.28c7.22,4.16,18.93,4.16,26.16,0Z"
        fill="#005289"
      />
      <path
        d="M2393.23,4159.82l-327.51,93.16v3.49c0,2.73,1.81,5.47,5.43,7.56l62.82,36.27c7.22,4.16,18.93,4.16,26.15,0l227.69-129.41c3.61-2.09,5.42-4.82,5.42-7.56v-3.51Z"
        fill="#1674b4"
      />
      <path
        d="M2160.14,4296.74l227.67-129.41c7.23-4.17,7.23-10.94.01-15.11l-62.8-36.27c-7.22-4.17-18.94-4.17-26.16,0l-227.71,129.41c-7.22,4.17-7.23,10.93,0,15.1l62.83,36.28c7.21,4.16,18.93,4.16,26.16,0Z"
        fill="#005289"
      />
      <path
        d="M2525.26,4237.42l-348.41,82.63v3.5c0,2.72,1.8,5.46,5.42,7.55l83.73,46.79c7.22,4.17,18.93,4.17,26.15,0l227.69-129.41c3.61-2.08,5.42-4.81,5.42-7.55v-3.51Z"
        fill="#1674b4"
      />
      <path
        d="M2292.16,4374.34l227.68-129.42c7.23-4.16,7.23-10.93.01-15.1l-83.71-46.8c-7.22-4.17-18.94-4.17-26.16,0l-227.7,129.41c-7.23,4.17-7.23,10.94-.01,15.11l83.73,46.8c7.22,4.16,18.94,4.16,26.16,0Z"
        fill="#005289"
      />
      <path
        d="M1646.57,4582.16L1110.2,4793.31v3.49c0,2.73,1.81,5.46,5.42,7.55l62.82,36.27c7.23,4.17,18.93,4.17,26.16,0l436.55-247.39c3.62-2.09,5.42-4.82,5.42-7.56v-3.51Z"
        fill="#1674b4"
      />
      <path
        d="M1204.61,4837.07l436.54-247.4c7.23-4.17,7.23-10.93.01-15.1l-62.8-36.28c-7.22-4.17-18.94-4.17-26.16,0l-436.57,247.4c-7.23,4.16-7.23,10.93,0,15.1l62.82,36.28c7.22,4.16,18.93,4.16,26.16,0Z"
        fill="#005289"
      />
      <path
        d="M2240.66,4402.4l-335.54-60.2v3.49c0,2.73,1.81,5.47,5.42,7.56l201.23,114.38c7.22,4.17,18.93,4.17,26.16,0l97.31-54.16c3.61-2.09,5.42-4.82,5.42-7.56v-3.51v0Z"
        fill="#1674b4"
      />
      <path
        d="M2137.94,4464.08l97.3-54.18c7.23-4.16,7.23-10.93,0-15.1l-201.2-114.14c-7.22-4.18-18.94-4.18-26.16-.01l-97.33,53.93c-7.23,4.17-7.23,10.93,0,15.1l201.23,114.39c7.21,4.17,18.93,4.17,26.16.01Z"
        fill="#005289"
      />
      <g>
        <path d="M2023.74,4271.72l-52.98-30.58v80.6l52.98,30.59v-80.61Z" fill="#005289" />
        <path d="M1970.76,4241.14l-35,20.2v80.61l35-20.21v-80.6Z" fill="#005289" />
      </g>
      <path d="M1988.74,4291.93l35-20.21v80.61l-35,20.2v-80.6Z" fill="#005289" />
      <g>
        <path
          d="M1935.76,4261.34l35-20.2l52.98,30.58-35,20.21-52.98-30.59Z"
          fill="#005289"
        />
      </g>
      <path d="M2114.5,4255.03l-35-20.21v96.73l35,20.21v-96.73Z" fill="#005289" />
      <path d="M2079.5,4234.82l-45.88,26.49v96.73l45.88-26.49v-96.73Z" fill="#005289" />
      <path d="M2033.63,4261.31l-9.89-5.71v96.73l9.89,5.71v-96.73Z" fill="#005289" />
      <path d="M2023.74,4255.6l-35,20.21v96.72l35-20.2v-96.73Z" fill="#005289" />
      <path
        d="M1998.63,4281.52l-9.89-5.71v16.12l-52.98-30.59v80.61l52.98,30.58l9.89,5.71l35,20.21v-96.73l-35-20.2Z"
        fill="url(#edEvCAwTnKp681-fill)"
      />
      <path
        d="M2033.62,4301.72l35-20.2l45.88-26.49v96.73l-45.88,26.48-35,20.21v-96.73Z"
        fill="#1674b4"
      />
      <path
        d="M2033.62,4301.72l35-20.2l45.88-26.49v96.73l-45.88,26.48-35,20.21v-96.73Z"
        fill="#1674b4"
      />
      <path
        d="M2033.62,4301.72l35-20.2l45.88-26.49v96.73l-45.88,26.48-35,20.21v-96.73Z"
        fill="url(#edEvCAwTnKp684-fill)"
      />
      <path
        d="M1988.74,4275.81l35-20.21l9.89,5.71l45.87-26.49l35,20.21-45.87,26.49-35,20.2-35-20.2-9.89-5.71Z"
        fill="#005289"
      />
      <path
        d="M1518,4596.91l17.66-10.2v14.1l-17.66,10.2v-14.1Z"
        fill="url(#edEvCAwTnKp686-fill)"
      />
      <path
        d="M1535.66,4586.71l28.48,16.44v14.1l-28.48-16.44v-14.1Z"
        fill="url(#edEvCAwTnKp687-fill)"
      />
      <path
        d="M1564.14,4603.15l51.54-29.76c.93-.53,1.39-1.23,1.39-1.93v14.1c0,.7-.46,1.39-1.39,1.93l-51.54,29.76v-14.1Z"
        fill="url(#edEvCAwTnKp688-fill)"
      />
      <path
        d="M1442.29,4592.12c0,.71.46,1.41,1.39,1.95l64.75,37.37c1.85,1.07,4.85,1.07,6.7,0l31.34-18.09v14.1l-31.34,18.09c-1.85,1.07-4.85,1.07-6.7,0l-64.75-37.38c-.93-.54-1.39-1.24-1.39-1.94v-14.1Z"
        fill="url(#edEvCAwTnKp689-fill)"
      />
      <path
        d="M1442.29,4592.12c0-.69.47-1.39,1.39-1.93l100.55-58.05c1.85-1.07,4.86-1.07,6.71,0l64.74,37.38c.93.54,1.39,1.24,1.39,1.94s-.46,1.4-1.39,1.93l-51.54,29.76-28.47-16.44-17.67,10.2l28.47,16.44-31.34,18.09c-1.85,1.07-4.85,1.07-6.7,0l-64.75-37.37c-.92-.54-1.39-1.24-1.39-1.95Z"
        fill="#005289"
      />
      <path
        d="M1442.29,4570.98c0,.7.46,1.41,1.39,1.94l29.02,16.76c1.85,1.06,4.86,1.06,6.71,0l73.5-42.44v21.14l-73.5,42.44c-1.85,1.07-4.86,1.07-6.71,0l-29.02-16.75c-.93-.54-1.39-1.24-1.39-1.95v-21.14Z"
        fill="url(#edEvCAwTnKp691-fill)"
      />
      <path
        d="M1552.91,4547.24l32.37,18.69c1.85,1.07,4.86,1.07,6.71,0l23.69-13.68c.93-.53,1.39-1.23,1.39-1.93v21.14c0,.7-.46,1.4-1.39,1.93l-23.69,13.68c-1.85,1.07-4.86,1.07-6.71,0l-32.37-18.69v-21.14Z"
        fill="url(#edEvCAwTnKp692-fill)"
      />
      <path
        d="M1442.29,4570.98c0-.7.47-1.4,1.39-1.93L1544.23,4511c1.85-1.07,4.86-1.07,6.71,0l1.41.81l30.96,17.88l32.37,18.69c.93.53,1.39,1.24,1.39,1.94s-.46,1.4-1.39,1.93l-23.69,13.68c-1.85,1.07-4.86,1.07-6.71,0l-32.37-18.69-73.5,42.44c-1.85,1.07-4.86,1.07-6.71,0l-29.02-16.76c-.92-.53-1.39-1.24-1.39-1.94Z"
        fill="#005289"
      />
      <path
        d="M1451.99,4562.79l26.05,15.04v7.05l-26.05-15.04v-7.05Z"
        fill="url(#edEvCAwTnKp694-fill)"
      />
      <path
        d="M1478.04,4577.83l75.91-43.82v7.05l-75.91,43.82v-7.05Z"
        fill="url(#edEvCAwTnKp695-fill)"
      />
      <path
        d="M1553.95,4534.01l35.8,20.67v7.05l-35.8-20.67v-7.05Z"
        fill="url(#edEvCAwTnKp696-fill)"
      />
      <path
        d="M1589.75,4554.68l19.27-11.12v7.04l-19.27,11.13v-7.05Z"
        fill="url(#edEvCAwTnKp697-fill)"
      />
      <path
        d="M1451.99,4562.79l75.91-43.82-.08-.05l19.26-11.12.08.04l26.05,15.04l35.8,20.68-19.26,11.12-35.8-20.67-75.91,43.82-26.05-15.04Z"
        fill="#005289"
      />
      <path
        d="M1285.89,4682.42c0,.71.46,1.41,1.39,1.94l64.74,37.38c1.86,1.07,4.86,1.07,6.71,0l113.58-65.57c.92-.53,1.39-1.23,1.39-1.93v14.09c0,.7-.47,1.4-1.39,1.94l-113.58,65.57c-1.85,1.07-4.85,1.07-6.71,0l-64.74-37.38c-.93-.54-1.39-1.24-1.39-1.94v-14.1Z"
        fill="url(#edEvCAwTnKp699-fill)"
      />
      <path
        d="M1285.89,4682.42c0-.7.47-1.4,1.39-1.93l44.37-25.62l28.47,16.44l17.67-10.19-28.48-16.44l51.55-29.76c1.85-1.07,4.85-1.07,6.71,0l64.74,37.38c.93.53,1.39,1.23,1.39,1.94c0,.7-.47,1.4-1.39,1.93l-113.58,65.57c-1.85,1.07-4.85,1.07-6.71,0l-64.74-37.38c-.93-.53-1.39-1.23-1.39-1.94Z"
        fill="#005289"
      />
      <path
        d="M1375.77,4609.39c0,.7.46,1.4,1.39,1.94l32.37,18.69v21.14l-32.37-18.69c-.93-.54-1.39-1.24-1.39-1.94v-21.14Z"
        fill="url(#edEvCAwTnKp701-fill)"
      />
      <path
        d="M1321.62,4681.91c0,.7.46,1.4,1.39,1.94l29.01,16.75c1.86,1.07,4.86,1.07,6.71,0l89.88-51.89l23.7-13.68c.92-.54,1.39-1.24,1.39-1.94v21.15c0,.7-.47,1.4-1.39,1.93l-23.7,13.68-89.88,51.89c-1.85,1.07-4.85,1.07-6.71,0l-29.01-16.75c-.93-.53-1.39-1.24-1.39-1.94v-21.14Z"
        fill="url(#edEvCAwTnKp702-fill)"
      />
      <path
        d="M1321.62,4681.91c0-.7.46-1.4,1.39-1.94l86.52-49.95-32.37-18.69c-.92-.54-1.39-1.24-1.39-1.94s.47-1.4,1.39-1.93l23.7-13.69c1.85-1.06,4.85-1.06,6.71,0l32.37,18.7l32.37,18.68c.93.54,1.39,1.24,1.39,1.95c0,.7-.47,1.39-1.39,1.93l-23.7,13.68-89.88,51.89c-1.85,1.07-4.85,1.07-6.71,0l-29.01-16.75c-.93-.54-1.39-1.24-1.39-1.94Z"
        fill="#005289"
      />
      <path
        d="M1384.14,4601.88l35.8,20.67v7.05l-35.8-20.68v-7.04Z"
        fill="url(#edEvCAwTnKp704-fill)"
      />
      <path
        d="M1357.05,4688.94l88.94-51.35v7.05l-88.94,51.34v-7.04Z"
        fill="url(#edEvCAwTnKp705-fill)"
      />
      <path
        d="M1445.99,4637.59l.08.04v7.05l-.08-.04v-7.05Z"
        fill="url(#edEvCAwTnKp706-fill)"
      />
      <path
        d="M1446.07,4637.63l19.26-11.12v7.05l-19.26,11.12v-7.05Z"
        fill="url(#edEvCAwTnKp707-fill)"
      />
      <path
        d="M1331,4673.89l88.94-51.34-35.8-20.67l19.26-11.13l35.8,20.67l26.06,15.05.07.04-19.26,11.12-.08-.04-88.93,51.35-26.06-15.05Z"
        fill="#005289"
      />
      <path
        d="M1903.55,4457.04l69.6,40.71v17.66l-69.6-40.72v-17.65Z"
        fill="url(#edEvCAwTnKp709-fill)"
      />
      <path d="M1973.15,4497.75l34.19-19.53v17.66l-34.19,19.53v-17.66Z" fill="#1674b4" />
      <path
        d="M1903.55,4457.04l34.19-19.53l69.6,40.71-34.19,19.53-69.6-40.71Z"
        fill="#005289"
      />
      <path
        d="M1809,4505.58l62.01,36.46v33.06L1809,4538.64v-33.06Z"
        fill="url(#edEvCAwTnKp712-fill)"
      />
      <path
        d="M1871.01,4542.04l102.62-59.74v33.06l-102.62,59.74v-33.06Z"
        fill="#1674b4"
      />
      <path
        d="M1809,4505.58l102.62-59.74l62.02,36.46-102.63,59.74-62.01-36.46Z"
        fill="#005289"
      />
      <path
        d="M1723.99,4553.19l62.01,36.46v33.06l-62.01-36.46v-33.06Z"
        fill="url(#edEvCAwTnKp715-fill)"
      />
      <path d="M1786,4589.65l62.22-35.49v33.06L1786,4622.71v-33.06Z" fill="#1674b4" />
      <path
        d="M1723.99,4553.19l62.21-35.5l62.02,36.47-62.22,35.49-62.01-36.46Z"
        fill="#005289"
      />
      <path
        d="M1746.78,4528.36l39.26,23.09v20.92l-39.26-23.08v-20.93Z"
        fill="url(#edEvCAwTnKp718-fill)"
      />
      <path d="M1786.04,4551.45l39.39-22.47v20.93l-39.39,22.46v-20.92Z" fill="#1674b4" />
      <path
        d="M1746.78,4528.36l39.39-22.46l39.26,23.08-39.39,22.47-39.26-23.09Z"
        fill="#005289"
      />
      <path
        d="M1598.15,4622.9l62.02,36.47v33.06l-62.02-36.47v-33.06Z"
        fill="url(#edEvCAwTnKp721-fill)"
      />
      <path
        d="M1660.17,4659.37l102.62-59.74v33.06l-102.62,59.74v-33.06Z"
        fill="#1674b4"
      />
      <path
        d="M1598.15,4622.9l102.63-59.74l62.01,36.47-102.62,59.74-62.02-36.47Z"
        fill="#005289"
      />
      <path
        d="M1483.47,4803.11L934,5022.53v3.49c0,2.73,1.806,5.47,5.42,7.55l62.82,36.27c7.23,4.17,18.93,4.17,26.16,0l449.66-255.66c3.61-2.09,5.41-4.82,5.41-7.56v-3.51Z"
        fill="#1674b4"
      />
      <path
        d="M1028.41,5067.09l449.65-255.67c7.23-4.17,7.23-10.93,0-15.1l-62.8-36.28c-7.22-4.17-18.93-4.17-26.16,0L939.428,5015.71c-7.223,4.17-7.23,10.93-.002,15.1l62.824,36.28c7.22,4.17,18.93,4.17,26.16,0Z"
        fill="#005289"
      />
      <path
        d="M1337.6,4774.25l69.6,40.71v17.66l-69.6-40.71v-17.66Z"
        fill="url(#edEvCAwTnKp726-fill)"
      />
      <path d="M1407.2,4814.96l34.18-19.53v17.66l-34.18,19.53v-17.66Z" fill="#1674b4" />
      <path
        d="M1337.6,4774.25l34.18-19.53l69.6,40.71-34.18,19.53-69.6-40.71Z"
        fill="#005289"
      />
      <path
        d="M1800.89,4382.17l69.6,40.71v17.65l-69.6-40.71v-17.65Z"
        fill="url(#edEvCAwTnKp729-fill)"
      />
      <path d="M1870.49,4422.88l34.19-19.53v17.65l-34.19,19.53v-17.65Z" fill="#1674b4" />
      <path
        d="M1800.89,4382.16l34.19-19.53l69.6,40.72-34.19,19.53-69.6-40.72Z"
        fill="#005289"
      />
      <path
        d="M1737.98,4416.17l69.6,40.72v17.65l-69.6-40.71v-17.66Z"
        fill="url(#edEvCAwTnKp732-fill)"
      />
      <path d="M1807.58,4456.89l34.18-19.54v17.66l-34.18,19.53v-17.65Z" fill="#1674b4" />
      <path
        d="M1737.98,4416.17l34.18-19.53l69.6,40.72-34.18,19.53-69.6-40.72Z"
        fill="#005289"
      />
      <path
        d="M1675.06,4450.18l69.6,40.71v17.66l-69.6-40.72v-17.65Z"
        fill="url(#edEvCAwTnKp735-fill)"
      />
      <path d="M1744.67,4490.89l34.18-19.53v17.66l-34.18,19.53v-17.66Z" fill="#1674b4" />
      <path
        d="M1675.06,4450.18l34.19-19.53l69.6,40.71-34.19,19.53-69.6-40.71Z"
        fill="#005289"
      />
      <path
        d="M1499.02,4701.67l47.16,25.99v17.8l-47.16-25.99v-17.8Z"
        fill="url(#edEvCAwTnKp738-fill)"
      />
      <path d="M1546.18,4727.66l102.62-59.74v17.8l-102.62,59.74v-17.8Z" fill="#1674b4" />
      <path
        d="M1499.02,4701.67l102.62-59.74l47.16,25.99-102.62,59.74-47.16-25.99Z"
        fill="#005289"
      />
      <g>
        <path
          d="M2223.65,4138.93l62.01,36.47v33.06L2223.65,4172v-33.07Z"
          fill="url(#edEvCAwTnKp742-fill)"
        />
        <path d="M2285.66,4175.4l62.22-35.5v33.07l-62.22,35.49v-33.06Z" fill="#1674b4" />
        <path
          d="M2223.65,4138.93l62.21-35.49l62.02,36.46-62.22,35.5-62.01-36.47Z"
          fill="#005289"
        />
        <path
          d="M2246.45,4114.11l39.25,23.09v20.92l-39.25-23.08v-20.93Z"
          fill="url(#edEvCAwTnKp745-fill)"
        />
        <path d="M2285.7,4137.2l39.39-22.47v20.93l-39.39,22.46v-20.92Z" fill="#1674b4" />
        <path
          d="M2246.45,4114.11l39.38-22.46l39.26,23.08-39.39,22.47-39.25-23.09Z"
          fill="#005289"
        />
      </g>
      <path
        d="M2015.11,4509.77l83.7,52.48v15.57l-83.7-52.48v-15.57Z"
        fill="url(#edEvCAwTnKp748-fill)"
      />
      <path d="M2098.81,4562.25l63.69-38.42v15.57l-63.69,38.42v-15.57Z" fill="#1674b4" />
      <path
        d="M2015.11,4509.77l63.68-38.42l83.7,52.48-63.68,38.42-83.7-52.48Z"
        fill="#005289"
      />
      <path
        d="M2512.25,4272.98l38.24,22.49v20.39l-38.24-22.49v-20.39Z"
        fill="url(#edEvCAwTnKp751-fill)"
      />
      <path
        d="M2451.99,4307.63l38.24,22.49v20.39l-38.24-22.49v-20.39Z"
        fill="url(#edEvCAwTnKp752-fill)"
      />
      <path d="M2490.23,4330.12l41.84-24.19v20.39l-41.84,24.19v-20.39Z" fill="#1674b4" />
      <path
        d="M2451.99,4307.63l41.83-24.19l38.25,22.49-41.84,24.19-38.24-22.49Z"
        fill="#005289"
      />
      <path
        d="M2391.72,4342.28l38.25,22.49v20.39l-38.25-22.49v-20.39Z"
        fill="url(#edEvCAwTnKp755-fill)"
      />
      <path d="M2429.97,4364.77l41.83-24.19v20.39l-41.83,24.19v-20.39Z" fill="#1674b4" />
      <path
        d="M2391.72,4342.28l41.84-24.19l38.24,22.49-41.83,24.19-38.25-22.49Z"
        fill="#005289"
      />
      <path
        d="M2331.46,4376.93l38.25,22.49v20.39l-38.25-22.49v-20.39Z"
        fill="url(#edEvCAwTnKp758-fill)"
      />
      <path d="M2369.71,4399.42l41.83-24.19v20.39l-41.83,24.19v-20.39Z" fill="#1674b4" />
      <path
        d="M2331.46,4376.93l41.84-24.19l38.24,22.49-41.83,24.19-38.25-22.49Z"
        fill="#005289"
      />
      <path
        d="M2186.83,4445.25l38.24,22.49v39.67l-38.24-22.49v-39.67Z"
        fill="url(#edEvCAwTnKp761-fill)"
      />
      <path d="M2225.07,4467.74l41.84-24.19v39.67l-41.84,24.18v-39.66Z" fill="#1674b4" />
      <path
        d="M2186.83,4445.25l41.83-24.19l38.25,22.49-41.84,24.19-38.24-22.49Z"
        fill="#005289"
      />
      <path
        d="M2313.66,4206.46l62.02,36.46v33.06l-62.02-36.46v-33.06Z"
        fill="url(#edEvCAwTnKp764-fill)"
      />
      <path
        d="M2375.68,4242.92l102.62-59.74v33.06l-102.62,59.74v-33.06Z"
        fill="#1674b4"
      />
      <path
        d="M2313.66,4206.46l102.63-59.74l62.01,36.46-102.62,59.74-62.02-36.46Z"
        fill="#005289"
      />
      <path
        d="M2193.92,4277.73l62.02,36.46v33.06l-62.02-36.46v-33.06Z"
        fill="url(#edEvCAwTnKp767-fill)"
      />
      <path
        d="M2255.94,4314.19l102.62-59.74v33.06l-102.62,59.74v-33.06Z"
        fill="#1674b4"
      />
      <path
        d="M2193.92,4277.73l102.63-59.74l62.01,36.46-102.62,59.74-62.02-36.46Z"
        fill="#005289"
      />
      <path
        d="M2100.82,4205.65l62.01,36.46v33.06l-62.01-36.46v-33.06Z"
        fill="url(#edEvCAwTnKp770-fill)"
      />
      <path
        d="M2162.83,4242.11l102.63-59.74v33.06l-102.63,59.74v-33.06Z"
        fill="#1674b4"
      />
      <path
        d="M2100.82,4205.65l102.62-59.74l62.02,36.46-102.63,59.74-62.01-36.46Z"
        fill="#005289"
      />
      <g>
        <path
          d="M2033.87,4623.12l-489.15,183.11v3.5c0,2.73,1.81,5.46,5.42,7.55l62.82,36.27c7.23,4.17,18.93,4.17,26.16,0l389.33-219.36c3.62-2.09,5.42-4.82,5.42-7.56v-3.51Z"
          fill="#1674b4"
        />
        <path
          d="M1639.13,4849.99l389.32-219.36c7.23-4.17,7.23-10.93.01-15.1l-62.8-36.28c-7.22-4.17-18.94-4.17-26.16,0l-389.35,219.36c-7.23,4.17-7.23,10.94-.01,15.11l62.83,36.27c7.22,4.17,18.93,4.17,26.16,0Z"
          fill="#005289"
        />
      </g>
      <path
        d="M1147.5,5129.37l444.69-251.75c7.23-4.17,7.23-10.93.01-15.1l-62.8-36.28c-7.22-4.17-18.94-4.17-26.16,0l-444.72,251.74c-7.23,4.17-7.23,10.94,0,15.11l62.82,36.28c7.22,4.16,18.93,4.16,26.16,0Z"
        fill="#005289"
      />
      <path
        d="M1449.3,4842.13l69.6,40.72v17.65l-69.6-40.71v-17.66Z"
        fill="url(#edEvCAwTnKp777-fill)"
      />
      <path d="M1518.9,4882.85l34.18-19.53v17.65l-34.18,19.53v-17.65Z" fill="#1674b4" />
      <path
        d="M1449.3,4842.14l34.18-19.54l69.6,40.72-34.18,19.53-69.6-40.71Z"
        fill="#005289"
      />
      <path
        d="M1401.26,4870.3l34.18-19.53l69.6,40.71-34.18,19.53-69.6-40.71Z"
        fill="#005289"
      />
      <path
        d="M1582.16,4789.89l38.25,22.48v20.39l-38.25-22.48v-20.39Z"
        fill="url(#edEvCAwTnKp781-fill)"
      />
      <path d="M1620.41,4812.37l41.83-24.19v20.39l-41.83,24.19v-20.39Z" fill="#1674b4" />
      <path
        d="M1582.16,4789.89L1624,4765.7l38.24,22.48-41.83,24.19-38.25-22.48Z"
        fill="#005289"
      />
      <path
        d="M1898.19,4587.08l69.6,40.72v17.65l-69.6-40.71v-17.66Z"
        fill="url(#edEvCAwTnKp784-fill)"
      />
      <path d="M1967.79,4627.8l34.18-19.53v17.65l-34.18,19.53v-17.65Z" fill="#1674b4" />
      <path
        d="M1898.19,4587.08l34.18-19.53l69.6,40.72-34.18,19.53-69.6-40.72Z"
        fill="#005289"
      />
      <path
        d="M1850.15,4615.25l69.6,40.71v17.65l-69.6-40.71v-17.65Z"
        fill="url(#edEvCAwTnKp787-fill)"
      />
      <path d="M1919.75,4655.96l34.18-19.53v17.65l-34.18,19.53v-17.65Z" fill="#1674b4" />
      <path
        d="M1850.15,4615.25l34.18-19.54l69.6,40.72-34.18,19.53-69.6-40.71Z"
        fill="#005289"
      />
      <path
        d="M1802.11,4643.41l69.6,40.71v17.66l-69.6-40.72v-17.65Z"
        fill="url(#edEvCAwTnKp790-fill)"
      />
      <path d="M1871.71,4684.12l34.18-19.53v17.66l-34.18,19.53v-17.66Z" fill="#1674b4" />
      <path
        d="M1802.11,4643.41l34.18-19.53l69.6,40.71-34.18,19.53-69.6-40.71Z"
        fill="#005289"
      />
      <path
        d="M1707.86,4706.45l58.2,34.23v22.19l-58.2-34.22v-22.2Z"
        fill="url(#edEvCAwTnKp793-fill)"
      />
      <path d="M1766.06,4740.68l61.67-35.37v22.19l-61.67,35.37v-22.19Z" fill="#1674b4" />
      <path
        d="M1707.86,4706.45l61.67-35.37l58.2,34.23-61.67,35.37-58.2-34.23Z"
        fill="#005289"
      />
      <path
        d="M1729.61,4666.23l36.3,21.35v37.94l-36.3-21.34v-37.95Z"
        fill="url(#edEvCAwTnKp796-fill)"
      />
      <path d="M1765.91,4687.58l38.46-22.06v37.94l-38.46,22.06v-37.94Z" fill="#1674b4" />
      <path
        d="M1729.61,4666.23l38.46-22.05l36.3,21.34-38.46,22.06-36.3-21.35Z"
        fill="#005289"
      />
      <g>
        <path
          d="M8233.62,955.558l-434.05,20.626v3.492c0,2.73,1.8,5.466,5.42,7.554l179.15,103.06c7.22,4.17,18.93,4.17,26.15,0L8228.2,966.624c3.61-2.086,5.42-4.82,5.42-7.555v-3.511Z"
          fill="#1674b4"
        />
        <path
          d="M7843.15,1046.23l-327.5,93.16v3.5c0,2.73,1.81,5.46,5.42,7.55l62.82,36.27c7.23,4.17,18.93,4.17,26.16,0l227.69-129.41c3.61-2.08,5.41-4.82,5.41-7.55v-3.52Z"
          fill="#1674b4"
        />
        <path
          d="M7610.06,1183.15l227.67-129.41c7.23-4.17,7.24-10.93.01-15.1l-62.8-36.28c-7.22-4.167-18.94-4.17-26.16,0l-227.7,129.41c-7.22,4.17-7.23,10.94,0,15.11l62.82,36.27c7.22,4.17,18.93,4.17,26.16,0Z"
          fill="#005289"
        />
        <path
          d="M8429.15,713l-327.51,93.158v3.493c0,2.729,1.81,5.466,5.42,7.553l62.83,36.271c7.22,4.168,18.93,4.168,26.15,0l227.69-129.408c3.61-2.087,5.42-4.82,5.42-7.555v-3.512Z"
          fill="#1674b4"
        />
        <path
          d="M8196.05,849.919l227.68-129.413c7.23-4.167,7.23-10.931.01-15.102l-62.81-36.274c-7.22-4.171-18.93-4.174-26.16-.005l-227.7,129.412c-7.22,4.17-7.23,10.935,0,15.106l62.82,36.275c7.22,4.167,18.93,4.167,26.16.001Z"
          fill="#005289"
        />
        <path
          d="M8010.3,1086.74l217.9-123.677c7.23-4.166,7.23-10.93,0-15.101L8049.07,844.896c-7.22-4.171-18.93-4.173-26.16-.005L7804.99,968.563c-7.22,4.169-7.23,10.935,0,15.105l179.15,103.062c7.22,4.17,18.93,4.17,26.16.01Z"
          fill="#005289"
        />
        <path
          d="M7955.36,1113.95l-327.5,93.16v3.49c0,2.73,1.8,5.47,5.42,7.56l62.82,36.27c7.22,4.16,18.93,4.16,26.15,0l227.69-129.41c3.61-2.09,5.42-4.82,5.42-7.56v-3.51Z"
          fill="#1674b4"
        />
        <path
          d="M7722.27,1250.87l227.67-129.41c7.23-4.17,7.23-10.94.01-15.11l-62.8-36.27c-7.22-4.17-18.94-4.17-26.16-.01l-227.7,129.42c-7.23,4.17-7.23,10.93-.01,15.1l62.83,36.28c7.22,4.16,18.93,4.16,26.16,0Z"
          fill="#005289"
        />
        <path
          d="M7670.59,1275.75l-264.37,55.43v3.49c0,2.73,1.81,5.47,5.42,7.56l62.82,36.27c7.23,4.16,18.93,4.16,26.16,0l164.55-91.69c3.62-2.08,5.42-4.82,5.42-7.55v-3.51v0Z"
          fill="#1674b4"
        />
        <path
          d="M7500.63,1374.94l164.55-91.69c7.22-4.16,7.23-10.93,0-15.1l-62.8-36.27c-7.22-4.17-18.94-4.18-26.16-.01l-164.57,91.69c-7.22,4.17-7.23,10.93,0,15.1l62.82,36.28c7.22,4.17,18.93,4.17,26.16,0Z"
          fill="#005289"
        />
        <path
          d="M7640.63,1030.01l62.02,36.47v33.06l-62.02-36.47v-33.06Z"
          fill="url(#edEvCAwTnKp810-fill)"
        />
        <path
          d="M7702.65,1066.48l102.62-59.74v33.06l-102.62,59.74v-33.06Z"
          fill="#1674b4"
        />
        <path
          d="M7640.63,1030.01l102.63-59.736l62.01,36.466-102.62,59.74-62.02-36.47Z"
          fill="#005289"
        />
        <path
          d="M7546.27,1110.8l54.09,31.64v15.95l-54.09-31.64v-15.95Z"
          fill="url(#edEvCAwTnKp813-fill)"
        />
        <path
          d="M7600.36,1142.44l102.62-59.74v15.95l-102.62,59.74v-15.95Z"
          fill="#1674b4"
        />
        <path
          d="M7546.27,1110.8l102.62-59.74l54.09,31.64-102.62,59.74-54.09-31.64Z"
          fill="#005289"
        />
        <path
          d="M8194.91,719.82l58.21,34.224v44.687l-58.21-34.223v-44.688Z"
          fill="url(#edEvCAwTnKp816-fill)"
        />
        <path
          d="M8194.91,719.82l31.93-18.435l58.21,34.223-31.93,18.435-58.21-34.223Z"
          fill="#005289"
        />
        <path
          d="M8143.68,750.911l58.2,34.223v44.687l-58.2-34.223v-44.687Z"
          fill="url(#edEvCAwTnKp818-fill)"
        />
        <path
          d="M8143.68,750.911l31.93-18.435l58.2,34.222-31.93,18.436-58.2-34.223Z"
          fill="#005289"
        />
        <path
          d="M7675.48,1178.71l54.1,31.64v15.94l-54.1-31.64v-15.94Z"
          fill="url(#edEvCAwTnKp820-fill)"
        />
        <path
          d="M7729.57,1209.79l102.63-59.74v15.94l-102.63,59.74v-15.94Z"
          fill="#1674b4"
        />
        <path
          d="M7675.48,1178.71l102.63-59.74l54.09,31.64-102.62,59.74-54.1-31.64Z"
          fill="#005289"
        />
        <path
          d="M7805.17,1072.19l58.21,34.22v44.69l-58.21-34.22v-44.69Z"
          fill="url(#edEvCAwTnKp823-fill)"
        />
        <path
          d="M7863.38,1106.41l31.93-18.43v44.68l-31.93,18.44v-44.69Z"
          fill="#1674b4"
        />
        <path
          d="M7805.17,1072.19l31.93-18.44l58.21,34.23-31.93,18.43-58.21-34.22Z"
          fill="#005289"
        />
        <g transform="translate(7293.07 986.71)">
          <path
            d="M262.9,218.2L0.4,274.2v3.5c0,2.7,1.8,5.5,5.4,7.6l62.8,36.3c7.2,4.2,18.9,4.2,26.2,0l162.7-92.2c3.6-2.1,5.4-4.8,5.4-7.6v-3.6Z"
            fill="#1674b4"
          />
          <path
            d="M94.8,317.9l162.6-92.2c7.2-4.2,7.2-10.9,0-15.1l-62.8-36.3c-7.2-4.2-18.9-4.2-26.2,0L5.9,266.5c-7.2,4.2-7.2,10.9,0,15.1l62.8,36.3c7.2,4.2,18.9,4.2,26.1,0Z"
            fill="#005289"
          />
          <path d="M132.9,32.4L181.2,4.5l41.2,23.8L173.9,56l-41-23.6Z" fill="#005289" />
          <path
            d="M136.7,24.3l37.1,22.3v9.4L136.7,34.6v-10.3Z"
            fill="url(#edEvCAwTnKp830-fill)"
          />
          <path d="M136.7,24.3L180.5,0.6l36.8,21.2-43.4,24.8-37.2-22.3Z" fill="#005289" />
          <path
            d="M39.9,241.7L111.4,283v14.2L39.9,255.9v-14.2Z"
            fill="url(#edEvCAwTnKp832-fill)"
          />
          <path d="M111.4,283l109.8-63.4v14.2L111.4,297.2v-14.2Z" fill="#1674b4" />
          <path d="M217.3,31.2l5.2-3l7.2,153.6-7.2,21.7-5.2,2.7v-175Z" fill="#1674b4" />
          <path d="M173.9,46.6l43.4-24.8v10.5L173.9,56v-9.4Z" fill="#1674b4" />
          <path
            d="M197.1,33.3l8.9,5.5v184.7l-8.9-5.1v-185.1Z"
            fill="url(#edEvCAwTnKp836-fill)"
          />
          <path d="M206,38.8l11.3-6.5v185.1L206,210.8v-172Z" fill="#1674b4" />
          <path d="M197.1,33.3l11.1-6.4l9.1,5.3L206,38.8l-8.9-5.5Z" fill="#005289" />
          <path
            d="M39.9,241.7l109.8-63.4l71.5,41.3L111.4,283L39.9,241.7Z"
            fill="#005289"
          />
          <g>
            <path
              d="M55.6,237.7c0,1,.7,2,2,2.8l16.2,9.3c2.7,1.5,7,1.5,9.6,0l8.9-5.1c1.3-.8,2-1.8,2-2.8v4.7c0,1-.7,2-2,2.8l-8.9,5.1c-2.7,1.5-7,1.5-9.6,0l-16.2-9.3c-1.3-.8-2-1.8-2-2.8v-4.7Z"
              fill="url(#edEvCAwTnKp841-fill)"
            />
            <path
              d="M55.6,237.7c0-1,.7-2,2-2.8l8.9-5.1c2.7-1.5,7-1.5,9.6,0l16.2,9.3c1.3.8,2,1.8,2,2.8s-.7,2-2,2.8l-8.9,5.1c-2.7,1.5-7,1.5-9.6,0l-16.2-9.3c-1.3-.8-2-1.8-2-2.8Z"
              fill="#005289"
            />
          </g>
          <path
            d="M132.9,32.4l41,23.6v163L133,195.1v-162.7Z"
            fill="url(#edEvCAwTnKp843-fill)"
          />
          <path d="M173.9,46.6v172.4l23.2-13.3v-158.8-4-9.6L173.9,46.6Z" fill="#1674b4" />
        </g>
        <path
          d="M7971.88,1042.12l114.91-66.971l48.44,27.111-117.13,66.58-46.22-26.72Z"
          fill="url(#edEvCAwTnKp845-fill)"
        />
        <path
          d="M8146.89,966.412c-.94-4.131-5.16-8.868-12.13-12.893-12.2-7.041-28.17-9.23-35.69-4.89-2.62,1.51-3.86,3.61-3.86,6.005v14.76c0-2.395,1.24-4.496,3.86-6.006c7.52-4.339,23.49-2.151,35.69,4.89c6.97,4.025,11.19,8.763,12.13,12.894v-14.76Z"
          fill="url(#edEvCAwTnKp846-fill)"
        />
        <path
          d="M8095.21,954.634c0,4.489,4.38,10.009,12.33,14.6c6.97,4.024,15.17,6.46,22.33,7.002v14.759c-7.16-.541-15.36-2.976-22.33-7.001-7.95-4.592-12.33-10.112-12.33-14.6v-14.76Z"
          fill="#103250"
        />
        <path
          d="M8012.25,835.829l149.48,86.305v59.037l-149.48-86.305v-59.037Z"
          fill="url(#edEvCAwTnKp848-fill)"
        />
        <path
          d="M8129.87,976.236l17.02-9.824v14.76l-17.02,9.823v-14.759Z"
          fill="url(#edEvCAwTnKp849-fill)"
        />
        <path
          d="M8095.21,954.633c0-2.394,1.24-4.495,3.86-6.005c7.52-4.34,23.49-2.151,35.69,4.89c6.97,4.025,11.19,8.762,12.13,12.893l-17.02,9.824c-7.16-.541-15.36-2.978-22.33-7.001-7.95-4.591-12.33-10.111-12.33-14.601Z"
          fill="url(#edEvCAwTnKp850-fill)"
        />
        <path
          d="M8129.87,987.397l8.1,4.585v3.69l-8.1-4.677v-3.598Z"
          fill="url(#edEvCAwTnKp851-fill)"
        />
        <path
          d="M8137.97,991.982l17.01-9.736v3.69l-17.01,9.736v-3.69Z"
          fill="url(#edEvCAwTnKp852-fill)"
        />
        <path
          d="M8129.87,987.397l17.02-9.823l8.09,4.671-17.01,9.83-8.1-4.678Z"
          fill="#005289"
        />
        <path
          d="M8155.97,983.552l-.99-.568v2.952l.99.568v-2.952Z"
          fill="url(#edEvCAwTnKp854-fill)"
        />
        <path
          d="M8154.98,982.984l-17.01,9.737v2.951l17.01-9.736v-2.952Z"
          fill="url(#edEvCAwTnKp855-fill)"
        />
        <path
          d="M8137.97,992.721l.99.567v2.952l-.99-.568v-2.951Z"
          fill="url(#edEvCAwTnKp856-fill)"
        />
        <path
          d="M8138.96,993.288l17.01-9.736v2.952l-17.01,9.736v-2.952Z"
          fill="url(#edEvCAwTnKp857-fill)"
        />
        <path
          d="M8137.97,992.721l17.01-9.737.99.568-17.01,9.736-.99-.567Z"
          fill="#005289"
        />
        <path
          d="M8156.95,984.857l-.98-.567v2.214l.98.568v-2.215Z"
          fill="url(#edEvCAwTnKp859-fill)"
        />
        <path
          d="M8155.97,984.29l-17.01,9.736v2.213l17.01-9.735v-2.214Z"
          fill="url(#edEvCAwTnKp860-fill)"
        />
        <path
          d="M8138.96,994.026l.98.568v2.214l-.98-.568v-2.214Z"
          fill="url(#edEvCAwTnKp861-fill)"
        />
        <path
          d="M8139.94,994.594l17.01-9.737v2.215l-17.01,9.735v-2.213Z"
          fill="url(#edEvCAwTnKp862-fill)"
        />
        <path
          d="M8138.96,994.026l17.01-9.736.98.567-17.01,9.737-.98-.568Z"
          fill="#005289"
        />
        <path
          d="M8157.93,986.163l-.98-.568v1.477l.98.567v-1.476Z"
          fill="url(#edEvCAwTnKp864-fill)"
        />
        <path
          d="M8156.95,985.595l-17.01,9.737v1.475l17.01-9.735v-1.477Z"
          fill="url(#edEvCAwTnKp865-fill)"
        />
        <path
          d="M8139.94,995.332l.98.567v1.477l-.98-.568v-1.476Z"
          fill="url(#edEvCAwTnKp866-fill)"
        />
        <path
          d="M8140.93,995.899l17-9.736v1.476l-17,9.736v-1.476Z"
          fill="url(#edEvCAwTnKp867-fill)"
        />
        <path
          d="M8139.94,995.332l17.01-9.737.98.568-17.01,9.736-.98-.567Z"
          fill="#005289"
        />
        <path
          d="M8158.92,987.469l-.99-.568v.739l.99.568v-.739Z"
          fill="url(#edEvCAwTnKp869-fill)"
        />
        <path
          d="M8157.93,986.901l-17,9.737v.738l17-9.736v-.739Z"
          fill="url(#edEvCAwTnKp870-fill)"
        />
        <path
          d="M8161.73,922.334l44.07-25.443-149.48-86.304-44.07,25.442l114.29,65.988-3.74,2.158c-9.26-2.702-18.52-2.83-23.73.175-2.61,1.51-3.86,3.612-3.86,6.007c0,2.372,1.23,5.033,3.56,7.692l-3.52,2.031-6.85-3.958-116.11,67.034l44.56,25.724l116.11-67.033-19.2-11.082l2.88-1.662c10.16,3.559,20.85,4.06,26.59.744c2.62-1.51,3.86-3.612,3.86-6.006c0-2.865-1.79-6.149-5.15-9.345l3.11-1.793l16.68,9.631Z"
          fill="#005289"
        />
        <path
          d="M8140.93,996.638l.98.568v.737l-.98-.567v-.738Z"
          fill="url(#edEvCAwTnKp872-fill)"
        />
        <path
          d="M8141.91,997.206l17.01-9.737v.739l-17.01,9.735v-.737Z"
          fill="url(#edEvCAwTnKp873-fill)"
        />
        <path d="M8140.93,996.638l17-9.737.99.568-17.01,9.737-.98-.568Z" fill="#005289" />
        <path
          d="M8161.73,922.135l44.07-25.444v59.038l-44.07,25.443v-59.037Z"
          fill="url(#edEvCAwTnKp875-fill)"
        />
        <path
          d="M8122.36,904.429l18.51,10.685v59.038l-18.51-10.686v-59.037Z"
          fill="url(#edEvCAwTnKp876-fill)"
        />
        <path
          d="M8140.87,915.114l4.15-2.374v59.038l-4.15,2.374v-59.038Z"
          fill="url(#edEvCAwTnKp877-fill)"
        />
        <path
          d="M8095.21,910.356c0,4.488,4.38,10.008,12.33,14.6c12.19,7.041,28.17,9.23,35.69,4.89c2.61-1.509,3.86-3.612,3.86-6.006v44.279c0,2.395-1.25,4.495-3.86,6.006-7.52,4.339-23.5,2.15-35.69-4.89-7.95-4.592-12.33-10.112-12.33-14.601v-44.278Z"
          fill="url(#edEvCAwTnKp878-fill)"
        />
        <path
          d="M8143.23,929.846c-6.79,3.918-20.47,2.513-32.04-2.98v44.278c11.57,5.493,25.25,6.899,32.04,2.98c2.62-1.51,3.86-3.61,3.86-6.005v-44.279c0,2.394-1.24,4.496-3.86,6.006Z"
          fill="url(#edEvCAwTnKp879-fill)"
        />
        <path
          d="M8119.86,927.243l-18.51-10.685v59.038l18.51,10.685v-59.038Z"
          fill="url(#edEvCAwTnKp880-fill)"
        />
        <path
          d="M8101.35,916.558l-8.36,4.825v59.037l8.36-4.824v-59.038Z"
          fill="url(#edEvCAwTnKp881-fill)"
        />
        <path
          d="M8092.99,921.383l18.51,10.686v59.037l-18.51-10.686v-59.037Z"
          fill="url(#edEvCAwTnKp882-fill)"
        />
        <path
          d="M8111.5,932.069l8.36-4.826v59.038l-8.36,4.825v-59.037Z"
          fill="url(#edEvCAwTnKp883-fill)"
        />
        <path
          d="M8126.54,946.295l-114.29-65.986v14.759l114.29,65.987v-14.76Z"
          fill="#005289"
        />
        <path
          d="M8012.25,880.309c0,0-18.33,26.129-24.92,61.239-2.46,13.095-3.21,27.49-3.21,40.304v14.759c0-12.814.75-27.209,3.21-40.303c6.59-35.111,24.92-61.24,24.92-61.24v-14.759Z"
          fill="#005289"
        />
        <path
          d="M7984.12,981.852c0,20.888,2.03,37.578,2.03,37.578v14.76c0,0-2.03-16.69-2.03-37.579v-14.759Z"
          fill="#005289"
        />
        <path d="M7986.15,1019.43l6.85,3.96v14.76l-6.85-3.96v-14.76Z" fill="#005289" />
        <path d="M7993,1023.39l133.54-77.096v14.76L7993,1038.15v-14.76Z" fill="#005289" />
        <path
          d="M7984.12,981.852c0-12.814.75-27.209,3.21-40.304c6.59-35.11,24.92-61.239,24.92-61.239l114.29,65.986L7993,1023.39l-6.85-3.95c0,0-2.03-16.7-2.03-37.588Z"
          fill="#005289"
        />
        <path
          d="M8123.35,980.58l-34.95-20.181v14.76l34.95,20.18v-14.759Z"
          fill="url(#edEvCAwTnKp890-fill)"
        />
        <path
          d="M8088.4,960.399l-116.11,67.031v14.76l116.11-67.031v-14.76Z"
          fill="url(#edEvCAwTnKp891-fill)"
        />
        <path
          d="M8007.24,1047.61l116.11-67.03v14.759l-116.11,67.031v-14.76Z"
          fill="url(#edEvCAwTnKp892-fill)"
        />
        <path
          d="M7972.29,1027.43l116.11-67.031l34.95,20.181-116.11,67.03-34.95-20.18Z"
          fill="url(#edEvCAwTnKp893-fill)"
        />
        <path
          d="M8132.96,941.846l-44.56-25.725v44.278l44.56,25.725v-44.278Z"
          fill="url(#edEvCAwTnKp894-fill)"
        />
        <path
          d="M8088.4,916.121l-116.11,67.035v44.274l116.11-67.031v-44.278Z"
          fill="url(#edEvCAwTnKp895-fill)"
        />
        <path
          d="M8016.85,1008.88l116.1-67.034v44.278l-116.1,67.036v-44.28Z"
          fill="url(#edEvCAwTnKp896-fill)"
        />
        <path
          d="M8027.01,980.317l-31.3-18.065v7.379l31.3,18.066v-7.38Z"
          fill="url(#edEvCAwTnKp897-fill)"
        />
        <path
          d="M7995.72,962.252l-23.43,13.524v7.38l23.43-13.525v-7.379Z"
          fill="url(#edEvCAwTnKp898-fill)"
        />
        <path
          d="M8003.58,993.841l23.43-13.524v7.38l-23.43,13.523v-7.379Z"
          fill="url(#edEvCAwTnKp899-fill)"
        />
        <path
          d="M7972.29,975.776l23.43-13.524l31.29,18.065-23.43,13.524-31.29-18.065Z"
          fill="#005289"
        />
        <path
          d="M8016.85,1008.88l-13.27-7.66v-7.379l-31.29-18.065v7.38v7.379v29.515v7.38v14.76l34.95,20.18v-14.76l9.61,5.55v-44.28Z"
          fill="url(#edEvCAwTnKp901-fill)"
        />
        <path
          d="M8019.85,824.276l16.08,9.28v7.38l-16.08-9.28v-7.38Z"
          fill="url(#edEvCAwTnKp902-fill)"
        />
        <path
          d="M8028.33,837.939l14.29,8.25v7.379l-14.29-8.249v-7.38Z"
          fill="url(#edEvCAwTnKp903-fill)"
        />
        <path
          d="M8042.62,846.189l28.47-16.434v7.379l-28.47,16.434v-7.379Z"
          fill="url(#edEvCAwTnKp904-fill)"
        />
        <path
          d="M8019.85,824.278l20.88-12.052l30.36,17.529-28.47,16.434-14.29-8.249l7.6-4.383-16.08-9.279Z"
          fill="#005289"
        />
        <path
          d="M8495.79,934.25l-469.17,172.5v3.49c0,2.73,1.8,5.47,5.41,7.56l62.83,36.27c7.22,4.17,18.93,4.17,26.15,0l369.37-208.753c3.61-2.086,5.41-4.82,5.41-7.555v-3.512Z"
          fill="#1674b4"
        />
        <path
          d="M8121.02,1150.51l369.36-208.755c7.22-4.166,7.23-10.93,0-15.101l-62.8-36.275c-7.22-4.17-18.94-4.172-26.16-.004L8032.04,1099.13c-7.22,4.17-7.23,10.93,0,15.1l62.82,36.28c7.22,4.17,18.93,4.17,26.16,0Z"
          fill="#005289"
        />
        <path
          d="M8186.94,999.603l69.6,40.717v17.65l-69.6-40.71v-17.657Z"
          fill="url(#edEvCAwTnKp908-fill)"
        />
        <path
          d="M8186.94,999.602l34.19-19.531l69.6,40.709-34.19,19.54-69.6-40.718Z"
          fill="#005289"
        />
        <path
          d="M8138.9,1027.76l69.6,40.72v17.65l-69.6-40.71v-17.66Z"
          fill="url(#edEvCAwTnKp910-fill)"
        />
        <path
          d="M8138.9,1027.76l34.18-19.53l69.6,40.72-34.18,19.53-69.6-40.72Z"
          fill="#005289"
        />
        <path
          d="M7537.88,1243.39l69.61,40.72v17.65l-69.61-40.71v-17.66Z"
          fill="url(#edEvCAwTnKp912-fill)"
        />
        <path
          d="M7607.49,1284.11l34.18-19.53v17.65l-34.18,19.53v-17.65Z"
          fill="#1674b4"
        />
        <path
          d="M7537.88,1243.39l34.19-19.53l69.6,40.72-34.18,19.53-69.61-40.72Z"
          fill="#005289"
        />
        <path
          d="M7486.87,1270.6l69.6,40.71v17.66l-69.6-40.72v-17.65Z"
          fill="url(#edEvCAwTnKp915-fill)"
        />
        <path
          d="M7556.47,1311.31l34.19-19.53v17.66l-34.19,19.53v-17.66Z"
          fill="#1674b4"
        />
        <path
          d="M7486.87,1270.6l34.19-19.53l69.6,40.71-34.19,19.53-69.6-40.71Z"
          fill="#005289"
        />
        <path
          d="M7435.86,1297.8l69.61,40.72v17.65l-69.61-40.71v-17.66Z"
          fill="url(#edEvCAwTnKp918-fill)"
        />
        <path
          d="M7505.46,1338.52l34.19-19.53v17.65l-34.19,19.53v-17.65Z"
          fill="#1674b4"
        />
        <path
          d="M7435.86,1297.8l34.19-19.53l69.6,40.72-34.18,19.53-69.61-40.72Z"
          fill="#005289"
        />
        <path
          d="M8090.52,1103.67l66.13-38.75v22.75l-66.13,38.75v-22.75Z"
          fill="#1674b4"
        />
        <path
          d="M8043.56,1076.2l66.13-38.75l46.96,27.47-66.13,38.75-46.96-27.47Z"
          fill="#005289"
        />
        <path
          d="M8087,1027.95l46.96,27.47v22.75L8087,1050.7v-22.75Z"
          fill="url(#edEvCAwTnKp923-fill)"
        />
        <path
          d="M8043.1,1076.82l46.96,27.47v22.75l-46.96-27.47v-22.75Z"
          fill="url(#edEvCAwTnKp924-fill)"
        />
        <path d="M8133.96,1055.42l22.8-13.42v22.75l-22.8,13.42v-22.75Z" fill="#1674b4" />
        <path
          d="M8087,1027.95l22.8-13.42l46.96,27.47-22.8,13.42-46.96-27.47Z"
          fill="#005289"
        />
        <g>
          <path
            d="M8070.04,1177.75l-542.99,215.93v3.49c0,2.73,1.81,5.47,5.42,7.56L7595.3,1441c7.22,4.16,18.93,4.16,26.15,0l443.18-252.19c3.61-2.08,5.41-4.82,5.41-7.55v-3.51Z"
            fill="#1674b4"
          />
          <path
            d="M7621.46,1438.24l443.17-252.18c7.22-4.17,7.23-10.93,0-15.11l-62.8-36.27c-7.22-4.17-18.93-4.17-26.16-.01l-443.19,252.19c-7.22,4.17-7.23,10.93,0,15.11l62.82,36.27c7.22,4.17,18.93,4.17,26.16,0Z"
            fill="#005289"
          />
          <path
            d="M7930.65,1145.4l69.6,40.72v17.65l-69.6-40.71v-17.66Z"
            fill="url(#edEvCAwTnKp930-fill)"
          />
          <path
            d="M8000.25,1186.12l34.18-19.53v17.65l-34.18,19.53v-17.65Z"
            fill="#1674b4"
          />
          <path
            d="M7930.65,1145.4l34.18-19.53l69.6,40.72-34.18,19.53-69.6-40.72Z"
            fill="#005289"
          />
          <path
            d="M7810.51,1202.3l62.01,36.46v33.06l-62.01-36.46v-33.06Z"
            fill="url(#edEvCAwTnKp933-fill)"
          />
          <path
            d="M7872.52,1238.76l102.63-59.74v33.06l-102.63,59.74v-33.06Z"
            fill="#1674b4"
          />
          <path
            d="M7810.51,1202.3l102.62-59.74l62.02,36.46-102.63,59.74-62.01-36.46Z"
            fill="#005289"
          />
          <path
            d="M7725.5,1249.9l62.02,36.47v33.06l-62.02-36.47v-33.06Z"
            fill="url(#edEvCAwTnKp936-fill)"
          />
          <path
            d="M7787.51,1286.37l62.22-35.5v33.07l-62.22,35.49v-33.06Z"
            fill="#1674b4"
          />
          <path
            d="M7725.5,1249.9l62.22-35.49l62.01,36.46-62.21,35.5-62.02-36.47Z"
            fill="#005289"
          />
          <path
            d="M7748.29,1225.08l39.26,23.08v20.93l-39.26-23.08v-20.93Z"
            fill="url(#edEvCAwTnKp939-fill)"
          />
          <path
            d="M7787.55,1248.16l39.39-22.46v20.93l-39.39,22.46v-20.93Z"
            fill="#1674b4"
          />
          <path
            d="M7748.29,1225.08l39.39-22.47l39.26,23.09-39.39,22.46-39.26-23.08Z"
            fill="#005289"
          />
          <path
            d="M7599.67,1319.62l62.01,36.46v33.07l-62.01-36.47v-33.06Z"
            fill="url(#edEvCAwTnKp942-fill)"
          />
          <path
            d="M7661.68,1356.08l102.62-59.74v33.07l-102.62,59.74v-33.07Z"
            fill="#1674b4"
          />
          <path
            d="M7599.67,1319.62l102.62-59.74l62.01,36.46-102.62,59.74-62.01-36.46Z"
            fill="#005289"
          />
        </g>
        <g>
          <g>
            <path
              d="M7286.47,1628.31L6814,1545.53v3.49c0,2.73,1.81,5.47,5.42,7.55l289.42,165.6c7.22,4.17,18.93,4.17,26.16,0l146.06-82.79c3.61-2.09,5.41-4.82,5.41-7.56v-3.51Z"
              fill="#1674b4"
            />
            <path
              d="M7135,1718.61l146.06-82.8c7.22-4.16,7.23-10.93,0-15.1l-289.4-165.36c-7.22-4.17-18.93-4.17-26.16,0l-146.07,82.56c-7.23,4.17-7.23,10.93-.01,15.1l289.42,165.6c7.22,4.17,18.94,4.17,26.16,0Z"
              fill="#005289"
            />
            <path
              d="M6853.84,1535.98l80.5-46.47l175.73,101.45-80.5,46.48-175.73-101.46Z"
              fill="url(#edEvCAwTnKp949-fill)"
            />
            <path
              d="M7074.51,1561.4l-151.72-87.59v22.31l151.72,87.59v-22.31Z"
              fill="url(#edEvCAwTnKp950-fill)"
            />
            <path
              d="M6922.79,1473.81l-60.81,35.11v22.31l60.81-35.11v-22.31Z"
              fill="url(#edEvCAwTnKp951-fill)"
            />
            <path
              d="M7013.69,1596.51l60.82-35.11v22.31l-60.82,35.11v-22.31Z"
              fill="url(#edEvCAwTnKp952-fill)"
            />
            <path
              d="M6861.98,1508.92l60.81-35.11l151.72,87.59-60.82,35.11-151.71-87.59Z"
              fill="url(#edEvCAwTnKp953-fill)"
            />
            <g>
              <path
                d="M7035.28,1624.02c4.34,0,7.86-2.03,7.86-4.53c0-2.51-3.52-4.54-7.86-4.54s-7.86,2.03-7.86,4.54c0,2.5,3.52,4.53,7.86,4.53Z"
                fill="url(#edEvCAwTnKp955-fill)"
              />
            </g>
            <path
              d="M7035.6,1617.22l-7.73-22.31-5.78.67l7.73,22.31v0c.11.32.38.62.81.87c1.15.67,3.01.67,4.17,0c.72-.42.99-1,.8-1.54Z"
              fill="url(#edEvCAwTnKp956-fill)"
            />
            <path
              d="M7048.37,1607.68l-5.59-1.08-7.73,13.38v.01c-.34.59-.1,1.27.71,1.74c1.16.66,3.02.66,4.17,0c.34-.19.57-.42.71-.67h.01l7.72-13.38Z"
              fill="url(#edEvCAwTnKp957-fill)"
            />
            <path
              d="M7024.66,1597.36c-1.15.67-3.02.67-4.17,0-1.15-.66-1.15-1.74,0-2.41c1.15-.66,3.02-.66,4.17,0c1.15.67,1.15,1.75,0,2.41Z"
              fill="url(#edEvCAwTnKp958-fill)"
            />
            <path
              d="M7045.26,1609.25c-1.15.67-3.02.67-4.17,0-1.16-.66-1.16-1.74,0-2.41c1.15-.66,3.02-.66,4.17,0c1.15.67,1.15,1.75,0,2.41Z"
              fill="url(#edEvCAwTnKp959-fill)"
            />
            <path
              d="M7116.5,1549.95l-175.73-101.46v22.31l175.73,105.92v-26.77Z"
              fill="#005289"
            />
            <path
              d="M6940.77,1448.49l-80.5,46.48v26.77l80.5-50.94v-22.31Z"
              fill="#005289"
            />
            <path
              d="M7036,1596.42l80.5-46.47v26.77l-80.5,46.47v-26.77Z"
              fill="url(#edEvCAwTnKp962-fill)"
            />
            <path
              d="M6860.27,1494.97l80.5-46.48l175.73,101.46-80.5,46.47-175.73-101.45Z"
              fill="#005289"
            />
            <path
              d="M6995.87,1550.64l39.4-22.75-115.92-66.93-39.4,22.75l115.92,66.93Z"
              fill="#005289"
            />
            <path
              d="M7035.27,1527.89v-7.94l-115.92-66.92v7.93l115.92,66.93Z"
              fill="#005289"
            />
            <path
              d="M7035.27,1519.95c0,0-11.28.09-19.7,4.95s-15.69,11.64-19.7,17.8l-115.92-66.92c4.01-6.17,11.28-12.95,19.7-17.81s19.7-4.94,19.7-4.94l115.92,66.92Z"
              fill="#005289"
            />
            <path
              d="M7035.27,1519.95v7.94l-39.4,22.75v-7.94c4.01-6.16,11.28-12.94,19.7-17.8s19.7-4.95,19.7-4.95Z"
              fill="url(#edEvCAwTnKp967-fill)"
            />
          </g>
          <g>
            <g>
              <g>
                <path
                  d="M7347.5,1330.7L7020,1423.86v3.49c0,2.73,1.81,5.47,5.42,7.56l62.82,36.27c7.23,4.16,18.93,4.16,26.16,0l227.68-129.41c3.62-2.09,5.42-4.82,5.42-7.56v-3.51Z"
                  fill="#1674b4"
                />
                <path
                  d="M7114.41,1467.62l227.67-129.41c7.23-4.17,7.23-10.93.01-15.1l-62.8-36.28c-7.22-4.17-18.94-4.17-26.16,0l-227.7,129.41c-7.23,4.17-7.23,10.93-.01,15.1l62.83,36.28c7.22,4.17,18.93,4.17,26.16,0Z"
                  fill="#005289"
                />
              </g>
              <g>
                <path
                  d="M7198.27,1287.93l58.2,34.22v44.69l-58.2-34.23v-44.68Z"
                  fill="url(#edEvCAwTnKp974-fill)"
                />
                <path
                  d="M7256.47,1322.15l31.94-18.44v44.69l-31.94,18.44v-44.69Z"
                  fill="#1674b4"
                />
                <path
                  d="M7198.27,1287.93l31.93-18.44l58.21,34.22-31.94,18.44-58.2-34.22Z"
                  fill="#005289"
                />
              </g>
              <g>
                <path
                  d="M7140.27,1322.93l58.2,34.22v44.68l-58.2-34.22v-44.68Z"
                  fill="url(#edEvCAwTnKp978-fill)"
                />
                <path
                  d="M7198.47,1357.15l31.94-18.44v44.69l-31.94,18.43v-44.68Z"
                  fill="#1674b4"
                />
                <path
                  d="M7140.27,1322.93l31.93-18.44l58.21,34.22-31.94,18.44-58.2-34.22Z"
                  fill="#005289"
                />
              </g>
              <g>
                <path
                  d="M7050.27,1374.93l58.2,34.22v44.68l-58.2-34.22v-44.68Z"
                  fill="url(#edEvCAwTnKp982-fill)"
                />
                <path
                  d="M7108.47,1409.15l31.94-18.44v44.69l-31.94,18.43v-44.68Z"
                  fill="#1674b4"
                />
                <path
                  d="M7050.27,1374.93l31.93-18.44l58.21,34.22-31.94,18.44-58.2-34.22Z"
                  fill="#005289"
                />
              </g>
            </g>
            <g>
              <g>
                <path
                  d="M7457.23,1399.7l-327.5,93.16v3.49c0,2.73,1.81,5.47,5.42,7.56l62.82,36.27c7.23,4.16,18.93,4.16,26.16,0l227.68-129.41c3.62-2.09,5.42-4.82,5.42-7.56v-3.51Z"
                  fill="#1674b4"
                />
                <path
                  d="M7224.14,1536.62l227.67-129.41c7.23-4.17,7.23-10.93.01-15.1l-62.8-36.28c-7.22-4.17-18.94-4.17-26.16,0l-227.7,129.41c-7.23,4.17-7.23,10.93,0,15.1l62.82,36.28c7.22,4.17,18.93,4.17,26.16,0Z"
                  fill="#005289"
                />
              </g>
              <g>
                <path
                  d="M7308,1356.93l58.2,34.22v44.69l-58.2-34.23v-44.68Z"
                  fill="url(#edEvCAwTnKp990-fill)"
                />
                <path
                  d="M7366.21,1391.15l31.93-18.44v44.69l-31.93,18.44v-44.69Z"
                  fill="#1674b4"
                />
                <path
                  d="M7308,1356.93l31.93-18.44l58.21,34.22-31.94,18.44-58.2-34.22Z"
                  fill="#005289"
                />
              </g>
              <g>
                <path
                  d="M7250,1391.93l58.2,34.22v44.68l-58.2-34.22v-44.68Z"
                  fill="url(#edEvCAwTnKp994-fill)"
                />
                <path
                  d="M7308.21,1426.15l31.93-18.44v44.69l-31.93,18.43v-44.68Z"
                  fill="#1674b4"
                />
                <path
                  d="M7250,1391.93l31.93-18.44l58.21,34.22-31.94,18.44-58.2-34.22Z"
                  fill="#005289"
                />
              </g>
              <g>
                <path
                  d="M7160,1443.93l58.2,34.22v44.68l-58.2-34.22v-44.68Z"
                  fill="url(#edEvCAwTnKp998-fill)"
                />
                <path
                  d="M7218.21,1478.15l31.93-18.44v44.69l-31.93,18.43v-44.68Z"
                  fill="#1674b4"
                />
                <path
                  d="M7160,1443.93l31.93-18.44l58.21,34.22-31.94,18.44-58.2-34.22Z"
                  fill="#005289"
                />
              </g>
            </g>
            <g>
              <g>
                <path
                  d="M7572.5,1463.7L7245,1556.86v3.49c0,2.73,1.81,5.47,5.42,7.56l62.82,36.27c7.23,4.16,18.93,4.16,26.16,0l227.68-129.41c3.62-2.09,5.42-4.82,5.42-7.56v-3.51Z"
                  fill="#1674b4"
                />
                <path
                  d="M7339.41,1600.62l227.67-129.41c7.23-4.17,7.23-10.93.01-15.1l-62.8-36.28c-7.22-4.17-18.94-4.17-26.16,0l-227.7,129.41c-7.23,4.17-7.23,10.93-.01,15.1l62.83,36.28c7.22,4.17,18.93,4.17,26.16,0Z"
                  fill="#005289"
                />
              </g>
              <g>
                <path
                  d="M7423.27,1420.93l58.2,34.22v44.69l-58.2-34.23v-44.68Z"
                  fill="url(#edEvCAwTnKp1006-fill)"
                />
                <path
                  d="M7481.47,1455.15l31.94-18.44v44.69l-31.94,18.44v-44.69Z"
                  fill="#1674b4"
                />
                <path
                  d="M7423.27,1420.93l31.93-18.44l58.21,34.22-31.94,18.44-58.2-34.22Z"
                  fill="#005289"
                />
              </g>
              <g>
                <path
                  d="M7365.27,1455.93l58.2,34.22v44.68l-58.2-34.22v-44.68Z"
                  fill="url(#edEvCAwTnKp1010-fill)"
                />
                <path
                  d="M7423.47,1490.15l31.94-18.44v44.69l-31.94,18.43v-44.68Z"
                  fill="#1674b4"
                />
                <path
                  d="M7365.27,1455.93l31.93-18.44l58.21,34.22-31.94,18.44-58.2-34.22Z"
                  fill="#005289"
                />
              </g>
              <g>
                <path
                  d="M7275.27,1507.93l58.2,34.22v44.68l-58.2-34.22v-44.68Z"
                  fill="url(#edEvCAwTnKp1014-fill)"
                />
                <path
                  d="M7333.47,1542.15l31.94-18.44v44.69l-31.94,18.43v-44.68Z"
                  fill="#1674b4"
                />
                <path
                  d="M7275.27,1507.93l31.93-18.44l58.21,34.22-31.94,18.44-58.2-34.22Z"
                  fill="#005289"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
      <g transform="translate(0-2)">
        <path d="M3661.66,3521.75l17.01-9.83v14.76l-17.01,9.82v-14.75Z" fill="#1674b4" />
        <path
          d="M3693.52,3467.64l44.06-25.44v59.04l-44.06,25.44v-59.04Z"
          fill="#1674b4"
        />
        <path d="M3672.65,3460.62l4.16-2.37v59.04l-4.16,2.37v-59.04Z" fill="#1674b4" />
        <path
          d="M3675.02,3475.36c-6.79,3.91-20.48,2.51-32.05-2.98v44.27c11.57,5.5,25.26,6.9,32.05,2.98c2.61-1.51,3.86-3.61,3.86-6v-44.28c0,2.39-1.25,4.5-3.86,6.01Z"
          fill="#1674b4"
        />
        <path
          d="M3539.03,3593.12l116.11-67.03v14.76l-116.11,67.03v-14.76Z"
          fill="#1674b4"
        />
        <path
          d="M3548.63,3554.39l116.11-67.03v44.27l-116.11,67.04v-44.28Z"
          fill="#1674b4"
        />
        <path
          d="M3686.77,3527.76l-17.01,9.73v.74l17.01-9.74v-.73Zm-16.03,11.04l17.01-9.74v.74l-17.01,9.74v-.74Zm18-8.43l-17.01,9.73v.74l17.01-9.73v-.74Zm-16.03,11.04l17.01-9.74v.74l-17.01,9.74v-.74Zm.98,1.31l17.01-9.74v.74l-17.01,9.73v-.73Z"
          clip-rule="evenodd"
          fill="#1674b4"
          fill-rule="evenodd"
        />
        <path d="M3643.29,3477.58l8.36-4.83v59.04l-8.36,4.83v-59.04Z" fill="#1674b4" />
      </g>
      <g id="edEvCAwTnKp1026" opacity="0">
        <path
          d="M3661.66,3521.75l17.01-9.83v14.76l-17.01,9.82v-14.75Z"
          fill="url(#edEvCAwTnKp1027-fill)"
        />
        <path
          d="M3693.52,3467.64l44.06-25.44v59.04l-44.06,25.44v-59.04Z"
          fill="url(#edEvCAwTnKp1028-fill)"
        />
        <path
          d="M3672.65,3460.62l4.16-2.37v59.04l-4.16,2.37v-59.04Z"
          fill="url(#edEvCAwTnKp1029-fill)"
        />
        <path
          d="M3675.02,3475.36c-6.79,3.91-20.48,2.51-32.05-2.98v44.27c11.57,5.5,25.26,6.9,32.05,2.98c2.61-1.51,3.86-3.61,3.86-6v-44.28c0,2.39-1.25,4.5-3.86,6.01Z"
          fill="url(#edEvCAwTnKp1030-fill)"
        />
        <path
          d="M3539.03,3593.12l116.11-67.03v14.76l-116.11,67.03v-14.76Z"
          fill="url(#edEvCAwTnKp1031-fill)"
        />
        <path
          d="M3548.63,3554.39l116.11-67.03v44.27l-116.11,67.04v-44.28Z"
          fill="url(#edEvCAwTnKp1032-fill)"
        />
        <path
          d="M3686.77,3527.76l-17.01,9.73v.74l17.01-9.74v-.73Zm-16.03,11.04l17.01-9.74v.74l-17.01,9.74v-.74Zm18-8.43l-17.01,9.73v.74l17.01-9.73v-.74Zm-16.03,11.04l17.01-9.74v.74l-17.01,9.74v-.74Zm.98,1.31l17.01-9.74v.74l-17.01,9.73v-.73Z"
          clip-rule="evenodd"
          fill="url(#edEvCAwTnKp1033-fill)"
          fill-rule="evenodd"
        />
        <path
          d="M3643.29,3477.58l8.36-4.83v59.04l-8.36,4.83v-59.04Z"
          fill="url(#edEvCAwTnKp1034-fill)"
        />
      </g>
      <path
        d="M3693.52,3467.84l44.06-25.44-149.48-86.3-44.07,25.44l114.3,65.99-3.74,2.16c-9.26-2.71-18.53-2.83-23.73.17-2.62,1.51-3.87,3.61-3.87,6.01c0,2.37,1.24,5.03,3.57,7.69l-3.52,2.03-6.85-3.96-116.11,67.04l44.55,25.72l116.11-67.03-19.19-11.08l2.88-1.67c10.16,3.56,20.84,4.06,26.59.75c2.61-1.51,3.86-3.61,3.86-6.01c0-2.86-1.79-6.15-5.15-9.34l3.1-1.8l16.69,9.63Z"
        fill="#005289"
      />
      <path d="M3574.41,3391.7l28.46-16.44v7.38l-28.46,16.44v-7.38Z" fill="#1674b4" />
      <path
        id="edEvCAwTnKp1037"
        d="M3574.41,3391.7l28.46-16.44v7.38l-28.46,16.44v-7.38Z"
        opacity="0"
        fill="url(#edEvCAwTnKp1037-fill)"
      />
      <g>
        <path d="M4841.1,2718.67l34.46-19.9v110.67l-34.46,19.9v-110.67Z" fill="#1674b4" />
        <path d="M4855.28,2875.26l21.31-12.31v10.25l-21.31,12.3v-10.24Z" fill="#1674b4" />
        <path
          d="M4828.47,2728.76l25.7-14.84v122.97l-25.7,14.84v-122.97Z"
          fill="#1674b4"
        />
        <path
          d="M4828.47,2749.25l26.96,15.56v102.48l-26.96-15.56v-102.48Z"
          fill="url(#edEvCAwTnKp1042-fill)"
        />
        <path
          d="M4855.43,2764.81l25.7-14.83v102.47l-25.7,14.84v-102.48Z"
          fill="#1674b4"
        />
        <path
          d="M4828.47,2749.25l25.7-14.84l26.96,15.57-25.7,14.83-26.96-15.56Z"
          fill="#005289"
        />
        <path
          d="M4780.93,2753.4l34.47-19.89v110.67l-34.47,19.9v-110.68Z"
          fill="#1674b4"
        />
        <path
          d="M4855.28,2875.26l-64.6-37.3v6.15v4.1v10.25l31.95,18.44v-10.25l32.65,18.85v-10.24Z"
          fill="url(#edEvCAwTnKp1046-fill)"
        />
        <path
          d="M4790.68,2837.96l21.31-12.31l64.6,37.3-21.31,12.31-64.6-37.3Z"
          fill="#005289"
        />
      </g>
      <g id="edEvCAwTnKp1048" opacity="0">
        <path
          d="M4841.1,2718.67l34.46-19.9v110.67l-34.46,19.9v-110.67Z"
          fill="url(#edEvCAwTnKp1049-fill)"
        />
        <path
          d="M4828.47,2728.76l25.7-14.84v122.97l-25.7,14.84v-122.97Z"
          fill="url(#edEvCAwTnKp1050-fill)"
        />
        <path
          d="M4828.47,2749.25l26.96,15.56v102.48l-26.96-15.56v-102.48Z"
          fill="url(#edEvCAwTnKp1051-fill)"
        />
        <path
          d="M4855.43,2764.81l25.7-14.83v102.47l-25.7,14.84v-102.48Z"
          fill="url(#edEvCAwTnKp1052-fill)"
        />
        <path
          d="M4828.47,2749.25l25.7-14.84l26.96,15.57-25.7,14.83-26.96-15.56Z"
          fill="#005289"
        />
        <path
          d="M4780.93,2753.4l34.47-19.89v110.67l-34.47,19.9v-110.68Z"
          fill="url(#edEvCAwTnKp1054-fill)"
        />
        <path
          d="M4855.28,2875.26l-64.6-37.3v6.15v4.1v10.25l31.95,18.44v-10.25l32.65,18.85v-10.24Z"
          fill="url(#edEvCAwTnKp1055-fill)"
        />
        <path
          d="M4855.28,2875.26l21.31-12.31v10.25l-21.31,12.3v-10.24Z"
          fill="url(#edEvCAwTnKp1056-fill)"
        />
        <path
          d="M4790.68,2837.96l21.31-12.31l64.6,37.3-21.31,12.31-64.6-37.3Z"
          fill="#005289"
        />
      </g>
      <g>
        <path
          d="M5326.86,2531.56l31.93-18.44v11.17l-31.93,18.44v-11.17Z"
          fill="#1674b4"
        />
        <path
          d="M5331.58,2489.59l31.93-18.43v44.68l-31.93,18.44v-44.69Z"
          fill="#1674b4"
        />
        <path
          d="M5300.39,2546.84l26.47-15.28v11.17l-26.47,15.28v-11.17Z"
          fill="#1674b4"
        />
        <path
          d="M5282.61,2491.89l26.26-15.16v55.86l-26.26,15.16v-55.86Z"
          fill="#1674b4"
        />
        <path
          d="M5268.46,2565.28l31.93-18.44v11.17l-31.93,18.44v-11.17Z"
          fill="#1674b4"
        />
        <path d="M5247.71,2579.3l20.74-14.02v11.17l-20.74,14.02v-11.17Z" fill="#1674b4" />
        <path d="M5206.17,2612.43l41.65-33.09v11.17l-41.65,33.1v-11.18Z" fill="#1674b4" />
        <path
          d="M5273.17,2523.31l31.94-18.43v44.68L5273.17,2568v-44.69Z"
          fill="#1674b4"
        />
        <path
          d="M5176.29,2467.38l31.93-18.44l96.89,55.94-31.94,18.43-96.88-55.93Z"
          fill="#005289"
        />
        <path d="M5207.74,2573.16l45.56-36.2v44.68l-45.56,36.21v-44.69Z" fill="#1674b4" />
      </g>
      <g id="edEvCAwTnKp1069" opacity="0">
        <path
          d="M5326.86,2531.56l31.93-18.44v11.17l-31.93,18.44v-11.17Z"
          fill="url(#edEvCAwTnKp1070-fill)"
        />
        <path
          d="M5331.58,2489.59l31.93-18.43v44.68l-31.93,18.44v-44.69Z"
          fill="url(#edEvCAwTnKp1071-fill)"
        />
        <path
          d="M5300.39,2546.84l26.47-15.28v11.17l-26.47,15.28v-11.17Z"
          fill="url(#edEvCAwTnKp1072-fill)"
        />
        <path
          d="M5282.61,2491.89l26.26-15.16v55.86l-26.26,15.16v-55.86Z"
          fill="url(#edEvCAwTnKp1073-fill)"
        />
        <path
          d="M5268.46,2565.28l31.93-18.44v11.17l-31.93,18.44v-11.17Z"
          fill="url(#edEvCAwTnKp1074-fill)"
        />
        <path
          d="M5247.71,2579.3l20.74-14.02v11.17l-20.74,14.02v-11.17Z"
          fill="url(#edEvCAwTnKp1075-fill)"
        />
        <path
          d="M5206.17,2612.43l41.65-33.09v11.17l-41.65,33.1v-11.18Z"
          fill="url(#edEvCAwTnKp1076-fill)"
        />
        <path
          d="M5273.17,2523.31l31.94-18.43v44.68L5273.17,2568v-44.69Z"
          fill="url(#edEvCAwTnKp1077-fill)"
        />
        <path
          d="M5176.29,2467.38l31.93-18.44l96.89,55.94-31.94,18.43-96.88-55.93Z"
          fill="#005289"
        />
        <path
          d="M5207.74,2573.16l45.56-36.2v44.68l-45.56,36.21v-44.69Z"
          fill="url(#edEvCAwTnKp1079-fill)"
        />
      </g>
      <g>
        <path
          d="M4059.94,3223.85l127.53-73.63v1.61l-127.53,73.63v-1.61Z"
          fill="#1674b4"
        />
        <path d="M4062,3198.89l92.02-60.47v19.32L4062,3218.21v-19.32Z" fill="#1674b4" />
        <path d="M4064,3180.72l76.84-54.89v19.32L4064,3200.04v-19.32Z" fill="#1674b4" />
        <path
          d="M4065.86,3162.48l60.54-50.86v19.31l-60.54,50.87v-19.32Z"
          fill="#1674b4"
        />
        <path
          d="M4056.71,3137.88l60.43-45.58v19.32l-60.43,45.58v-19.32Z"
          fill="#1674b4"
        />
        <path d="M4040.8,3115.82l24.5-14.14v12.88l-24.5,14.14v-12.88Z" fill="#1674b4" />
        <path
          d="M4240.91,3119.37l127.53-73.63v1.61l-127.53,73.63v-1.61Z"
          fill="#1674b4"
        />
        <path
          d="M4253.94,3080.74l104.73-53.13v19.32l-104.73,53.12v-19.31Z"
          fill="#1674b4"
        />
        <path
          d="M4265.59,3053.81l95.07-44.37v19.32l-95.07,44.37v-19.32Z"
          fill="#1674b4"
        />
        <path d="M4274.42,3026.16l88.1-34.96v19.32l-88.1,34.95v-19.31Z" fill="#1674b4" />
        <path d="M4274.42,3001.5l78.95-34.9v19.32l-78.95,34.89v-19.31Z" fill="#1674b4" />
        <path d="M4309.8,2957.72l24.49-14.14v12.88l-24.49,14.14v-12.88Z" fill="#1674b4" />
      </g>
      <g id="edEvCAwTnKp1093" opacity="0">
        <path
          d="M4059.94,3223.85l127.53-73.63v1.61l-127.53,73.63v-1.61Z"
          fill="url(#edEvCAwTnKp1094-fill)"
        />
        <path
          d="M4062,3198.89l92.02-60.47v19.32L4062,3218.21v-19.32Z"
          fill="url(#edEvCAwTnKp1095-fill)"
        />
        <path
          d="M4064,3180.72l76.84-54.89v19.32L4064,3200.04v-19.32Z"
          fill="url(#edEvCAwTnKp1096-fill)"
        />
        <path
          d="M4065.86,3162.48l60.54-50.86v19.31l-60.54,50.87v-19.32Z"
          fill="url(#edEvCAwTnKp1097-fill)"
        />
        <path
          d="M4056.71,3137.88l60.43-45.58v19.32l-60.43,45.58v-19.32Z"
          fill="url(#edEvCAwTnKp1098-fill)"
        />
        <path
          d="M4040.8,3115.82l24.5-14.14v12.88l-24.5,14.14v-12.88Z"
          fill="url(#edEvCAwTnKp1099-fill)"
        />
        <path
          d="M4240.91,3119.37l127.53-73.63v1.61l-127.53,73.63v-1.61Z"
          fill="url(#edEvCAwTnKp1100-fill)"
        />
        <path
          d="M4253.94,3080.74l104.73-53.13v19.32l-104.73,53.12v-19.31Z"
          fill="url(#edEvCAwTnKp1101-fill)"
        />
        <path
          d="M4265.59,3053.81l95.07-44.37v19.32l-95.07,44.37v-19.32Z"
          fill="url(#edEvCAwTnKp1102-fill)"
        />
        <path
          d="M4274.42,3026.16l88.1-34.96v19.32l-88.1,34.95v-19.31Z"
          fill="url(#edEvCAwTnKp1103-fill)"
        />
        <path
          d="M4274.42,3001.5l78.95-34.9v19.32l-78.95,34.89v-19.31Z"
          fill="url(#edEvCAwTnKp1104-fill)"
        />
        <path
          d="M4309.8,2957.72l24.49-14.14v12.88l-24.49,14.14v-12.88Z"
          fill="url(#edEvCAwTnKp1105-fill)"
        />
      </g>
      <g>
        <g>
          <path
            d="M5985.05,2050.65l17.66-10.2v14.09l-17.66,10.2v-14.09Z"
            fill="url(#edEvCAwTnKp1108-fill)"
          />
          <path
            d="M6002.71,2040.45l28.48,16.44v14.09l-28.48-16.44v-14.09Z"
            fill="url(#edEvCAwTnKp1109-fill)"
          />
          <path
            d="M6031.19,2056.89l51.54-29.76c.93-.53,1.39-1.23,1.39-1.93v14.09c0,.7-.46,1.4-1.39,1.94l-51.54,29.75v-14.09Z"
            fill="url(#edEvCAwTnKp1110-fill)"
          />
          <path
            d="M5909.34,2045.86c0,.7.46,1.41,1.39,1.94l64.74,37.38c1.85,1.07,4.86,1.07,6.71,0l31.34-18.09v14.09l-31.34,18.1c-1.85,1.06-4.86,1.06-6.71,0l-64.74-37.38c-.93-.54-1.39-1.24-1.39-1.94v-14.1Z"
            fill="url(#edEvCAwTnKp1111-fill)"
          />
          <path
            d="M5909.34,2045.86c0-.7.47-1.4,1.39-1.93l100.55-58.05c1.85-1.07,4.86-1.07,6.71,0l64.74,37.38c.93.53,1.39,1.23,1.39,1.94c0,.7-.46,1.4-1.39,1.93l-51.54,29.76-28.48-16.44-17.66,10.2l28.47,16.44-31.34,18.09c-1.85,1.07-4.85,1.07-6.71,0l-64.74-37.38c-.93-.53-1.39-1.24-1.39-1.94Z"
            fill="#005289"
          />
          <path
            d="M5909.34,2024.72c0,.7.46,1.4,1.39,1.94l29.02,16.75c1.85,1.07,4.85,1.07,6.7,0l73.51-42.43v21.14l-73.51,42.43c-1.85,1.07-4.85,1.07-6.7,0l-29.02-16.75c-.93-.53-1.39-1.24-1.39-1.94v-21.14Z"
            fill="url(#edEvCAwTnKp1113-fill)"
          />
          <path
            d="M6019.96,2000.98l32.37,18.69c1.85,1.07,4.85,1.07,6.71,0l23.69-13.68c.93-.54,1.39-1.24,1.39-1.94v21.15c0,.7-.46,1.4-1.39,1.93l-23.69,13.68c-1.86,1.07-4.86,1.07-6.71,0l-32.37-18.69v-21.14Z"
            fill="url(#edEvCAwTnKp1114-fill)"
          />
          <path
            d="M5909.34,2024.72c0-.7.47-1.4,1.39-1.93l100.55-58.06c1.85-1.07,4.86-1.07,6.71,0l1.4.82l30.97,17.87l32.37,18.69c.93.54,1.39,1.24,1.39,1.94s-.46,1.4-1.39,1.94l-23.69,13.68c-1.86,1.07-4.86,1.07-6.71,0l-32.37-18.69-73.51,42.43c-1.85,1.07-4.85,1.07-6.7,0l-29.02-16.75c-.93-.54-1.39-1.24-1.39-1.94Z"
            fill="#005289"
          />
          <path
            d="M5919.04,2016.53l26.05,15.04v7.05l-26.05-15.04v-7.05Z"
            fill="url(#edEvCAwTnKp1116-fill)"
          />
          <path
            d="M5945.09,2031.57l75.9-43.83v7.05l-75.9,43.83v-7.05Z"
            fill="url(#edEvCAwTnKp1117-fill)"
          />
          <path
            d="M6021,1987.74l35.8,20.68v7.04l-35.8-20.67v-7.05Z"
            fill="url(#edEvCAwTnKp1118-fill)"
          />
          <path
            d="M6056.8,2008.42l19.26-11.13v7.05l-19.26,11.12v-7.04Z"
            fill="url(#edEvCAwTnKp1119-fill)"
          />
          <path
            d="M5919.04,2016.53l75.9-43.83-.07-.04l19.26-11.12.08.04l26.05,15.04l35.8,20.67-19.26,11.13-35.8-20.68-75.91,43.83-26.05-15.04Z"
            fill="#005289"
          />
        </g>
        <g>
          <path
            d="M5816.36,2098.41l28.48,16.44v14.1l-28.48-16.44v-14.1Z"
            fill="url(#edEvCAwTnKp1122-fill)"
          />
          <path
            d="M5752.94,2136.16c0,.7.46,1.41,1.39,1.94l64.74,37.38c1.85,1.07,4.85,1.07,6.71,0l113.57-65.57c.93-.54,1.39-1.24,1.39-1.94v14.1c0,.7-.46,1.4-1.39,1.93l-113.57,65.58c-1.86,1.06-4.86,1.06-6.71,0l-64.74-37.38c-.93-.54-1.39-1.24-1.39-1.94v-14.1Z"
            fill="url(#edEvCAwTnKp1123-fill)"
          />
          <path
            d="M5752.94,2136.16c0-.7.46-1.4,1.39-1.93l44.36-25.62l28.48,16.44l17.67-10.2-28.48-16.44l51.54-29.76c1.86-1.07,4.86-1.07,6.71,0l64.74,37.38c.93.54,1.39,1.24,1.39,1.94s-.46,1.4-1.39,1.94l-113.57,65.57c-1.86,1.07-4.86,1.07-6.71,0l-64.74-37.38c-.93-.54-1.39-1.24-1.39-1.94Z"
            fill="#005289"
          />
          <path
            d="M5842.82,2063.12c0,.7.46,1.41,1.39,1.94l32.37,18.69v21.15l-32.37-18.69c-.93-.54-1.39-1.24-1.39-1.94v-21.15Z"
            fill="url(#edEvCAwTnKp1125-fill)"
          />
          <path
            d="M5788.66,2135.64c0,.71.46,1.41,1.39,1.94l29.02,16.76c1.85,1.07,4.86,1.07,6.71,0l89.88-51.9l23.7-13.68c.92-.53,1.38-1.23,1.38-1.93v21.14c0,.7-.46,1.4-1.38,1.94l-23.7,13.68-89.88,51.89c-1.85,1.07-4.86,1.07-6.71,0l-29.02-16.75c-.93-.54-1.39-1.24-1.39-1.94v-21.15Z"
            fill="url(#edEvCAwTnKp1126-fill)"
          />
          <path
            d="M5788.66,2135.64c0-.7.47-1.4,1.39-1.93l86.53-49.96-32.37-18.69c-.93-.53-1.39-1.24-1.39-1.94s.47-1.4,1.39-1.93l23.69-13.68c1.86-1.07,4.86-1.07,6.71,0l32.38,18.69l32.37,18.69c.92.54,1.38,1.24,1.38,1.94s-.46,1.4-1.38,1.93l-23.7,13.68-89.88,51.9c-1.85,1.07-4.86,1.07-6.71,0l-29.02-16.76c-.93-.53-1.39-1.24-1.39-1.94Z"
            fill="#005289"
          />
          <path
            d="M5851.18,2055.61l35.8,20.67v7.05l-35.8-20.67v-7.05Z"
            fill="url(#edEvCAwTnKp1128-fill)"
          />
          <path
            d="M5798.05,2127.63l26.05,15.04v7.05l-26.05-15.04v-7.05Z"
            fill="url(#edEvCAwTnKp1129-fill)"
          />
          <path
            d="M5824.1,2142.67l88.94-51.35v7.05l-88.94,51.35v-7.05Z"
            fill="url(#edEvCAwTnKp1130-fill)"
          />
          <path
            d="M5913.12,2091.37l19.26-11.12v7.04l-19.26,11.13v-7.05Z"
            fill="#1674b4"
          />
          <path
            d="M5798.05,2127.63l88.94-51.35-35.81-20.67l19.27-11.12l35.8,20.67l26.05,15.04.08.05-19.26,11.12-.08-.05-88.94,51.35-26.05-15.04Z"
            fill="#005289"
          />
        </g>
        <g>
          <path
            d="M5692.45,2219.58l17.66-10.2v14.1l-17.66,10.2v-14.1Z"
            fill="url(#edEvCAwTnKp1134-fill)"
          />
          <path
            d="M5710.11,2209.38l28.48,16.44v14.1l-28.48-16.44v-14.1Z"
            fill="url(#edEvCAwTnKp1135-fill)"
          />
          <path
            d="M5738.59,2225.82l44.36-25.61c.93-.54,1.39-1.24,1.39-1.94v14.1c0,.7-.46,1.4-1.39,1.93l-44.36,25.62v-14.1Z"
            fill="url(#edEvCAwTnKp1136-fill)"
          />
          <path
            d="M5596.54,2226.46c0,.7.46,1.4,1.39,1.94l64.74,37.38c1.85,1.07,4.85,1.07,6.71,0l51.54-29.76v14.1l-51.54,29.75c-1.86,1.07-4.86,1.07-6.71,0l-64.74-37.38c-.93-.53-1.39-1.23-1.39-1.94v-14.09Z"
            fill="url(#edEvCAwTnKp1137-fill)"
          />
          <path
            d="M5596.54,2226.46c0-.7.46-1.4,1.39-1.93l113.57-65.58c1.86-1.07,4.86-1.07,6.71,0l64.74,37.38c.93.54,1.39,1.24,1.39,1.94s-.46,1.4-1.39,1.94l-44.36,25.61-28.48-16.44-17.66,10.2l28.47,16.44-51.54,29.76c-1.86,1.07-4.86,1.07-6.71,0l-64.74-37.38c-.93-.54-1.39-1.24-1.39-1.94Z"
            fill="#005289"
          />
          <path
            d="M5660.7,2209.55l86.53-49.96c.92-.53,1.39-1.23,1.39-1.93v21.14c0,.7-.47,1.4-1.39,1.93l-86.53,49.96v-21.14Z"
            fill="url(#edEvCAwTnKp1139-fill)"
          />
          <path
            d="M5596.54,2205.31c0,.71.46,1.41,1.39,1.95l32.37,18.69l32.37,18.69c1.85,1.06,4.85,1.06,6.71,0l23.69-13.68c.93-.54,1.39-1.24,1.39-1.94v21.15c0,.7-.46,1.39-1.39,1.93l-23.69,13.68c-1.86,1.07-4.86,1.07-6.71,0l-32.37-18.69-32.37-18.69c-.93-.54-1.39-1.24-1.39-1.94v-21.15Z"
            fill="url(#edEvCAwTnKp1140-fill)"
          />
          <path
            d="M5596.54,2206.47c0-.7.46-1.4,1.39-1.93l23.69-13.68l89.88-51.9c1.86-1.07,4.86-1.07,6.71,0l29.02,16.76c.93.53,1.39,1.24,1.39,1.94s-.47,1.4-1.39,1.93l-86.53,49.96l32.37,18.69c.93.53,1.39,1.23,1.39,1.94c0,.7-.46,1.4-1.39,1.93l-23.69,13.68c-1.86,1.07-4.86,1.07-6.71,0l-32.37-18.69-32.37-18.69c-.93-.54-1.39-1.24-1.39-1.94Z"
            fill="#005289"
          />
          <path
            d="M5650.29,2201.77l88.94-51.35v7.05l-88.94,51.35v-7.05Z"
            fill="url(#edEvCAwTnKp1142-fill)"
          />
          <path
            d="M5604.9,2197.81l.08.04l26.05,15.04l35.8,20.67v7.05l-35.8-20.67-26.05-15.04-.08-.05v-7.04Z"
            fill="url(#edEvCAwTnKp1143-fill)"
          />
          <path
            d="M5666.83,2233.56l19.26-11.12v7.05l-19.26,11.12v-7.05Z"
            fill="url(#edEvCAwTnKp1144-fill)"
          />
          <path
            d="M5604.9,2197.81l19.27-11.13.07.05l88.94-51.35l26.05,15.04-88.93,51.35l35.8,20.67-19.27,11.12-35.8-20.67-26.05-15.04-.08-.04Z"
            fill="#005289"
          />
        </g>
      </g>
      <g id="edEvCAwTnKp1146" opacity="0">
        <g>
          <path
            d="M5985.21,2050.91l17.67-10.2v14.1l-17.67,10.2v-14.1Z"
            fill="url(#edEvCAwTnKp1148-fill)"
          />
          <path
            d="M6002.88,2040.71l28.47,16.44v14.1l-28.47-16.44v-14.1Z"
            fill="url(#edEvCAwTnKp1149-fill)"
          />
          <path
            d="M6031.35,2057.15l51.55-29.76c.92-.53,1.39-1.23,1.39-1.93v14.1c0,.7-.47,1.39-1.39,1.93l-51.55,29.76v-14.1Z"
            fill="url(#edEvCAwTnKp1150-fill)"
          />
          <path
            d="M5909.51,2046.12c0,.71.46,1.41,1.39,1.95l64.74,37.37c1.85,1.07,4.86,1.07,6.71,0l31.34-18.09v14.09l-31.34,18.1c-1.85,1.07-4.86,1.07-6.71,0l-64.74-37.38c-.93-.54-1.39-1.24-1.39-1.94v-14.1Z"
            fill="url(#edEvCAwTnKp1151-fill)"
          />
          <path
            d="M5909.51,2046.12c0-.69.46-1.39,1.39-1.93l100.55-58.05c1.85-1.07,4.85-1.07,6.71,0l64.74,37.38c.93.54,1.39,1.24,1.39,1.94s-.47,1.4-1.39,1.93l-51.55,29.76-28.47-16.44-17.66,10.2l28.47,16.44-31.34,18.09c-1.85,1.07-4.86,1.07-6.71,0l-64.74-37.37c-.93-.54-1.39-1.24-1.39-1.95Z"
            fill="#005289"
          />
          <path
            d="M5909.51,2024.98c0,.7.46,1.41,1.39,1.94l29.01,16.76c1.86,1.06,4.86,1.06,6.71,0l73.5-42.44v21.14l-73.5,42.44c-1.85,1.07-4.85,1.07-6.71,0l-29.01-16.75c-.93-.54-1.39-1.24-1.39-1.95v-21.14Z"
            fill="url(#edEvCAwTnKp1153-fill)"
          />
          <path
            d="M6020.12,2001.24l32.37,18.69c1.86,1.07,4.86,1.07,6.71,0l23.7-13.68c.92-.53,1.39-1.23,1.39-1.93v21.14c0,.7-.47,1.4-1.39,1.93l-23.7,13.68c-1.85,1.07-4.85,1.07-6.71,0l-32.37-18.69v-21.14Z"
            fill="url(#edEvCAwTnKp1154-fill)"
          />
          <path
            d="M5909.51,2024.98c0-.7.46-1.4,1.39-1.93L6011.45,1965c1.85-1.07,4.85-1.07,6.71,0l1.4.81l30.97,17.88l32.37,18.69c.93.53,1.39,1.24,1.39,1.94s-.47,1.4-1.39,1.93l-23.7,13.68c-1.85,1.07-4.85,1.07-6.7,0l-32.38-18.69-73.5,42.44c-1.85,1.07-4.85,1.07-6.71,0l-29.01-16.76c-.93-.53-1.39-1.24-1.39-1.94Z"
            fill="#005289"
          />
          <path
            d="M5919.2,2016.79l26.05,15.04v7.05l-26.05-15.04v-7.05Z"
            fill="url(#edEvCAwTnKp1156-fill)"
          />
          <path
            d="M5945.25,2031.83l75.91-43.82v7.05l-75.91,43.82v-7.05Z"
            fill="url(#edEvCAwTnKp1157-fill)"
          />
          <path
            d="M6021.16,1988.01l35.8,20.67v7.05l-35.8-20.67v-7.05Z"
            fill="url(#edEvCAwTnKp1158-fill)"
          />
          <path
            d="M6056.96,2008.68l19.27-11.12v7.04l-19.27,11.13v-7.05Z"
            fill="url(#edEvCAwTnKp1159-fill)"
          />
          <path
            d="M5919.2,2016.79l75.91-43.82-.08-.05l19.27-11.12.07.04l26.06,15.05l35.8,20.67-19.27,11.12-35.8-20.67-75.91,43.82-26.05-15.04Z"
            fill="#005289"
          />
        </g>
        <g>
          <path
            d="M5753.11,2136.42c0,.71.46,1.41,1.39,1.94l64.74,37.38c1.85,1.07,4.85,1.07,6.71,0l113.57-65.57c.93-.53,1.39-1.23,1.39-1.93v14.09c0,.7-.46,1.4-1.39,1.94l-113.57,65.57c-1.86,1.07-4.86,1.07-6.71,0l-64.74-37.38c-.93-.54-1.39-1.24-1.39-1.94v-14.1Z"
            fill="url(#edEvCAwTnKp1162-fill)"
          />
          <path
            d="M5753.11,2136.42c0-.7.46-1.4,1.39-1.93l44.36-25.62l28.48,16.45l17.66-10.2-28.47-16.44l51.54-29.76c1.85-1.07,4.86-1.07,6.71,0l64.74,37.38c.93.53,1.39,1.24,1.39,1.94s-.46,1.4-1.39,1.93l-113.57,65.57c-1.86,1.07-4.86,1.07-6.71,0l-64.74-37.38c-.93-.53-1.39-1.23-1.39-1.94Z"
            fill="#005289"
          />
          <path
            d="M5842.99,2063.39c0,.7.46,1.4,1.39,1.94l32.37,18.69v21.14l-32.37-18.69c-.93-.54-1.39-1.24-1.39-1.94v-21.14Z"
            fill="url(#edEvCAwTnKp1164-fill)"
          />
          <path
            d="M5788.83,2135.91c0,.7.46,1.4,1.39,1.94l29.02,16.75c1.85,1.07,4.85,1.07,6.71,0l89.88-51.89l23.69-13.68c.93-.54,1.39-1.24,1.39-1.94v21.15c0,.7-.46,1.4-1.39,1.93l-23.69,13.68-89.88,51.89c-1.86,1.07-4.86,1.07-6.71,0l-29.02-16.75c-.93-.54-1.39-1.24-1.39-1.94v-21.14Z"
            fill="url(#edEvCAwTnKp1165-fill)"
          />
          <path
            d="M5788.83,2135.91c0-.7.47-1.4,1.39-1.94l86.53-49.95-32.37-18.69c-.93-.54-1.39-1.24-1.39-1.94s.46-1.4,1.39-1.94l23.69-13.68c1.86-1.06,4.86-1.06,6.71,0l32.37,18.7l32.37,18.68c.93.54,1.39,1.24,1.39,1.95c0,.7-.46,1.39-1.39,1.93l-23.69,13.68-89.88,51.89c-1.86,1.07-4.86,1.07-6.71,0l-29.02-16.75c-.93-.54-1.39-1.24-1.39-1.94Z"
            fill="#005289"
          />
          <path
            d="M5851.35,2055.88l35.8,20.67v7.05l-35.8-20.68v-7.04Z"
            fill="url(#edEvCAwTnKp1167-fill)"
          />
          <path
            d="M5824.27,2142.94l88.94-51.35v7.05l-88.94,51.34v-7.04Z"
            fill="url(#edEvCAwTnKp1168-fill)"
          />
          <path
            d="M5913.28,2091.63l19.27-11.12v7.05l-19.27,11.12v-7.05Z"
            fill="url(#edEvCAwTnKp1169-fill)"
          />
          <path
            d="M5798.22,2127.89l88.93-51.34-35.8-20.67l19.27-11.13l35.8,20.67l26.05,15.05.08.04-19.27,11.12-.07-.04-88.94,51.35-26.05-15.05Z"
            fill="#005289"
          />
          <path
            d="M5816.53,2098.68l28.47,16.44v14.09l-28.47-16.44v-14.09Z"
            fill="url(#edEvCAwTnKp1171-fill)"
          />
          <path
            d="M5798.22,2127.89l26.05,15.05v7.04l-26.05-15.04v-7.05Z"
            fill="url(#edEvCAwTnKp1172-fill)"
          />
        </g>
        <g>
          <path
            d="M5692.61,2219.84l17.67-10.19v14.09l-17.67,10.2v-14.1Z"
            fill="url(#edEvCAwTnKp1174-fill)"
          />
          <path
            d="M5710.28,2209.65l28.47,16.43v14.1l-28.47-16.44v-14.09Z"
            fill="url(#edEvCAwTnKp1175-fill)"
          />
          <path
            d="M5738.75,2226.08l44.37-25.61c.93-.53,1.39-1.23,1.39-1.93v14.09c0,.7-.46,1.4-1.39,1.93l-44.37,25.62v-14.1Z"
            fill="url(#edEvCAwTnKp1176-fill)"
          />
          <path
            d="M5596.7,2226.72c0,.7.46,1.41,1.39,1.94l64.74,37.38c1.86,1.07,4.86,1.07,6.71,0l51.55-29.76v14.1l-51.55,29.76c-1.85,1.07-4.85,1.07-6.71,0l-64.74-37.38c-.93-.54-1.39-1.24-1.39-1.94v-14.1Z"
            fill="url(#edEvCAwTnKp1177-fill)"
          />
          <path
            d="M5596.7,2226.72c0-.7.47-1.4,1.39-1.93l113.58-65.57c1.85-1.07,4.85-1.07,6.71,0l64.74,37.38c.93.53,1.39,1.23,1.39,1.94c0,.7-.46,1.4-1.39,1.93l-44.37,25.61-28.47-16.43-17.67,10.19l28.48,16.44-51.55,29.76c-1.85,1.07-4.85,1.07-6.71,0l-64.74-37.38c-.92-.53-1.39-1.24-1.39-1.94Z"
            fill="#005289"
          />
          <path
            d="M5660.87,2209.81l86.53-49.96c.92-.53,1.39-1.23,1.39-1.93v21.14c0,.7-.47,1.4-1.39,1.94l-86.53,49.95v-21.14Z"
            fill="url(#edEvCAwTnKp1179-fill)"
          />
          <path
            d="M5596.7,2205.58c0,.7.46,1.4,1.39,1.94l32.37,18.69l32.37,18.69c1.86,1.07,4.86,1.07,6.71,0l23.7-13.68c.92-.53,1.39-1.23,1.39-1.93v21.14c0,.7-.47,1.4-1.39,1.93l-23.7,13.68c-1.85,1.07-4.85,1.07-6.71,0l-32.37-18.69-32.37-18.69c-.93-.53-1.39-1.24-1.39-1.94v-21.14Z"
            fill="url(#edEvCAwTnKp1180-fill)"
          />
          <path
            d="M5596.7,2206.73c0-.7.47-1.4,1.39-1.93l23.7-13.68l89.88-51.89c1.85-1.07,4.85-1.07,6.71,0l29.01,16.75c.93.53,1.39,1.24,1.39,1.94s-.46,1.4-1.39,1.93l-86.52,49.96l32.37,18.69c.93.53,1.39,1.24,1.39,1.94s-.47,1.4-1.39,1.93l-23.7,13.68c-1.85,1.07-4.85,1.07-6.71,0l-32.37-18.69-32.37-18.69c-.92-.53-1.39-1.23-1.39-1.94Z"
            fill="#005289"
          />
          <path
            d="M5650.46,2202.03l88.94-51.34v7.04l-88.94,51.35v-7.05Z"
            fill="url(#edEvCAwTnKp1182-fill)"
          />
          <path
            d="M5605.07,2198.07l.07.04l26.06,15.04l35.8,20.67v7.05l-35.8-20.67-26.06-15.04-.07-.04v-7.05Z"
            fill="url(#edEvCAwTnKp1183-fill)"
          />
          <path
            d="M5667,2233.82l19.26-11.12v7.05L5667,2240.87v-7.05Z"
            fill="url(#edEvCAwTnKp1184-fill)"
          />
          <path
            d="M5605.07,2198.07l19.26-11.12.08.04l88.93-51.35l26.05,15.04-88.93,51.35l35.8,20.67-19.26,11.12-35.8-20.67-26.06-15.04-.07-.04Z"
            fill="#005289"
          />
        </g>
      </g>
      <path
        d="M6500.84,1755.72l35-20.2l45.87-26.49v96.73l-45.87,26.48-35,20.21v-96.73Z"
        fill="#1674b4"
      />
      <path
        id="edEvCAwTnKp1187"
        d="M6500.84,1755.72l35-20.2l45.87-26.49v96.73l-45.87,26.48-35,20.21v-96.73Z"
        opacity="0"
        fill="url(#edEvCAwTnKp1187-fill)"
      />
      <g>
        <path
          d="M6861.98,1508.92l151.71,87.59v22.31l-151.71-87.59v-22.31Z"
          fill="#1674b4"
        />
        <path
          d="M6860.27,1494.97L7036,1596.42v26.77l-175.73-101.45v-26.77Z"
          fill="#1674b4"
        />
        <path d="M6995.87,1542.7v7.94l-115.92-66.93v-7.93l115.92,66.92Z" fill="#1674b4" />
      </g>
      <g id="edEvCAwTnKp1192" opacity="0">
        <path
          d="M6861.98,1508.92l151.71,87.59v22.31l-151.71-87.59v-22.31Z"
          fill="url(#edEvCAwTnKp1193-fill)"
        />
        <path
          d="M6860.27,1494.97L7036,1596.42v26.77l-175.73-101.45v-26.77Z"
          fill="url(#edEvCAwTnKp1194-fill)"
        />
        <path
          d="M6995.87,1542.7v7.94l-115.92-66.93v-7.93l115.92,66.92Z"
          fill="url(#edEvCAwTnKp1195-fill)"
        />
      </g>
    </g>
    <path
      id="edEvCAwTnKp1196"
      d="M527.675541,78.17L324.229,79.4999"
      transform="translate(0 132)"
      opacity="0"
      fill="none"
      stroke="#d0d0d0"
      stroke-width="2"
      stroke-dasharray="2,2"
    />
    <g id="edEvCAwTnKp1197" transform="translate(322.99056 158.627781)" opacity="0">
      <path
        d="M11.8224,6.08212L6.55244,12.3891l-.187-.442-2.669,3.247-.561-2.363l5.44-6.74898h3.24696Zm-7.25896,0v11.21998h-2.924v-11.21998h2.924Zm2.941,3.706L12.0264,17.3021h-3.31496l-3.4-5.882l2.193-1.63198ZM17.8825,11.9131c0-.3966-.1133-.7083-.34-.935-.2153-.238-.51-.357-.884-.357s-.697.0964-.969.289c-.2606.1814-.442.51-.544.986l-2.448-.578c.1587-.816.578-1.46764,1.258-1.95498s1.6377-.731,2.873-.731c.8274,0,1.53.12467,2.108.374.5894.238,1.037.60067,1.343,1.08798.3174.476.476,1.0654.476,1.768v3.111c0,.442.1984.663.595.663.204,0,.3684-.0226.493-.068l-.17,1.649c-.34.1587-.7536.238-1.241.238-.442,0-.833-.068-1.173-.204-.34-.1473-.6063-.3626-.799-.646-.1926-.2946-.289-.663-.289-1.105v-.102l.323-.119c0,.4874-.1473.8954-.442,1.224-.2833.3287-.6573.5724-1.122.731-.4533.1587-.9293.238-1.428.238-.578,0-1.0823-.0906-1.513-.272s-.765-.442-1.003-.782c-.2266-.3513-.34-.782-.34-1.292c0-.612.1814-1.1163.544-1.513.374-.408.9577-.6913,1.751-.85l3.213-.663-.017,1.53-1.632.34c-.34.068-.595.17-.765.306-.1586.1247-.238.3174-.238.578c0,.2494.0907.4364.272.561s.3967.187.646.187c.1927,0,.374-.0283.544-.085.1814-.0566.34-.1416.476-.255.136-.1246.2437-.2776.323-.459s.119-.3966.119-.646v-2.244Zm5.1018,5.389v-8.49998h2.55l.119,1.83598c.2153-.6346.5326-1.12764.952-1.47898.4306-.35133.9746-.527,1.632-.527.2153,0,.3966.017.544.051.1586.034.2833.07934.374.136l-.289,2.37998c-.1134-.0453-.2607-.0793-.442-.102-.17-.034-.3797-.051-.629-.051-.34,0-.6574.0737-.952.221-.2947.1474-.5327.3684-.714.663-.17.2834-.255.646-.255,1.088v4.284h-2.89Zm11.353.17c-.9406,0-1.7566-.1756-2.448-.527-.68-.3513-1.207-.8556-1.581-1.513-.374-.6573-.561-1.4506-.561-2.38c0-.9293.187-1.7226.561-2.38s.8954-1.16164,1.564-1.51298c.68-.35133,1.4564-.527,2.329-.527.8954,0,1.6547.17567,2.278.527.6347.34,1.1164.816,1.445,1.42798.3287.6007.493,1.292.493,2.074c0,.204-.0056.408-.017.612-.0113.204-.0283.374-.051.51h-6.732v-1.547h5.457l-1.377.527c0-.68-.1246-1.2013-.374-1.564-.238-.3626-.612-.544-1.122-.544-.3626,0-.6743.085-.935.255-.2493.17-.442.4364-.578.799-.1246.3627-.187.8274-.187,1.394c0,.5554.0737,1.0087.221,1.36.1474.34.357.5894.629.748.272.1474.6007.221.986.221.4307,0,.7707-.085,1.02-.255.2607-.17.4534-.408.578-.714l2.312.765c-.1586.4874-.4363.901-.833,1.241-.3853.3287-.85.578-1.394.748-.5326.17-1.0936.255-1.683.255Zm20.5832-.17h-3.009l-.782-2.533h-3.842l-.799,2.533h-2.941l3.944-11.21998h3.502l3.927,11.21998Zm-7.089-4.522h2.754l-1.377-4.53898-1.377,4.53898ZM11.0234,28.0821l-4.89596,5.015-.204.221-3.009,3.077v-1.836l6.324-6.477h1.78496Zm-7.42896,0v11.22h-1.36v-11.22h1.36Zm2.669,4.148l4.81096,7.072h-1.63196l-4.301-6.307l1.122-.765Zm6.87226,7.072v-8.5h1.105l.187,1.394c.238-.5213.5837-.9123,1.037-1.173.4647-.2606,1.0257-.391,1.683-.391.1473,0,.306.0114.476.034.1813.0227.3343.068.459.136l-.238,1.241c-.1247-.0453-.2607-.0793-.408-.102-.1473-.0226-.357-.034-.629-.034-.3513,0-.7083.102-1.071.306-.3513.204-.646.5157-.884.935-.238.408-.357.9294-.357,1.564v4.59h-1.36Zm11.671-5.491c0-.6346-.17-1.122-.51-1.462-.34-.3513-.8216-.527-1.445-.527-.5893,0-1.088.1304-1.496.391-.408.2494-.7083.6574-.901,1.224l-1.105-.68c.2267-.6346.646-1.1446,1.258-1.53.612-.3966,1.3714-.595,2.278-.595.612,0,1.1674.1077,1.666.323.4987.204.8897.5214,1.173.952.2947.4194.442.9634.442,1.632v4.114c0,.408.2154.612.646.612.2154,0,.425-.0283.629-.085l-.068,1.071c-.2266.1134-.5213.17-.884.17-.3286,0-.6233-.0623-.884-.187-.2606-.1246-.4646-.3116-.612-.561-.1473-.2606-.221-.5836-.221-.969v-.17l.34.051c-.136.442-.3683.8047-.697,1.088-.3286.272-.697.476-1.105.612-.408.1247-.8103.187-1.207.187-.4986,0-.9633-.085-1.394-.255s-.7763-.425-1.037-.765c-.2493-.3513-.374-.782-.374-1.292c0-.6346.2097-1.156.629-1.564.4307-.4193,1.0257-.7026,1.785-.85l3.366-.663v1.122l-2.737.561c-.5553.1134-.969.272-1.241.476s-.408.4874-.408.85c0,.3514.136.6404.408.867.2834.2154.68.323,1.19.323.3287,0,.6404-.0396.935-.119.306-.0906.578-.221.816-.391.238-.1813.425-.4023.561-.663.136-.272.204-.5893.204-.952v-2.346Zm4.6649,5.491v-8.5h1.19l.119,1.904-.221-.187c.1814-.4533.425-.816.731-1.088.306-.2833.6574-.4873,1.054-.612.408-.1246.8274-.187,1.258-.187.612,0,1.1674.119,1.666.357.4987.2267.8954.578,1.19,1.054.306.476.459,1.0824.459,1.819v5.44h-1.36v-4.964c0-.9406-.204-1.5923-.612-1.955-.3966-.374-.8896-.561-1.479-.561-.408,0-.816.0964-1.224.289-.408.1927-.748.5044-1.02.935-.2606.4307-.391,1.0087-.391,1.734v4.522h-1.36ZM40.677,29.1701c-.306,0-.5553-.0906-.748-.272-.1813-.1926-.272-.442-.272-.748s.0907-.5496.272-.731c.1927-.1926.442-.289.748-.289s.5497.0964.731.289c.1927.1814.289.425.289.731s-.0963.5554-.289.748c-.1813.1814-.425.272-.731.272Zm.68,1.632v9.367c0,.7027-.136,1.258-.408,1.666s-.6063.697-1.003.867-.7877.255-1.173.255c-.3513,0-.6743-.0566-.969-.17-.2947-.102-.5383-.2323-.731-.391l.289-1.292c.1587.1474.357.272.595.374s.5043.153.799.153c.3627,0,.6573-.119.884-.357.238-.238.357-.6516.357-1.241v-9.231h1.36Z"
        fill="#fff"
      />
      <path
        d="M8.40644,84.8072c-1.60534,0-3.00534-.308-4.2-.924-1.176-.6346-2.16534-1.6613-2.968-3.08l4.228-2.1c.20533.7467.532,1.344.98,1.792.46666.448,1.15733.672,2.072.672.57866,0,1.07333-.1026,1.48396-.308s.728-.504.952-.896c.2427-.4106.364-.9053.364-1.484c0-.56-.112-1.0266-.336-1.4-.2053-.3733-.5133-.6533-.924-.84-.41063-.2053-.92396-.308-1.53996-.308-.448,0-.84934.0467-1.204.14-.35467.0747-.68134.196-.98.364-.28.1494-.54134.3454-.784.588l-3.64-.672l1.176-10.304h11.64796v3.724h-8.14796l-.476,3.696-.084.448h.028c.37333-.4293.896-.756,1.568-.98s1.41866-.336,2.24-.336c1.21336,0,2.24936.2427,3.10796.728.8587.4854,1.5214,1.148,1.988,1.988.4667.84.7,1.8014.7,2.884c0,1.1387-.196,2.128-.588,2.968-.3733.8214-.9053,1.5027-1.596,2.044-.672.5414-1.4466.9427-2.324,1.204-.8586.2614-1.7733.392-2.74396.392Zm17.33226,0c-2.52,0-4.4334-.8026-5.74-2.408-1.288-1.6053-1.932-3.976-1.932-7.112s.644-5.5066,1.932-7.112c1.3066-1.6053,3.22-2.408,5.74-2.408s4.424.8027,5.712,2.408c1.3066,1.6054,1.96,3.976,1.96,7.112s-.6534,5.5067-1.96,7.112c-1.288,1.6054-3.192,2.408-5.712,2.408Zm0-3.752c.6906,0,1.2506-.1866,1.68-.56.4293-.392.7373-1.008.924-1.848.2053-.8586.308-1.9786.308-3.36c0-1.3813-.1027-2.492-.308-3.332-.1867-.8586-.4947-1.4746-.924-1.848-.4294-.392-.9894-.588-1.68-.588-.672,0-1.232.196-1.68.588-.4294.3734-.7467.9894-.952,1.848-.1867.84-.28,1.9507-.28,3.332c0,1.3814.0933,2.5014.28,3.36.2053.84.5226,1.456.952,1.848.448.3734,1.008.56,1.68.56Zm12.7901-1.344c.8773,0,1.5586.224,2.044.672.504.448.756,1.0734.756,1.876c0,.784-.252,1.4-.756,1.848-.4854.448-1.1667.672-2.044.672-.8587,0-1.54-.224-2.044-.672s-.756-1.064-.756-1.848c0-.8026.252-1.428.756-1.876s1.1853-.672,2.044-.672Zm12.069,5.096c-1.6053,0-3.0053-.308-4.2-.924-1.176-.6346-2.1653-1.6613-2.968-3.08l4.228-2.1c.2054.7467.532,1.344.98,1.792.4667.448,1.1574.672,2.072.672.5787,0,1.0734-.1026,1.484-.308s.728-.504.952-.896c.2427-.4106.364-.9053.364-1.484c0-.56-.112-1.0266-.336-1.4-.2053-.3733-.5133-.6533-.924-.84-.4106-.2053-.924-.308-1.54-.308-.448,0-.8493.0467-1.204.14-.3546.0747-.6813.196-.98.364-.28.1494-.5413.3454-.784.588l-3.64-.672l1.176-10.304h11.648v3.724h-8.148l-.476,3.696-.084.448h.028c.3734-.4293.896-.756,1.568-.98s1.4187-.336,2.24-.336c1.2134,0,2.2494.2427,3.108.728s1.5214,1.148,1.988,1.988c.4667.84.7,1.8014.7,2.884c0,1.1387-.196,2.128-.588,2.968-.3733.8214-.9053,1.5027-1.596,2.044-.672.5414-1.4466.9427-2.324,1.204-.8586.2614-1.7733.392-2.744.392Zm17.3323,0c-2.52,0-4.4334-.8026-5.74-2.408-1.288-1.6053-1.932-3.976-1.932-7.112s.644-5.5066,1.932-7.112c1.3066-1.6053,3.22-2.408,5.74-2.408s4.424.8027,5.712,2.408c1.3066,1.6054,1.96,3.976,1.96,7.112s-.6534,5.5067-1.96,7.112c-1.288,1.6054-3.192,2.408-5.712,2.408Zm0-3.752c.6906,0,1.2506-.1866,1.68-.56.4293-.392.7373-1.008.924-1.848.2053-.8586.308-1.9786.308-3.36c0-1.3813-.1027-2.492-.308-3.332-.1867-.8586-.4947-1.4746-.924-1.848-.4294-.392-.9894-.588-1.68-.588-.672,0-1.232.196-1.68.588-.4294.3734-.7467.9894-.952,1.848-.1867.84-.28,1.9507-.28,3.332c0,1.3814.0933,2.5014.28,3.36.2053.84.5226,1.456.952,1.848.448.3734,1.008.56,1.68.56Zm18.0195,3.752c-2.52,0-4.4333-.8026-5.74-2.408-1.288-1.6053-1.932-3.976-1.932-7.112s.644-5.5066,1.932-7.112c1.3067-1.6053,3.22-2.408,5.74-2.408s4.424.8027,5.712,2.408c1.3067,1.6054,1.96,3.976,1.96,7.112s-.6533,5.5067-1.96,7.112c-1.288,1.6054-3.192,2.408-5.712,2.408Zm0-3.752c.6907,0,1.2507-.1866,1.68-.56.4293-.392.7373-1.008.924-1.848.2053-.8586.308-1.9786.308-3.36c0-1.3813-.1027-2.492-.308-3.332-.1867-.8586-.4947-1.4746-.924-1.848-.4293-.392-.9893-.588-1.68-.588-.672,0-1.232.196-1.68.588-.4293.3734-.7467.9894-.952,1.848-.1867.84-.28,1.9507-.28,3.332c0,1.3814.0933,2.5014.28,3.36.2053.84.5227,1.456.952,1.848.448.3734,1.008.56,1.68.56Zm18.7234,3.472v-14h4.256l.14,2.716c.448-.9893,1.073-1.736,1.876-2.24.821-.504,1.764-.756,2.828-.756c1.045,0,1.951.2334,2.716.7.765.4667,1.335,1.1574,1.708,2.072.299-.616.681-1.1293,1.148-1.54.485-.4106,1.036-.7186,1.652-.924.616-.2053,1.251-.308,1.904-.308.933,0,1.755.1867,2.464.56.709.3547,1.269.9054,1.68,1.652.429.728.644,1.6427.644,2.744v9.324h-4.76v-8.232c0-.896-.177-1.5213-.532-1.876-.336-.3546-.793-.532-1.372-.532-.467,0-.896.1214-1.288.364-.373.224-.663.5694-.868,1.036-.205.4667-.308,1.0547-.308,1.764v7.476h-4.76v-8.232c0-.896-.177-1.5213-.532-1.876s-.812-.532-1.372-.532c-.429,0-.84.112-1.232.336-.373.224-.672.5787-.896,1.064-.224.4667-.336,1.0827-.336,1.848v7.392h-4.76Zm25.463-9.324v-2.156c.448-.2613.878-.504,1.288-.728.411-.2426.812-.4853,1.204-.728.784-.5413,1.419-1.0266,1.904-1.456.486-.4293.831-.8306,1.036-1.204.224-.3733.336-.728.336-1.064c0-.392-.112-.7-.336-.924-.205-.224-.532-.336-.98-.336-.504,0-.886.1867-1.148.56-.242.3547-.364.8774-.364,1.568l-3.332-.7c.038-1.2506.495-2.24,1.372-2.968.896-.7466,2.082-1.12,3.556-1.12c1.176,0,2.119.1867,2.828.56.71.3547,1.223.812,1.54,1.372.336.5414.504,1.1107.504,1.708c0,.4667-.102.924-.308,1.372-.205.4294-.513.8587-.924,1.288-.392.4107-.886.8214-1.484,1.232-.317.2054-.662.4014-1.036.588-.354.168-.728.3267-1.12.476v.056c.28-.0373.672-.0653,1.176-.084.504-.0186.962-.028,1.372-.028h2.464v2.716h-9.548Z"
        fill="#fdb927"
      />
    </g>
    <g id="edEvCAwTnKp1200" transform="translate(322.58956 160.060644)" opacity="0">
      <path
        d="M10.3604,8.19054h-5.79696v2.37996h4.624v2.261h-4.624v4.318h-2.924v-11.21996h8.72096v2.261Zm4.8021,9.12896c-.9406,0-1.7566-.1756-2.448-.527-.68-.3513-1.207-.8556-1.581-1.513s-.561-1.4506-.561-2.38c0-.9293.187-1.7226.561-2.38s.8954-1.16163,1.564-1.51296c.68-.35134,1.4564-.527,2.329-.527.8954,0,1.6547.17566,2.278.527.6347.34,1.1164.816,1.445,1.42796.3287.6007.493,1.292.493,2.074c0,.204-.0056.408-.017.612s-.0283.374-.051.51h-6.732v-1.547h5.457l-1.377.527c0-.68-.1246-1.2013-.374-1.564-.238-.3626-.612-.544-1.122-.544-.3626,0-.6743.085-.935.255-.2493.17-.442.4364-.578.799-.1246.3627-.187.8274-.187,1.394c0,.5554.0737,1.0087.221,1.36.1474.34.357.5894.629.748.272.1474.6007.221.986.221.4307,0,.7707-.085,1.02-.255.2607-.17.4534-.408.578-.714l2.312.765c-.1586.4874-.4363.901-.833,1.241-.3853.3287-.85.578-1.394.748-.5326.17-1.0936.255-1.683.255Zm5.6968-.17v-8.49996h2.584l.153,2.92396-.323-.323c.1133-.612.3116-1.122.595-1.52996.2946-.408.6573-.714,1.088-.918.442-.21534.935-.323,1.479-.323.5893,0,1.0993.11333,1.53.34.442.22666.7876.561,1.037,1.003.2493.44196.374.99736.374,1.66596v5.661h-2.89v-4.896c0-.5893-.1134-.9973-.34-1.224s-.5157-.34-.867-.34c-.272,0-.527.068-.765.204-.238.1247-.425.3287-.561.612-.136.2834-.204.663-.204,1.139v4.505h-2.89Zm11.987-9.48596c-.5894,0-1.02-.10767-1.292-.323-.2607-.22667-.391-.578-.391-1.054c0-.48734.1303-.83867.391-1.054.272-.22667.7026-.34,1.292-.34.578,0,1.003.11333,1.275.34.272.21533.408.56666.408,1.054c0,.476-.136.82733-.408,1.054-.272.21533-.697.323-1.275.323Zm1.445.986v8.49996h-2.89v-8.49996h2.89Zm11.3902,0l-4.08,4.35196-.544.153-2.431,2.72-.017-2.958l3.859-4.26696h3.213Zm-6.443-3.604v12.10396h-2.89v-12.10396h2.89Zm2.805,6.15396l3.825,5.95h-3.196l-2.516-4.25l1.887-1.7Zm8.3838,6.12c-.85,0-1.6433-.136-2.38-.408-.7253-.2833-1.326-.6856-1.802-1.207l1.36-1.598c.2833.3627.6573.6687,1.122.918.476.238,1.003.357,1.581.357.3513,0,.6403-.051.867-.153s.34-.2606.34-.476c0-.1586-.0567-.2833-.17-.374-.1133-.102-.34-.187-.68-.255l-1.19-.238c-1.0653-.2153-1.8247-.5326-2.278-.952-.442-.4306-.663-.9916-.663-1.683c0-.4646.1417-.9066.425-1.32596.2833-.43067.7197-.77634,1.309-1.037.5893-.272,1.343-.408,2.261-.408.8613,0,1.6207.12466,2.278.374s1.1787.612,1.564,1.088l-1.377,1.56396c-.272-.34-.6233-.6063-1.054-.799s-.8613-.289-1.292-.289c-.272,0-.5043.0284-.697.085-.1813.0454-.3173.1134-.408.204s-.136.204-.136.34c0,.1474.068.2777.204.391.1473.102.4137.1927.799.272l1.547.306c.8727.1587,1.5017.4477,1.887.867s.578.9237.578,1.513c0,.5554-.1473,1.054-.442,1.496s-.7367.7934-1.326,1.054c-.5893.2494-1.3317.374-2.227.374ZM3.59444,37.8745h6.42596v1.275h-7.78596v-11.22h1.36v9.945Zm9.22516-8.857c-.306,0-.5553-.0906-.748-.272-.1813-.1926-.272-.442-.272-.748s.0907-.5496.272-.731c.1927-.1926.442-.289.748-.289s.5497.0964.731.289c.1927.1814.289.425.289.731s-.0963.5554-.289.748c-.1813.1814-.425.272-.731.272Zm.68,1.632v9.367c0,.7027-.136,1.258-.408,1.666s-.6063.697-1.003.867-.7877.255-1.173.255c-.3513,0-.6743-.0566-.96901-.17-.29466-.102-.53833-.2323-.731-.391l.289-1.292c.15867.1474.357.272.59501.374s.5043.153.799.153c.3627,0,.6573-.119.884-.357.238-.238.357-.6516.357-1.241v-9.231h1.36Zm6.2326,8.67c-.544,0-1.0596-.102-1.547-.306-.476-.204-.867-.5326-1.173-.986-.2946-.4646-.442-1.0653-.442-1.802v-5.576h1.36v5.219c0,.8614.187,1.4564.561,1.785.374.3174.901.476,1.581.476.3174,0,.629-.051.935-.153.306-.1133.578-.2833.816-.51.2494-.238.442-.5383.578-.901.1474-.3626.221-.7933.221-1.292v-4.624h1.36v8.5h-1.19l-.085-1.292c-.2946.51-.697.884-1.207,1.122-.4986.2267-1.088.34-1.768.34Zm11.5802,0c-.476,0-.918-.085-1.326-.255s-.7593-.408-1.054-.714-.5157-.6516-.663-1.037l.187-.238-.119,2.074h-1.19v-12.41h1.36v5.831l-.17-.255c.2267-.5326.6063-.969,1.139-1.309.544-.3513,1.1617-.527,1.853-.527.7027,0,1.3487.1757,1.938.527.5893.3514,1.0597.8557,1.411,1.513.3513.6574.527,1.4507.527,2.38c0,.918-.1813,1.7114-.544,2.38-.3513.6574-.8217,1.1617-1.411,1.513-.5893.3514-1.2353.527-1.938.527Zm-.136-1.19c.8387,0,1.4903-.2946,1.955-.884.476-.5893.714-1.3713.714-2.346s-.2323-1.7566-.697-2.346-1.1163-.884-1.955-.884c-.5327,0-1.003.136-1.411.408-.3967.272-.7083.6517-.935,1.139s-.34,1.0597-.34,1.717c0,.646.1077,1.2127.323,1.7.2267.476.5383.8444.935,1.105.408.2607.8783.391,1.411.391Zm7.9212-11.39v10.251c0,.4307.0793.731.238.901.1587.1587.4137.238.765.238.2267,0,.4137-.017.561-.051s.3457-.0963.595-.187l-.221,1.19c-.1813.0794-.3797.136-.595.17-.2153.0454-.4363.068-.663.068-.6913,0-1.207-.187-1.547-.561-.3287-.374-.493-.9463-.493-1.717v-10.302h1.36Zm4.5843,2.278c-.306,0-.5553-.0906-.748-.272-.1813-.1926-.272-.442-.272-.748s.0907-.5496.272-.731c.1927-.1926.442-.289.748-.289s.5497.0964.731.289c.1927.1814.289.425.289.731s-.0963.5554-.289.748c-.1813.1814-.425.272-.731.272Zm.68,1.632v9.367c0,.7027-.136,1.258-.408,1.666s-.6063.697-1.003.867-.7877.255-1.173.255c-.3513,0-.6743-.0566-.969-.17-.2947-.102-.5383-.2323-.731-.391l.289-1.292c.1587.1474.357.272.595.374s.5043.153.799.153c.3627,0,.6573-.119.884-.357.238-.238.357-.6516.357-1.241v-9.231h1.36Zm8.1196,3.009c0-.6346-.17-1.122-.51-1.462-.34-.3513-.8216-.527-1.445-.527-.5893,0-1.088.1304-1.496.391-.408.2494-.7083.6574-.901,1.224l-1.105-.68c.2267-.6346.646-1.1446,1.258-1.53.612-.3966,1.3714-.595,2.278-.595.612,0,1.1674.1077,1.666.323.4987.204.8897.5214,1.173.952.2947.4194.442.9634.442,1.632v4.114c0,.408.2154.612.646.612.2154,0,.425-.0283.629-.085l-.068,1.071c-.2266.1134-.5213.17-.884.17-.3286,0-.6233-.0623-.884-.187-.2606-.1246-.4646-.3116-.612-.561-.1473-.2606-.221-.5836-.221-.969v-.17l.34.051c-.136.442-.3683.8047-.697,1.088-.3286.272-.697.476-1.105.612-.408.1247-.8103.187-1.207.187-.4986,0-.9633-.085-1.394-.255s-.7763-.425-1.037-.765c-.2493-.3513-.374-.782-.374-1.292c0-.6346.2097-1.156.629-1.564.4307-.4193,1.0257-.7026,1.785-.85l3.366-.663v1.122l-2.737.561c-.5553.1134-.969.272-1.241.476s-.408.4874-.408.85c0,.3514.136.6404.408.867.2834.2154.68.323,1.19.323.3287,0,.6404-.0396.935-.119.306-.0906.578-.221.816-.391.238-.1813.425-.4023.561-.663.136-.272.204-.5893.204-.952v-2.346Zm4.6649,5.491v-8.5h1.19l.119,1.904-.221-.187c.1814-.4533.425-.816.731-1.088.306-.2833.6574-.4873,1.054-.612.408-.1246.8274-.187,1.258-.187.612,0,1.1674.119,1.666.357.4987.2267.8954.578,1.19,1.054.306.476.459,1.0824.459,1.819v5.44h-1.36v-4.964c0-.9406-.204-1.5923-.612-1.955-.3966-.374-.8896-.561-1.479-.561-.408,0-.816.0964-1.224.289-.408.1927-.748.5044-1.02.935-.2606.4307-.391,1.0087-.391,1.734v4.522h-1.36Zm15.4894-5.491c0-.6346-.17-1.122-.51-1.462-.34-.3513-.8216-.527-1.445-.527-.5893,0-1.088.1304-1.496.391-.408.2494-.7083.6574-.901,1.224l-1.105-.68c.2267-.6346.646-1.1446,1.258-1.53.612-.3966,1.3714-.595,2.278-.595.612,0,1.1674.1077,1.666.323.4987.204.8897.5214,1.173.952.2947.4194.442.9634.442,1.632v4.114c0,.408.2154.612.646.612.2154,0,.425-.0283.629-.085l-.068,1.071c-.2266.1134-.5213.17-.884.17-.3286,0-.6233-.0623-.884-.187-.2606-.1246-.4646-.3116-.612-.561-.1473-.2606-.221-.5836-.221-.969v-.17l.34.051c-.136.442-.3683.8047-.697,1.088-.3286.272-.697.476-1.105.612-.408.1247-.8103.187-1.207.187-.4986,0-.9633-.085-1.394-.255-.4306-.17-.7763-.425-1.037-.765-.2493-.3513-.374-.782-.374-1.292c0-.6346.2097-1.156.629-1.564.4307-.4193,1.0257-.7026,1.785-.85l3.366-.663v1.122l-2.737.561c-.5553.1134-.969.272-1.241.476s-.408.4874-.408.85c0,.3514.136.6404.408.867.2834.2154.68.323,1.19.323.3287,0,.6404-.0396.935-.119.306-.0906.578-.221.816-.391.238-.1813.425-.4023.561-.663.136-.272.204-.5893.204-.952v-2.346Z"
        fill="#fff"
      />
      <path
        d="M9.16244,65.6706c1.39996,0,2.61336.2054,3.63996.616s1.82.9987,2.38,1.764c.5787.7467.868,1.6427.868,2.688c0,.9894-.2426,1.8387-.728,2.548s-1.204,1.2507-2.156,1.624v.028c1.12.3734,1.988.924,2.604,1.652.616.7094.924,1.624.924,2.744c0,1.0827-.308,2.0254-.924,2.828-.5973.784-1.456,1.4-2.576,1.848-1.12.4294-2.464.644-4.03196.644-1.54934,0-2.884-.2146-4.004-.644-1.12-.448-1.988-1.064-2.604-1.848-.59734-.8026-.896-1.7453-.896-2.828c0-1.12.308-2.0346.924-2.744.616-.728,1.484-1.2786,2.604-1.652v-.028c-.93334-.3546-1.652-.8866-2.156-1.596-.504-.728-.756-1.5866-.756-2.576c0-1.0453.28-1.9413.84-2.688.57866-.7653,1.39066-1.3533,2.436-1.764s2.24933-.616,3.612-.616Zm.028,3.5c-.74667,0-1.344.1867-1.792.56-.448.3734-.672.896-.672,1.568c0,.6534.224,1.176.672,1.568.448.3734,1.04533.56,1.792.56s1.33466-.1866,1.76396-.56c.448-.392.672-.9146.672-1.568c0-.672-.224-1.1946-.672-1.568-.4293-.3733-1.0173-.56-1.76396-.56Zm0,11.984c.59733,0,1.10136-.084,1.51196-.252.4294-.1866.756-.4573.98-.812.224-.3546.336-.7653.336-1.232c0-.4853-.112-.896-.336-1.232-.224-.3546-.5506-.616-.98-.784-.4293-.1866-.9333-.28-1.51196-.28s-1.092.0934-1.54.28c-.42934.168-.756.4294-.98.784-.224.336-.336.7467-.336,1.232c0,.4667.112.8774.336,1.232.224.3547.55066.6254.98.812.42933.168.94266.252,1.54.252Zm16.77066,3.5c-1.6053,0-3.0053-.308-4.2-.924-1.176-.6346-2.1653-1.6613-2.968-3.08l4.228-2.1c.2054.7467.532,1.344.98,1.792.4667.448,1.1574.672,2.072.672.5787,0,1.0734-.1026,1.484-.308.4107-.2053.728-.504.952-.896.2427-.4106.364-.9053.364-1.484c0-.56-.112-1.0266-.336-1.4-.2053-.3733-.5133-.6533-.924-.84-.4106-.2053-.924-.308-1.54-.308-.448,0-.8493.0467-1.204.14-.3546.0747-.6813.196-.98.364-.28.1494-.5413.3454-.784.588l-3.64-.672l1.176-10.304h11.648v3.724h-8.148l-.476,3.696-.084.448h.028c.3734-.4293.896-.756,1.568-.98s1.4187-.336,2.24-.336c1.2134,0,2.2494.2427,3.108.728.8587.4854,1.5214,1.148,1.988,1.988s.7,1.8014.7,2.884c0,1.1387-.196,2.128-.588,2.968-.3733.8214-.9053,1.5027-1.596,2.044-.672.5414-1.4466.9427-2.324,1.204-.8586.2614-1.7733.392-2.744.392Zm12.3762-5.096c.8774,0,1.5587.224,2.044.672.504.448.756,1.0734.756,1.876c0,.784-.252,1.4-.756,1.848-.4853.448-1.1666.672-2.044.672-.8586,0-1.54-.224-2.044-.672s-.756-1.064-.756-1.848c0-.8026.252-1.428.756-1.876s1.1854-.672,2.044-.672Zm12.4891,5.096c-1.9786,0-3.6306-.3826-4.956-1.148-1.3066-.784-2.212-1.9226-2.716-3.416l4.424-1.904c.0934.672.2614,1.2134.504,1.624.2614.392.6067.6814,1.036.868.4294.168.9334.252,1.512.252.5227,0,.9614-.084,1.316-.252.3734-.1866.6627-.448.868-.784s.308-.7373.308-1.204c0-.4853-.1026-.8773-.308-1.176-.1866-.2986-.4666-.5133-.84-.644-.3546-.1306-.7933-.196-1.316-.196-.2426,0-.4666.0094-.672.028-.2053,0-.4386.0187-.7.056v-3.136c.1494.0187.2987.0374.448.056.1494,0,.3267,0,.532,0c.8774,0,1.5027-.1773,1.876-.532.392-.3733.588-.952.588-1.736c0-.672-.196-1.1853-.588-1.54-.3733-.3546-.9053-.532-1.596-.532-.728,0-1.3253.196-1.792.588-.4666.3734-.7653,1.0174-.896,1.932l-4.228-1.456c.2054-1.0266.644-1.8946,1.316-2.604.672-.7093,1.512-1.2506,2.52-1.624c1.0267-.3733,2.156-.56,3.388-.56c1.4187,0,2.6134.2054,3.584.616.9707.4107,1.708.9987,2.212,1.764s.756,1.6614.756,2.688c0,.8027-.1306,1.4747-.392,2.016-.2426.5414-.56.98-.952,1.316-.3733.336-.756.588-1.148.756-.392.1494-.7186.2427-.98.28v.084c.336,0,.7187.0654,1.148.196.4294.1307.8494.3454,1.26.644.4107.28.7467.672,1.008,1.176.28.504.42,1.1294.42,1.876c0,1.1574-.308,2.156-.924,2.996-.5973.84-1.4186,1.4934-2.464,1.96-1.0453.448-2.2306.672-3.556.672Zm18.3897-.28v-4.06h-9.016v-3.024c.168-.2986.3827-.6626.644-1.092.28-.4293.6067-.924.98-1.484l6.02-8.82h5.628v11.116h2.828v3.304h-2.828v4.06h-4.256Zm-5.152-7.364h5.208v-5.6c0-.3733.0093-.756.028-1.148.0187-.4106.0373-.8213.056-1.232h-.056c-.1867.392-.4107.8027-.672,1.232-.2427.4107-.476.784-.7,1.12l-3.276,4.788c-.0933.1494-.1867.2894-.28.42-.0933.1307-.196.2707-.308.42Zm12.563-11.116h15.204v3.416c-1.5306,1.512-2.744,3.0707-3.64,4.676-.8773,1.5867-1.5026,3.2387-1.876,4.956-.3546,1.7174-.532,3.528-.532,5.432h-4.76c0-2.0346.252-3.9666.756-5.796.5227-1.848,1.3254-3.612,2.408-5.292c1.1014-1.68,2.52-3.304,4.256-4.872l1.008,1.26h-12.824v-3.78Zm25.1469,18.48v-14h4.256l.14,2.716c.448-.9893,1.074-1.736,1.876-2.24.822-.504,1.764-.756,2.828-.756c1.046,0,1.951.2334,2.716.7.766.4667,1.335,1.1574,1.708,2.072.299-.616.682-1.1293,1.148-1.54.486-.4106,1.036-.7186,1.652-.924s1.251-.308,1.904-.308c.934,0,1.755.1867,2.464.56.71.3547,1.27.9054,1.68,1.652.43.728.644,1.6427.644,2.744v9.324h-4.76v-8.232c0-.896-.177-1.5213-.532-1.876-.336-.3546-.793-.532-1.372-.532-.466,0-.896.1214-1.288.364-.373.224-.662.5694-.868,1.036-.205.4667-.308,1.0547-.308,1.764v7.476h-4.76v-8.232c0-.896-.177-1.5213-.532-1.876-.354-.3546-.812-.532-1.372-.532-.429,0-.84.112-1.232.336-.373.224-.672.5787-.896,1.064-.224.4667-.336,1.0827-.336,1.848v7.392h-4.76Zm25.464-9.324v-2.156c.448-.2613.877-.504,1.288-.728.41-.2426.812-.4853,1.204-.728.784-.5413,1.418-1.0266,1.904-1.456.485-.4293.83-.8306,1.036-1.204.224-.3733.336-.728.336-1.064c0-.392-.112-.7-.336-.924-.206-.224-.532-.336-.98-.336-.504,0-.887.1867-1.148.56-.243.3547-.364.8774-.364,1.568l-3.332-.7c.037-1.2506.494-2.24,1.372-2.968.896-.7466,2.081-1.12,3.556-1.12c1.176,0,2.118.1867,2.828.56.709.3547,1.222.812,1.54,1.372.336.5414.504,1.1107.504,1.708c0,.4667-.103.924-.308,1.372-.206.4294-.514.8587-.924,1.288-.392.4107-.887.8214-1.484,1.232-.318.2054-.663.4014-1.036.588-.355.168-.728.3267-1.12.476v.056c.28-.0373.672-.0653,1.176-.084s.961-.028,1.372-.028h2.464v2.716h-9.548Z"
        fill="#fdb927"
      />
    </g>
    <g id="edEvCAwTnKp1203" transform="translate(321.614315 160.402264)" opacity="0">
      <path
        d="M12.0099,5.89352L6.73994,12.2005l-.187-.442-2.669,3.247-.561-2.363l5.44-6.74898h3.24696Zm-7.25896,0v11.21998h-2.924v-11.21998h2.924Zm2.941,3.706L12.2139,17.1135h-3.31496l-3.4-5.882l2.193-1.63198ZM13.41,17.1135v-8.49997h2.55l.119,1.83597c.2154-.63464.5327-1.12764.952-1.47898.4307-.35133.9747-.527,1.632-.527.2154,0,.3967.017.544.051.1587.03401.2834.07934.374.13601l-.289,2.37997c-.1133-.0453-.2606-.0793-.442-.102-.17-.034-.3796-.051-.629-.051-.34,0-.6573.0737-.952.221-.2946.1474-.5326.3684-.714.663-.17.2834-.255.646-.255,1.088v4.284h-2.89Zm8.7497-9.48598c-.5893,0-1.02-.10766-1.292-.32299-.2606-.22667-.391-.578-.391-1.05401c0-.48733.1304-.83866.391-1.054.272-.22666.7027-.33999,1.292-.33999.578,0,1.003.11333,1.275.33999.272.21534.408.56667.408,1.054c0,.47601-.136.82734-.408,1.05401-.272.21533-.697.32299-1.275.32299Zm1.445.98601v8.49997h-2.89v-8.49997h2.89ZM29.232,17.2835c-.85,0-1.6433-.136-2.38-.408-.7253-.2833-1.326-.6856-1.802-1.207l1.36-1.598c.2833.3627.6573.6687,1.122.918.476.238,1.003.357,1.581.357.3513,0,.6403-.051.867-.153s.34-.2606.34-.476c0-.1586-.0567-.2833-.17-.374-.1133-.102-.34-.187-.68-.255l-1.19-.238c-1.0653-.2153-1.8247-.5326-2.278-.952-.442-.4306-.663-.9916-.663-1.683c0-.4646.1417-.9066.425-1.32597.2833-.43067.7197-.77634,1.309-1.03701.5893-.272,1.343-.408,2.261-.408.8613,0,1.6207.12467,2.278.374s1.1787.61201,1.564,1.088L31.799,11.4695c-.272-.34-.6233-.6063-1.054-.799s-.8613-.289-1.292-.289c-.272,0-.5043.0284-.697.085-.1813.0454-.3173.1134-.408.204s-.136.204-.136.34c0,.1474.068.2777.204.391.1473.102.4137.1927.799.272l1.547.306c.8727.1587,1.5017.4477,1.887.867s.578.9237.578,1.513c0,.5554-.1473,1.054-.442,1.496s-.7367.7934-1.326,1.054c-.5893.2494-1.3317.374-2.227.374ZM38.2795,5.91052v8.17698c0,.408.0963.7027.289.884.204.17.4816.255.833.255.272,0,.5043-.0283.697-.085.204-.068.3853-.1643.544-.289l.306,1.785c-.2834.204-.6404.3627-1.071.476-.4307.1134-.8727.17-1.326.17-.646,0-1.207-.0906-1.683-.272-.4647-.1813-.8274-.4703-1.088-.867-.2494-.3966-.3797-.9236-.391-1.581v-7.85398l2.89-.799Zm2.533,2.70301v2.05697h-6.885v-2.05697h6.885Zm6.2273,3.11097c0-.3966-.1134-.7083-.34-.935-.2154-.238-.51-.357-.884-.357s-.697.0964-.969.289c-.2607.1814-.442.51-.544.986l-2.448-.578c.1586-.816.578-1.46764,1.258-1.95497s1.6376-.73101,2.873-.73101c.8273,0,1.53.12467,2.108.374.5893.23801,1.037.60067,1.343,1.088.3173.47598.476,1.06538.476,1.76798v3.111c0,.442.1983.663.595.663.204,0,.3683-.0226.493-.068l-.17,1.649c-.34.1587-.7537.238-1.241.238-.442,0-.833-.068-1.173-.204-.34-.1473-.6064-.3626-.799-.646-.1927-.2946-.289-.663-.289-1.105v-.102l.323-.119c0,.4874-.1474.8954-.442,1.224-.2834.3287-.6574.5724-1.122.731-.4534.1587-.9294.238-1.428.238-.578,0-1.0824-.0906-1.513-.272-.4307-.1813-.765-.442-1.003-.782-.2267-.3513-.34-.782-.34-1.292c0-.612.1813-1.1163.544-1.513.374-.408.9576-.6913,1.751-.85l3.213-.663-.017,1.53-1.632.34c-.34.068-.595.17-.765.306-.1587.1247-.238.3174-.238.578c0,.2494.0906.4364.272.561.1813.1247.3966.187.646.187.1926,0,.374-.0283.544-.085.1813-.0566.34-.1416.476-.255.136-.1246.2436-.2776.323-.459s.119-.3966.119-.646v-2.244Zm7.9577-6.71497v9.21397c0,.374.0623.6404.187.799s.3343.238.629.238c.17,0,.3117-.0113.425-.034.1133-.0226.2493-.0566.408-.102l-.187,1.734c-.204.1247-.4703.2267-.799.306s-.6517.119-.969.119c-.9067,0-1.564-.2096-1.972-.629s-.612-1.105-.612-2.057v-9.58797h2.89ZM57.703,17.1135v-8.49997h2.584l.153,2.92397-.323-.323c.1133-.612.3117-1.122.595-1.52997.2947-.408.6573-.714,1.088-.91801.442-.21533.935-.323,1.479-.323.5893,0,1.0993.11334,1.53.34001.442.22666.7877.56099,1.037,1.00299s.374.99738.374,1.66598v5.661h-2.89v-4.896c0-.5893-.1133-.9973-.34-1.224-.2267-.2266-.5157-.34-.867-.34-.272,0-.527.068-.765.204-.238.1247-.425.3287-.561.612s-.204.663-.204,1.139v4.505h-2.89Zm15.285-5.389c0-.3966-.1133-.7083-.34-.935-.2153-.238-.51-.357-.884-.357s-.697.0964-.969.289c-.2607.1814-.442.51-.544.986l-2.448-.578c.1587-.816.578-1.46764,1.258-1.95497s1.6377-.73101,2.873-.73101c.8273,0,1.53.12467,2.108.374.5893.23801,1.037.60067,1.343,1.088.3173.47598.476,1.06538.476,1.76798v3.111c0,.442.1983.663.595.663.204,0,.3683-.0226.493-.068l-.17,1.649c-.34.1587-.7537.238-1.241.238-.442,0-.833-.068-1.173-.204-.34-.1473-.6063-.3626-.799-.646-.1927-.2946-.289-.663-.289-1.105v-.102l.323-.119c0,.4874-.1473.8954-.442,1.224-.2833.3287-.6573.5724-1.122.731-.4533.1587-.9293.238-1.428.238-.578,0-1.0823-.0906-1.513-.272s-.765-.442-1.003-.782c-.2267-.3513-.34-.782-.34-1.292c0-.612.1813-1.1163.544-1.513.374-.408.9577-.6913,1.751-.85l3.213-.663-.017,1.53-1.632.34c-.34.068-.595.17-.765.306-.1587.1247-.238.3174-.238.578c0,.2494.0907.4364.272.561.1813.1247.3967.187.646.187.1927,0,.374-.0283.544-.085.1813-.0566.34-.1416.476-.255.136-.1246.2437-.2776.323-.459s.119-.3966.119-.646v-2.244Zm9.8,8.959v-12.06997h2.601l.153,3.07697-.34-.357c.0793-.5666.255-1.0653.527-1.49598s.6233-.77066,1.054-1.02c.4306-.24933.9236-.374,1.479-.374.7026,0,1.3146.17567,1.836.527.5213.34.9236.83867,1.207,1.49598.2946.646.442,1.4337.442,2.363c0,.9294-.1474,1.7284-.442,2.397-.2947.6687-.7084,1.1787-1.241,1.53-.5214.3514-1.1334.527-1.836.527-.7707,0-1.394-.2266-1.87-.68-.476-.4646-.7934-1.0483-.952-1.751l.272-.408v6.239h-2.89Zm4.454-5.525c.4986,0,.8896-.1813,1.173-.544.2833-.374.425-.9576.425-1.751s-.1417-1.3713-.425-1.734c-.272-.374-.6574-.561-1.156-.561-.3174,0-.595.0907-.833.272-.238.17-.425.425-.561.765-.1247.34-.187.7594-.187,1.258c0,.476.0566.8897.17,1.241.1246.34.306.6007.544.782s.5213.272.85.272Zm10.8642-3.434c0-.3966-.1134-.7083-.34-.935-.2154-.238-.51-.357-.884-.357s-.697.0964-.969.289c-.2607.1814-.442.51-.544.986l-2.448-.578c.1586-.816.578-1.46764,1.258-1.95497s1.6376-.73101,2.873-.73101c.8273,0,1.53.12467,2.108.374.5893.23801,1.0368.60067,1.3428,1.088.318.47598.476,1.06538.476,1.76798v3.111c0,.442.199.663.595.663.204,0,.369-.0226.493-.068l-.17,1.649c-.34.1587-.753.238-1.241.238-.442,0-.8328-.068-1.1728-.204-.34-.1473-.6064-.3626-.799-.646-.1927-.2946-.289-.663-.289-1.105v-.102l.323-.119c0,.4874-.1474.8954-.442,1.224-.2834.3287-.6574.5724-1.122.731-.4534.1587-.9294.238-1.428.238-.578,0-1.0824-.0906-1.513-.272-.4307-.1813-.765-.442-1.003-.782-.2267-.3513-.34-.782-.34-1.292c0-.612.1813-1.1163.544-1.513.374-.408.9576-.6913,1.751-.85l3.213-.663-.017,1.53-1.632.34c-.34.068-.595.17-.765.306-.1587.1247-.238.3174-.238.578c0,.2494.0906.4364.272.561.1813.1247.3966.187.646.187.1926,0,.374-.0283.544-.085.1813-.0566.34-.1416.476-.255.136-.1246.2436-.2776.323-.459.0793-.1813.119-.3966.119-.646v-2.244Zm7.9578-6.71497v9.21397c0,.374.062.6404.187.799s.334.238.629.238c.17,0,.312-.0113.425-.034.113-.0226.249-.0566.408-.102l-.187,1.734c-.204.1247-.47.2267-.799.306s-.652.119-.969.119c-.907,0-1.564-.2096-1.972-.629s-.612-1.105-.612-2.057v-9.58797h2.89Zm7.581,6.71497c0-.3966-.113-.7083-.34-.935-.215-.238-.51-.357-.884-.357s-.697.0964-.969.289c-.26.1814-.442.51-.544.986l-2.448-.578c.159-.816.578-1.46764,1.258-1.95497s1.638-.73101,2.873-.73101c.828,0,1.53.12467,2.108.374.59.23801,1.037.60067,1.343,1.088.318.47598.476,1.06538.476,1.76798v3.111c0,.442.199.663.595.663.204,0,.369-.0226.493-.068l-.17,1.649c-.34.1587-.753.238-1.241.238-.442,0-.833-.068-1.173-.204-.34-.1473-.606-.3626-.799-.646-.192-.2946-.289-.663-.289-1.105v-.102l.323-.119c0,.4874-.147.8954-.442,1.224-.283.3287-.657.5724-1.122.731-.453.1587-.929.238-1.428.238-.578,0-1.082-.0906-1.513-.272-.43-.1813-.765-.442-1.003-.782-.226-.3513-.34-.782-.34-1.292c0-.612.182-1.1163.544-1.513.374-.408.958-.6913,1.751-.85l3.213-.663-.017,1.53-1.632.34c-.34.068-.595.17-.765.306-.158.1247-.238.3174-.238.578c0,.2494.091.4364.272.561.182.1247.397.187.646.187.193,0,.374-.0283.544-.085.182-.0566.34-.1416.476-.255.136-.1246.244-.2776.323-.459.08-.1813.119-.3966.119-.646v-2.244Zm9.065-3.28098c.861,0,1.575.12467,2.142.374.578.23801,1.025.56101,1.343.969.328.39668.532.82738.612,1.29198l-2.669.884c-.08-.4873-.227-.85-.442-1.088-.204-.2493-.505-.374-.901-.374-.363,0-.669.085-.918.255-.238.1587-.42.4194-.544.782-.125.3514-.187.8047-.187,1.36s.068,1.0087.204,1.36c.136.34.328.5894.578.748.249.1474.544.221.884.221.283,0,.515-.051.697-.153.192-.1133.351-.272.476-.476.124-.204.204-.4533.238-.748l2.601.833c-.08.4987-.295.9464-.646,1.343-.34.3854-.794.6914-1.36.918-.567.2267-1.23.34-1.989.34-.93,0-1.74-.17-2.431-.51-.692-.3513-1.224-.8556-1.598-1.513-.374-.6686-.561-1.4676-.561-2.397s.187-1.7226.561-2.38c.374-.66864.895-1.17298,1.564-1.51298.68-.35133,1.462-.527,2.346-.527Zm3.145-3.876l-1.853,2.94101h-2.805l-1.853-2.94101h2.091l1.156,1.513l1.173-1.513h2.091Zm7.214,7.15698c0-.3966-.113-.7083-.34-.935-.215-.238-.51-.357-.884-.357s-.697.0964-.969.289c-.261.1814-.442.51-.544.986l-2.448-.578c.159-.816.578-1.46764,1.258-1.95497s1.638-.73101,2.873-.73101c.827,0,1.53.12467,2.108.374.589.23801,1.037.60067,1.343,1.088.317.47598.476,1.06538.476,1.76798v3.111c0,.442.198.663.595.663.204,0,.368-.0226.493-.068l-.17,1.649c-.34.1587-.754.238-1.241.238-.442,0-.833-.068-1.173-.204-.34-.1473-.606-.3626-.799-.646-.193-.2946-.289-.663-.289-1.105v-.102l.323-.119c0,.4874-.147.8954-.442,1.224-.283.3287-.657.5724-1.122.731-.453.1587-.929.238-1.428.238-.578,0-1.082-.0906-1.513-.272s-.765-.442-1.003-.782c-.227-.3513-.34-.782-.34-1.292c0-.612.181-1.1163.544-1.513.374-.408.958-.6913,1.751-.85l3.213-.663-.017,1.53-1.632.34c-.34.068-.595.17-.765.306-.159.1247-.238.3174-.238.578c0,.2494.091.4364.272.561.181.1247.397.187.646.187.193,0,.374-.0283.544-.085.181-.0566.34-.1416.476-.255.136-.1246.244-.2776.323-.459s.119-.3966.119-.646v-2.244ZM3.78194,37.8385h6.42596v1.275h-7.78596v-11.22h1.36v9.945Zm9.22516-8.857c-.306,0-.5553-.0906-.748-.272-.1813-.1926-.272-.442-.272-.748s.0907-.5496.272-.731c.1927-.1926.442-.289.748-.289s.5497.0964.731.289c.1927.1814.289.425.289.731s-.0963.5554-.289.748c-.1813.1814-.425.272-.731.272Zm.68,1.632v9.367c0,.7027-.136,1.258-.408,1.666s-.6063.697-1.003.867-.7877.255-1.173.255c-.3513,0-.6743-.0566-.969-.17-.29467-.102-.53834-.2323-.73101-.391l.289-1.292c.15867.1474.35701.272.59501.374s.5043.153.799.153c.3627,0,.6573-.119.884-.357.238-.238.357-.6516.357-1.241v-9.231h1.36Zm6.2326,8.67c-.544,0-1.0596-.102-1.547-.306-.476-.204-.867-.5326-1.173-.986-.2946-.4646-.442-1.0653-.442-1.802v-5.576h1.36v5.219c0,.8614.187,1.4564.561,1.785.374.3174.901.476,1.581.476.3174,0,.629-.051.935-.153.306-.1133.578-.2833.816-.51.2494-.238.442-.5383.578-.901.1474-.3626.221-.7933.221-1.292v-4.624h1.36v8.5h-1.19l-.085-1.292c-.2946.51-.697.884-1.207,1.122-.4986.2267-1.088.34-1.768.34Zm11.5802,0c-.476,0-.918-.085-1.326-.255s-.7593-.408-1.054-.714-.5157-.6516-.663-1.037l.187-.238-.119,2.074h-1.19v-12.41h1.36v5.831l-.17-.255c.2267-.5326.6063-.969,1.139-1.309.544-.3513,1.1617-.527,1.853-.527.7027,0,1.3487.1757,1.938.527s1.0597.8557,1.411,1.513c.3513.6574.527,1.4507.527,2.38c0,.918-.1813,1.7114-.544,2.38-.3513.6574-.8217,1.1617-1.411,1.513s-1.2353.527-1.938.527Zm-.136-1.19c.8387,0,1.4903-.2946,1.955-.884.476-.5893.714-1.3713.714-2.346s-.2323-1.7566-.697-2.346c-.4647-.5893-1.1163-.884-1.955-.884-.5327,0-1.003.136-1.411.408-.3967.272-.7083.6517-.935,1.139s-.34,1.0597-.34,1.717c0,.646.1077,1.2127.323,1.7.2267.476.5383.8444.935,1.105.408.2607.8783.391,1.411.391Zm7.9212-11.39v10.251c0,.4307.0793.731.238.901.1587.1587.4137.238.765.238.2267,0,.4137-.017.561-.051s.3457-.0963.595-.187l-.221,1.19c-.1813.0794-.3797.136-.595.17-.2153.0454-.4363.068-.663.068-.6913,0-1.207-.187-1.547-.561-.3287-.374-.493-.9463-.493-1.717v-10.302h1.36Zm4.5843,2.278c-.306,0-.5553-.0906-.748-.272-.1813-.1926-.272-.442-.272-.748s.0907-.5496.272-.731c.1927-.1926.442-.289.748-.289s.5497.0964.731.289c.1927.1814.289.425.289.731s-.0963.5554-.289.748c-.1813.1814-.425.272-.731.272Zm.68,1.632v9.367c0,.7027-.136,1.258-.408,1.666s-.6063.697-1.003.867-.7877.255-1.173.255c-.3513,0-.6743-.0566-.969-.17-.2947-.102-.5383-.2323-.731-.391l.289-1.292c.1587.1474.357.272.595.374s.5043.153.799.153c.3627,0,.6573-.119.884-.357.238-.238.357-.6516.357-1.241v-9.231h1.36Zm8.1196,3.009c0-.6346-.17-1.122-.51-1.462-.34-.3513-.8216-.527-1.445-.527-.5893,0-1.088.1304-1.496.391-.408.2494-.7083.6574-.901,1.224l-1.105-.68c.2267-.6346.646-1.1446,1.258-1.53.612-.3966,1.3714-.595,2.278-.595.612,0,1.1674.1077,1.666.323.4987.204.8897.5214,1.173.952.2947.4194.442.9634.442,1.632v4.114c0,.408.2154.612.646.612.2154,0,.425-.0283.629-.085l-.068,1.071c-.2266.1134-.5213.17-.884.17-.3286,0-.6233-.0623-.884-.187-.2606-.1246-.4646-.3116-.612-.561-.1473-.2606-.221-.5836-.221-.969v-.17l.34.051c-.136.442-.3683.8047-.697,1.088-.3286.272-.697.476-1.105.612-.408.1247-.8103.187-1.207.187-.4986,0-.9633-.085-1.394-.255s-.7763-.425-1.037-.765c-.2493-.3513-.374-.782-.374-1.292c0-.6346.2097-1.156.629-1.564.4307-.4193,1.0257-.7026,1.785-.85l3.366-.663v1.122l-2.737.561c-.5553.1134-.969.272-1.241.476s-.408.4874-.408.85c0,.3514.136.6404.408.867.2834.2154.68.323,1.19.323.3287,0,.6404-.0396.935-.119.306-.0906.578-.221.816-.391.238-.1813.425-.4023.561-.663.136-.272.204-.5893.204-.952v-2.346Zm4.6649,5.491v-8.5h1.19l.119,1.904-.221-.187c.1814-.4533.425-.816.731-1.088.306-.2833.6574-.4873,1.054-.612.408-.1246.8274-.187,1.258-.187.612,0,1.1674.119,1.666.357.4987.2267.8954.578,1.19,1.054.306.476.459,1.0824.459,1.819v5.44h-1.36v-4.964c0-.9406-.204-1.5923-.612-1.955-.3966-.374-.8896-.561-1.479-.561-.408,0-.816.0964-1.224.289-.408.1927-.748.5044-1.02.935-.2606.4307-.391,1.0087-.391,1.734v4.522h-1.36Zm15.4894-5.491c0-.6346-.17-1.122-.51-1.462-.34-.3513-.8216-.527-1.445-.527-.5893,0-1.088.1304-1.496.391-.408.2494-.7083.6574-.901,1.224l-1.105-.68c.2267-.6346.646-1.1446,1.258-1.53.612-.3966,1.3714-.595,2.278-.595.612,0,1.1674.1077,1.666.323.4987.204.8897.5214,1.173.952.2947.4194.442.9634.442,1.632v4.114c0,.408.2154.612.646.612.2154,0,.425-.0283.629-.085l-.068,1.071c-.2266.1134-.5213.17-.884.17-.3286,0-.6233-.0623-.884-.187-.2606-.1246-.4646-.3116-.612-.561-.1473-.2606-.221-.5836-.221-.969v-.17l.34.051c-.136.442-.3683.8047-.697,1.088-.3286.272-.697.476-1.105.612-.408.1247-.8103.187-1.207.187-.4986,0-.9633-.085-1.394-.255-.4306-.17-.7763-.425-1.037-.765-.2493-.3513-.374-.782-.374-1.292c0-.6346.2097-1.156.629-1.564.4307-.4193,1.0257-.7026,1.785-.85l3.366-.663v1.122l-2.737.561c-.5553.1134-.969.272-1.241.476s-.408.4874-.408.85c0,.3514.136.6404.408.867.2834.2154.68.323,1.19.323.3287,0,.6404-.0396.935-.119.306-.0906.578-.221.816-.391.238-.1813.425-.4023.561-.663.136-.272.204-.5893.204-.952v-2.346Z"
        transform="translate(1.188745-.30562)"
        fill="#fff"
      />
      <path
        d="M10.6184,84.322v-4.06h-9.01596v-3.024c.168-.2986.38266-.6626.644-1.092.28-.4293.60666-.924.98-1.484l6.02-8.82h5.62796v11.116h2.828v3.304h-2.828v4.06h-4.256ZM5.46644,76.958h5.20796v-5.6c0-.3733.0094-.756.028-1.148.0187-.4106.0374-.8213.056-1.232h-.056c-.1866.392-.4106.8027-.672,1.232-.24263.4107-.47596.784-.69996,1.12l-3.276,4.788c-.09334.1494-.18667.2894-.28.42-.09334.1307-.196.2707-.308.42ZM28.076,65.562c.9893,0,1.904.1307,2.744.392.8587.2614,1.6053.6907,2.24,1.288s1.1107,1.4,1.428,2.408l-3.92,1.848c-.1867-.6533-.5133-1.1666-.98-1.54-.448-.392-1.0547-.588-1.82-.588-.5227,0-1.008.1307-1.456.392-.4293.2427-.8027.5974-1.12,1.064-.3173.4667-.56,1.036-.728,1.708-.1493.672-.224,1.428-.224,2.268c0,.056,0,.1214,0,.196c0,.056,0,.14,0,.252l.056.168c.224-.56.5693-1.0266,1.036-1.4.4853-.392,1.036-.6906,1.652-.896.616-.2053,1.232-.308,1.848-.308c1.1387,0,2.156.224,3.052.672s1.596,1.092,2.1,1.932c.5227.8214.784,1.82.784,2.996c0,1.2694-.2893,2.3707-.868,3.304-.5787.9147-1.3813,1.624-2.408,2.128s-2.2493.756-3.668.756c-1.5867,0-2.9867-.3453-4.2-1.036-1.1947-.7093-2.128-1.7546-2.8-3.136-.6533-1.4-.98-3.1266-.98-5.18c0-2.2026.364-4.0133,1.092-5.432.728-1.4186,1.708-2.4826,2.94-3.192c1.2507-.7093,2.6507-1.064,4.2-1.064Zm-.336,10.5c-.4853,0-.9333.1027-1.344.308-.392.1867-.7093.4667-.952.84-.224.3734-.336.812-.336,1.316c0,.4854.1213.9147.364,1.288.2427.3734.56.6627.952.868s.8307.308,1.316.308c.84,0,1.484-.2146,1.932-.644.4667-.4293.7-1.036.7-1.82c0-.5226-.1027-.9613-.308-1.316-.2053-.3733-.504-.6533-.896-.84-.3733-.2053-.8493-.308-1.428-.308Zm12.0739,3.444c.8773,0,1.5587.224,2.044.672.504.448.756,1.0734.756,1.876c0,.784-.252,1.4-.756,1.848-.4853.448-1.1667.672-2.044.672-.8587,0-1.54-.224-2.044-.672s-.756-1.064-.756-1.848c0-.8026.252-1.428.756-1.876s1.1853-.672,2.044-.672Zm1.8406-13.664h15.204v3.416c-1.5307,1.512-2.744,3.0707-3.64,4.676-.8774,1.5867-1.5027,3.2387-1.876,4.956-.3547,1.7174-.532,3.528-.532,5.432h-4.76c0-2.0346.252-3.9666.756-5.796.5226-1.848,1.3253-3.612,2.408-5.292c1.1013-1.68,2.52-3.304,4.256-4.872l1.008,1.26h-12.824v-3.78Zm24.3283-.224c1.4,0,2.6133.2054,3.64.616c1.0266.4107,1.82.9987,2.3799,1.764.5787.7467.8681,1.6427.8681,2.688c0,.9894-.2427,1.8387-.728,2.548-.4854.7094-1.204,1.2507-2.156,1.624v.028c1.12.3734,1.988.924,2.604,1.652.616.7094.924,1.624.924,2.744c0,1.0827-.308,2.0254-.924,2.828-.5974.784-1.456,1.4-2.576,1.848-1.12.4294-2.464.644-4.032.644-1.5494,0-2.884-.2146-4.004-.644-1.12-.448-1.988-1.064-2.604-1.848-.5974-.8026-.896-1.7453-.896-2.828c0-1.12.308-2.0346.924-2.744.616-.728,1.484-1.2786,2.604-1.652v-.028c-.9334-.3546-1.652-.8866-2.156-1.596-.504-.728-.756-1.5866-.756-2.576c0-1.0453.28-1.9413.84-2.688.5786-.7653,1.3906-1.3533,2.436-1.764c1.0453-.4106,2.2493-.616,3.612-.616Zm.028,3.5c-.7467,0-1.344.1867-1.792.56-.448.3734-.672.896-.672,1.568c0,.6534.224,1.176.672,1.568.448.3734,1.0453.56,1.792.56.7466,0,1.3346-.1866,1.764-.56.448-.392.672-.9146.672-1.568c0-.672-.224-1.1946-.672-1.568-.4294-.3733-1.0174-.56-1.764-.56Zm0,11.984c.5973,0,1.1013-.084,1.512-.252.4293-.1866.756-.4573.98-.812.224-.3546.336-.7653.336-1.232c0-.4853-.112-.896-.336-1.232-.224-.3546-.5507-.616-.98-.784-.4294-.1866-.9334-.28-1.512-.28-.5787,0-1.092.0934-1.54.28-.4294.168-.756.4294-.98.784-.224.336-.336.7467-.336,1.232c0,.4667.112.8774.336,1.232.224.3547.5506.6254.98.812.4293.168.9426.252,1.54.252Zm18.9826,3.22v-4.06h-9.016v-3.024c.168-.2986.3827-.6626.644-1.092.28-.4293.6067-.924.98-1.484l6.02-8.82h5.628v11.116h2.828v3.304h-2.828v4.06h-4.256Zm-5.152-7.364h5.208v-5.6c0-.3733.0094-.756.028-1.148.0187-.4106.0374-.8213.056-1.232h-.056c-.1866.392-.4106.8027-.672,1.232-.2426.4107-.476.784-.7,1.12l-3.276,4.788c-.0933.1494-.1866.2894-.28.42-.0933.1307-.196.2707-.308.42Zm22.7536,7.364v-14h4.256l.14,2.716c.448-.9893,1.073-1.736,1.876-2.24.821-.504,1.764-.756,2.828-.756c1.045,0,1.95.2334,2.716.7.765.4667,1.334,1.1574,1.708,2.072.298-.616.681-1.1293,1.148-1.54.485-.4106,1.036-.7186,1.652-.924.616-.2053,1.25-.308,1.904-.308.933,0,1.754.1867,2.464.56.709.3547,1.269.9054,1.68,1.652.429.728.644,1.6427.644,2.744v9.324h-4.76v-8.232c0-.896-.178-1.5213-.532-1.876-.336-.3546-.794-.532-1.372-.532-.467,0-.896.1214-1.288.364-.374.224-.663.5694-.868,1.036-.206.4667-.308,1.0547-.308,1.764v7.476h-4.76v-8.232c0-.896-.178-1.5213-.532-1.876-.355-.3546-.812-.532-1.372-.532-.43,0-.84.112-1.232.336-.374.224-.672.5787-.896,1.064-.224.4667-.336,1.0827-.336,1.848v7.392h-4.76Zm25.463-9.324v-2.156c.448-.2613.877-.504,1.288-.728.411-.2426.812-.4853,1.204-.728.784-.5413,1.419-1.0266,1.904-1.456s.831-.8306,1.036-1.204c.224-.3733.336-.728.336-1.064c0-.392-.112-.7-.336-.924-.205-.224-.532-.336-.98-.336-.504,0-.887.1867-1.148.56-.243.3547-.364.8774-.364,1.568l-3.332-.7c.037-1.2506.495-2.24,1.372-2.968.896-.7466,2.081-1.12,3.556-1.12c1.176,0,2.119.1867,2.828.56.709.3547,1.223.812,1.54,1.372.336.5414.504,1.1107.504,1.708c0,.4667-.103.924-.308,1.372-.205.4294-.513.8587-.924,1.288-.392.4107-.887.8214-1.484,1.232-.317.2054-.663.4014-1.036.588-.355.168-.728.3267-1.12.476v.056c.28-.0373.672-.0653,1.176-.084s.961-.028,1.372-.028h2.464v2.716h-9.548Z"
        fill="#fdb927"
      />
    </g>
    <g id="edEvCAwTnKp1206" transform="translate(323.558562 159.736993)" opacity="0">
      <path
        d="M6.02544,5.93019c1.04266,0,1.96066.16433,2.754.493.80466.31733,1.50166.78767,2.09096,1.411l-1.41096,1.887c-.48734-.51-1.01434-.88967-1.581-1.139-.55534-.26067-1.19-.391-1.904-.391-.41934,0-.75934.04533-1.02.136s-.44767.21533-.561.374-.17.34-.17.544c0,.238.10766.442.323.612.22666.15871.58933.29471,1.088.40801l1.887.425c1.122.2607,1.94366.6403,2.465,1.139s.78196,1.1617.78196,1.989c0,.7933-.204,1.4677-.612,2.023-.40796.544-.96896.9577-1.68296,1.241-.714.272-1.53.408-2.448.408-.748,0-1.462-.0793-2.142-.238-.68-.17-1.292-.408-1.836-.714s-1.003-.6573-1.377002-1.054l1.411002-1.955c.28333.3287.629.6233,1.037.884.41933.2493.87266.4477,1.36.595.49866.1473,1.003.221,1.513.221.39666,0,.72533-.0397.986-.119.272-.0793.47033-.1983.595-.357s.187-.3457.187-.561c0-.238-.085-.4363-.255-.595-.17-.17-.493-.3117-.969-.425l-2.074-.459c-.63467-.1473-1.20134-.34-1.7-.578-.48734-.2493-.87267-.578-1.156-.986-.28334-.4193-.425-.9407-.425-1.56401c0-.70267.19266-1.326.578-1.87.38533-.55533.94066-.99167,1.666-1.309s1.59233-.476,2.601-.476ZM12.3593,20.8902v-12.07001h2.601l.153,3.07701-.34-.357c.0793-.5667.255-1.0653.527-1.496s.6233-.77068,1.054-1.02001.9236-.374,1.479-.374c.7026,0,1.3146.17567,1.836.527.5213.34.9236.83871,1.207,1.49601.2946.646.442,1.4337.442,2.363s-.1474,1.7283-.442,2.397-.7084,1.1787-1.241,1.53c-.5214.3513-1.1334.527-1.836.527-.7707,0-1.394-.2267-1.87-.68-.476-.4647-.7934-1.0483-.952-1.751l.272-.408v6.239h-2.89Zm4.454-5.525c.4986,0,.8896-.1813,1.173-.544.2833-.374.425-.9577.425-1.751s-.1417-1.3713-.425-1.734c-.272-.374-.6574-.561-1.156-.561-.3174,0-.595.0907-.833.272-.238.17-.425.425-.561.765-.1247.34-.187.7593-.187,1.258c0,.476.0566.8897.17,1.241.1246.34.306.6007.544.782s.5213.272.85.272Zm10.8642-3.434c0-.3967-.1134-.7083-.34-.935-.2154-.238-.51-.357-.884-.357s-.697.0963-.969.289c-.2607.1813-.442.51-.544.986l-2.448-.578c.1586-.816.578-1.46768,1.258-1.95501s1.6376-.731,2.873-.731c.8273,0,1.53.12467,2.108.374.5893.238,1.037.60067,1.343,1.08801.3173.476.476,1.0653.476,1.768v3.111c0,.442.1983.663.595.663.204,0,.3683-.0227.493-.068l-.17,1.649c-.34.1587-.7537.238-1.241.238-.442,0-.833-.068-1.173-.204-.34-.1473-.6064-.3627-.799-.646-.1927-.2947-.289-.663-.289-1.105v-.102l.323-.119c0,.4873-.1474.8953-.442,1.224-.2834.3287-.6574.5723-1.122.731-.4534.1587-.9294.238-1.428.238-.578,0-1.0824-.0907-1.513-.272-.4307-.1813-.765-.442-1.003-.782-.2267-.3513-.34-.782-.34-1.292c0-.612.1813-1.1163.544-1.513.374-.408.9576-.6913,1.751-.85l3.213-.663-.017,1.53-1.632.34c-.34.068-.595.17-.765.306-.1587.1247-.238.3173-.238.578c0,.2493.0906.4363.272.561s.3966.187.646.187c.1926,0,.374-.0283.544-.085.1813-.0567.34-.1417.476-.255.136-.1247.2436-.2777.323-.459s.119-.3967.119-.646v-2.244Zm5.1017,5.389v-8.50001h2.55l.119,1.83601c.2153-.6347.5327-1.12768.952-1.47901.4307-.35133.9747-.527,1.632-.527.2153,0,.3967.017.544.051.1587.034.2833.07933.374.136l-.289,2.38001c-.1133-.0453-.2607-.0793-.442-.102-.17-.034-.3797-.051-.629-.051-.34,0-.6573.0737-.952.221s-.5327.3683-.714.663c-.17.2833-.255.646-.255,1.088v4.284h-2.89Zm13.7903-1.224l-.51-.986h7.837v2.21h-9.622v-2.108l7.157-7.88801.51.986h-7.548v-2.21h9.299v2.108l-7.123,7.88801Zm13.6304-4.165c0-.3967-.1133-.7083-.34-.935-.2153-.238-.51-.357-.884-.357s-.697.0963-.969.289c-.2606.1813-.442.51-.544.986l-2.448-.578c.1587-.816.578-1.46768,1.258-1.95501s1.6377-.731,2.873-.731c.8274,0,1.53.12467,2.108.374.5894.238,1.037.60067,1.343,1.08801.3174.476.476,1.0653.476,1.768v3.111c0,.442.1984.663.595.663.204,0,.3684-.0227.493-.068l-.17,1.649c-.34.1587-.7536.238-1.241.238-.442,0-.833-.068-1.173-.204-.34-.1473-.6063-.3627-.799-.646-.1926-.2947-.289-.663-.289-1.105v-.102l.323-.119c0,.4873-.1473.8953-.442,1.224-.2833.3287-.6573.5723-1.122.731-.4533.1587-.9293.238-1.428.238-.578,0-1.0823-.0907-1.513-.272-.4306-.1813-.765-.442-1.003-.782-.2266-.3513-.34-.782-.34-1.292c0-.612.1814-1.1163.544-1.513.374-.408.9577-.6913,1.751-.85l3.213-.663-.017,1.53-1.632.34c-.34.068-.595.17-.765.306-.1586.1247-.238.3173-.238.578c0,.2493.0907.4363.272.561s.3967.187.646.187c.1927,0,.374-.0283.544-.085.1814-.0567.34-.1417.476-.255.136-.1247.2437-.2777.323-.459.0794-.1813.119-.3967.119-.646v-2.244Zm7.9577-6.71501v9.21401c0,.374.0624.6403.187.799.1247.1587.3344.238.629.238.17,0,.3117-.0113.425-.034.1134-.0227.2494-.0567.408-.102l-.187,1.734c-.204.1247-.4703.2267-.799.306-.3286.0793-.6516.119-.969.119-.9066,0-1.564-.2097-1.972-.629s-.612-1.105-.612-2.057v-9.58801h2.89Zm6.7516,3.434c.8953,0,1.6773.17567,2.346.527.68.34,1.207.84431,1.581,1.51301.3853.6573.578,1.4507.578,2.38s-.1927,1.7283-.578,2.397c-.374.6573-.901,1.1617-1.581,1.513-.6687.34-1.4507.51-2.346.51-.8727,0-1.649-.17-2.329-.51-.68-.3513-1.2127-.8557-1.598-1.513-.374-.6687-.561-1.4677-.561-2.397s.187-1.7227.561-2.38c.3853-.6687.918-1.17301,1.598-1.51301.68-.35133,1.4563-.527,2.329-.527Zm0,2.05701c-.3287,0-.612.0793-.85.238s-.4194.4137-.544.765-.187.8047-.187,1.36.0623,1.0087.187,1.36c.1246.34.306.595.544.765.238.1587.5213.238.85.238.34,0,.629-.0793.867-.238.238-.17.4193-.425.544-.765.1246-.3513.187-.8047.187-1.36s-.0624-1.0087-.187-1.36c-.1247-.3513-.306-.6063-.544-.765s-.527-.238-.867-.238ZM89.1517,6.54219l.238,1.938c-.068-.02267-.136-.034-.204-.034-.068-.01133-.136-.017-.204-.017-.4986,0-.8726.12467-1.122.374-.238.238-.357.53833-.357.901l-1.02-.374c0-.46467.085-.91233.255-1.343s.4307-.782.782-1.054c.3627-.272.816-.408,1.36-.408.034,0,.0737,0,.119,0c.0567,0,.1077.00567.153.017Zm-2.924,8.89101c.986,0,1.7397.2097,2.261.629.5327.408.799.9973.799,1.768c0,.7027-.1926,1.2863-.578,1.751-.3853.4647-.9293.8103-1.632,1.037-.6913.238-1.513.357-2.465.357-1.5413,0-2.652-.1927-3.332-.578s-1.02-.9067-1.02-1.564c0-.476.1927-.8613.578-1.156.3854-.2947,1.0257-.4533,1.921-.476l-.068.272c-.6913-.0907-1.207-.2947-1.547-.612s-.51-.748-.51-1.292.2154-.986.646-1.326c.4307-.34,1.003-.527,1.717-.561l1.054.493h-.272c-.442.0227-.7536.0963-.935.221s-.272.2777-.272.459c0,.1927.0794.34.238.442.1587.0907.3967.136.714.136h2.703Zm-1.598,3.672c.544,0,.9917-.0397,1.343-.119.3627-.068.6347-.17.816-.306.1814-.1247.272-.272.272-.442s-.0623-.306-.187-.408c-.1246-.0907-.3513-.136-.68-.136h-3.043c-.2153,0-.391.0567-.527.17-.1246.1133-.187.255-.187.425c0,.2607.1927.459.578.595.3854.1473.9237.221,1.615.221Zm.102-10.45501c.8614,0,1.598.11333,2.21.34s1.0767.55533,1.394.986c.3287.41931.493.94071.493,1.56401c0,.612-.1643,1.1333-.493,1.564-.3173.4307-.782.7593-1.394.986-.612.2153-1.3486.323-2.21.323-1.3486,0-2.3743-.2493-3.077-.748-.6913-.4987-1.037-1.207-1.037-2.125c0-.6233.1587-1.1447.476-1.56401.3287-.43067.799-.75933,1.411-.986s1.3544-.34,2.227-.34Zm0,1.64901c-.374,0-.68.1077-.918.323-.2266.2153-.34.5213-.34.918c0,.3853.1134.6857.34.901.238.2153.544.323.918.323.3627,0,.663-.1077.901-.323s.357-.5157.357-.901c0-.3967-.119-.7027-.357-.918s-.5383-.323-.901-.323ZM3.59444,38.0452h6.42596v1.275h-7.78596v-11.22h1.36v9.945Zm9.22516-8.857c-.306,0-.5553-.0907-.748-.272-.1813-.1927-.272-.442-.272-.748s.0907-.5497.272-.731c.1927-.1927.442-.289.748-.289s.5497.0963.731.289c.1927.1813.289.425.289.731s-.0963.5553-.289.748c-.1813.1813-.425.272-.731.272Zm.68,1.632v9.367c0,.7027-.136,1.258-.408,1.666s-.6063.697-1.003.867-.7877.255-1.173.255c-.3513,0-.6743-.0567-.96901-.17-.29466-.102-.53833-.2323-.731-.391l.289-1.292c.15867.1473.357.272.59501.374s.5043.153.799.153c.3627,0,.6573-.119.884-.357.238-.238.357-.6517.357-1.241v-9.231h1.36Zm6.2326,8.67c-.544,0-1.0596-.102-1.547-.306-.476-.204-.867-.5327-1.173-.986-.2946-.4647-.442-1.0653-.442-1.802v-5.576h1.36v5.219c0,.8613.187,1.4563.561,1.785.374.3173.901.476,1.581.476.3174,0,.629-.051.935-.153.306-.1133.578-.2833.816-.51.2494-.238.442-.5383.578-.901.1474-.3627.221-.7933.221-1.292v-4.624h1.36v8.5h-1.19l-.085-1.292c-.2946.51-.697.884-1.207,1.122-.4986.2267-1.088.34-1.768.34Zm11.5802,0c-.476,0-.918-.085-1.326-.255s-.7593-.408-1.054-.714-.5157-.6517-.663-1.037l.187-.238-.119,2.074h-1.19v-12.41h1.36v5.831l-.17-.255c.2267-.5327.6063-.969,1.139-1.309.544-.3513,1.1617-.527,1.853-.527.7027,0,1.3487.1757,1.938.527s1.0597.8557,1.411,1.513.527,1.4507.527,2.38c0,.918-.1813,1.7113-.544,2.38-.3513.6573-.8217,1.1617-1.411,1.513s-1.2353.527-1.938.527Zm-.136-1.19c.8387,0,1.4903-.2947,1.955-.884.476-.5893.714-1.3713.714-2.346s-.2323-1.7567-.697-2.346-1.1163-.884-1.955-.884c-.5327,0-1.003.136-1.411.408-.3967.272-.7083.6517-.935,1.139s-.34,1.0597-.34,1.717c0,.646.1077,1.2127.323,1.7.2267.476.5383.8443.935,1.105.408.2607.8783.391,1.411.391Zm7.9212-11.39v10.251c0,.4307.0793.731.238.901.1587.1587.4137.238.765.238.2267,0,.4137-.017.561-.051s.3457-.0963.595-.187l-.221,1.19c-.1813.0793-.3797.136-.595.17-.2153.0453-.4363.068-.663.068-.6913,0-1.207-.187-1.547-.561-.3287-.374-.493-.9463-.493-1.717v-10.302h1.36Zm4.5843,2.278c-.306,0-.5553-.0907-.748-.272-.1813-.1927-.272-.442-.272-.748s.0907-.5497.272-.731c.1927-.1927.442-.289.748-.289s.5497.0963.731.289c.1927.1813.289.425.289.731s-.0963.5553-.289.748c-.1813.1813-.425.272-.731.272Zm.68,1.632v9.367c0,.7027-.136,1.258-.408,1.666s-.6063.697-1.003.867-.7877.255-1.173.255c-.3513,0-.6743-.0567-.969-.17-.2947-.102-.5383-.2323-.731-.391l.289-1.292c.1587.1473.357.272.595.374s.5043.153.799.153c.3627,0,.6573-.119.884-.357.238-.238.357-.6517.357-1.241v-9.231h1.36Zm8.1196,3.009c0-.6347-.17-1.122-.51-1.462-.34-.3513-.8216-.527-1.445-.527-.5893,0-1.088.1303-1.496.391-.408.2493-.7083.6573-.901,1.224l-1.105-.68c.2267-.6347.646-1.1447,1.258-1.53.612-.3967,1.3714-.595,2.278-.595.612,0,1.1674.1077,1.666.323.4987.204.8897.5213,1.173.952.2947.4193.442.9633.442,1.632v4.114c0,.408.2154.612.646.612.2154,0,.425-.0283.629-.085l-.068,1.071c-.2266.1133-.5213.17-.884.17-.3286,0-.6233-.0623-.884-.187s-.4646-.3117-.612-.561c-.1473-.2607-.221-.5837-.221-.969v-.17l.34.051c-.136.442-.3683.8047-.697,1.088-.3286.272-.697.476-1.105.612-.408.1247-.8103.187-1.207.187-.4986,0-.9633-.085-1.394-.255s-.7763-.425-1.037-.765c-.2493-.3513-.374-.782-.374-1.292c0-.6347.2097-1.156.629-1.564.4307-.4193,1.0257-.7027,1.785-.85l3.366-.663v1.122l-2.737.561c-.5553.1133-.969.272-1.241.476s-.408.4873-.408.85c0,.3513.136.6403.408.867.2834.2153.68.323,1.19.323.3287,0,.6404-.0397.935-.119.306-.0907.578-.221.816-.391.238-.1813.425-.4023.561-.663.136-.272.204-.5893.204-.952v-2.346Zm4.6649,5.491v-8.5h1.19l.119,1.904-.221-.187c.1814-.4533.425-.816.731-1.088.306-.2833.6574-.4873,1.054-.612.408-.1247.8274-.187,1.258-.187.612,0,1.1674.119,1.666.357.4987.2267.8954.578,1.19,1.054.306.476.459,1.0823.459,1.819v5.44h-1.36v-4.964c0-.9407-.204-1.5923-.612-1.955-.3966-.374-.8896-.561-1.479-.561-.408,0-.816.0963-1.224.289s-.748.5043-1.02.935c-.2606.4307-.391,1.0087-.391,1.734v4.522h-1.36Zm15.4894-5.491c0-.6347-.17-1.122-.51-1.462-.34-.3513-.8216-.527-1.445-.527-.5893,0-1.088.1303-1.496.391-.408.2493-.7083.6573-.901,1.224l-1.105-.68c.2267-.6347.646-1.1447,1.258-1.53.612-.3967,1.3714-.595,2.278-.595.612,0,1.1674.1077,1.666.323.4987.204.8897.5213,1.173.952.2947.4193.442.9633.442,1.632v4.114c0,.408.2154.612.646.612.2154,0,.425-.0283.629-.085l-.068,1.071c-.2266.1133-.5213.17-.884.17-.3286,0-.6233-.0623-.884-.187-.2606-.1247-.4646-.3117-.612-.561-.1473-.2607-.221-.5837-.221-.969v-.17l.34.051c-.136.442-.3683.8047-.697,1.088-.3286.272-.697.476-1.105.612-.408.1247-.8103.187-1.207.187-.4986,0-.9633-.085-1.394-.255-.4306-.17-.7763-.425-1.037-.765-.2493-.3513-.374-.782-.374-1.292c0-.6347.2097-1.156.629-1.564.4307-.4193,1.0257-.7027,1.785-.85l3.366-.663v1.122l-2.737.561c-.5553.1133-.969.272-1.241.476s-.408.4873-.408.85c0,.3513.136.6403.408.867.2834.2153.68.323,1.19.323.3287,0,.6404-.0397.935-.119.306-.0907.578-.221.816-.391.238-.1813.425-.4023.561-.663.136-.272.204-.5893.204-.952v-2.346Z"
        fill="#fff"
      />
      <path
        d="M8.40644,84.8253c-1.60534,0-3.00534-.308-4.2-.924-1.176-.6347-2.16534-1.6613-2.968-3.08l4.228-2.1c.20533.7467.532,1.344.98,1.792.46666.448,1.15733.672,2.072.672.57866,0,1.07333-.1027,1.48396-.308s.728-.504.952-.896c.2427-.4107.364-.9053.364-1.484c0-.56-.112-1.0267-.336-1.4-.2053-.3733-.5133-.6533-.924-.84-.41063-.2053-.92396-.308-1.53996-.308-.448,0-.84934.0467-1.204.14-.35467.0747-.68134.196-.98.364-.28.1493-.54134.3453-.784.588l-3.64-.672l1.176-10.304h11.64796v3.724h-8.14796l-.476,3.696-.084.448h.028c.37333-.4293.896-.756,1.568-.98s1.41866-.336,2.24-.336c1.21336,0,2.24936.2427,3.10796.728.8587.4853,1.5214,1.148,1.988,1.988.4667.84.7,1.8013.7,2.884c0,1.1387-.196,2.128-.588,2.968-.3733.8213-.9053,1.5027-1.596,2.044-.672.5413-1.4466.9427-2.324,1.204-.8586.2613-1.7733.392-2.74396.392Zm12.37626-5.096c.8773,0,1.5586.224,2.044.672.504.448.756,1.0733.756,1.876c0,.784-.252,1.4-.756,1.848-.4854.448-1.1667.672-2.044.672-.8587,0-1.54-.224-2.044-.672s-.756-1.064-.756-1.848c0-.8027.252-1.428.756-1.876s1.1853-.672,2.044-.672Zm12.8251-13.888c1.4,0,2.6133.2053,3.64.616s1.82.9987,2.3799,1.764c.5787.7467.8681,1.6427.8681,2.688c0,.9893-.2427,1.8387-.728,2.548s-1.204,1.2507-2.156,1.624v.028c1.12.3733,1.988.924,2.604,1.652.616.7093.924,1.624.924,2.744c0,1.0827-.308,2.0253-.924,2.828-.5974.784-1.456,1.4-2.576,1.848-1.12.4293-2.464.644-4.032.644-1.5494,0-2.884-.2147-4.004-.644-1.12-.448-1.988-1.064-2.604-1.848-.5974-.8027-.896-1.7453-.896-2.828c0-1.12.308-2.0347.924-2.744.616-.728,1.484-1.2787,2.604-1.652v-.028c-.9334-.3547-1.652-.8867-2.156-1.596-.504-.728-.756-1.5867-.756-2.576c0-1.0453.28-1.9413.84-2.688.5786-.7653,1.3906-1.3533,2.436-1.764s2.2493-.616,3.612-.616Zm.028,3.5c-.7467,0-1.344.1867-1.792.56s-.672.896-.672,1.568c0,.6533.224,1.176.672,1.568.448.3733,1.0453.56,1.792.56.7466,0,1.3346-.1867,1.764-.56.448-.392.672-.9147.672-1.568c0-.672-.224-1.1947-.672-1.568-.4294-.3733-1.0174-.56-1.764-.56Zm0,11.984c.5973,0,1.1013-.084,1.512-.252.4293-.1867.756-.4573.98-.812s.336-.7653.336-1.232c0-.4853-.112-.896-.336-1.232-.224-.3547-.5507-.616-.98-.784-.4294-.1867-.9334-.28-1.512-.28-.5787,0-1.092.0933-1.54.28-.4294.168-.756.4293-.98.784-.224.336-.336.7467-.336,1.232c0,.4667.112.8773.336,1.232s.5506.6253.98.812c.4293.168.9426.252,1.54.252Zm17.7786,3.5c-2.52,0-4.4333-.8027-5.74-2.408-1.288-1.6053-1.932-3.976-1.932-7.112s.644-5.5067,1.932-7.112c1.3067-1.6053,3.22-2.408,5.74-2.408s4.424.8027,5.712,2.408c1.3067,1.6053,1.96,3.976,1.96,7.112s-.6533,5.5067-1.96,7.112c-1.288,1.6053-3.192,2.408-5.712,2.408Zm0-3.752c.6907,0,1.2507-.1867,1.68-.56.4294-.392.7374-1.008.924-1.848.2054-.8587.308-1.9787.308-3.36s-.1026-2.492-.308-3.332c-.1866-.8587-.4946-1.4747-.924-1.848-.4293-.392-.9893-.588-1.68-.588-.672,0-1.232.196-1.68.588-.4293.3733-.7466.9893-.952,1.848-.1866.84-.28,1.9507-.28,3.332s.0934,2.5013.28,3.36c.2054.84.5227,1.456.952,1.848.448.3733,1.008.56,1.68.56Zm17.2128,3.752c-1.9786,0-3.6306-.3827-4.956-1.148-1.3066-.784-2.212-1.9227-2.716-3.416l4.424-1.904c.0934.672.2614,1.2133.504,1.624.2614.392.6067.6813,1.036.868.4294.168.9334.252,1.512.252.5227,0,.9614-.084,1.316-.252.3734-.1867.6627-.448.868-.784s.308-.7373.308-1.204c0-.4853-.1026-.8773-.308-1.176-.1866-.2987-.4666-.5133-.84-.644-.3546-.1307-.7933-.196-1.316-.196-.2426,0-.4666.0093-.672.028-.2053,0-.4386.0187-.7.056v-3.136c.1494.0187.2987.0373.448.056.1494,0,.3267,0,.532,0c.8774,0,1.5027-.1773,1.876-.532.392-.3733.588-.952.588-1.736c0-.672-.196-1.1853-.588-1.54-.3733-.3547-.9053-.532-1.596-.532-.728,0-1.3253.196-1.792.588-.4666.3733-.7653,1.0173-.896,1.932l-4.228-1.456c.2054-1.0267.644-1.8947,1.316-2.604s1.512-1.2507,2.52-1.624c1.0267-.3733,2.156-.56,3.388-.56c1.4187,0,2.6134.2053,3.584.616.9707.4107,1.708.9987,2.212,1.764s.756,1.6613.756,2.688c0,.8027-.1306,1.4747-.392,2.016-.2426.5413-.56.98-.952,1.316-.3733.336-.756.588-1.148.756-.392.1493-.7186.2427-.98.28v.084c.336,0,.7187.0653,1.148.196.4294.1307.8494.3453,1.26.644.4107.28.7467.672,1.008,1.176.28.504.42,1.1293.42,1.876c0,1.1573-.308,2.156-.924,2.996-.5973.84-1.4186,1.4933-2.464,1.96-1.0453.448-2.2306.672-3.556.672Zm17.8894-.28v-14h4.256l.14,2.716c.448-.9893,1.0733-1.736,1.876-2.24.8213-.504,1.764-.756,2.828-.756c1.0453,0,1.9507.2333,2.716.7s1.3347,1.1573,1.7084,2.072c.298-.616.681-1.1293,1.148-1.54.485-.4107,1.036-.7187,1.652-.924s1.25-.308,1.904-.308c.933,0,1.754.1867,2.464.56.709.3547,1.269.9053,1.68,1.652.429.728.644,1.6427.644,2.744v9.324h-4.76v-8.232c0-.896-.178-1.5213-.532-1.876-.336-.3547-.794-.532-1.372-.532-.467,0-.896.1213-1.288.364-.374.224-.663.5693-.868,1.036-.206.4667-.308,1.0547-.308,1.764v7.476h-4.7604v-8.232c0-.896-.1773-1.5213-.532-1.876s-.812-.532-1.372-.532c-.4293,0-.84.112-1.232.336-.3733.224-.672.5787-.896,1.064-.224.4667-.336,1.0827-.336,1.848v7.392h-4.76Zm25.4634-9.324v-2.156c.448-.2613.877-.504,1.288-.728.411-.2427.812-.4853,1.204-.728.784-.5413,1.419-1.0267,1.904-1.456s.831-.8307,1.036-1.204c.224-.3733.336-.728.336-1.064c0-.392-.112-.7-.336-.924-.205-.224-.532-.336-.98-.336-.504,0-.887.1867-1.148.56-.243.3547-.364.8773-.364,1.568l-3.332-.7c.037-1.2507.495-2.24,1.372-2.968.896-.7467,2.081-1.12,3.556-1.12c1.176,0,2.119.1867,2.828.56.709.3547,1.223.812,1.54,1.372.336.5413.504,1.1107.504,1.708c0,.4667-.103.924-.308,1.372-.205.4293-.513.8587-.924,1.288-.392.4107-.887.8213-1.484,1.232-.317.2053-.663.4013-1.036.588-.355.168-.728.3267-1.12.476v.056c.28-.0373.672-.0653,1.176-.084s.961-.028,1.372-.028h2.464v2.716h-9.548Z"
        fill="#fdb927"
      />
    </g>
    <g id="edEvCAwTnKp1209" transform="translate(323.298562 160.102764)" opacity="0">
      <path
        d="M6.67144,5.71742c1.13333,0,2.108.23233,2.924.697.82736.45333,1.46196,1.11067,1.90396,1.972s.663,1.89838.663,3.11098-.221,2.2497-.663,3.111-1.0766,1.5244-1.90396,1.989c-.816.4534-1.79067.68-2.924.68s-2.11367-.2266-2.941-.68c-.82734-.4646-1.462-1.1276-1.904-1.989s-.663-1.8983-.663-3.111.221-2.24964.663-3.11098s1.07666-1.51867,1.904-1.972c.82733-.46467,1.80766-.697,2.941-.697Zm0,2.295c-.544,0-1.003.13033-1.377.391s-.65734.65167-.85,1.173c-.19267.50998-.289,1.15038-.289,1.92098c0,.7594.09633,1.3997.289,1.921s.476.9124.85,1.173.833.391,1.377.391.99733-.1303,1.36-.391c.374-.2606.65733-.6516.85-1.173s.289-1.1616.289-1.921c0-.7706-.09634-1.411-.289-1.92098-.19267-.52133-.476-.91233-.85-1.173-.36267-.26067-.816-.391-1.36-.391ZM19.3934,17.2774c-.5553,0-1.0483-.1246-1.479-.374-.4193-.2493-.765-.5893-1.037-1.02-.272-.442-.4477-.9406-.527-1.496l.272-.357-.153,3.077h-2.533v-12.10398h2.89v6.27298l-.272-.408c.1587-.7026.4817-1.28065.969-1.73398.4873-.46467,1.1447-.697,1.972-.697.6573,0,1.241.17567,1.751.527.5213.35133.9237.86133,1.207,1.52998.2947.6574.442,1.4564.442,2.397c0,.918-.1473,1.7057-.442,2.363s-.7027,1.1617-1.224,1.513c-.5213.34-1.1333.51-1.836.51Zm-1.003-2.125c.4987,0,.8897-.1813,1.173-.544.2833-.374.425-.9576.425-1.751s-.1417-1.3713-.425-1.734c-.2833-.374-.6743-.561-1.173-.561-.3287,0-.612.0964-.85.289-.2267.1814-.4023.442-.527.782s-.187.7537-.187,1.241c0,.4874.0623.901.187,1.241s.306.6007.544.782c.238.17.5157.255.833.255Zm7.6492-7.53098c-.5893,0-1.02-.10767-1.292-.323-.2606-.22666-.391-.578-.391-1.054c0-.48733.1304-.83867.391-1.054.272-.22667.7027-.34,1.292-.34.578,0,1.003.11333,1.275.34.272.21533.408.56667.408,1.054c0,.476-.136.82734-.408,1.054-.272.21533-.697.323-1.275.323Zm1.445.986v8.97598c0,.7707-.136,1.3884-.408,1.853-.2606.4647-.6346.799-1.122,1.003-.4873.2154-1.0766.323-1.768.323-.4533,0-.867-.051-1.241-.153-.374-.0906-.7026-.221-.986-.391l.408-1.87c.1247.0907.2777.1644.459.221.1814.068.391.102.629.102.34,0,.612-.102.816-.306.2154-.1926.323-.5383.323-1.037v-8.72098h2.89Zm6.2053,8.66998c-.9407,0-1.7567-.1756-2.448-.527-.68-.3513-1.207-.8556-1.581-1.513-.374-.6573-.561-1.4506-.561-2.38s.187-1.7226.561-2.38.8953-1.16165,1.564-1.51298c.68-.35133,1.4563-.527,2.329-.527.8953,0,1.6546.17567,2.278.527.6346.34,1.1163.816,1.445,1.42798.3286.6007.493,1.292.493,2.074c0,.204-.0057.408-.017.612s-.0283.374-.051.51h-6.732v-1.547h5.457l-1.377.527c0-.68-.1247-1.2013-.374-1.564-.238-.3626-.612-.544-1.122-.544-.3627,0-.6744.085-.935.255-.2494.17-.442.4364-.578.799-.1247.3627-.187.8274-.187,1.394c0,.5554.0736,1.0087.221,1.36.1473.34.357.5894.629.748.272.1474.6006.221.986.221.4306,0,.7706-.085,1.02-.255.2606-.17.4533-.408.578-.714l2.312.765c-.1587.4874-.4364.901-.833,1.241-.3854.3287-.85.578-1.394.748-.5327.17-1.0937.255-1.683.255ZM48.7196,8.60742l-4.08,4.35198-.544.153-2.431,2.72-.017-2.958l3.859-4.26698h3.213Zm-6.443-3.604v12.10398h-2.89v-12.10398h2.89Zm2.805,6.15398l3.825,5.95h-3.196l-2.516-4.25l1.887-1.7Zm8.4332-5.25298v8.17698c0,.408.0963.7027.289.884.204.17.4817.255.833.255.272,0,.5043-.0283.697-.085.204-.068.3853-.1643.544-.289l.306,1.785c-.2833.204-.6403.3627-1.071.476-.4307.1134-.8727.17-1.326.17-.646,0-1.207-.0906-1.683-.272-.4647-.1813-.8273-.4703-1.088-.867-.2493-.3966-.3797-.9236-.391-1.581v-7.85398l2.89-.799Zm2.533,2.703v2.05698h-6.885v-2.05698h6.885Zm15.6797-2.72l-3.961,7.12298v4.097h-2.924v-4.097l-3.961-7.12298h3.026l1.581,3.077.833,1.86998.85-1.86998l1.581-3.077h2.975ZM3.59444,37.8324h6.42596v1.275h-7.78596v-11.22h1.36v9.945Zm9.22516-8.857c-.306,0-.5553-.0906-.748-.272-.1813-.1926-.272-.442-.272-.748s.0907-.5496.272-.731c.1927-.1926.442-.289.748-.289s.5497.0964.731.289c.1927.1814.289.425.289.731s-.0963.5554-.289.748c-.1813.1814-.425.272-.731.272Zm.68,1.632v9.367c0,.7027-.136,1.258-.408,1.666s-.6063.697-1.003.867-.7877.255-1.173.255c-.3513,0-.6743-.0566-.96901-.17-.29466-.102-.53833-.2323-.731-.391l.289-1.292c.15867.1474.357.272.59501.374s.5043.153.799.153c.3627,0,.6573-.119.884-.357.238-.238.357-.6516.357-1.241v-9.231h1.36Zm6.2326,8.67c-.544,0-1.0596-.102-1.547-.306-.476-.204-.867-.5326-1.173-.986-.2946-.4646-.442-1.0653-.442-1.802v-5.576h1.36v5.219c0,.8614.187,1.4564.561,1.785.374.3174.901.476,1.581.476.3174,0,.629-.051.935-.153.306-.1133.578-.2833.816-.51.2494-.238.442-.5383.578-.901.1474-.3626.221-.7933.221-1.292v-4.624h1.36v8.5h-1.19l-.085-1.292c-.2946.51-.697.884-1.207,1.122-.4986.2267-1.088.34-1.768.34Zm11.5802,0c-.476,0-.918-.085-1.326-.255s-.7593-.408-1.054-.714-.5157-.6516-.663-1.037l.187-.238-.119,2.074h-1.19v-12.41h1.36v5.831l-.17-.255c.2267-.5326.6063-.969,1.139-1.309.544-.3513,1.1617-.527,1.853-.527.7027,0,1.3487.1757,1.938.527s1.0597.8557,1.411,1.513.527,1.4507.527,2.38c0,.918-.1813,1.7114-.544,2.38-.3513.6574-.8217,1.1617-1.411,1.513s-1.2353.527-1.938.527Zm-.136-1.19c.8387,0,1.4903-.2946,1.955-.884.476-.5893.714-1.3713.714-2.346c0-.9746-.2323-1.7566-.697-2.346s-1.1163-.884-1.955-.884c-.5327,0-1.003.136-1.411.408-.3967.272-.7083.6517-.935,1.139-.2267.4874-.34,1.0597-.34,1.717c0,.646.1077,1.2127.323,1.7.2267.476.5383.8444.935,1.105.408.2607.8783.391,1.411.391Zm7.9212-11.39v10.251c0,.4307.0793.731.238.901.1587.1587.4137.238.765.238.2267,0,.4137-.017.561-.051s.3457-.0963.595-.187l-.221,1.19c-.1813.0794-.3797.136-.595.17-.2153.0454-.4363.068-.663.068-.6913,0-1.207-.187-1.547-.561-.3287-.374-.493-.9463-.493-1.717v-10.302h1.36Zm4.5843,2.278c-.306,0-.5553-.0906-.748-.272-.1813-.1926-.272-.442-.272-.748s.0907-.5496.272-.731c.1927-.1926.442-.289.748-.289s.5497.0964.731.289c.1927.1814.289.425.289.731s-.0963.5554-.289.748c-.1813.1814-.425.272-.731.272Zm.68,1.632v9.367c0,.7027-.136,1.258-.408,1.666s-.6063.697-1.003.867-.7877.255-1.173.255c-.3513,0-.6743-.0566-.969-.17-.2947-.102-.5383-.2323-.731-.391l.289-1.292c.1587.1474.357.272.595.374s.5043.153.799.153c.3627,0,.6573-.119.884-.357.238-.238.357-.6516.357-1.241v-9.231h1.36Zm8.1196,3.009c0-.6346-.17-1.122-.51-1.462-.34-.3513-.8216-.527-1.445-.527-.5893,0-1.088.1304-1.496.391-.408.2494-.7083.6574-.901,1.224l-1.105-.68c.2267-.6346.646-1.1446,1.258-1.53.612-.3966,1.3714-.595,2.278-.595.612,0,1.1674.1077,1.666.323.4987.204.8897.5214,1.173.952.2947.4194.442.9634.442,1.632v4.114c0,.408.2154.612.646.612.2154,0,.425-.0283.629-.085l-.068,1.071c-.2266.1134-.5213.17-.884.17-.3286,0-.6233-.0623-.884-.187s-.4646-.3116-.612-.561c-.1473-.2606-.221-.5836-.221-.969v-.17l.34.051c-.136.442-.3683.8047-.697,1.088-.3286.272-.697.476-1.105.612-.408.1247-.8103.187-1.207.187-.4986,0-.9633-.085-1.394-.255s-.7763-.425-1.037-.765c-.2493-.3513-.374-.782-.374-1.292c0-.6346.2097-1.156.629-1.564.4307-.4193,1.0257-.7026,1.785-.85l3.366-.663v1.122l-2.737.561c-.5553.1134-.969.272-1.241.476s-.408.4874-.408.85c0,.3514.136.6404.408.867.2834.2154.68.323,1.19.323.3287,0,.6404-.0396.935-.119.306-.0906.578-.221.816-.391.238-.1813.425-.4023.561-.663.136-.272.204-.5893.204-.952v-2.346Zm4.6649,5.491v-8.5h1.19l.119,1.904-.221-.187c.1814-.4533.425-.816.731-1.088.306-.2833.6574-.4873,1.054-.612.408-.1246.8274-.187,1.258-.187.612,0,1.1674.119,1.666.357.4987.2267.8954.578,1.19,1.054.306.476.459,1.0824.459,1.819v5.44h-1.36v-4.964c0-.9406-.204-1.5923-.612-1.955-.3966-.374-.8896-.561-1.479-.561-.408,0-.816.0964-1.224.289-.408.1927-.748.5044-1.02.935-.2606.4307-.391,1.0087-.391,1.734v4.522h-1.36Zm15.4894-5.491c0-.6346-.17-1.122-.51-1.462-.34-.3513-.8216-.527-1.445-.527-.5893,0-1.088.1304-1.496.391-.408.2494-.7083.6574-.901,1.224l-1.105-.68c.2267-.6346.646-1.1446,1.258-1.53.612-.3966,1.3714-.595,2.278-.595.612,0,1.1674.1077,1.666.323.4987.204.8897.5214,1.173.952.2947.4194.442.9634.442,1.632v4.114c0,.408.2154.612.646.612.2154,0,.425-.0283.629-.085l-.068,1.071c-.2266.1134-.5213.17-.884.17-.3286,0-.6233-.0623-.884-.187-.2606-.1246-.4646-.3116-.612-.561-.1473-.2606-.221-.5836-.221-.969v-.17l.34.051c-.136.442-.3683.8047-.697,1.088-.3286.272-.697.476-1.105.612-.408.1247-.8103.187-1.207.187-.4986,0-.9633-.085-1.394-.255-.4306-.17-.7763-.425-1.037-.765-.2493-.3513-.374-.782-.374-1.292c0-.6346.2097-1.156.629-1.564.4307-.4193,1.0257-.7026,1.785-.85l3.366-.663v1.122l-2.737.561c-.5553.1134-.969.272-1.241.476s-.408.4874-.408.85c0,.3514.136.6404.408.867.2834.2154.68.323,1.19.323.3287,0,.6404-.0396.935-.119.306-.0906.578-.221.816-.391.238-.1813.425-.4023.561-.663.136-.272.204-.5893.204-.952v-2.346Z"
        fill="#fff"
      />
      <path
        d="M5.74644,84.3325v-10.64c0-.4853,0-.98,0-1.484.01866-.5226.028-1.0546.028-1.596-.616.56-1.29734,1.0547-2.044,1.484-.74667.4107-1.53067.6907-2.352.84l-.448002-3.976c.485332-.0373.998662-.1586,1.540002-.364.56-.2053,1.11066-.4573,1.652-.756s1.02666-.616,1.456-.952c.42933-.3546.756-.7.98-1.036h3.83596v18.48h-4.64796Zm15.72656.28c-2.52,0-4.4333-.8026-5.74-2.408-1.288-1.6053-1.932-3.976-1.932-7.112s.644-5.5066,1.932-7.112c1.3067-1.6053,3.22-2.408,5.74-2.408s4.424.8027,5.712,2.408c1.3067,1.6054,1.96,3.976,1.96,7.112s-.6533,5.5067-1.96,7.112c-1.288,1.6054-3.192,2.408-5.712,2.408Zm0-3.752c.6907,0,1.2507-.1866,1.68-.56.4294-.392.7374-1.008.924-1.848.2054-.8586.308-1.9786.308-3.36c0-1.3813-.1026-2.492-.308-3.332-.1866-.8586-.4946-1.4746-.924-1.848-.4293-.392-.9893-.588-1.68-.588-.672,0-1.232.196-1.68.588-.4293.3734-.7466.9894-.952,1.848-.1866.84-.28,1.9507-.28,3.332c0,1.3814.0934,2.5014.28,3.36.2054.84.5227,1.456.952,1.848.448.3734,1.008.56,1.68.56Zm12.7901-1.344c.8774,0,1.5587.224,2.044.672.504.448.756,1.0734.756,1.876c0,.784-.252,1.4-.756,1.848-.4853.448-1.1666.672-2.044.672-.8586,0-1.54-.224-2.044-.672s-.756-1.064-.756-1.848c0-.8026.252-1.428.756-1.876s1.1854-.672,2.044-.672Zm12.0691,5.096c-1.6053,0-3.0053-.308-4.2-.924-1.176-.6346-2.1653-1.6613-2.968-3.08l4.228-2.1c.2054.7467.532,1.344.98,1.792.4667.448,1.1574.672,2.072.672.5787,0,1.0734-.1026,1.484-.308.4107-.2053.728-.504.952-.896.2427-.4106.364-.9053.364-1.484c0-.56-.112-1.0266-.336-1.4-.2053-.3733-.5133-.6533-.924-.84-.4106-.2053-.924-.308-1.54-.308-.448,0-.8493.0467-1.204.14-.3546.0747-.6813.196-.98.364-.28.1494-.5413.3454-.784.588l-3.64-.672l1.176-10.304h11.648v3.724h-8.148l-.476,3.696-.084.448h.028c.3734-.4293.896-.756,1.568-.98s1.4187-.336,2.24-.336c1.2134,0,2.2494.2427,3.108.728.8587.4854,1.5214,1.148,1.988,1.988.4667.84.7,1.8014.7,2.884c0,1.1387-.196,2.128-.588,2.968-.3733.8214-.9053,1.5027-1.596,2.044-.672.5414-1.4466.9427-2.324,1.204-.8586.2614-1.7733.392-2.744.392Zm8.3926-18.76h15.204v3.416c-1.5307,1.512-2.744,3.0707-3.64,4.676-.8774,1.5867-1.5027,3.2387-1.876,4.956-.3547,1.7174-.532,3.528-.532,5.432h-4.76c0-2.0346.252-3.9666.756-5.796.5226-1.848,1.3253-3.612,2.408-5.292c1.1013-1.68,2.52-3.304,4.256-4.872l1.008,1.26h-12.824v-3.78Zm24.4162,18.76c-2.52,0-4.4333-.8026-5.74-2.408-1.288-1.6053-1.932-3.976-1.932-7.112s.644-5.5066,1.932-7.112c1.3067-1.6053,3.22-2.408,5.74-2.408s4.424.8027,5.712,2.408c1.3067,1.6054,1.96,3.976,1.96,7.112s-.6533,5.5067-1.96,7.112c-1.288,1.6054-3.192,2.408-5.712,2.408Zm0-3.752c.6907,0,1.2507-.1866,1.68-.56.4293-.392.7373-1.008.924-1.848.2053-.8586.308-1.9786.308-3.36c0-1.3813-.1027-2.492-.308-3.332-.1867-.8586-.4947-1.4746-.924-1.848-.4293-.392-.9893-.588-1.68-.588-.672,0-1.232.196-1.68.588-.4293.3734-.7467.9894-.952,1.848-.1867.84-.28,1.9507-.28,3.332c0,1.3814.0933,2.5014.28,3.36.2053.84.5227,1.456.952,1.848.448.3734,1.008.56,1.68.56Zm18.7233,3.472v-14h4.2557l.14,2.716c.448-.9893,1.074-1.736,1.876-2.24.822-.504,1.764-.756,2.828-.756c1.046,0,1.951.2334,2.716.7.766.4667,1.335,1.1574,1.708,2.072.299-.616.682-1.1293,1.148-1.54.486-.4106,1.036-.7186,1.652-.924s1.251-.308,1.904-.308c.934,0,1.755.1867,2.464.56.71.3547,1.27.9054,1.68,1.652.43.728.644,1.6427.644,2.744v9.324h-4.76v-8.232c0-.896-.177-1.5213-.532-1.876-.336-.3546-.793-.532-1.372-.532-.466,0-.896.1214-1.288.364-.373.224-.662.5694-.868,1.036-.205.4667-.308,1.0547-.308,1.764v7.476h-4.76v-8.232c0-.896-.177-1.5213-.532-1.876-.354-.3546-.812-.532-1.372-.532-.429,0-.84.112-1.232.336-.373.224-.672.5787-.896,1.064-.224.4667-.336,1.0827-.336,1.848v7.392h-4.7597Zm25.4637-9.324v-2.156c.448-.2613.877-.504,1.288-.728.41-.2426.812-.4853,1.204-.728.784-.5413,1.418-1.0266,1.904-1.456.485-.4293.83-.8306,1.036-1.204.224-.3733.336-.728.336-1.064c0-.392-.112-.7-.336-.924-.206-.224-.532-.336-.98-.336-.504,0-.887.1867-1.148.56-.243.3547-.364.8774-.364,1.568l-3.332-.7c.037-1.2506.494-2.24,1.372-2.968.896-.7466,2.081-1.12,3.556-1.12c1.176,0,2.118.1867,2.828.56.709.3547,1.222.812,1.54,1.372.336.5414.504,1.1107.504,1.708c0,.4667-.103.924-.308,1.372-.206.4294-.514.8587-.924,1.288-.392.4107-.887.8214-1.484,1.232-.318.2054-.663.4014-1.036.588-.355.168-.728.3267-1.12.476v.056c.28-.0373.672-.0653,1.176-.084.504-.0186.961-.028,1.372-.028h2.464v2.716h-9.548Z"
        fill="#fdb927"
      />
    </g>
    <g id="edEvCAwTnKp1212" transform="translate(322.73856 159.083953)" opacity="0">
      <path
        d="M1.63944,17.0892v-11.21997h8.73796v2.261h-5.81396v2.27797h4.624v2.125h-4.624v2.295h6.03496v2.261h-8.95896Zm10.52056,0v-8.49997h2.584l.085,1.64897c.272-.60063.6517-1.05397,1.139-1.35997.4987-.306,1.071-.459,1.717-.459.6347,0,1.1844.14167,1.649.425s.8104.70267,1.037,1.25797c.1814-.37397.4137-.68563.697-.93497.2947-.24933.629-.43633,1.003-.561s.7594-.187,1.156-.187c.5667,0,1.0654.11334,1.496.34.4307.21534.7707.54967,1.02,1.003.2607.44197.391.99737.391,1.66597v5.661h-2.89v-4.998c0-.544-.1076-.9236-.323-1.139-.204-.2153-.4816-.323-.833-.323-.2833,0-.544.0737-.782.221-.2266.136-.4023.3457-.527.629s-.187.6404-.187,1.071v4.539h-2.89v-4.998c0-.544-.1076-.9236-.323-1.139-.2153-.2153-.493-.323-.833-.323-.2606,0-.51.068-.748.204-.2266.136-.408.3514-.544.646-.136.2834-.204.6574-.204,1.122v4.488h-2.89ZM32.21,8.41923c.8953,0,1.6773.17567,2.346.527.68.34,1.207.84434,1.581,1.51297.3853.6574.578,1.4507.578,2.38s-.1927,1.7284-.578,2.397c-.374.6574-.901,1.1617-1.581,1.513-.6687.34-1.4507.51-2.346.51-.8727,0-1.649-.17-2.329-.51-.68-.3513-1.2127-.8556-1.598-1.513-.374-.6686-.561-1.4676-.561-2.397s.187-1.7226.561-2.38c.3853-.66863.918-1.17297,1.598-1.51297.68-.35133,1.4563-.527,2.329-.527Zm0,2.05697c-.3287,0-.612.0794-.85.238s-.4194.4137-.544.765-.187.8047-.187,1.36.0623,1.0087.187,1.36c.1246.34.306.595.544.765.238.1587.5213.238.85.238.34,0,.629-.0793.867-.238.238-.17.4193-.425.544-.765.1246-.3513.187-.8046.187-1.36s-.0624-1.0086-.187-1.36c-.1247-.3513-.306-.6063-.544-.765s-.527-.238-.867-.238Zm6.1307,6.613v-8.49997h2.584l.153,2.92397-.323-.323c.1133-.612.3117-1.122.595-1.52997.2947-.408.6573-.714,1.088-.918.442-.21533.935-.323,1.479-.323.5893,0,1.0993.11334,1.53.34.442.22667.7877.561,1.037,1.003s.374.99737.374,1.66597v5.661h-2.89v-4.896c0-.5893-.1133-.9973-.34-1.224s-.5157-.34-.867-.34c-.272,0-.527.068-.765.204-.238.1247-.425.3287-.561.612s-.204.663-.204,1.139v4.505h-2.89Zm15.285-5.389c0-.3966-.1133-.7083-.34-.935-.2153-.238-.51-.357-.884-.357s-.697.0964-.969.289c-.2607.1814-.442.51-.544.986l-2.448-.578c.1587-.816.578-1.46763,1.258-1.95497s1.6377-.731,2.873-.731c.8273,0,1.53.12467,2.108.374.5893.238,1.037.60067,1.343,1.088.3173.47597.476,1.06537.476,1.76797v3.111c0,.442.1983.663.595.663.204,0,.3683-.0226.493-.068l-.17,1.649c-.34.1587-.7537.238-1.241.238-.442,0-.833-.068-1.173-.204-.34-.1473-.6063-.3626-.799-.646-.1927-.2946-.289-.663-.289-1.105v-.102l.323-.119c0,.4874-.1473.8954-.442,1.224-.2833.3287-.6573.5724-1.122.731-.4533.1587-.9293.238-1.428.238-.578,0-1.0823-.0906-1.513-.272s-.765-.442-1.003-.782c-.2267-.3513-.34-.782-.34-1.292c0-.612.1813-1.1163.544-1.513.374-.408.9577-.6913,1.751-.85l3.213-.663-.017,1.53-1.632.34c-.34.068-.595.17-.765.306-.1587.1247-.238.3174-.238.578c0,.2494.0907.4364.272.561.1813.1247.3967.187.646.187.1927,0,.374-.0283.544-.085.1813-.0566.34-.1416.476-.255.136-.1246.2437-.2776.323-.459s.119-.3966.119-.646v-2.244ZM3.59444,37.8142h6.42596v1.275h-7.78596v-11.22h1.36v9.945Zm9.22516-8.857c-.306,0-.5553-.0906-.748-.272-.1813-.1926-.272-.442-.272-.748s.0907-.5496.272-.731c.1927-.1926.442-.289.748-.289s.5497.0964.731.289c.1927.1814.289.425.289.731s-.0963.5554-.289.748c-.1813.1814-.425.272-.731.272Zm.68,1.632v9.367c0,.7027-.136,1.258-.408,1.666s-.6063.697-1.003.867-.7877.255-1.173.255c-.3513,0-.6743-.0566-.96901-.17-.29466-.102-.53833-.2323-.731-.391l.289-1.292c.15867.1474.357.272.59501.374s.5043.153.799.153c.3627,0,.6573-.119.884-.357.238-.238.357-.6516.357-1.241v-9.231h1.36Zm6.2326,8.67c-.544,0-1.0596-.102-1.547-.306-.476-.204-.867-.5326-1.173-.986-.2946-.4646-.442-1.0653-.442-1.802v-5.576h1.36v5.219c0,.8614.187,1.4564.561,1.785.374.3174.901.476,1.581.476.3174,0,.629-.051.935-.153.306-.1133.578-.2833.816-.51.2494-.238.442-.5383.578-.901.1474-.3626.221-.7933.221-1.292v-4.624h1.36v8.5h-1.19l-.085-1.292c-.2946.51-.697.884-1.207,1.122-.4986.2267-1.088.34-1.768.34Zm11.5802,0c-.476,0-.918-.085-1.326-.255s-.7593-.408-1.054-.714-.5157-.6516-.663-1.037l.187-.238-.119,2.074h-1.19v-12.41h1.36v5.831l-.17-.255c.2267-.5326.6063-.969,1.139-1.309.544-.3513,1.1617-.527,1.853-.527.7027,0,1.3487.1757,1.938.527s1.0597.8557,1.411,1.513.527,1.4507.527,2.38c0,.918-.1813,1.7114-.544,2.38-.3513.6574-.8217,1.1617-1.411,1.513s-1.2353.527-1.938.527Zm-.136-1.19c.8387,0,1.4903-.2946,1.955-.884.476-.5893.714-1.3713.714-2.346c0-.9746-.2323-1.7566-.697-2.346s-1.1163-.884-1.955-.884c-.5327,0-1.003.136-1.411.408-.3967.272-.7083.6517-.935,1.139-.2267.4874-.34,1.0597-.34,1.717c0,.646.1077,1.2127.323,1.7.2267.476.5383.8444.935,1.105.408.2607.8783.391,1.411.391Zm7.9212-11.39v10.251c0,.4307.0793.731.238.901.1587.1587.4137.238.765.238.2267,0,.4137-.017.561-.051s.3457-.0963.595-.187l-.221,1.19c-.1813.0794-.3797.136-.595.17-.2153.0454-.4363.068-.663.068-.6913,0-1.207-.187-1.547-.561-.3287-.374-.493-.9463-.493-1.717v-10.302h1.36Zm4.5843,2.278c-.306,0-.5553-.0906-.748-.272-.1813-.1926-.272-.442-.272-.748s.0907-.5496.272-.731c.1927-.1926.442-.289.748-.289s.5497.0964.731.289c.1927.1814.289.425.289.731s-.0963.5554-.289.748c-.1813.1814-.425.272-.731.272Zm.68,1.632v9.367c0,.7027-.136,1.258-.408,1.666s-.6063.697-1.003.867-.7877.255-1.173.255c-.3513,0-.6743-.0566-.969-.17-.2947-.102-.5383-.2323-.731-.391l.289-1.292c.1587.1474.357.272.595.374s.5043.153.799.153c.3627,0,.6573-.119.884-.357.238-.238.357-.6516.357-1.241v-9.231h1.36Zm8.1196,3.009c0-.6346-.17-1.122-.51-1.462-.34-.3513-.8216-.527-1.445-.527-.5893,0-1.088.1304-1.496.391-.408.2494-.7083.6574-.901,1.224l-1.105-.68c.2267-.6346.646-1.1446,1.258-1.53.612-.3966,1.3714-.595,2.278-.595.612,0,1.1674.1077,1.666.323.4987.204.8897.5214,1.173.952.2947.4194.442.9634.442,1.632v4.114c0,.408.2154.612.646.612.2154,0,.425-.0283.629-.085l-.068,1.071c-.2266.1134-.5213.17-.884.17-.3286,0-.6233-.0623-.884-.187s-.4646-.3116-.612-.561c-.1473-.2606-.221-.5836-.221-.969v-.17l.34.051c-.136.442-.3683.8047-.697,1.088-.3286.272-.697.476-1.105.612-.408.1247-.8103.187-1.207.187-.4986,0-.9633-.085-1.394-.255s-.7763-.425-1.037-.765c-.2493-.3513-.374-.782-.374-1.292c0-.6346.2097-1.156.629-1.564.4307-.4193,1.0257-.7026,1.785-.85l3.366-.663v1.122l-2.737.561c-.5553.1134-.969.272-1.241.476s-.408.4874-.408.85c0,.3514.136.6404.408.867.2834.2154.68.323,1.19.323.3287,0,.6404-.0396.935-.119.306-.0906.578-.221.816-.391.238-.1813.425-.4023.561-.663.136-.272.204-.5893.204-.952v-2.346Zm4.6649,5.491v-8.5h1.19l.119,1.904-.221-.187c.1814-.4533.425-.816.731-1.088.306-.2833.6574-.4873,1.054-.612.408-.1246.8274-.187,1.258-.187.612,0,1.1674.119,1.666.357.4987.2267.8954.578,1.19,1.054.306.476.459,1.0824.459,1.819v5.44h-1.36v-4.964c0-.9406-.204-1.5923-.612-1.955-.3966-.374-.8896-.561-1.479-.561-.408,0-.816.0964-1.224.289s-.748.5044-1.02.935c-.2606.4307-.391,1.0087-.391,1.734v4.522h-1.36Zm15.4894-5.491c0-.6346-.17-1.122-.51-1.462-.34-.3513-.8216-.527-1.445-.527-.5893,0-1.088.1304-1.496.391-.408.2494-.7083.6574-.901,1.224l-1.105-.68c.2267-.6346.646-1.1446,1.258-1.53.612-.3966,1.3714-.595,2.278-.595.612,0,1.1674.1077,1.666.323.4987.204.8897.5214,1.173.952.2947.4194.442.9634.442,1.632v4.114c0,.408.2154.612.646.612.2154,0,.425-.0283.629-.085l-.068,1.071c-.2266.1134-.5213.17-.884.17-.3286,0-.6233-.0623-.884-.187-.2606-.1246-.4646-.3116-.612-.561-.1473-.2606-.221-.5836-.221-.969v-.17l.34.051c-.136.442-.3683.8047-.697,1.088-.3286.272-.697.476-1.105.612-.408.1247-.8103.187-1.207.187-.4986,0-.9633-.085-1.394-.255-.4306-.17-.7763-.425-1.037-.765-.2493-.3513-.374-.782-.374-1.292c0-.6346.2097-1.156.629-1.564.4307-.4193,1.0257-.7026,1.785-.85l3.366-.663v1.122l-2.737.561c-.5553.1134-.969.272-1.241.476s-.408.4874-.408.85c0,.3514.136.6404.408.867.2834.2154.68.323,1.19.323.3287,0,.6404-.0396.935-.119.306-.0906.578-.221.816-.391.238-.1813.425-.4023.561-.663.136-.272.204-.5893.204-.952v-2.346Z"
        fill="#fff"
      />
      <path
        d="M2.07844,84.3143v-3.08c1.58666-.9893,2.94-1.9133,4.06-2.772c1.12-.8586,2.02533-1.6706,2.716-2.436.70933-.7653,1.23196-1.4933,1.56796-2.184.336-.6906.504-1.3626.504-2.016c0-.7093-.2146-1.2973-.644-1.764-.41063-.4853-1.02663-.728-1.84796-.728-.87734,0-1.55867.3267-2.044.98-.48534.6347-.74667,1.568-.784,2.8l-4.116-1.26c.03733-1.3813.364-2.5386.98-3.472.63466-.9333,1.49333-1.6333,2.576-2.1c1.08266-.4853,2.31466-.728,3.696-.728c1.21333,0,2.25866.1774,3.13596.532.896.336,1.624.7934,2.184,1.372.56.56.9707,1.1947,1.232,1.904.28.6907.42,1.4.42,2.128c0,1.1947-.308,2.3147-.924,3.36-.616,1.0267-1.512,2.0254-2.688,2.996-1.1573.952-2.56663,1.9134-4.22796,2.884v.028c.31733-.0186.69066-.0373,1.12-.056.42933-.0186.87733-.028,1.34396-.028.4667-.0186.8867-.028,1.26-.028h4.34v3.668h-13.85996Zm24.01566.28c-2.52,0-4.4333-.8026-5.74-2.408-1.288-1.6053-1.932-3.976-1.932-7.112s.644-5.5066,1.932-7.112c1.3067-1.6053,3.22-2.408,5.74-2.408s4.424.8027,5.712,2.408c1.3067,1.6054,1.96,3.976,1.96,7.112s-.6533,5.5067-1.96,7.112c-1.288,1.6054-3.192,2.408-5.712,2.408Zm0-3.752c.6907,0,1.2507-.1866,1.68-.56.4294-.392.7374-1.008.924-1.848.2054-.8586.308-1.9786.308-3.36c0-1.3813-.1026-2.492-.308-3.332-.1866-.8586-.4946-1.4746-.924-1.848-.4293-.392-.9893-.588-1.68-.588-.672,0-1.232.196-1.68.588-.4293.3734-.7466.9894-.952,1.848-.1866.84-.28,1.9507-.28,3.332c0,1.3814.0934,2.5014.28,3.36.2054.84.5227,1.456.952,1.848.448.3734,1.008.56,1.68.56Zm12.7901-1.344c.8774,0,1.5587.224,2.044.672.504.448.756,1.0734.756,1.876c0,.784-.252,1.4-.756,1.848-.4853.448-1.1666.672-2.044.672-.8586,0-1.54-.224-2.044-.672s-.756-1.064-.756-1.848c0-.8026.252-1.428.756-1.876s1.1854-.672,2.044-.672Zm6.5654,4.816v-10.64c0-.4853,0-.98,0-1.484.0186-.5226.028-1.0546.028-1.596-.616.56-1.2974,1.0547-2.044,1.484-.7467.4107-1.5307.6907-2.352.84l-.448-3.976c.4853-.0373.9986-.1586,1.54-.364.56-.2053,1.1106-.4573,1.652-.756.5413-.2986,1.0266-.616,1.456-.952.4293-.3546.756-.7.98-1.036h3.836v18.48h-4.648Zm16.2866-18.76c.9893,0,1.904.1307,2.744.392.8586.2614,1.6053.6907,2.24,1.288.6346.5974,1.1106,1.4,1.428,2.408l-3.92,1.848c-.1867-.6533-.5134-1.1666-.98-1.54-.448-.392-1.0547-.588-1.82-.588-.5227,0-1.008.1307-1.456.392-.4294.2427-.8027.5974-1.12,1.064-.3174.4667-.56,1.036-.728,1.708-.1494.672-.224,1.428-.224,2.268c0,.056,0,.1214,0,.196c0,.056,0,.14,0,.252l.056.168c.224-.56.5693-1.0266,1.036-1.4.4853-.392,1.036-.6906,1.652-.896.616-.2053,1.232-.308,1.848-.308c1.1386,0,2.156.224,3.052.672s1.596,1.092,2.1,1.932c.5226.8214.784,1.82.784,2.996c0,1.2694-.2894,2.3707-.868,3.304-.5787.9147-1.3814,1.624-2.408,2.128s-2.2494.756-3.668.756c-1.5867,0-2.9867-.3453-4.2-1.036-1.1947-.7093-2.128-1.7546-2.8-3.136-.6534-1.4-.98-3.1266-.98-5.18c0-2.2026.364-4.0133,1.092-5.432.728-1.4186,1.708-2.4826,2.94-3.192c1.2506-.7093,2.6506-1.064,4.2-1.064Zm-.336,10.5c-.4854,0-.9334.1027-1.344.308-.392.1867-.7094.4667-.952.84-.224.3734-.336.812-.336,1.316c0,.4854.1213.9147.364,1.288.2426.3734.56.6627.952.868s.8306.308,1.316.308c.84,0,1.484-.2146,1.932-.644.4666-.4293.7-1.036.7-1.82c0-.5226-.1027-.9613-.308-1.316-.2054-.3733-.504-.6533-.896-.84-.3734-.2053-.8494-.308-1.428-.308Zm16.4419,8.54c-1.9787,0-3.6307-.3826-4.956-1.148-1.3067-.784-2.212-1.9226-2.716-3.416l4.424-1.904c.0933.672.2613,1.2134.504,1.624.2613.392.6066.6814,1.036.868.4293.168.9333.252,1.512.252.5226,0,.9613-.084,1.316-.252.3733-.1866.6626-.448.868-.784.2053-.336.308-.7373.308-1.204c0-.4853-.1027-.8773-.308-1.176-.1867-.2986-.4667-.5133-.84-.644-.3547-.1306-.7934-.196-1.316-.196-.2427,0-.4667.0094-.672.028-.2054,0-.4387.0187-.7.056v-3.136c.1493.0187.2986.0374.448.056.1493,0,.3266,0,.532,0c.8773,0,1.5026-.1773,1.876-.532.392-.3733.588-.952.588-1.736c0-.672-.196-1.1853-.588-1.54-.3734-.3546-.9054-.532-1.596-.532-.728,0-1.3254.196-1.792.588-.4667.3734-.7654,1.0174-.896,1.932l-4.228-1.456c.2053-1.0266.644-1.8946,1.316-2.604.672-.7093,1.512-1.2506,2.52-1.624c1.0266-.3733,2.156-.56,3.388-.56c1.4186,0,2.6133.2054,3.584.616.9706.4107,1.708.9987,2.212,1.764.504.7654.756,1.6614.756,2.688c0,.8027-.1307,1.4747-.392,2.016-.2427.5414-.56.98-.952,1.316-.3734.336-.756.588-1.148.756-.392.1494-.7187.2427-.98.28v.084c.336,0,.7186.0654,1.148.196.4293.1307.8493.3454,1.26.644.4106.28.7466.672,1.008,1.176.28.504.42,1.1294.42,1.876c0,1.1574-.308,2.156-.924,2.996-.5974.84-1.4187,1.4934-2.464,1.96-1.0454.448-2.2307.672-3.556.672Zm17.8893-.28v-14h4.256l.1396,2.716c.448-.9893,1.074-1.736,1.876-2.24.822-.504,1.764-.756,2.828-.756c1.046,0,1.951.2334,2.716.7.766.4667,1.335,1.1574,1.708,2.072.299-.616.682-1.1293,1.148-1.54.486-.4106,1.036-.7186,1.652-.924.616-.2053,1.251-.308,1.904-.308.934,0,1.755.1867,2.464.56.71.3547,1.27.9054,1.68,1.652.43.728.644,1.6427.644,2.744v9.324h-4.76v-8.232c0-.896-.177-1.5213-.532-1.876-.336-.3546-.793-.532-1.372-.532-.466,0-.896.1214-1.288.364-.373.224-.662.5694-.868,1.036-.205.4667-.308,1.0547-.308,1.764v7.476h-4.76v-8.232c0-.896-.177-1.5213-.532-1.876-.354-.3546-.812-.532-1.372-.532-.429,0-.84.112-1.232.336-.373.224-.672.5787-.896,1.064-.224.4667-.336,1.0827-.336,1.848v7.392h-4.7596Zm25.4636-9.324v-2.156c.448-.2613.877-.504,1.288-.728.41-.2426.812-.4853,1.204-.728.784-.5413,1.418-1.0266,1.904-1.456.485-.4293.83-.8306,1.036-1.204.224-.3733.336-.728.336-1.064c0-.392-.112-.7-.336-.924-.206-.224-.532-.336-.98-.336-.504,0-.887.1867-1.148.56-.243.3547-.364.8774-.364,1.568l-3.332-.7c.037-1.2506.494-2.24,1.372-2.968.896-.7466,2.081-1.12,3.556-1.12c1.176,0,2.118.1867,2.828.56.709.3547,1.222.812,1.54,1.372.336.5414.504,1.1107.504,1.708c0,.4667-.103.924-.308,1.372-.206.4294-.514.8587-.924,1.288-.392.4107-.887.8214-1.484,1.232-.318.2054-.663.4014-1.036.588-.355.168-.728.3267-1.12.476v.056c.28-.0373.672-.0653,1.176-.084s.961-.028,1.372-.028h2.464v2.716h-9.548Z"
        fill="#fdb927"
      />
    </g>
    <g id="edEvCAwTnKp1215" transform="translate(323.558562 159.322363)" opacity="0">
      <path
        d="M6.02544,6.49782c1.04266,0,1.96066.16433,2.754.493.80466.31733,1.50166.78766,2.09096,1.411L9.45944,10.2888c-.48734-.50998-1.01434-.88965-1.581-1.13898-.55534-.26067-1.19-.391-1.904-.391-.41934,0-.75934.04533-1.02.136s-.44767.21533-.561.374-.17.34-.17.544c0,.23798.10766.44198.323.61198.22666.1587.58933.2947,1.088.408l1.887.425c1.122.2607,1.94366.6404,2.465,1.139s.78196,1.1617.78196,1.989c0,.7934-.204,1.4677-.612,2.023-.40796.544-.96896.9577-1.68296,1.241-.714.272-1.53.408-2.448.408-.748,0-1.462-.0793-2.142-.238-.68-.17-1.292-.408-1.836-.714s-1.003-.6573-1.377002-1.054l1.411002-1.955c.28333.3287.629.6234,1.037.884.41933.2494.87266.4477,1.36.595.49866.1474,1.003.221,1.513.221.39666,0,.72533-.0396.986-.119.272-.0793.47033-.1983.595-.357s.187-.3456.187-.561c0-.238-.085-.4363-.255-.595-.17-.17-.493-.3116-.969-.425l-2.074-.459c-.63467-.1473-1.20134-.34-1.7-.578-.48734-.2493-.87267-.578-1.156-.986-.28334-.4193-.425-.9406-.425-1.564c0-.70265.19266-1.32598.578-1.86998.38533-.55534.94066-.99167,1.666-1.309s1.59233-.476,2.601-.476Zm9.92006.187v8.17698c0,.408.0963.7027.289.884.204.17.4816.255.833.255.272,0,.5043-.0283.697-.085.204-.068.3853-.1643.544-.289l.306,1.785c-.2834.204-.6404.3627-1.071.476-.4307.1134-.8727.17-1.326.17-.646,0-1.207-.0906-1.683-.272-.4647-.1813-.8274-.4703-1.088-.867-.2494-.3966-.3797-.9236-.391-1.581v-7.85398l2.89-.799Zm2.533,2.703v2.05698h-6.885v-2.05698h6.885Zm5.4829,8.66998c-.9407,0-1.7567-.1756-2.448-.527-.68-.3513-1.207-.8556-1.581-1.513s-.561-1.4506-.561-2.38.187-1.7226.561-2.38c.374-.6573.8953-1.1616,1.564-1.51298.68-.35134,1.4563-.527,2.329-.527.8953,0,1.6546.17566,2.278.527.6346.33998,1.1163.81598,1.445,1.42798.3286.6007.493,1.292.493,2.074c0,.204-.0057.408-.017.612s-.0284.374-.051.51h-6.732v-1.547h5.457l-1.377.527c0-.68-.1247-1.2013-.374-1.564-.238-.3626-.612-.544-1.122-.544-.3627,0-.6744.085-.935.255-.2494.17-.442.4364-.578.799-.1247.3627-.187.8274-.187,1.394c0,.5554.0736,1.0087.221,1.36.1473.34.357.5894.629.748.272.1474.6006.221.986.221.4306,0,.7706-.085,1.02-.255.2606-.17.4533-.408.578-.714l2.312.765c-.1587.4874-.4364.901-.833,1.241-.3854.3287-.85.578-1.394.748-.5327.17-1.0937.255-1.683.255ZM38.9911,9.38782l-4.08,4.35198-.544.153-2.431,2.72-.017-2.958l3.859-4.26698h3.213Zm-6.443-3.604v12.10398h-2.89v-12.10398h2.89Zm2.805,6.15398l3.825,5.95h-3.196l-2.516-4.25l1.887-1.7Zm7.7362-6.15398v9.21398c0,.374.0623.6404.187.799.1247.1587.3343.238.629.238.17,0,.3117-.0113.425-.034s.2493-.0566.408-.102l-.187,1.734c-.204.1247-.4703.2267-.799.306s-.6517.119-.969.119c-.9067,0-1.564-.2096-1.972-.629s-.612-1.105-.612-2.057v-9.58798h2.89ZM49.9428,18.0578c-.9407,0-1.7567-.1756-2.448-.527-.68-.3513-1.207-.8556-1.581-1.513s-.561-1.4506-.561-2.38.187-1.7226.561-2.38c.374-.6573.8953-1.1616,1.564-1.51298.68-.35134,1.4563-.527,2.329-.527.8953,0,1.6547.17566,2.278.527.6347.33998,1.1163.81598,1.445,1.42798.3287.6007.493,1.292.493,2.074c0,.204-.0057.408-.017.612s-.0283.374-.051.51h-6.732v-1.547h5.457l-1.377.527c0-.68-.1247-1.2013-.374-1.564-.238-.3626-.612-.544-1.122-.544-.3627,0-.6743.085-.935.255-.2493.17-.442.4364-.578.799-.1247.3627-.187.8274-.187,1.394c0,.5554.0737,1.0087.221,1.36.1473.34.357.5894.629.748.272.1474.6007.221.986.221.4307,0,.7707-.085,1.02-.255.2607-.17.4533-.408.578-.714l2.312.765c-.1587.4874-.4363.901-.833,1.241-.3853.3287-.85.578-1.394.748-.5327.17-1.0937.255-1.683.255Zm5.6967-.17v-8.49998h2.584l.153,2.92398-.323-.323c.1134-.612.3117-1.122.595-1.53.2947-.408.6574-.71398,1.088-.91798.442-.21534.935-.323,1.479-.323.5894,0,1.0994.11333,1.53.34.442.22666.7877.56098,1.037,1.00298s.374.9974.374,1.666v5.661h-2.89v-4.896c0-.5893-.1133-.9973-.34-1.224-.2266-.2266-.5156-.34-.867-.34-.272,0-.527.068-.765.204-.238.1247-.425.3287-.561.612s-.204.663-.204,1.139v4.505h-2.89Zm11.987-9.48598c-.5893,0-1.02-.10767-1.292-.323-.2606-.22667-.391-.578-.391-1.054c0-.48734.1304-.83867.391-1.054.272-.22667.7027-.34,1.292-.34.578,0,1.003.11333,1.275.34.272.21533.408.56666.408,1.054c0,.476-.136.82733-.408,1.054-.272.21533-.697.323-1.275.323Zm1.445.986v8.49998h-2.89v-8.49998h2.89ZM79.1211,18.0578c-.7027,0-1.3204-.17-1.853-.51-.5214-.3513-.9294-.8556-1.224-1.513-.2834-.6573-.425-1.445-.425-2.363c0-.952.1473-1.7566.442-2.414.306-.6573.7253-1.1616,1.258-1.51298.544-.35134,1.1673-.527,1.87-.527.7706,0,1.3883.238,1.853.714.476.46468.782,1.05968.918,1.78498l-.272.357v-6.28998h2.89v12.10398h-2.584l-.187-2.89.34.255c-.068.5667-.2437,1.0597-.527,1.479-.272.4194-.6234.748-1.054.986-.4194.2267-.901.34-1.445.34Zm1.003-2.125c.3286,0,.6063-.085.833-.255.238-.1813.4193-.4476.544-.799s.187-.782.187-1.292c0-.476-.0624-.8783-.187-1.207-.1134-.34-.289-.595-.527-.765-.2267-.1813-.5044-.272-.833-.272-.4987,0-.8954.187-1.19.561-.2834.3627-.425.9407-.425,1.734s.1416,1.377.425,1.751c.2833.3627.6743.544,1.173.544ZM92.1763,9.38782h2.992l-3.06,8.49998h-3.451l-3.06-8.49998h3.043l1.751,6.47698l1.785-6.47698Zm7.9007-.17c.895,0,1.677.17566,2.346.527.68.33998,1.207.84438,1.581,1.51298.385.6574.578,1.4507.578,2.38s-.193,1.7284-.578,2.397c-.374.6574-.901,1.1617-1.581,1.513-.669.34-1.451.51-2.346.51-.8725,0-1.6489-.17-2.3289-.51-.68-.3513-1.2126-.8556-1.598-1.513-.374-.6686-.561-1.4676-.561-2.397s.187-1.7226.561-2.38c.3854-.6686.918-1.173,1.598-1.51298.68-.35134,1.4564-.527,2.3289-.527Zm0,2.05698c-.3285,0-.6119.0794-.8499.238s-.4193.4137-.544.765c-.1246.3514-.187.8047-.187,1.36s.0624,1.0087.187,1.36c.1247.34.306.595.544.765.238.1587.5214.238.8499.238.34,0,.629-.0793.867-.238.238-.17.419-.425.544-.765.125-.3513.187-.8046.187-1.36s-.062-1.0086-.187-1.36c-.125-.3513-.306-.6063-.544-.765s-.527-.238-.867-.238Zm6.131,6.613v-8.49998h2.55l.119,1.83598c.215-.6346.533-1.1276.952-1.47898.431-.35134.975-.527,1.632-.527.215,0,.397.017.544.051.159.034.283.07933.374.136l-.289,2.37998c-.113-.0453-.261-.0793-.442-.102-.17-.034-.38-.051-.629-.051-.34,0-.657.0737-.952.221s-.533.3684-.714.663c-.17.2834-.255.646-.255,1.088v4.284h-2.89ZM3.59444,38.6128h6.42596v1.275h-7.78596v-11.22h1.36v9.945Zm9.22516-8.857c-.306,0-.5553-.0906-.748-.272-.1813-.1926-.272-.442-.272-.748s.0907-.5496.272-.731c.1927-.1926.442-.289.748-.289s.5497.0964.731.289c.1927.1814.289.425.289.731s-.0963.5554-.289.748c-.1813.1814-.425.272-.731.272Zm.68,1.632v9.367c0,.7027-.136,1.258-.408,1.666s-.6063.697-1.003.867-.7877.255-1.173.255c-.3513,0-.6743-.0566-.96901-.17-.29466-.102-.53833-.2323-.731-.391l.289-1.292c.15867.1474.357.272.59501.374s.5043.153.799.153c.3627,0,.6573-.119.884-.357.238-.238.357-.6516.357-1.241v-9.231h1.36Zm6.2326,8.67c-.544,0-1.0596-.102-1.547-.306-.476-.204-.867-.5326-1.173-.986-.2946-.4646-.442-1.0653-.442-1.802v-5.576h1.36v5.219c0,.8614.187,1.4564.561,1.785.374.3174.901.476,1.581.476.3174,0,.629-.051.935-.153.306-.1133.578-.2833.816-.51.2494-.238.442-.5383.578-.901.1474-.3626.221-.7933.221-1.292v-4.624h1.36v8.5h-1.19l-.085-1.292c-.2946.51-.697.884-1.207,1.122-.4986.2267-1.088.34-1.768.34Zm11.5802,0c-.476,0-.918-.085-1.326-.255s-.7593-.408-1.054-.714-.5157-.6516-.663-1.037l.187-.238-.119,2.074h-1.19v-12.41h1.36v5.831l-.17-.255c.2267-.5326.6063-.969,1.139-1.309.544-.3513,1.1617-.527,1.853-.527.7027,0,1.3487.1757,1.938.527s1.0597.8557,1.411,1.513.527,1.4507.527,2.38c0,.918-.1813,1.7114-.544,2.38-.3513.6574-.8217,1.1617-1.411,1.513s-1.2353.527-1.938.527Zm-.136-1.19c.8387,0,1.4903-.2946,1.955-.884.476-.5893.714-1.3713.714-2.346c0-.9746-.2323-1.7566-.697-2.346s-1.1163-.884-1.955-.884c-.5327,0-1.003.136-1.411.408-.3967.272-.7083.6517-.935,1.139-.2267.4874-.34,1.0597-.34,1.717c0,.646.1077,1.2127.323,1.7.2267.476.5383.8444.935,1.105.408.2607.8783.391,1.411.391Zm7.9212-11.39v10.251c0,.4307.0793.731.238.901.1587.1587.4137.238.765.238.2267,0,.4137-.017.561-.051s.3457-.0963.595-.187l-.221,1.19c-.1813.0794-.3797.136-.595.17-.2153.0454-.4363.068-.663.068-.6913,0-1.207-.187-1.547-.561-.3287-.374-.493-.9463-.493-1.717v-10.302h1.36Zm4.5843,2.278c-.306,0-.5553-.0906-.748-.272-.1813-.1926-.272-.442-.272-.748s.0907-.5496.272-.731c.1927-.1926.442-.289.748-.289s.5497.0964.731.289c.1927.1814.289.425.289.731s-.0963.5554-.289.748c-.1813.1814-.425.272-.731.272Zm.68,1.632v9.367c0,.7027-.136,1.258-.408,1.666s-.6063.697-1.003.867-.7877.255-1.173.255c-.3513,0-.6743-.0566-.969-.17-.2947-.102-.5383-.2323-.731-.391l.289-1.292c.1587.1474.357.272.595.374s.5043.153.799.153c.3627,0,.6573-.119.884-.357.238-.238.357-.6516.357-1.241v-9.231h1.36Zm8.1196,3.009c0-.6346-.17-1.122-.51-1.462-.34-.3513-.8216-.527-1.445-.527-.5893,0-1.088.1304-1.496.391-.408.2494-.7083.6574-.901,1.224l-1.105-.68c.2267-.6346.646-1.1446,1.258-1.53.612-.3966,1.3714-.595,2.278-.595.612,0,1.1674.1077,1.666.323.4987.204.8897.5214,1.173.952.2947.4194.442.9634.442,1.632v4.114c0,.408.2154.612.646.612.2154,0,.425-.0283.629-.085l-.068,1.071c-.2266.1134-.5213.17-.884.17-.3286,0-.6233-.0623-.884-.187s-.4646-.3116-.612-.561c-.1473-.2606-.221-.5836-.221-.969v-.17l.34.051c-.136.442-.3683.8047-.697,1.088-.3286.272-.697.476-1.105.612-.408.1247-.8103.187-1.207.187-.4986,0-.9633-.085-1.394-.255s-.7763-.425-1.037-.765c-.2493-.3513-.374-.782-.374-1.292c0-.6346.2097-1.156.629-1.564.4307-.4193,1.0257-.7026,1.785-.85l3.366-.663v1.122l-2.737.561c-.5553.1134-.969.272-1.241.476s-.408.4874-.408.85c0,.3514.136.6404.408.867.2834.2154.68.323,1.19.323.3287,0,.6404-.0396.935-.119.306-.0906.578-.221.816-.391.238-.1813.425-.4023.561-.663.136-.272.204-.5893.204-.952v-2.346Zm4.6649,5.491v-8.5h1.19l.119,1.904-.221-.187c.1814-.4533.425-.816.731-1.088.306-.2833.6574-.4873,1.054-.612.408-.1246.8274-.187,1.258-.187.612,0,1.1674.119,1.666.357.4987.2267.8954.578,1.19,1.054.306.476.459,1.0824.459,1.819v5.44h-1.36v-4.964c0-.9406-.204-1.5923-.612-1.955-.3966-.374-.8896-.561-1.479-.561-.408,0-.816.0964-1.224.289s-.748.5044-1.02.935c-.2606.4307-.391,1.0087-.391,1.734v4.522h-1.36Zm15.4894-5.491c0-.6346-.17-1.122-.51-1.462-.34-.3513-.8216-.527-1.445-.527-.5893,0-1.088.1304-1.496.391-.408.2494-.7083.6574-.901,1.224l-1.105-.68c.2267-.6346.646-1.1446,1.258-1.53.612-.3966,1.3714-.595,2.278-.595.612,0,1.1674.1077,1.666.323.4987.204.8897.5214,1.173.952.2947.4194.442.9634.442,1.632v4.114c0,.408.2154.612.646.612.2154,0,.425-.0283.629-.085l-.068,1.071c-.2266.1134-.5213.17-.884.17-.3286,0-.6233-.0623-.884-.187-.2606-.1246-.4646-.3116-.612-.561-.1473-.2606-.221-.5836-.221-.969v-.17l.34.051c-.136.442-.3683.8047-.697,1.088-.3286.272-.697.476-1.105.612-.408.1247-.8103.187-1.207.187-.4986,0-.9633-.085-1.394-.255-.4306-.17-.7763-.425-1.037-.765-.2493-.3513-.374-.782-.374-1.292c0-.6346.2097-1.156.629-1.564.4307-.4193,1.0257-.7026,1.785-.85l3.366-.663v1.122l-2.737.561c-.5553.1134-.969.272-1.241.476s-.408.4874-.408.85c0,.3514.136.6404.408.867.2834.2154.68.323,1.19.323.3287,0,.6404-.0396.935-.119.306-.0906.578-.221.816-.391.238-.1813.425-.4023.561-.663.136-.272.204-.5893.204-.952v-2.346Z"
        fill="#fff"
      />
      <path
        d="M8.82644,85.3929c-1.97867,0-3.63067-.3827-4.956-1.148-1.30667-.784-2.212-1.9227-2.716-3.416l4.424-1.904c.09333.672.26133,1.2133.504,1.624.26133.392.60666.6813,1.036.868.42933.168.93333.252,1.512.252.52266,0,.96133-.084,1.316-.252.37336-.1867.66266-.448.86796-.784.2054-.336.308-.7373.308-1.204c0-.4853-.1026-.8773-.308-1.176-.1866-.2987-.4666-.5133-.83996-.644-.35467-.1307-.79334-.196-1.316-.196-.24267,0-.46667.0093-.672.028-.20534,0-.43867.0187-.7.056v-3.136c.14933.0187.29866.0373.448.056.14933,0,.32666,0,.532,0c.87733,0,1.50266-.1773,1.87596-.532.392-.3733.588-.952.588-1.736c0-.672-.196-1.1853-.588-1.54-.3733-.3547-.9053-.532-1.59596-.532-.728,0-1.32534.196-1.792.588-.46667.3733-.76534,1.0173-.896,1.932l-4.228-1.456c.20533-1.0267.644-1.8947,1.316-2.604s1.512-1.2507,2.52-1.624c1.02666-.3733,2.156-.56,3.388-.56c1.41866,0,2.61336.2053,3.58396.616.9707.4107,1.708.9987,2.212,1.764s.756,1.6613.756,2.688c0,.8027-.1306,1.4747-.392,2.016-.2426.5413-.56.98-.952,1.316-.3733.336-.756.588-1.148.756-.392.1493-.7186.2427-.98.28v.084c.336,0,.7187.0653,1.148.196s.8494.3453,1.26.644c.4107.28.7467.672,1.008,1.176.28.504.42,1.1293.42,1.876c0,1.1573-.308,2.156-.924,2.996-.5973.84-1.4186,1.4933-2.464,1.96-1.0453.448-2.2306.672-3.55596.672Zm16.59766,0c-1.9787,0-3.6307-.3827-4.956-1.148-1.3067-.784-2.212-1.9227-2.716-3.416l4.424-1.904c.0933.672.2613,1.2133.504,1.624.2613.392.6067.6813,1.036.868.4293.168.9333.252,1.512.252.5227,0,.9613-.084,1.316-.252.3733-.1867.6627-.448.868-.784s.308-.7373.308-1.204c0-.4853-.1027-.8773-.308-1.176-.1867-.2987-.4667-.5133-.84-.644-.3547-.1307-.7933-.196-1.316-.196-.2427,0-.4667.0093-.672.028-.2053,0-.4387.0187-.7.056v-3.136c.1493.0187.2987.0373.448.056.1493,0,.3267,0,.532,0c.8773,0,1.5027-.1773,1.876-.532.392-.3733.588-.952.588-1.736c0-.672-.196-1.1853-.588-1.54-.3733-.3547-.9053-.532-1.596-.532-.728,0-1.3253.196-1.792.588-.4667.3733-.7653,1.0173-.896,1.932l-4.228-1.456c.2053-1.0267.644-1.8947,1.316-2.604s1.512-1.2507,2.52-1.624c1.0267-.3733,2.156-.56,3.388-.56c1.4187,0,2.6133.2053,3.584.616s1.708.9987,2.212,1.764.756,1.6613.756,2.688c0,.8027-.1307,1.4747-.392,2.016-.2427.5413-.56.98-.952,1.316-.3733.336-.756.588-1.148.756-.392.1493-.7187.2427-.98.28v.084c.336,0,.7187.0653,1.148.196s.8493.3453,1.26.644c.4107.28.7467.672,1.008,1.176.28.504.42,1.1293.42,1.876c0,1.1573-.308,2.156-.924,2.996-.5973.84-1.4187,1.4933-2.464,1.96-1.0453.448-2.2307.672-3.556.672Zm12.2297-5.096c.8773,0,1.5586.224,2.044.672.504.448.756,1.0733.756,1.876c0,.784-.252,1.4-.756,1.848-.4854.448-1.1667.672-2.044.672-.8587,0-1.54-.224-2.044-.672s-.756-1.064-.756-1.848c0-.8027.252-1.428.756-1.876s1.1853-.672,2.044-.672Zm12.825-13.888c1.4,0,2.6134.2053,3.64.616s1.82.9987,2.38,1.764c.5787.7467.868,1.6427.868,2.688c0,.9893-.2426,1.8387-.728,2.548s-1.204,1.2507-2.156,1.624v.028c1.12.3733,1.988.924,2.604,1.652.616.7093.924,1.624.924,2.744c0,1.0827-.308,2.0253-.924,2.828-.5973.784-1.456,1.4-2.576,1.848-1.12.4293-2.464.644-4.032.644-1.5493,0-2.884-.2147-4.004-.644-1.12-.448-1.988-1.064-2.604-1.848-.5973-.8027-.896-1.7453-.896-2.828c0-1.12.308-2.0347.924-2.744.616-.728,1.484-1.2787,2.604-1.652v-.028c-.9333-.3547-1.652-.8867-2.156-1.596-.504-.728-.756-1.5867-.756-2.576c0-1.0453.28-1.9413.84-2.688.5787-.7653,1.3907-1.3533,2.436-1.764c1.0454-.4107,2.2494-.616,3.612-.616Zm.028,3.5c-.7466,0-1.344.1867-1.792.56s-.672.896-.672,1.568c0,.6533.224,1.176.672,1.568.448.3733,1.0454.56,1.792.56.7467,0,1.3347-.1867,1.764-.56.448-.392.672-.9147.672-1.568c0-.672-.224-1.1947-.672-1.568-.4293-.3733-1.0173-.56-1.764-.56Zm0,11.984c.5974,0,1.1014-.084,1.512-.252.4294-.1867.756-.4573.98-.812s.336-.7653.336-1.232c0-.4853-.112-.896-.336-1.232-.224-.3547-.5506-.616-.98-.784-.4293-.1867-.9333-.28-1.512-.28-.5786,0-1.092.0933-1.54.28-.4293.168-.756.4293-.98.784-.224.336-.336.7467-.336,1.232c0,.4667.112.8773.336,1.232s.5507.6253.98.812c.4294.168.9427.252,1.54.252Zm10.4427,3.22v-3.08c1.5867-.9893,2.94-1.9133,4.06-2.772s2.0254-1.6707,2.716-2.436c.7094-.7653,1.232-1.4933,1.568-2.184s.504-1.3627.504-2.016c0-.7093-.2146-1.2973-.644-1.764-.4106-.4853-1.0266-.728-1.848-.728-.8773,0-1.5586.3267-2.044.98-.4853.6347-.7466,1.568-.784,2.8l-4.116-1.26c.0374-1.3813.364-2.5387.98-3.472.6347-.9333,1.4934-1.6333,2.576-2.1c1.0827-.4853,2.3147-.728,3.696-.728c1.2134,0,2.2587.1773,3.136.532.896.336,1.624.7933,2.184,1.372.56.56.9707,1.1947,1.232,1.904.28.6907.42,1.4.42,2.128c0,1.1947-.308,2.3147-.924,3.36-.616,1.0267-1.512,2.0253-2.688,2.996-1.1573.952-2.5666,1.9133-4.228,2.884v.028c.3174-.0187.6907-.0373,1.12-.056.4294-.0187.8774-.028,1.344-.028.4667-.0187.8867-.028,1.26-.028h4.34v3.668h-13.86Zm20.3477,0v-10.64c0-.4853,0-.98,0-1.484.0187-.5227.028-1.0547.028-1.596-.616.56-1.2973,1.0547-2.044,1.484-.7466.4107-1.5306.6907-2.352.84l-.448-3.976c.4854-.0373.9987-.1587,1.54-.364.56-.2053,1.1107-.4573,1.652-.756.5414-.2987,1.0267-.616,1.456-.952.4294-.3547.756-.7.98-1.036h3.836v18.48h-4.648Zm16.4303,0v-14h4.2565l.14,2.716c.448-.9893,1.073-1.736,1.876-2.24.821-.504,1.764-.756,2.828-.756c1.045,0,1.95.2333,2.716.7.765.4667,1.334,1.1573,1.708,2.072.298-.616.681-1.1293,1.148-1.54.485-.4107,1.036-.7187,1.652-.924s1.25-.308,1.904-.308c.933,0,1.754.1867,2.464.56.709.3547,1.269.9053,1.68,1.652.429.728.644,1.6427.644,2.744v9.324h-4.76v-8.232c0-.896-.178-1.5213-.532-1.876-.336-.3547-.794-.532-1.372-.532-.467,0-.896.1213-1.288.364-.374.224-.663.5693-.868,1.036-.206.4667-.308,1.0547-.308,1.764v7.476h-4.76v-8.232c0-.896-.178-1.5213-.532-1.876-.355-.3547-.812-.532-1.372-.532-.43,0-.84.112-1.232.336-.374.224-.672.5787-.896,1.064-.224.4667-.336,1.0827-.336,1.848v7.392h-4.7605Zm25.4635-9.324v-2.156c.448-.2613.877-.504,1.288-.728.411-.2427.812-.4853,1.204-.728.784-.5413,1.419-1.0267,1.904-1.456s.831-.8307,1.036-1.204c.224-.3733.336-.728.336-1.064c0-.392-.112-.7-.336-.924-.205-.224-.532-.336-.98-.336-.504,0-.887.1867-1.148.56-.243.3547-.364.8773-.364,1.568l-3.332-.7c.037-1.2507.495-2.24,1.372-2.968.896-.7467,2.081-1.12,3.556-1.12c1.176,0,2.119.1867,2.828.56.709.3547,1.223.812,1.54,1.372.336.5413.504,1.1107.504,1.708c0,.4667-.103.924-.308,1.372-.205.4293-.513.8587-.924,1.288-.392.4107-.887.8213-1.484,1.232-.317.2053-.663.4013-1.036.588-.355.168-.728.3267-1.12.476v.056c.28-.0373.672-.0653,1.176-.084s.961-.028,1.372-.028h2.464v2.716h-9.548Z"
        fill="#fdb927"
      />
    </g>
    <g id="edEvCAwTnKp1218" transform="translate(323.298562 160.116803)" opacity="0">
      <path
        d="M6.99444,5.87338c1.33733,0,2.37433.31734,3.11096.952.748.62334,1.122,1.45634,1.122,2.499c0,1.14472-.3683,2.01732-1.105,2.61802s-1.77363.901-3.11096.901l-.272.153h-2.227v4.097h-2.873v-11.22002h5.355Zm-.408,5.04902c.56666,0,.99166-.1133,1.275-.34s.425-.58935.425-1.08802c0-.48733-.14167-.84433-.425-1.071s-.70834-.34-1.275-.34h-2.074v2.83902h2.074Zm1.717.612l3.58696,5.559h-3.22996l-2.873-4.913l2.516-.646Zm8.88446,5.729c-.9406,0-1.7566-.1757-2.448-.527-.68-.3513-1.207-.8557-1.581-1.513s-.561-1.4507-.561-2.38.187-1.7227.561-2.38.8954-1.16168,1.564-1.51302c.68-.35133,1.4564-.527,2.329-.527.8954,0,1.6547.17567,2.278.527.6347.34,1.1164.816,1.445,1.42802.3287.6007.493,1.292.493,2.074c0,.204-.0056.408-.017.612s-.0283.374-.051.51h-6.732v-1.547h5.457l-1.377.527c0-.68-.1246-1.2013-.374-1.564-.238-.3627-.612-.544-1.122-.544-.3626,0-.6743.085-.935.255-.2493.17-.442.4363-.578.799-.1246.3627-.187.8273-.187,1.394c0,.5553.0737,1.0087.221,1.36.1474.34.357.5893.629.748.272.1473.6007.221.986.221.4307,0,.7707-.085,1.02-.255.2607-.17.4534-.408.578-.714l2.312.765c-.1586.4873-.4363.901-.833,1.241-.3853.3287-.85.578-1.394.748-.5326.17-1.0936.255-1.683.255Zm5.2548-.17v-1.768l3.383-3.842.901-.901-1.343.034h-2.907v-2.02302h7.446v1.76802l-3.332,3.808-.935.935l1.496-.034h2.924v2.023h-7.633ZM33.0953,7.60738c-.5894,0-1.02-.10766-1.292-.323-.2607-.22666-.391-.578-.391-1.054c0-.48733.1303-.83866.391-1.054.272-.22666.7026-.34,1.292-.34.578,0,1.003.11334,1.275.34.272.21534.408.56667.408,1.054c0,.476-.136.82734-.408,1.054-.272.21534-.697.323-1.275.323Zm1.445.986v8.50002h-2.89v-8.50002h2.89Zm5.1852,8.67002c-.7026,0-1.3203-.17-1.853-.51-.5213-.3513-.9293-.8557-1.224-1.513-.2833-.6573-.425-1.445-.425-2.363c0-.952.1474-1.7567.442-2.414.306-.65735.7254-1.16168,1.258-1.51302.544-.35133,1.1674-.527,1.87-.527.7707,0,1.3884.238,1.853.714.476.46467.782,1.05972.918,1.78502l-.272.357v-6.29002h2.89v12.10402h-2.584l-.187-2.89.34.255c-.068.5667-.2436,1.0597-.527,1.479-.272.4193-.6233.748-1.054.986-.4193.2267-.901.34-1.445.34Zm1.003-2.125c.3287,0,.6064-.085.833-.255.238-.1813.4194-.4477.544-.799.1247-.3513.187-.782.187-1.292c0-.476-.0623-.8783-.187-1.207-.1133-.34-.289-.595-.527-.765-.2266-.1813-.5043-.272-.833-.272-.4986,0-.8953.187-1.19.561-.2833.3627-.425.9407-.425,1.734s.1417,1.377.425,1.751c.2834.3627.6744.544,1.173.544Zm10.6753,2.125c-.9407,0-1.7567-.1757-2.448-.527-.68-.3513-1.207-.8557-1.581-1.513s-.561-1.4507-.561-2.38.187-1.7227.561-2.38.8953-1.16168,1.564-1.51302c.68-.35133,1.4563-.527,2.329-.527.8953,0,1.6546.17567,2.278.527.6346.34,1.1163.816,1.445,1.42802.3286.6007.493,1.292.493,2.074c0,.204-.0057.408-.017.612-.0114.204-.0284.374-.051.51h-6.732v-1.547h5.457l-1.377.527c0-.68-.1247-1.2013-.374-1.564-.238-.3627-.612-.544-1.122-.544-.3627,0-.6744.085-.935.255-.2494.17-.442.4363-.578.799-.1247.3627-.187.8273-.187,1.394c0,.5553.0736,1.0087.221,1.36.1473.34.357.5893.629.748.272.1473.6006.221.986.221.4306,0,.7706-.085,1.02-.255.2606-.17.4533-.408.578-.714l2.312.765c-.1587.4873-.4364.901-.833,1.241-.3854.3287-.85.578-1.394.748-.5327.17-1.0937.255-1.683.255Zm5.6967-.17v-8.50002h2.584l.153,2.92402-.323-.323c.1133-.612.3116-1.122.595-1.53002.2946-.408.6573-.714,1.088-.918.442-.21533.935-.323,1.479-.323.5893,0,1.0993.11334,1.53.34.442.22667.7876.561,1.037,1.003s.374.99732.374,1.66602v5.661h-2.89v-4.896c0-.5893-.1134-.9973-.34-1.224-.2267-.2267-.5157-.34-.867-.34-.272,0-.527.068-.765.204-.238.1247-.425.3287-.561.612s-.204.663-.204,1.139v4.505h-2.89Zm14.571-8.67002c.8613,0,1.5753.12467,2.142.374.578.238,1.0256.561,1.343.969.3286.39672.5326.82732.612,1.29202l-2.669.884c-.0794-.4873-.2267-.85-.442-1.088-.204-.2493-.5044-.374-.901-.374-.3627,0-.6687.085-.918.255-.238.1587-.4194.4193-.544.782-.1247.3513-.187.8047-.187,1.36s.068,1.0087.204,1.36c.136.34.3286.5893.578.748.2493.1473.544.221.884.221.2833,0,.5156-.051.697-.153.1926-.1133.3513-.272.476-.476.1246-.204.204-.4533.238-.748l2.601.833c-.0794.4987-.2947.9463-.646,1.343-.34.3853-.7934.6913-1.36.918s-1.2297.34-1.989.34c-.9294,0-1.7397-.17-2.431-.51-.6914-.3513-1.224-.8557-1.598-1.513-.374-.6687-.561-1.4677-.561-2.397s.187-1.7227.561-2.38c.374-.66868.8953-1.17302,1.564-1.51302.68-.35133,1.462-.527,2.346-.527ZM82.031,11.7044c0-.3967-.1134-.7083-.34-.935-.2154-.238-.51-.357-.884-.357s-.697.0963-.969.289c-.2607.1813-.442.51-.544.986l-2.448-.578c.1586-.816.578-1.46768,1.258-1.95502s1.6376-.731,2.873-.731c.8273,0,1.53.12467,2.108.374.5893.238,1.037.60067,1.343,1.088.3173.47602.476,1.06532.476,1.76802v3.111c0,.442.1983.663.595.663.204,0,.3683-.0227.493-.068l-.17,1.649c-.34.1587-.7537.238-1.241.238-.442,0-.833-.068-1.173-.204-.34-.1473-.6064-.3627-.799-.646-.1927-.2947-.289-.663-.289-1.105v-.102l.323-.119c0,.4873-.1474.8953-.442,1.224-.2834.3287-.6574.5723-1.122.731-.4534.1587-.9294.238-1.428.238-.578,0-1.0824-.0907-1.513-.272-.4307-.1813-.765-.442-1.003-.782-.2267-.3513-.34-.782-.34-1.292c0-.612.1813-1.1163.544-1.513.374-.408.9576-.6913,1.751-.85l3.213-.663-.017,1.53-1.632.34c-.34.068-.595.17-.765.306-.1587.1247-.238.3173-.238.578c0,.2493.0906.4363.272.561.1813.1247.3966.187.646.187.1926,0,.374-.0283.544-.085.1813-.0567.34-.1417.476-.255.136-.1247.2436-.2777.323-.459.0793-.1813.119-.3967.119-.646v-2.244ZM3.59444,37.8184h6.42596v1.275h-7.78596v-11.22h1.36v9.945Zm9.22516-8.857c-.306,0-.5553-.0907-.748-.272-.1813-.1927-.272-.442-.272-.748s.0907-.5497.272-.731c.1927-.1927.442-.289.748-.289s.5497.0963.731.289c.1927.1813.289.425.289.731s-.0963.5553-.289.748c-.1813.1813-.425.272-.731.272Zm.68,1.632v9.367c0,.7027-.136,1.258-.408,1.666s-.6063.697-1.003.867-.7877.255-1.173.255c-.3513,0-.6743-.0567-.96901-.17-.29466-.102-.53833-.2323-.731-.391l.289-1.292c.15867.1473.357.272.59501.374s.5043.153.799.153c.3627,0,.6573-.119.884-.357.238-.238.357-.6517.357-1.241v-9.231h1.36Zm6.2326,8.67c-.544,0-1.0596-.102-1.547-.306-.476-.204-.867-.5327-1.173-.986-.2946-.4647-.442-1.0653-.442-1.802v-5.576h1.36v5.219c0,.8613.187,1.4563.561,1.785.374.3173.901.476,1.581.476.3174,0,.629-.051.935-.153.306-.1133.578-.2833.816-.51.2494-.238.442-.5383.578-.901.1474-.3627.221-.7933.221-1.292v-4.624h1.36v8.5h-1.19l-.085-1.292c-.2946.51-.697.884-1.207,1.122-.4986.2267-1.088.34-1.768.34Zm11.5802,0c-.476,0-.918-.085-1.326-.255s-.7593-.408-1.054-.714-.5157-.6517-.663-1.037l.187-.238-.119,2.074h-1.19v-12.41h1.36v5.831l-.17-.255c.2267-.5327.6063-.969,1.139-1.309.544-.3514,1.1617-.527,1.853-.527.7027,0,1.3487.1756,1.938.527s1.0597.8557,1.411,1.513.527,1.4507.527,2.38c0,.918-.1813,1.7113-.544,2.38-.3513.6573-.8217,1.1617-1.411,1.513s-1.2353.527-1.938.527Zm-.136-1.19c.8387,0,1.4903-.2947,1.955-.884.476-.5893.714-1.3713.714-2.346s-.2323-1.7567-.697-2.346-1.1163-.884-1.955-.884c-.5327,0-1.003.136-1.411.408-.3967.272-.7083.6517-.935,1.139s-.34,1.0597-.34,1.717c0,.646.1077,1.2127.323,1.7.2267.476.5383.8443.935,1.105.408.2607.8783.391,1.411.391Zm7.9212-11.39v10.251c0,.4307.0793.731.238.901.1587.1587.4137.238.765.238.2267,0,.4137-.017.561-.051s.3457-.0963.595-.187l-.221,1.19c-.1813.0793-.3797.136-.595.17-.2153.0453-.4363.068-.663.068-.6913,0-1.207-.187-1.547-.561-.3287-.374-.493-.9463-.493-1.717v-10.302h1.36Zm4.5843,2.278c-.306,0-.5553-.0907-.748-.272-.1813-.1927-.272-.442-.272-.748s.0907-.5497.272-.731c.1927-.1927.442-.289.748-.289s.5497.0963.731.289c.1927.1813.289.425.289.731s-.0963.5553-.289.748c-.1813.1813-.425.272-.731.272Zm.68,1.632v9.367c0,.7027-.136,1.258-.408,1.666s-.6063.697-1.003.867-.7877.255-1.173.255c-.3513,0-.6743-.0567-.969-.17-.2947-.102-.5383-.2323-.731-.391l.289-1.292c.1587.1473.357.272.595.374s.5043.153.799.153c.3627,0,.6573-.119.884-.357.238-.238.357-.6517.357-1.241v-9.231h1.36Zm8.1196,3.009c0-.6347-.17-1.122-.51-1.462-.34-.3513-.8216-.527-1.445-.527-.5893,0-1.088.1303-1.496.391-.408.2493-.7083.6573-.901,1.224l-1.105-.68c.2267-.6347.646-1.1447,1.258-1.53.612-.3967,1.3714-.595,2.278-.595.612,0,1.1674.1076,1.666.323.4987.204.8897.5213,1.173.952.2947.4193.442.9633.442,1.632v4.114c0,.408.2154.612.646.612.2154,0,.425-.0283.629-.085l-.068,1.071c-.2266.1133-.5213.17-.884.17-.3286,0-.6233-.0623-.884-.187s-.4646-.3117-.612-.561c-.1473-.2607-.221-.5837-.221-.969v-.17l.34.051c-.136.442-.3683.8047-.697,1.088-.3286.272-.697.476-1.105.612-.408.1247-.8103.187-1.207.187-.4986,0-.9633-.085-1.394-.255s-.7763-.425-1.037-.765c-.2493-.3513-.374-.782-.374-1.292c0-.6347.2097-1.156.629-1.564.4307-.4193,1.0257-.7027,1.785-.85l3.366-.663v1.122l-2.737.561c-.5553.1133-.969.272-1.241.476s-.408.4873-.408.85c0,.3513.136.6403.408.867.2834.2153.68.323,1.19.323.3287,0,.6404-.0397.935-.119.306-.0907.578-.221.816-.391.238-.1813.425-.4023.561-.663.136-.272.204-.5893.204-.952v-2.346Zm4.6649,5.491v-8.5h1.19l.119,1.904-.221-.187c.1814-.4533.425-.816.731-1.088.306-.2834.6574-.4874,1.054-.612.408-.1247.8274-.187,1.258-.187.612,0,1.1674.119,1.666.357.4987.2267.8954.578,1.19,1.054.306.476.459,1.0823.459,1.819v5.44h-1.36v-4.964c0-.9407-.204-1.5923-.612-1.955-.3966-.374-.8896-.561-1.479-.561-.408,0-.816.0963-1.224.289s-.748.5043-1.02.935c-.2606.4307-.391,1.0087-.391,1.734v4.522h-1.36Zm15.4894-5.491c0-.6347-.17-1.122-.51-1.462-.34-.3513-.8216-.527-1.445-.527-.5893,0-1.088.1303-1.496.391-.408.2493-.7083.6573-.901,1.224l-1.105-.68c.2267-.6347.646-1.1447,1.258-1.53.612-.3967,1.3714-.595,2.278-.595.612,0,1.1674.1076,1.666.323.4987.204.8897.5213,1.173.952.2947.4193.442.9633.442,1.632v4.114c0,.408.2154.612.646.612.2154,0,.425-.0283.629-.085l-.068,1.071c-.2266.1133-.5213.17-.884.17-.3286,0-.6233-.0623-.884-.187-.2606-.1247-.4646-.3117-.612-.561-.1473-.2607-.221-.5837-.221-.969v-.17l.34.051c-.136.442-.3683.8047-.697,1.088-.3286.272-.697.476-1.105.612-.408.1247-.8103.187-1.207.187-.4986,0-.9633-.085-1.394-.255-.4306-.17-.7763-.425-1.037-.765-.2493-.3513-.374-.782-.374-1.292c0-.6347.2097-1.156.629-1.564.4307-.4193,1.0257-.7027,1.785-.85l3.366-.663v1.122l-2.737.561c-.5553.1133-.969.272-1.241.476s-.408.4873-.408.85c0,.3513.136.6403.408.867.2834.2153.68.323,1.19.323.3287,0,.6404-.0397.935-.119.306-.0907.578-.221.816-.391.238-.1813.425-.4023.561-.663.136-.272.204-.5893.204-.952v-2.346Z"
        fill="#fff"
      />
      <path
        d="M5.74644,84.3185v-10.64c0-.4854,0-.98,0-1.484.01866-.5227.028-1.0547.028-1.596-.616.56-1.29734,1.0546-2.044,1.484-.74667.4106-1.53067.6906-2.352.84l-.448002-3.976c.485332-.0374.998662-.1587,1.540002-.364.56-.2054,1.11066-.4574,1.652-.756s1.02666-.616,1.456-.952c.42933-.3547.756-.7.98-1.036h3.83596v18.48h-4.64796Zm8.39056,0v-3.08c1.5867-.9894,2.94-1.9134,4.06-2.772s2.0254-1.6707,2.716-2.436c.7094-.7654,1.232-1.4934,1.568-2.184.336-.6907.504-1.3627.504-2.016c0-.7094-.2146-1.2974-.644-1.764-.4106-.4854-1.0266-.728-1.848-.728-.8773,0-1.5586.3266-2.044.98-.4853.6346-.7466,1.568-.784,2.8l-4.116-1.26c.0374-1.3814.364-2.5387.98-3.472.6347-.9334,1.4934-1.6334,2.576-2.1c1.0827-.4854,2.3147-.728,3.696-.728c1.2134,0,2.2587.1773,3.136.532.896.336,1.624.7933,2.184,1.372.56.56.9707,1.1946,1.232,1.904.28.6906.42,1.4.42,2.128c0,1.1946-.308,2.3146-.924,3.36-.616,1.0266-1.512,2.0253-2.688,2.996-1.1573.952-2.5666,1.9133-4.228,2.884v.028c.3174-.0187.6907-.0374,1.12-.056.4294-.0187.8774-.028,1.344-.028.4667-.0187.8867-.028,1.26-.028h4.34v3.668h-13.86Zm19.0597-4.816c.8774,0,1.5587.224,2.044.672.504.448.756,1.0733.756,1.876c0,.784-.252,1.4-.756,1.848-.4853.448-1.1666.672-2.044.672-.8586,0-1.54-.224-2.044-.672s-.756-1.064-.756-1.848c0-.8027.252-1.428.756-1.876s1.1854-.672,2.044-.672Zm12.0691,5.096c-1.6053,0-3.0053-.308-4.2-.924-1.176-.6347-2.1653-1.6614-2.968-3.08l4.228-2.1c.2053.7466.532,1.344.98,1.792.4667.448,1.1573.672,2.072.672.5787,0,1.0733-.1027,1.484-.308s.728-.504.952-.896c.2427-.4107.364-.9054.364-1.484c0-.56-.112-1.0267-.336-1.4-.2053-.3734-.5133-.6534-.924-.84-.4107-.2054-.924-.308-1.54-.308-.448,0-.8493.0466-1.204.14-.3547.0746-.6813.196-.98.364-.28.1493-.5413.3453-.784.588l-3.64-.672l1.176-10.304h11.648v3.724h-8.148l-.476,3.696-.084.448h.028c.3733-.4294.896-.756,1.568-.98s1.4187-.336,2.24-.336c1.2133,0,2.2493.2426,3.108.728s1.5213,1.148,1.988,1.988.7,1.8013.7,2.884c0,1.1386-.196,2.128-.588,2.968-.3733.8213-.9053,1.5026-1.596,2.044-.672.5413-1.4467.9426-2.324,1.204-.8587.2613-1.7733.392-2.744.392Zm9.9962-.28v-3.08c1.5867-.9894,2.94-1.9134,4.06-2.772s2.0254-1.6707,2.716-2.436c.7094-.7654,1.232-1.4934,1.568-2.184.336-.6907.504-1.3627.504-2.016c0-.7094-.2146-1.2974-.644-1.764-.4106-.4854-1.0266-.728-1.848-.728-.8773,0-1.5586.3266-2.044.98-.4853.6346-.7466,1.568-.784,2.8l-4.116-1.26c.0374-1.3814.364-2.5387.98-3.472.6347-.9334,1.4934-1.6334,2.576-2.1c1.0827-.4854,2.3147-.728,3.696-.728c1.2134,0,2.2587.1773,3.136.532.896.336,1.624.7933,2.184,1.372.56.56.9707,1.1946,1.232,1.904.28.6906.42,1.4.42,2.128c0,1.1946-.308,2.3146-.924,3.36-.616,1.0266-1.512,2.0253-2.688,2.996-1.1573.952-2.5666,1.9133-4.228,2.884v.028c.3174-.0187.6907-.0374,1.12-.056.4294-.0187.8774-.028,1.344-.028.4667-.0187.8867-.028,1.26-.028h4.34v3.668h-13.86Zm20.3477,0v-10.64c0-.4854,0-.98,0-1.484.0187-.5227.028-1.0547.028-1.596-.616.56-1.2973,1.0546-2.044,1.484-.7466.4106-1.5306.6906-2.352.84l-.448-3.976c.4854-.0374.9987-.1587,1.54-.364.56-.2054,1.1107-.4574,1.652-.756.5414-.2987,1.0267-.616,1.456-.952.4294-.3547.756-.7.98-1.036h3.836v18.48h-4.648Zm16.4303,0v-14h4.256l.14,2.716c.448-.9894,1.0734-1.736,1.876-2.24.8214-.504,1.764-.756,2.828-.756c1.045,0,1.951.2333,2.716.7.765.4666,1.335,1.1573,1.708,2.072.299-.616.681-1.1294,1.148-1.54.485-.4107,1.036-.7187,1.652-.924.616-.2054,1.251-.308,1.904-.308.933,0,1.755.1866,2.464.56.709.3546,1.269.9053,1.68,1.652.429.728.644,1.6426.644,2.744v9.324h-4.76v-8.232c0-.896-.177-1.5214-.532-1.876-.336-.3547-.793-.532-1.372-.532-.467,0-.896.1213-1.288.364-.373.224-.663.5693-.868,1.036-.205.4666-.308,1.0546-.308,1.764v7.476h-4.76v-8.232c0-.896-.177-1.5214-.532-1.876s-.812-.532-1.372-.532c-.4293,0-.84.112-1.232.336-.3733.224-.672.5786-.896,1.064-.224.4666-.336,1.0826-.336,1.848v7.392h-4.76Zm25.463-9.324v-2.156c.448-.2614.878-.504,1.288-.728.411-.2427.812-.4854,1.204-.728.784-.5414,1.419-1.0267,1.904-1.456.486-.4294.831-.8307,1.036-1.204.224-.3734.336-.728.336-1.064c0-.392-.112-.7-.336-.924-.205-.224-.532-.336-.98-.336-.504,0-.886.1866-1.148.56-.242.3546-.364.8773-.364,1.568l-3.332-.7c.038-1.2507.495-2.24,1.372-2.968.896-.7467,2.082-1.12,3.556-1.12c1.176,0,2.119.1866,2.828.56.71.3546,1.223.812,1.54,1.372.336.5413.504,1.1106.504,1.708c0,.4666-.102.924-.308,1.372-.205.4293-.513.8586-.924,1.288-.392.4106-.886.8213-1.484,1.232-.317.2053-.662.4013-1.036.588-.354.168-.728.3266-1.12.476v.056c.28-.0374.672-.0654,1.176-.084s.962-.028,1.372-.028h2.464v2.716h-9.548Z"
        fill="#fdb927"
      />
    </g>
    <path
      d=""
      transform="translate(0 132)"
      fill="none"
      stroke="#3f5787"
      stroke-width="1.632"
    />
  </svg>
</template>

<script setup>
import { onMounted } from "vue";
onMounted(() => {
  !(function (t, e) {
    "object" == typeof exports && "undefined" != typeof module
      ? (module.exports = e())
      : "function" == typeof __SVGATOR_DEFINE__ && __SVGATOR_DEFINE__.amd
      ? __SVGATOR_DEFINE__(e)
      : (((t =
          "undefined" != typeof globalThis ? globalThis : t || self).__SVGATOR_PLAYER__ =
          t.__SVGATOR_PLAYER__ || {}),
        (t.__SVGATOR_PLAYER__["91c80d77"] = e()));
  })(this, function () {
    "use strict";
    function t(t, e) {
      var n = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        e &&
          (r = r.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })),
          n.push.apply(n, r);
      }
      return n;
    }
    function e(e) {
      for (var n = 1; n < arguments.length; n++) {
        var r = null != arguments[n] ? arguments[n] : {};
        n % 2
          ? t(Object(r), !0).forEach(function (t) {
              u(e, t, r[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r))
          : t(Object(r)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
            });
      }
      return e;
    }
    function n(t) {
      return (n =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            })(t);
    }
    function r(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }
    function i(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        (r.enumerable = r.enumerable || !1),
          (r.configurable = !0),
          "value" in r && (r.writable = !0),
          Object.defineProperty(t, r.key, r);
      }
    }
    function o(t, e, n) {
      return e && i(t.prototype, e), n && i(t, n), t;
    }
    function u(t, e, n) {
      return (
        e in t
          ? Object.defineProperty(t, e, {
              value: n,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (t[e] = n),
        t
      );
    }
    function a(t) {
      return (a = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          })(t);
    }
    function s(t, e) {
      return (s =
        Object.setPrototypeOf ||
        function (t, e) {
          return (t.__proto__ = e), t;
        })(t, e);
    }
    function l() {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return (
          Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})),
          !0
        );
      } catch (t) {
        return !1;
      }
    }
    function f(t, e, n) {
      return (f = l()
        ? Reflect.construct
        : function (t, e, n) {
            var r = [null];
            r.push.apply(r, e);
            var i = new (Function.bind.apply(t, r))();
            return n && s(i, n.prototype), i;
          }).apply(null, arguments);
    }
    function c(t, e) {
      if (e && ("object" == typeof e || "function" == typeof e)) return e;
      if (void 0 !== e)
        throw new TypeError("Derived constructors may only return object or undefined");
      return (function (t) {
        if (void 0 === t)
          throw new ReferenceError(
            "this hasn't been initialised - super() hasn't been called"
          );
        return t;
      })(t);
    }
    function h(t, e, n) {
      return (h =
        "undefined" != typeof Reflect && Reflect.get
          ? Reflect.get
          : function (t, e, n) {
              var r = (function (t, e) {
                for (
                  ;
                  !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = a(t));

                );
                return t;
              })(t, e);
              if (r) {
                var i = Object.getOwnPropertyDescriptor(r, e);
                return i.get ? i.get.call(n) : i.value;
              }
            })(t, e, n || t);
    }
    function v(t) {
      return (
        (function (t) {
          if (Array.isArray(t)) return y(t);
        })(t) ||
        (function (t) {
          if (
            ("undefined" != typeof Symbol && null != t[Symbol.iterator]) ||
            null != t["@@iterator"]
          )
            return Array.from(t);
        })(t) ||
        (function (t, e) {
          if (!t) return;
          if ("string" == typeof t) return y(t, e);
          var n = Object.prototype.toString.call(t).slice(8, -1);
          "Object" === n && t.constructor && (n = t.constructor.name);
          if ("Map" === n || "Set" === n) return Array.from(t);
          if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
            return y(t, e);
        })(t) ||
        (function () {
          throw new TypeError(
            "Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
          );
        })()
      );
    }
    function y(t, e) {
      (null == e || e > t.length) && (e = t.length);
      for (var n = 0, r = new Array(e); n < e; n++) r[n] = t[n];
      return r;
    }
    Number.isInteger ||
      (Number.isInteger = function (t) {
        return "number" == typeof t && isFinite(t) && Math.floor(t) === t;
      }),
      Number.EPSILON || (Number.EPSILON = 2220446049250313e-31);
    var d = g(Math.pow(10, -6));
    function g(t) {
      var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 6;
      if (Number.isInteger(t)) return t;
      var n = Math.pow(10, e);
      return Math.round((+t + Number.EPSILON) * n) / n;
    }
    function p(t, e) {
      var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : d;
      return Math.abs(t - e) < n;
    }
    var m = Math.PI / 180;
    function b(t) {
      return t;
    }
    function w(t, e, n) {
      var r = 1 - n;
      return 3 * n * r * (t * r + e * n) + n * n * n;
    }
    function k() {
      var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0,
        e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
        n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1,
        r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 1;
      return t < 0 || t > 1 || n < 0 || n > 1
        ? null
        : p(t, e) && p(n, r)
        ? b
        : function (i) {
            if (i <= 0) return t > 0 ? (i * e) / t : 0 === e && n > 0 ? (i * r) / n : 0;
            if (i >= 1)
              return n < 1
                ? 1 + ((i - 1) * (r - 1)) / (n - 1)
                : 1 === n && t < 1
                ? 1 + ((i - 1) * (e - 1)) / (t - 1)
                : 1;
            for (var o, u = 0, a = 1; u < a; ) {
              var s = w(t, n, (o = (u + a) / 2));
              if (p(i, s)) break;
              s < i ? (u = o) : (a = o);
            }
            return w(e, r, o);
          };
    }
    function _() {
      return 1;
    }
    function A(t) {
      return 1 === t ? 1 : 0;
    }
    function x() {
      var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1,
        e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
      if (1 === t) {
        if (0 === e) return A;
        if (1 === e) return _;
      }
      var n = 1 / t;
      return function (t) {
        return t >= 1 ? 1 : (t += e * n) - (t % n);
      };
    }
    var O = Math.sin,
      S = Math.cos,
      E = Math.acos,
      P = Math.asin,
      j = Math.tan,
      M = Math.atan2,
      B = Math.PI / 180,
      T = 180 / Math.PI,
      I = Math.sqrt,
      R = (function () {
        function t() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1,
            n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
            i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0,
            o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 1,
            u = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 0,
            a = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : 0;
          r(this, t),
            (this.m = [e, n, i, o, u, a]),
            (this.i = null),
            (this.w = null),
            (this.s = null);
        }
        return (
          o(
            t,
            [
              {
                key: "determinant",
                get: function () {
                  var t = this.m;
                  return t[0] * t[3] - t[1] * t[2];
                },
              },
              {
                key: "isIdentity",
                get: function () {
                  if (null === this.i) {
                    var t = this.m;
                    this.i =
                      1 === t[0] &&
                      0 === t[1] &&
                      0 === t[2] &&
                      1 === t[3] &&
                      0 === t[4] &&
                      0 === t[5];
                  }
                  return this.i;
                },
              },
              {
                key: "point",
                value: function (t, e) {
                  var n = this.m;
                  return { x: n[0] * t + n[2] * e + n[4], y: n[1] * t + n[3] * e + n[5] };
                },
              },
              {
                key: "translateSelf",
                value: function () {
                  var t =
                      arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0,
                    e =
                      arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                  if (!t && !e) return this;
                  var n = this.m;
                  return (
                    (n[4] += n[0] * t + n[2] * e),
                    (n[5] += n[1] * t + n[3] * e),
                    (this.w = this.s = this.i = null),
                    this
                  );
                },
              },
              {
                key: "rotateSelf",
                value: function () {
                  var t =
                    arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0;
                  if ((t %= 360)) {
                    var e = O((t *= B)),
                      n = S(t),
                      r = this.m,
                      i = r[0],
                      o = r[1];
                    (r[0] = i * n + r[2] * e),
                      (r[1] = o * n + r[3] * e),
                      (r[2] = r[2] * n - i * e),
                      (r[3] = r[3] * n - o * e),
                      (this.w = this.s = this.i = null);
                  }
                  return this;
                },
              },
              {
                key: "scaleSelf",
                value: function () {
                  var t =
                      arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1,
                    e =
                      arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1;
                  if (1 !== t || 1 !== e) {
                    var n = this.m;
                    (n[0] *= t),
                      (n[1] *= t),
                      (n[2] *= e),
                      (n[3] *= e),
                      (this.w = this.s = this.i = null);
                  }
                  return this;
                },
              },
              {
                key: "skewSelf",
                value: function (t, e) {
                  if (((e %= 360), (t %= 360) || e)) {
                    var n = this.m,
                      r = n[0],
                      i = n[1],
                      o = n[2],
                      u = n[3];
                    t && ((t = j(t * B)), (n[2] += r * t), (n[3] += i * t)),
                      e && ((e = j(e * B)), (n[0] += o * e), (n[1] += u * e)),
                      (this.w = this.s = this.i = null);
                  }
                  return this;
                },
              },
              {
                key: "resetSelf",
                value: function () {
                  var t =
                      arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1,
                    e =
                      arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
                    n =
                      arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0,
                    r =
                      arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 1,
                    i =
                      arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 0,
                    o =
                      arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : 0,
                    u = this.m;
                  return (
                    (u[0] = t),
                    (u[1] = e),
                    (u[2] = n),
                    (u[3] = r),
                    (u[4] = i),
                    (u[5] = o),
                    (this.w = this.s = this.i = null),
                    this
                  );
                },
              },
              {
                key: "recomposeSelf",
                value: function () {
                  var t =
                      arguments.length > 0 && void 0 !== arguments[0]
                        ? arguments[0]
                        : null,
                    e =
                      arguments.length > 1 && void 0 !== arguments[1]
                        ? arguments[1]
                        : null,
                    n =
                      arguments.length > 2 && void 0 !== arguments[2]
                        ? arguments[2]
                        : null,
                    r =
                      arguments.length > 3 && void 0 !== arguments[3]
                        ? arguments[3]
                        : null,
                    i =
                      arguments.length > 4 && void 0 !== arguments[4]
                        ? arguments[4]
                        : null;
                  return (
                    this.isIdentity || this.resetSelf(),
                    t && (t.x || t.y) && this.translateSelf(t.x, t.y),
                    e && this.rotateSelf(e),
                    n && (n.x && this.skewSelf(n.x, 0), n.y && this.skewSelf(0, n.y)),
                    !r || (1 === r.x && 1 === r.y) || this.scaleSelf(r.x, r.y),
                    i && (i.x || i.y) && this.translateSelf(i.x, i.y),
                    this
                  );
                },
              },
              {
                key: "decompose",
                value: function () {
                  var t =
                      arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0,
                    e =
                      arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
                    n = this.m,
                    r = n[0] * n[0] + n[1] * n[1],
                    i = [
                      [n[0], n[1]],
                      [n[2], n[3]],
                    ],
                    o = I(r);
                  if (0 === o)
                    return {
                      origin: { x: g(n[4]), y: g(n[5]) },
                      translate: { x: g(t), y: g(e) },
                      scale: { x: 0, y: 0 },
                      skew: { x: 0, y: 0 },
                      rotate: 0,
                    };
                  (i[0][0] /= o), (i[0][1] /= o);
                  var u = n[0] * n[3] - n[1] * n[2] < 0;
                  u && (o = -o);
                  var a = i[0][0] * i[1][0] + i[0][1] * i[1][1];
                  (i[1][0] -= i[0][0] * a), (i[1][1] -= i[0][1] * a);
                  var s = I(i[1][0] * i[1][0] + i[1][1] * i[1][1]);
                  if (0 === s)
                    return {
                      origin: { x: g(n[4]), y: g(n[5]) },
                      translate: { x: g(t), y: g(e) },
                      scale: { x: g(o), y: 0 },
                      skew: { x: 0, y: 0 },
                      rotate: 0,
                    };
                  (i[1][0] /= s), (i[1][1] /= s), (a /= s);
                  var l = 0;
                  return (
                    i[1][1] < 0
                      ? ((l = E(i[1][1]) * T), i[0][1] < 0 && (l = 360 - l))
                      : (l = P(i[0][1]) * T),
                    u && (l = -l),
                    (a = M(a, I(i[0][0] * i[0][0] + i[0][1] * i[0][1])) * T),
                    u && (a = -a),
                    {
                      origin: { x: g(n[4]), y: g(n[5]) },
                      translate: { x: g(t), y: g(e) },
                      scale: { x: g(o), y: g(s) },
                      skew: { x: g(a), y: 0 },
                      rotate: g(l),
                    }
                  );
                },
              },
              {
                key: "clone",
                value: function () {
                  var t = this.m;
                  return new this.constructor(t[0], t[1], t[2], t[3], t[4], t[5]);
                },
              },
              {
                key: "toString",
                value: function () {
                  var t =
                    arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : " ";
                  if (null === this.s) {
                    var e = this.m.map(function (t) {
                      return g(t);
                    });
                    1 === e[0] && 0 === e[1] && 0 === e[2] && 1 === e[3]
                      ? (this.s = "translate(" + e[4] + t + e[5] + ")")
                      : (this.s = "matrix(" + e.join(t) + ")");
                  }
                  return this.s;
                },
              },
            ],
            [
              {
                key: "create",
                value: function (t) {
                  return t
                    ? Array.isArray(t)
                      ? f(this, v(t))
                      : t instanceof this
                      ? t.clone()
                      : new this().recomposeSelf(
                          t.origin,
                          t.rotate,
                          t.skew,
                          t.scale,
                          t.translate
                        )
                    : new this();
                },
              },
            ]
          ),
          t
        );
      })();
    function N(t, e, n) {
      return t >= 0.5 ? n : e;
    }
    function F(t, e, n) {
      return 0 === t || e === n ? e : t * (n - e) + e;
    }
    function C(t, e, n) {
      var r = F(t, e, n);
      return r <= 0 ? 0 : r;
    }
    function D(t, e, n) {
      var r = F(t, e, n);
      return r <= 0 ? 0 : r >= 1 ? 1 : r;
    }
    function L(t, e, n) {
      return 0 === t ? e : 1 === t ? n : { x: F(t, e.x, n.x), y: F(t, e.y, n.y) };
    }
    function V(t, e, n) {
      return 0 === t ? e : 1 === t ? n : { x: C(t, e.x, n.x), y: C(t, e.y, n.y) };
    }
    function q(t, e, n) {
      var r = (function (t, e, n) {
        return Math.round(F(t, e, n));
      })(t, e, n);
      return r <= 0 ? 0 : r >= 255 ? 255 : r;
    }
    function G(t, e, n) {
      return 0 === t
        ? e
        : 1 === t
        ? n
        : {
            r: q(t, e.r, n.r),
            g: q(t, e.g, n.g),
            b: q(t, e.b, n.b),
            a: F(t, null == e.a ? 1 : e.a, null == n.a ? 1 : n.a),
          };
    }
    function z(t, e, n) {
      var r = e.length;
      if (r !== n.length) return N(t, e, n);
      for (var i = new Array(r), o = 0; o < r; o++) i[o] = F(t, e[o], n[o]);
      return i;
    }
    function Y(t, e) {
      for (var n = [], r = 0; r < t; r++) n.push(e);
      return n;
    }
    function U(t, e) {
      if (--e <= 0) return t;
      var n = (t = Object.assign([], t)).length;
      do {
        for (var r = 0; r < n; r++) t.push(t[r]);
      } while (--e > 0);
      return t;
    }
    var W,
      $ = (function () {
        function t(e) {
          r(this, t), (this.list = e), (this.length = e.length);
        }
        return (
          o(t, [
            {
              key: "setAttribute",
              value: function (t, e) {
                for (var n = this.list, r = 0; r < this.length; r++)
                  n[r].setAttribute(t, e);
              },
            },
            {
              key: "removeAttribute",
              value: function (t) {
                for (var e = this.list, n = 0; n < this.length; n++)
                  e[n].removeAttribute(t);
              },
            },
            {
              key: "style",
              value: function (t, e) {
                for (var n = this.list, r = 0; r < this.length; r++) n[r].style[t] = e;
              },
            },
          ]),
          t
        );
      })(),
      H = /-./g,
      Q = function (t, e) {
        return e.toUpperCase();
      };
    function X(t) {
      return "function" == typeof t ? t : N;
    }
    function J(t) {
      return t
        ? "function" == typeof t
          ? t
          : Array.isArray(t)
          ? (function (t) {
              var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : b;
              if (!Array.isArray(t)) return e;
              switch (t.length) {
                case 1:
                  return x(t[0]) || e;
                case 2:
                  return x(t[0], t[1]) || e;
                case 4:
                  return k(t[0], t[1], t[2], t[3]) || e;
              }
              return e;
            })(t, null)
          : (function (t, e) {
              var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : b;
              switch (t) {
                case "linear":
                  return b;
                case "steps":
                  return x(e.steps || 1, e.jump || 0) || n;
                case "bezier":
                case "cubic-bezier":
                  return k(e.x1 || 0, e.y1 || 0, e.x2 || 0, e.y2 || 0) || n;
              }
              return n;
            })(t.type, t.value, null)
        : null;
    }
    function K(t, e, n) {
      var r = arguments.length > 3 && void 0 !== arguments[3] && arguments[3],
        i = e.length - 1;
      if (t <= e[0].t) return r ? [0, 0, e[0].v] : e[0].v;
      if (t >= e[i].t) return r ? [i, 1, e[i].v] : e[i].v;
      var o,
        u = e[0],
        a = null;
      for (o = 1; o <= i; o++) {
        if (!(t > e[o].t)) {
          a = e[o];
          break;
        }
        u = e[o];
      }
      return null == a
        ? r
          ? [i, 1, e[i].v]
          : e[i].v
        : u.t === a.t
        ? r
          ? [o, 1, a.v]
          : a.v
        : ((t = (t - u.t) / (a.t - u.t)),
          u.e && (t = u.e(t)),
          r ? [o, t, n(t, u.v, a.v)] : n(t, u.v, a.v));
    }
    function Z(t, e) {
      var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null;
      return t && t.length
        ? "function" != typeof e
          ? null
          : ("function" != typeof n && (n = null),
            function (r) {
              var i = K(r, t, e);
              return null != i && n && (i = n(i)), i;
            })
        : null;
    }
    function tt(t, e) {
      return t.t - e.t;
    }
    function et(t, e, r, i, o) {
      var u,
        a = "@" === r[0],
        s = "#" === r[0],
        l = W[r],
        f = N;
      switch (
        (a ? ((u = r.substr(1)), (r = u.replace(H, Q))) : s && (r = r.substr(1)), n(l))
      ) {
        case "function":
          if (((f = l(i, o, K, J, r, a, e, t)), s)) return f;
          break;
        case "string":
          f = Z(i, X(l));
          break;
        case "object":
          if ((f = Z(i, X(l.i), l.f)) && "function" == typeof l.u)
            return l.u(e, f, r, a, t);
      }
      return f
        ? (function (t, e, n) {
            if (arguments.length > 3 && void 0 !== arguments[3] && arguments[3])
              return t instanceof $
                ? function (r) {
                    return t.style(e, n(r));
                  }
                : function (r) {
                    return (t.style[e] = n(r));
                  };
            if (Array.isArray(e)) {
              var r = e.length;
              return function (i) {
                var o = n(i);
                if (null == o) for (var u = 0; u < r; u++) t[u].removeAttribute(e);
                else for (var a = 0; a < r; a++) t[a].setAttribute(e, o);
              };
            }
            return function (r) {
              var i = n(r);
              null == i ? t.removeAttribute(e) : t.setAttribute(e, i);
            };
          })(e, r, f, a)
        : null;
    }
    function nt(t, e, r, i) {
      if (!i || "object" !== n(i)) return null;
      var o = null,
        u = null;
      return (
        Array.isArray(i)
          ? (u = (function (t) {
              if (!t || !t.length) return null;
              for (var e = 0; e < t.length; e++) t[e].e && (t[e].e = J(t[e].e));
              return t.sort(tt);
            })(i))
          : ((u = i.keys), (o = i.data || null)),
        u ? et(t, e, r, u, o) : null
      );
    }
    function rt(t, e, n) {
      if (!n) return null;
      var r = [];
      for (var i in n)
        if (n.hasOwnProperty(i)) {
          var o = nt(t, e, i, n[i]);
          o && r.push(o);
        }
      return r.length ? r : null;
    }
    function it(t, e) {
      if (!e.settings.duration || e.settings.duration < 0) return null;
      var n,
        r,
        i,
        o,
        u,
        a = (function (t, e) {
          if (!e) return null;
          var n = [];
          if (Array.isArray(e))
            for (var r = e.length, i = 0; i < r; i++) {
              var o = e[i];
              if (2 === o.length) {
                var u = null;
                if ("string" == typeof o[0]) u = t.getElementById(o[0]);
                else if (Array.isArray(o[0])) {
                  u = [];
                  for (var a = 0; a < o[0].length; a++)
                    if ("string" == typeof o[0][a]) {
                      var s = t.getElementById(o[0][a]);
                      s && u.push(s);
                    }
                  u = u.length ? (1 === u.length ? u[0] : new $(u)) : null;
                }
                if (u) {
                  var l = rt(t, u, o[1]);
                  l && (n = n.concat(l));
                }
              }
            }
          else
            for (var f in e)
              if (e.hasOwnProperty(f)) {
                var c = t.getElementById(f);
                if (c) {
                  var h = rt(t, c, e[f]);
                  h && (n = n.concat(h));
                }
              }
          return n.length ? n : null;
        })(t, e.elements);
      return a
        ? ((n = a),
          (r = e.settings),
          (i = r.duration),
          (o = n.length),
          (u = null),
          function (t, e) {
            var a = r.iterations || 1 / 0,
              s = (r.alternate && a % 2 == 0) ^ (r.direction > 0) ? i : 0,
              l = t % i,
              f = 1 + (t - l) / i;
            (e *= r.direction), r.alternate && f % 2 == 0 && (e = -e);
            var c = !1;
            if (f > a) (l = s), (c = !0), -1 === r.fill && (l = r.direction > 0 ? 0 : i);
            else if ((e < 0 && (l = i - l), l === u)) return !1;
            u = l;
            for (var h = 0; h < o; h++) n[h](l);
            return c;
          })
        : null;
    }
    function ot(t, e) {
      if (((W = e), !t || !t.root || !Array.isArray(t.animations))) return null;
      var n = (function (t) {
        for (var e = document.getElementsByTagName("svg"), n = 0; n < e.length; n++)
          if (e[n].id === t.root && !e[n].svgatorAnimation)
            return (e[n].svgatorAnimation = !0), e[n];
        return null;
      })(t);
      if (!n) return null;
      var r = t.animations
        .map(function (t) {
          return it(n, t);
        })
        .filter(function (t) {
          return !!t;
        });
      return r.length
        ? {
            svg: n,
            animations: r,
            animationSettings: t.animationSettings,
            options: t.options || void 0,
          }
        : null;
    }
    function ut(t) {
      return +("0x" + (t.replace(/[^0-9a-fA-F]+/g, "") || 27));
    }
    function at(t, e, n) {
      return !t || !n || e > t.length
        ? t
        : t.substring(0, e) + at(t.substring(e + 1), n, n);
    }
    function st(t) {
      var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 27;
      return !t || t % e ? t % e : st(t / e, e);
    }
    function lt(t, e, n) {
      if (t && t.length) {
        var r = ut(n),
          i = ut(e),
          o = st(r) + 5,
          u = at(t, st(r, 5), o);
        return (
          (u = u.replace(/\x7c$/g, "==").replace(/\x2f$/g, "=")),
          (u = (function (t, e, n) {
            var r = +("0x" + t.substring(0, 4));
            t = t.substring(4);
            for (var i = (e % r) + (n % 27), o = [], u = 0; u < t.length; u += 2)
              if ("|" !== t[u]) {
                var a = +("0x" + t[u] + t[u + 1]) - i;
                o.push(a);
              } else {
                var s = +("0x" + t.substring(u + 1, u + 1 + 4)) - i;
                (u += 3), o.push(s);
              }
            return String.fromCharCode.apply(String, o);
          })((u = (u = atob(u)).replace(/[\x41-\x5A]/g, "")), i, r)),
          (u = JSON.parse(u))
        );
      }
    }
    var ft = [
        { key: "alternate", def: !1 },
        { key: "fill", def: 1 },
        { key: "iterations", def: 0 },
        { key: "direction", def: 1 },
        { key: "speed", def: 1 },
        { key: "fps", def: 100 },
      ],
      ct = (function () {
        function t(e, n) {
          var i = this,
            o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null;
          r(this, t),
            (this._id = 0),
            (this._running = !1),
            (this._rollingBack = !1),
            (this._animations = e),
            (this._settings = n),
            (!o || o < "2022-05-02") && delete this._settings.speed,
            ft.forEach(function (t) {
              i._settings[t.key] = i._settings[t.key] || t.def;
            }),
            (this.duration = n.duration),
            (this.offset = n.offset || 0),
            (this.rollbackStartOffset = 0);
        }
        return (
          o(
            t,
            [
              {
                key: "alternate",
                get: function () {
                  return this._settings.alternate;
                },
              },
              {
                key: "fill",
                get: function () {
                  return this._settings.fill;
                },
              },
              {
                key: "iterations",
                get: function () {
                  return this._settings.iterations;
                },
              },
              {
                key: "direction",
                get: function () {
                  return this._settings.direction;
                },
              },
              {
                key: "speed",
                get: function () {
                  return this._settings.speed;
                },
              },
              {
                key: "fps",
                get: function () {
                  return this._settings.fps;
                },
              },
              {
                key: "maxFiniteDuration",
                get: function () {
                  return this.iterations > 0
                    ? this.iterations * this.duration
                    : this.duration;
                },
              },
              {
                key: "_apply",
                value: function (t) {
                  for (
                    var e =
                        arguments.length > 1 && void 0 !== arguments[1]
                          ? arguments[1]
                          : {},
                      n = this._animations,
                      r = n.length,
                      i = 0,
                      o = 0;
                    o < r;
                    o++
                  )
                    e[o] ? i++ : ((e[o] = n[o](t, 1)), e[o] && i++);
                  return i;
                },
              },
              {
                key: "_rollback",
                value: function (t) {
                  var e = this,
                    n = 1 / 0,
                    r = null;
                  (this.rollbackStartOffset = t),
                    (this._rollingBack = !0),
                    (this._running = !0);
                  this._id = window.requestAnimationFrame(function i(o) {
                    if (e._rollingBack) {
                      null == r && (r = o);
                      var u = Math.round(t - (o - r) * e.speed);
                      if (u > e.duration && n !== 1 / 0) {
                        var a = !!e.alternate && (u / e.duration) % 2 > 1,
                          s = u % e.duration;
                        u = (s += a ? e.duration : 0) || e.duration;
                      }
                      var l = (e.fps ? 1e3 / e.fps : 0) * e.speed,
                        f = Math.max(0, u);
                      f <= n - l && ((e.offset = f), (n = f), e._apply(f));
                      var c =
                        e.iterations > 0 && -1 === e.fill && u >= e.maxFiniteDuration;
                      (u <= 0 || e.offset < u || c) && e.stop(),
                        (e._id = window.requestAnimationFrame(i));
                    }
                  });
                },
              },
              {
                key: "_start",
                value: function () {
                  var t = this,
                    e =
                      arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0,
                    n = -1 / 0,
                    r = null,
                    i = {};
                  this._running = !0;
                  var o = function o(u) {
                    null == r && (r = u);
                    var a = Math.round((u - r) * t.speed + e),
                      s = (t.fps ? 1e3 / t.fps : 0) * t.speed;
                    if (
                      a >= n + s &&
                      !t._rollingBack &&
                      ((t.offset = a), (n = a), t._apply(a, i) === t._animations.length)
                    )
                      return void t.pause(!0);
                    t._id = window.requestAnimationFrame(o);
                  };
                  this._id = window.requestAnimationFrame(o);
                },
              },
              {
                key: "_pause",
                value: function () {
                  this._id && window.cancelAnimationFrame(this._id), (this._running = !1);
                },
              },
              {
                key: "play",
                value: function () {
                  if (!this._running)
                    return this._rollingBack
                      ? this._rollback(this.offset)
                      : this._start(this.offset);
                },
              },
              {
                key: "stop",
                value: function () {
                  this._pause(),
                    (this.offset = 0),
                    (this.rollbackStartOffset = 0),
                    (this._rollingBack = !1),
                    this._apply(0);
                },
              },
              {
                key: "reachedToEnd",
                value: function () {
                  return (
                    this.iterations > 0 && this.offset >= this.iterations * this.duration
                  );
                },
              },
              {
                key: "restart",
                value: function () {
                  var t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                  this.stop(t), this.play(t);
                },
              },
              {
                key: "pause",
                value: function () {
                  this._pause();
                },
              },
              {
                key: "reverse",
                value: function () {
                  this.direction = -this.direction;
                },
              },
            ],
            [
              {
                key: "build",
                value: function (t, e) {
                  delete t.animationSettings,
                    (t.options = lt(t.options, t.root, "91c80d77")),
                    t.animations.map(function (e) {
                      (e.settings = lt(e.s, t.root, "91c80d77")),
                        delete e.s,
                        t.animationSettings || (t.animationSettings = e.settings);
                    });
                  var n = t.version;
                  if (!(t = ot(t, e))) return null;
                  var r = t.options || {},
                    i = new this(t.animations, t.animationSettings, n);
                  return { el: t.svg, options: r, player: i };
                },
              },
              {
                key: "push",
                value: function (t) {
                  return this.build(t);
                },
              },
              {
                key: "init",
                value: function () {
                  var t = this,
                    e =
                      window.__SVGATOR_PLAYER__ && window.__SVGATOR_PLAYER__["91c80d77"];
                  Array.isArray(e) &&
                    e.splice(0).forEach(function (e) {
                      return t.build(e);
                    });
                },
              },
            ]
          ),
          t
        );
      })();
    !(function () {
      for (
        var t = 0, e = ["ms", "moz", "webkit", "o"], n = 0;
        n < e.length && !window.requestAnimationFrame;
        ++n
      )
        (window.requestAnimationFrame = window[e[n] + "RequestAnimationFrame"]),
          (window.cancelAnimationFrame =
            window[e[n] + "CancelAnimationFrame"] ||
            window[e[n] + "CancelRequestAnimationFrame"]);
      window.requestAnimationFrame ||
        ((window.requestAnimationFrame = function (e) {
          var n = Date.now(),
            r = Math.max(0, 16 - (n - t)),
            i = window.setTimeout(function () {
              e(n + r);
            }, r);
          return (t = n + r), i;
        }),
        (window.cancelAnimationFrame = window.clearTimeout));
    })();
    var ht = (function () {
      function t(e, n, i) {
        r(this, t);
        var o = (function (t) {
          var e,
            n,
            r,
            i =
              t &&
              1 ===
                (null === (e = t.ownerDocument) ||
                void 0 === e ||
                null === (n = e.childNodes) ||
                void 0 === n
                  ? void 0
                  : n.length) &&
              window.parent !== window,
            o = { el: t, window: window };
          if (!i) return o;
          try {
            r = window.parent.document;
          } catch (t) {
            return o;
          }
          return (
            (o.window = window.parent),
            (o.el =
              Array.from(r.querySelectorAll("iframe,object")).filter(function (t) {
                return t.contentWindow === window;
              })[0] || o.el),
            o
          );
        })(e);
        (n = Math.max(1, n || 1)),
          (n = Math.min(n, 100)),
          (this.el = o.el),
          (this._handlers = []),
          (this.onThresholdChange = i && i.call ? i : function () {}),
          (this.thresholdPercent = n || 1),
          (this.currentVisibility = null),
          (this.visibilityCalculator = (function (t, e) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : n,
              r = !1,
              i = null,
              o = function () {
                for (
                  var o = 0, u = n.innerHeight, a = 0, s = n.innerWidth, l = t.parentNode;
                  l instanceof Element;

                ) {
                  var f = n.getComputedStyle(l);
                  if ("visible" !== f.overflowY || "visible" !== f.overflowX) {
                    var c = l.getBoundingClientRect();
                    "visible" !== f.overflowY &&
                      ((o = Math.max(o, c.top)), (u = Math.min(u, c.bottom))),
                      "visible" !== f.overflowX &&
                        ((a = Math.max(a, c.left)), (s = Math.min(s, c.right)));
                  }
                  if (l === l.parentNode) break;
                  l = l.parentNode;
                }
                r = !1;
                var h = t.getBoundingClientRect(),
                  v = Math.min(h.height, Math.max(0, o - h.top)),
                  y = Math.min(h.height, Math.max(0, h.bottom - u)),
                  d = Math.min(h.width, Math.max(0, a - h.left)),
                  g = Math.min(h.width, Math.max(0, h.right - s)),
                  p = (h.height - v - y) / h.height,
                  m = (h.width - d - g) / h.width,
                  b = Math.round(p * m * 100);
                (null !== i && i === b) || ((i = b), e(b));
              };
            return function (t) {
              r && clearTimeout(r),
                (r = setTimeout(function () {
                  return o();
                }, 100));
            };
          })(this.el, this.onVisibilityUpdate.bind(this), o.window)),
          this.bindScrollWatchers(),
          this.visibilityCalculator();
      }
      return (
        o(t, [
          {
            key: "bindScrollWatchers",
            value: function () {
              for (
                var t = this.el.parentNode;
                t &&
                (this._handlers.push({
                  element: t,
                  event: "scroll",
                  handler: this.visibilityCalculator,
                }),
                t.addEventListener("scroll", this.visibilityCalculator),
                t !== t.parentNode && t !== document);

              )
                t = t.parentNode;
            },
          },
          {
            key: "onVisibilityUpdate",
            value: function (t) {
              var e = this.currentVisibility >= this.thresholdPercent,
                n = t >= this.thresholdPercent;
              if (null === this.currentVisibility || e !== n)
                return (this.currentVisibility = t), void this.onThresholdChange(n);
              this.currentVisibility = t;
            },
          },
          {
            key: "destruct",
            value: function () {
              this._handlers.forEach(function (t) {
                t.element.removeEventListener(t.event, t.handler);
              });
            },
          },
        ]),
        t
      );
    })();
    function vt(t) {
      return g(t) + "";
    }
    function yt(t) {
      var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : " ";
      return t && t.length ? t.map(vt).join(e) : "";
    }
    function dt(t) {
      return vt(t.x) + "," + vt(t.y);
    }
    function gt(t) {
      if (!t) return "transparent";
      if (null == t.a || t.a >= 1) {
        var e = function (t) {
            return 1 === (t = parseInt(t).toString(16)).length ? "0" + t : t;
          },
          n = function (t) {
            return t.charAt(0) === t.charAt(1);
          },
          r = e(t.r),
          i = e(t.g),
          o = e(t.b);
        return (
          n(r) &&
            n(i) &&
            n(o) &&
            ((r = r.charAt(0)), (i = i.charAt(0)), (o = o.charAt(0))),
          "#" + r + i + o
        );
      }
      return "rgba(" + t.r + "," + t.g + "," + t.b + "," + t.a + ")";
    }
    function pt(t) {
      return t ? "url(#" + t + ")" : "none";
    }
    var mt = {
        f: null,
        i: V,
        u: function (t, e) {
          return function (n) {
            var r = e(n);
            t.setAttribute("rx", vt(r.x)), t.setAttribute("ry", vt(r.y));
          };
        },
      },
      bt = {
        f: null,
        i: function (t, e, n) {
          return 0 === t
            ? e
            : 1 === t
            ? n
            : { width: C(t, e.width, n.width), height: C(t, e.height, n.height) };
        },
        u: function (t, e) {
          return function (n) {
            var r = e(n);
            t.setAttribute("width", vt(r.width)), t.setAttribute("height", vt(r.height));
          };
        },
      };
    Object.freeze({ M: 2, L: 2, Z: 0, H: 1, V: 1, C: 6, Q: 4, T: 2, S: 4, A: 7 });
    var wt = {},
      kt = null;
    function _t(t) {
      var e = (function () {
        if (kt) return kt;
        if (
          "object" !== ("undefined" == typeof document ? "undefined" : n(document)) ||
          !document.createElementNS
        )
          return {};
        var t = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        return t && t.style
          ? ((t.style.position = "absolute"),
            (t.style.opacity = "0.01"),
            (t.style.zIndex = "-9999"),
            (t.style.left = "-9999px"),
            (t.style.width = "1px"),
            (t.style.height = "1px"),
            (kt = { svg: t }))
          : {};
      })().svg;
      if (!e)
        return function (t) {
          return null;
        };
      var r = document.createElementNS(e.namespaceURI, "path");
      r.setAttributeNS(null, "d", t),
        r.setAttributeNS(null, "fill", "none"),
        r.setAttributeNS(null, "stroke", "none"),
        e.appendChild(r);
      var i = r.getTotalLength();
      return function (t) {
        var e = r.getPointAtLength(i * t);
        return { x: e.x, y: e.y };
      };
    }
    function At(t) {
      return wt[t] ? wt[t] : (wt[t] = _t(t));
    }
    function xt(t, e, n, r) {
      if (!t || !r) return !1;
      var i = ["M", t.x, t.y];
      if (
        (e && n && (i.push("C"), i.push(e.x), i.push(e.y), i.push(n.x), i.push(n.y)),
        e ? !n : n)
      ) {
        var o = e || n;
        i.push("Q"), i.push(o.x), i.push(o.y);
      }
      return e || n || i.push("L"), i.push(r.x), i.push(r.y), i.join(" ");
    }
    function Ot(t, e, n, r) {
      var i = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 1,
        o = xt(t, e, n, r),
        u = At(o);
      try {
        return u(i);
      } catch (t) {
        return null;
      }
    }
    function St(t, e, n) {
      return t + (e - t) * n;
    }
    function Et(t, e, n) {
      var r = arguments.length > 3 && void 0 !== arguments[3] && arguments[3],
        i = { x: St(t.x, e.x, n), y: St(t.y, e.y, n) };
      return r && (i.a = Pt(t, e)), i;
    }
    function Pt(t, e) {
      return Math.atan2(e.y - t.y, e.x - t.x);
    }
    function jt(t, e, n, r) {
      var i = 1 - r;
      return i * i * t + 2 * i * r * e + r * r * n;
    }
    function Mt(t, e, n, r) {
      return 2 * (1 - r) * (e - t) + 2 * r * (n - e);
    }
    function Bt(t, e, n, r) {
      var i = arguments.length > 4 && void 0 !== arguments[4] && arguments[4],
        o = Ot(t, e, null, n, r);
      return (
        o || (o = { x: jt(t.x, e.x, n.x, r), y: jt(t.y, e.y, n.y, r) }),
        i && (o.a = Tt(t, e, n, r)),
        o
      );
    }
    function Tt(t, e, n, r) {
      return Math.atan2(Mt(t.y, e.y, n.y, r), Mt(t.x, e.x, n.x, r));
    }
    function It(t, e, n, r, i) {
      var o = i * i;
      return (
        i * o * (r - t + 3 * (e - n)) + 3 * o * (t + n - 2 * e) + 3 * i * (e - t) + t
      );
    }
    function Rt(t, e, n, r, i) {
      var o = 1 - i;
      return 3 * (o * o * (e - t) + 2 * o * i * (n - e) + i * i * (r - n));
    }
    function Nt(t, e, n, r, i) {
      var o = arguments.length > 5 && void 0 !== arguments[5] && arguments[5],
        u = Ot(t, e, n, r, i);
      return (
        u || (u = { x: It(t.x, e.x, n.x, r.x, i), y: It(t.y, e.y, n.y, r.y, i) }),
        o && (u.a = Ft(t, e, n, r, i)),
        u
      );
    }
    function Ft(t, e, n, r, i) {
      return Math.atan2(Rt(t.y, e.y, n.y, r.y, i), Rt(t.x, e.x, n.x, r.x, i));
    }
    function Ct(t, e, n) {
      var r = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];
      if (Lt(e)) {
        if (Vt(n)) return Bt(e, n.start, n, t, r);
      } else if (Lt(n)) {
        if (qt(e)) return Bt(e, e.end, n, t, r);
      } else {
        if (qt(e)) return Vt(n) ? Nt(e, e.end, n.start, n, t, r) : Bt(e, e.end, n, t, r);
        if (Vt(n)) return Bt(e, n.start, n, t, r);
      }
      return Et(e, n, t, r);
    }
    function Dt(t, e, n) {
      var r = Ct(t, e, n, !0);
      return (
        (r.a =
          (function (t) {
            return arguments.length > 1 && void 0 !== arguments[1] && arguments[1]
              ? t + Math.PI
              : t;
          })(r.a) / m),
        r
      );
    }
    function Lt(t) {
      return !t.type || "corner" === t.type;
    }
    function Vt(t) {
      return null != t.start && !Lt(t);
    }
    function qt(t) {
      return null != t.end && !Lt(t);
    }
    var Gt = new R();
    var zt = {
        f: function (t) {
          return t ? t.join(" ") : "";
        },
        i: function (t, e, r) {
          if (0 === t) return e;
          if (1 === t) return r;
          var i = e.length;
          if (i !== r.length) return N(t, e, r);
          for (var o, u = new Array(i), a = 0; a < i; a++) {
            if ((o = n(e[a])) !== n(r[a])) return N(t, e, r);
            if ("number" === o) u[a] = F(t, e[a], r[a]);
            else {
              if (e[a] !== r[a]) return N(t, e, r);
              u[a] = e[a];
            }
          }
          return u;
        },
      },
      Yt = {
        f: null,
        i: z,
        u: function (t, e) {
          return function (n) {
            var r = e(n);
            t.setAttribute("x1", vt(r[0])),
              t.setAttribute("y1", vt(r[1])),
              t.setAttribute("x2", vt(r[2])),
              t.setAttribute("y2", vt(r[3]));
          };
        },
      },
      Ut = { f: vt, i: F },
      Wt = { f: vt, i: D },
      $t = {
        f: function (t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : " ";
          return (
            t &&
              t.length > 0 &&
              (t = t.map(function (t) {
                return g(t, 4);
              })),
            yt(t, e)
          );
        },
        i: function (t, e, n) {
          var r,
            i,
            o,
            u = e.length,
            a = n.length;
          if (u !== a)
            if (0 === u) e = Y((u = a), 0);
            else if (0 === a) (a = u), (n = Y(u, 0));
            else {
              var s =
                (o =
                  ((r = u) * (i = a)) /
                  (function (t, e) {
                    for (var n; e; ) (n = e), (e = t % e), (t = n);
                    return t || 1;
                  })(r, i)) < 0
                  ? -o
                  : o;
              (e = U(e, Math.floor(s / u))), (n = U(n, Math.floor(s / a))), (u = a = s);
            }
          for (var l = [], f = 0; f < u; f++) l.push(g(C(t, e[f], n[f])));
          return l;
        },
      };
    function Ht(t, e, n) {
      return t.map(function (t) {
        return (function (t, e, n) {
          var r = t.v;
          if (!r || "g" !== r.t || r.s || !r.v || !r.r) return t;
          var i = n.getElementById(r.r),
            o = (i && i.querySelectorAll("stop")) || [];
          return (
            (r.s = r.v.map(function (t, e) {
              var n = o[e] && o[e].getAttribute("offset");
              return { c: t, o: (n = g(parseInt(n) / 100)) };
            })),
            delete r.v,
            t
          );
        })(t, 0, n);
      });
    }
    var Qt = {
      gt: "gradientTransform",
      c: { x: "cx", y: "cy" },
      rd: "r",
      f: { x: "x1", y: "y1" },
      to: { x: "x2", y: "y2" },
    };
    function Xt(t, e, r, i, o, u, a, s) {
      return (
        Ht(t, 0, s),
        (e = (function (t, e, n) {
          for (var r, i, o, u = t.length - 1, a = {}, s = 0; s <= u; s++)
            (r = t[s]).e && (r.e = e(r.e)),
              r.v &&
                "g" === (i = r.v).t &&
                i.r &&
                (o = n.getElementById(i.r)) &&
                (a[i.r] = { e: o, s: o.querySelectorAll("stop") });
          return a;
        })(t, i, s)),
        function (i) {
          var o = r(i, t, Jt);
          if (!o) return "none";
          if ("c" === o.t) return gt(o.v);
          if ("g" === o.t) {
            if (!e[o.r]) return pt(o.r);
            var u = e[o.r];
            return (
              (function (t, e) {
                for (var n = t.s, r = n.length; r < e.length; r++) {
                  var i = n[n.length - 1].cloneNode();
                  (i.id = te(i.id)),
                    t.e.appendChild(i),
                    (n = t.s = t.e.querySelectorAll("stop"));
                }
                for (var o = 0, u = n.length, a = e.length - 1; o < u; o++)
                  n[o].setAttribute("stop-color", gt(e[Math.min(o, a)].c)),
                    n[o].setAttribute("offset", e[Math.min(o, a)].o);
              })(u, o.s),
              Object.keys(Qt).forEach(function (t) {
                if (void 0 !== o[t])
                  if ("object" !== n(Qt[t])) {
                    var e,
                      r =
                        "gt" === t
                          ? ((e = o[t]),
                            Array.isArray(e) ? "matrix(" + e.join(" ") + ")" : "")
                          : o[t],
                      i = Qt[t];
                    u.e.setAttribute(i, r);
                  } else
                    Object.keys(Qt[t]).forEach(function (e) {
                      if (void 0 !== o[t][e]) {
                        var n = o[t][e],
                          r = Qt[t][e];
                        u.e.setAttribute(r, n);
                      }
                    });
              }),
              pt(o.r)
            );
          }
          return "none";
        }
      );
    }
    function Jt(t, n, r) {
      if (0 === t) return n;
      if (1 === t) return r;
      if (n && r) {
        var i = n.t;
        if (i === r.t)
          switch (n.t) {
            case "c":
              return { t: i, v: G(t, n.v, r.v) };
            case "g":
              if (n.r === r.r) {
                var o = { t: i, s: Kt(t, n.s, r.s), r: n.r };
                return (
                  n.gt && r.gt && (o.gt = z(t, n.gt, r.gt)),
                  n.c
                    ? ((o.c = L(t, n.c, r.c)), (o.rd = C(t, n.rd, r.rd)))
                    : n.f && ((o.f = L(t, n.f, r.f)), (o.to = L(t, n.to, r.to))),
                  o
                );
              }
          }
        if (("c" === n.t && "g" === r.t) || ("c" === r.t && "g" === n.t)) {
          var u = "c" === n.t ? n : r,
            a = "g" === n.t ? e({}, n) : e({}, r),
            s = a.s.map(function (t) {
              return { c: u.v, o: t.o };
            });
          return (a.s = "c" === n.t ? Kt(t, s, a.s) : Kt(t, a.s, s)), a;
        }
      }
      return N(t, n, r);
    }
    function Kt(t, e, n) {
      if (e.length === n.length)
        return e.map(function (e, r) {
          return Zt(t, e, n[r]);
        });
      for (var r = Math.max(e.length, n.length), i = [], o = 0; o < r; o++) {
        var u = Zt(t, e[Math.min(o, e.length - 1)], n[Math.min(o, n.length - 1)]);
        i.push(u);
      }
      return i;
    }
    function Zt(t, e, n) {
      return { o: D(t, e.o, n.o || 0), c: G(t, e.c, n.c || {}) };
    }
    function te(t) {
      return t.replace(/-fill-([0-9]+)$/, function (t, e) {
        return "-fill-" + (+e + 1);
      });
    }
    var ee = {
      blur: V,
      brightness: C,
      contrast: C,
      "drop-shadow": function (t, e, n) {
        return 0 === t
          ? e
          : 1 === t
          ? n
          : {
              blur: V(t, e.blur, n.blur),
              offset: L(t, e.offset, n.offset),
              color: G(t, e.color, n.color),
            };
      },
      grayscale: C,
      "hue-rotate": F,
      invert: C,
      opacity: C,
      saturate: C,
      sepia: C,
    };
    function ne(t, e, n) {
      if (0 === t) return e;
      if (1 === t) return n;
      var r = e.length;
      if (r !== n.length) return N(t, e, n);
      for (var i, o = [], u = 0; u < r; u++) {
        if (e[u].type !== n[u].type) return e;
        if (!(i = ee[e[u].type])) return N(t, e, n);
        o.push({ type: e.type, value: i(t, e[u].value, n[u].value) });
      }
      return o;
    }
    var re = {
      blur: function (t) {
        return t
          ? function (e) {
              t.setAttribute("stdDeviation", dt(e));
            }
          : null;
      },
      brightness: function (t, e, n) {
        return (t = oe(n, e))
          ? function (e) {
              (e = vt(e)),
                t.map(function (t) {
                  return t.setAttribute("slope", e);
                });
            }
          : null;
      },
      contrast: function (t, e, n) {
        return (t = oe(n, e))
          ? function (e) {
              var n = vt((1 - e) / 2);
              (e = vt(e)),
                t.map(function (t) {
                  t.setAttribute("slope", e), t.setAttribute("intercept", n);
                });
            }
          : null;
      },
      "drop-shadow": function (t, e, n) {
        var r = n.getElementById(e + "-blur");
        if (!r) return null;
        var i = n.getElementById(e + "-offset");
        if (!i) return null;
        var o = n.getElementById(e + "-flood");
        return o
          ? function (t) {
              r.setAttribute("stdDeviation", dt(t.blur)),
                i.setAttribute("dx", vt(t.offset.x)),
                i.setAttribute("dy", vt(t.offset.y)),
                o.setAttribute("flood-color", gt(t.color));
            }
          : null;
      },
      grayscale: function (t) {
        return t
          ? function (e) {
              t.setAttribute(
                "values",
                yt(
                  (function (t) {
                    return [
                      0.2126 + 0.7874 * (t = 1 - t),
                      0.7152 - 0.7152 * t,
                      0.0722 - 0.0722 * t,
                      0,
                      0,
                      0.2126 - 0.2126 * t,
                      0.7152 + 0.2848 * t,
                      0.0722 - 0.0722 * t,
                      0,
                      0,
                      0.2126 - 0.2126 * t,
                      0.7152 - 0.7152 * t,
                      0.0722 + 0.9278 * t,
                      0,
                      0,
                      0,
                      0,
                      0,
                      1,
                      0,
                    ];
                  })(e)
                )
              );
            }
          : null;
      },
      "hue-rotate": function (t) {
        return t
          ? function (e) {
              return t.setAttribute("values", vt(e));
            }
          : null;
      },
      invert: function (t, e, n) {
        return (t = oe(n, e))
          ? function (e) {
              (e = vt(e) + " " + vt(1 - e)),
                t.map(function (t) {
                  return t.setAttribute("tableValues", e);
                });
            }
          : null;
      },
      opacity: function (t, e, n) {
        return (t = n.getElementById(e + "-A"))
          ? function (e) {
              return t.setAttribute("tableValues", "0 " + vt(e));
            }
          : null;
      },
      saturate: function (t) {
        return t
          ? function (e) {
              return t.setAttribute("values", vt(e));
            }
          : null;
      },
      sepia: function (t) {
        return t
          ? function (e) {
              return t.setAttribute(
                "values",
                yt(
                  (function (t) {
                    return [
                      0.393 + 0.607 * (t = 1 - t),
                      0.769 - 0.769 * t,
                      0.189 - 0.189 * t,
                      0,
                      0,
                      0.349 - 0.349 * t,
                      0.686 + 0.314 * t,
                      0.168 - 0.168 * t,
                      0,
                      0,
                      0.272 - 0.272 * t,
                      0.534 - 0.534 * t,
                      0.131 + 0.869 * t,
                      0,
                      0,
                      0,
                      0,
                      0,
                      1,
                      0,
                    ];
                  })(e)
                )
              );
            }
          : null;
      },
    };
    var ie = ["R", "G", "B"];
    function oe(t, e) {
      var n = ie.map(function (n) {
        return t.getElementById(e + "-" + n) || null;
      });
      return -1 !== n.indexOf(null) ? null : n;
    }
    var ue = {
        fill: Xt,
        "fill-opacity": Wt,
        stroke: Xt,
        "stroke-opacity": Wt,
        "stroke-width": Ut,
        "stroke-dashoffset": { f: vt, i: F },
        "stroke-dasharray": $t,
        opacity: Wt,
        transform: function (t, e, r, i) {
          if (
            !(t = (function (t, e) {
              if (!t || "object" !== n(t)) return null;
              var r = !1;
              for (var i in t)
                t.hasOwnProperty(i) &&
                  (t[i] && t[i].length
                    ? (t[i].forEach(function (t) {
                        t.e && (t.e = e(t.e));
                      }),
                      (r = !0))
                    : delete t[i]);
              return r ? t : null;
            })(t, i))
          )
            return null;
          var o = function (n, i, o) {
            var u = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null;
            return t[n] ? r(i, t[n], o) : e && e[n] ? e[n] : u;
          };
          return e && e.a && t.o
            ? function (e) {
                var n = r(e, t.o, Dt);
                return Gt.recomposeSelf(
                  n,
                  o("r", e, F, 0) + n.a,
                  o("k", e, L),
                  o("s", e, L),
                  o("t", e, L)
                ).toString();
              }
            : function (t) {
                return Gt.recomposeSelf(
                  o("o", t, Ct, null),
                  o("r", t, F, 0),
                  o("k", t, L),
                  o("s", t, L),
                  o("t", t, L)
                ).toString();
              };
        },
        "#filter": function (t, e, n, r, i, o, u, a) {
          if (!e.items || !t || !t.length) return null;
          var s = (function (t, e) {
            var n = (t = t.map(function (t) {
              return t && re[t[0]]
                ? (e.getElementById(t[1]), re[t[0]](e.getElementById(t[1]), t[1], e))
                : null;
            })).length;
            return function (e) {
              for (var r = 0; r < n; r++) t[r] && t[r](e[r].value);
            };
          })(e.items, a);
          return s
            ? ((t = (function (t, e) {
                return t.map(function (t) {
                  return (t.e = e(t.e)), t;
                });
              })(t, r)),
              function (e) {
                s(n(e, t, ne));
              })
            : null;
        },
        "#line": Yt,
        points: { f: yt, i: z },
        d: zt,
        r: Ut,
        "#size": bt,
        "#radius": mt,
        _: function (t, e) {
          if (Array.isArray(t)) for (var n = 0; n < t.length; n++) this[t[n]] = e;
          else this[t] = e;
        },
      },
      ae = {
        currentTime: "offset",
        duration: "duration",
        hasEnded: function () {
          return this.reachedToEnd();
        },
        isAlternate: "alternate",
        isPlaying: "_running",
        isRollingBack: "_rollingBack",
        state: function (t, e) {
          return e.isPlaying
            ? e.isRollingBack
              ? "rollback"
              : "playing"
            : e.hasEnded
            ? "ended"
            : "paused";
        },
        totalTime: "maxFiniteDuration",
        iterations: "iterations",
        direction: "direction",
        fill: "fill",
        isReversed: function (t, e) {
          return -1 === e.direction;
        },
        isBackwards: function (t, e) {
          return -1 === e.fill;
        },
        isInfinite: function (t, e) {
          return 0 === e.iterations;
        },
        speed: "speed",
        fps: "fps",
      },
      se = {
        destruct: "destruct",
        pause: "pause",
        play: function (t, e) {
          return le(t, e.hasEnded ? "restart" : "play", e);
        },
        restart: "restart",
        reverse: function (t, e) {
          return le(t, "reverse", e, [!0]);
        },
        seek: "seek",
        seekBy: "seekBy",
        seekTo: "seekTo",
        stop: "stop",
        toggle: "toggle",
        togglePlay: "toggle",
        set: "set",
      };
    function le(t, e, n) {
      var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : [];
      return function () {
        var i,
          o = Array.prototype.slice.call(arguments);
        return o.unshift.apply(o, v(r)), (i = t[e]).call.apply(i, [t].concat(v(o))), n;
      };
    }
    var fe = function t(e) {
      r(this, t);
      var n = {},
        i = ["on", "off"],
        o = {
          get: function (t, e, r) {
            return ae[e]
              ? "function" == typeof ae[e]
                ? ae[e].call(t, t, r)
                : t[ae[e]]
              : se[e]
              ? "function" == typeof se[e]
                ? se[e].call(t, t, r)
                : le(t, se[e], r)
              : -1 !== i.indexOf(e)
              ? n[e]
              : "ready" === e
              ? function (t) {
                  return t && t.call(r, r), r;
                }
              : void 0;
          },
          set: function (t, e, r) {
            return -1 !== i.indexOf(e) && (n[e] = r);
          },
          ownKeys: function (t) {
            return Object.keys(ae);
          },
          has: function (t, e) {
            return void 0 !== ae[e];
          },
        };
      if ("function" == typeof Proxy) return new Proxy(e, o);
      var u = Object.keys(ae).concat(Object.keys(se)).concat(i),
        a = {};
      return (
        u.forEach(function (t) {
          var n = {
            enumerable: !1,
            configurable: !1,
            get: function () {
              return o.get(e, t, a);
            },
          };
          -1 !== i.indexOf(t) &&
            (n.set = function (n) {
              return o.set(e, t, n);
            }),
            Object.defineProperty(a, t, n);
        }),
        a
      );
    };
    function ce(t) {
      t || (t = this);
      var e = {};
      (this.on = function (t, n) {
        var r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
        return (
          "function" == typeof n &&
          (t.split(/[, ]+/g).forEach(function (t) {
            return (e[t] = e[t] || []), r ? e[t].unshift(n) : e[t].push(n);
          }),
          !0)
        );
      }),
        (this.off = function (t, n) {
          for (var r in e)
            if (e.hasOwnProperty(r) && r.substr(0, t.length) === t)
              if (n)
                for (var i = 0; i < e[r].length; i++) e[r][i] === n && (e[r][i] = null);
              else e[r] = null;
        }),
        (this.trigger = function () {
          var n,
            r = Array.prototype.slice.call(arguments),
            i = r[0],
            o = r.slice(1);
          t: for (var u in e)
            if (
              e.hasOwnProperty(u) &&
              e[u] &&
              (u === i || u.substr(0, i.length + 1) === i + ".")
            )
              for (var a = 0; a < (e[u] || []).length; a++)
                if (e[u][a] && !1 === (n = e[u][a].apply(t, o))) break t;
          return n;
        });
    }
    var he = !0,
      ve = ["iterations", "speed", "fps", "direction", "fill", "alternate"],
      ye = (function (t) {
        !(function (t, e) {
          if ("function" != typeof e && null !== e)
            throw new TypeError("Super expression must either be null or a function");
          (t.prototype = Object.create(e && e.prototype, {
            constructor: { value: t, writable: !0, configurable: !0 },
          })),
            e && s(t, e);
        })(u, t);
        var e,
          n,
          i =
            ((e = u),
            (n = l()),
            function () {
              var t,
                r = a(e);
              if (n) {
                var i = a(this).constructor;
                t = Reflect.construct(r, arguments, i);
              } else t = r.apply(this, arguments);
              return c(this, t);
            });
        function u(t, e) {
          var n,
            o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null;
          return r(this, u), ((n = i.call(this, t, e, o))._handlers = []), n;
        }
        return (
          o(
            u,
            [
              {
                key: "_adjustOffset",
                value: function () {
                  var t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
                    e = this.alternate ? 2 * this.duration : this.duration;
                  if (t) {
                    if (!this._rollingBack && 0 === this.offset)
                      return void (this.offset = e);
                    this._rollingBack && (this.offset, this.maxFiniteDuration);
                  }
                  !this._rollingBack || this.rollbackStartOffset <= this.duration
                    ? 0 !== this.iterations &&
                      (this.offset = Math.min(this.offset, this.maxFiniteDuration))
                    : ((this.offset =
                        this.rollbackStartOffset -
                        ((this.rollbackStartOffset - this.offset) % e)),
                      (this.rollbackStartOffset = 0));
                },
              },
              {
                key: "reverse",
                value: function () {
                  var t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                  if (!this._running)
                    return (
                      this._adjustOffset(t),
                      (this._rollingBack = !this._rollingBack),
                      t && this.play(!1),
                      void this.trigger("reverse", this.offset)
                    );
                  this.pause(!1, !1),
                    this._adjustOffset(),
                    (this._rollingBack = !this._rollingBack),
                    this.play(!1),
                    this.trigger("reverse", this.offset);
                },
              },
              {
                key: "play",
                value: function () {
                  var t =
                      arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : he,
                    e = h(a(u.prototype), "play", this).call(this);
                  return t === he && this.trigger("play", this.offset), e;
                },
              },
              {
                key: "pause",
                value: function () {
                  var t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
                    e =
                      arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : he,
                    n = h(a(u.prototype), "pause", this).call(this);
                  return e === he && this.trigger(t ? "end" : "pause", this.offset), n;
                },
              },
              {
                key: "restart",
                value: function () {
                  var t = h(a(u.prototype), "restart", this).call(this, !1);
                  return this.trigger("restart", this.offset), t;
                },
              },
              {
                key: "stop",
                value: function () {
                  var t =
                      arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : he,
                    e = h(a(u.prototype), "stop", this).call(this);
                  return t === he && this.trigger("stop", this.offset), e;
                },
              },
              {
                key: "_apply",
                value: function (t) {
                  var e = this,
                    n =
                      arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : he,
                    r = h(a(u.prototype), "_apply", this).call(this, t);
                  if (n === he) {
                    var i = function () {
                      return e.trigger("keyframe", t);
                    };
                    window.requestAnimationFrame(i);
                  }
                  return r;
                },
              },
              {
                key: "seekTo",
                value: function (t) {
                  var e,
                    n,
                    r,
                    i = this._running;
                  i && this.pause(!1, !1),
                    (this.offset =
                      this.iterations > 0
                        ? ((e = t),
                          (n = 0),
                          (r = this.maxFiniteDuration),
                          e < n ? n : e > r ? r : e)
                        : Math.max(t, 0)),
                    this._apply(this.offset),
                    i && this.play(!1);
                },
              },
              {
                key: "seek",
                value: function (t) {
                  return this.seekTo(Math.round((t / 100) * this.maxFiniteDuration));
                },
              },
              {
                key: "seekBy",
                value: function (t) {
                  return this.seekTo(this.offset + t);
                },
              },
              {
                key: "toggle",
                value: function () {
                  return this._running
                    ? this.pause()
                    : this.reachedToEnd()
                    ? this.restart()
                    : this.play();
                },
              },
              {
                key: "set",
                value: function (t, e) {
                  if (ve.includes(t)) {
                    var n = this._running;
                    n && this.pause(!1, !1),
                      (this._settings[t] = e),
                      n ? this.play(!1) : this._apply(this.offset, {}, !1);
                  }
                },
              },
              {
                key: "destruct",
                value: function () {
                  var t = this;
                  this.stop(),
                    this._handlers.forEach(function (t) {
                      t.element
                        ? t.element.removeEventListener(t.event, t.handler)
                        : t.callback && t.callback.call && t.callback.call();
                    });
                  var e = function () {},
                    n = Object.getOwnPropertyNames(Object.getPrototypeOf(this));
                  n.push.apply(n, v(Object.getOwnPropertyNames(this))),
                    n.forEach(function (n) {
                      "function" == typeof t[n] ? (t[n] = e) : delete t[n];
                    });
                },
              },
            ],
            [
              {
                key: "build",
                value: function (t) {
                  var e = h(a(u), "build", this).call(this, t, ue);
                  if (!e) return null;
                  var n = e.el,
                    r = e.options,
                    i = e.player,
                    o = new fe(i),
                    s = new ce(o);
                  (o.on = s.on), (o.off = s.off), (i.trigger = s.trigger);
                  var l =
                    n.svgatorPlayer &&
                    n.svgatorPlayer.ready &&
                    n.svgatorPlayer.ready.call &&
                    n.svgatorPlayer.ready.call();
                  (n.svgatorPlayer = o),
                    (function (t, e, n) {
                      if ("click" === n.start) {
                        var r = function () {
                          switch (n.click) {
                            case "freeze":
                              return !t._running && t.reachedToEnd()
                                ? t.restart()
                                : t.toggle();
                            case "restart":
                              return t.offset > 0 ? t.restart() : t.play();
                            case "reverse":
                              return t._running
                                ? t.reverse()
                                : t.reachedToEnd()
                                ? 1 === t.fill
                                  ? t.reverse(!0)
                                  : t.restart()
                                : t.play();
                            case "none":
                            default:
                              if (t._running) return;
                              return t.reachedToEnd() ? t.restart() : t.play();
                          }
                        };
                        return (
                          t._handlers.push({ element: e, event: "click", handler: r }),
                          void e.addEventListener("click", r)
                        );
                      }
                      if ("hover" === n.start) {
                        var i = function () {
                          return t.reachedToEnd()
                            ? t.restart()
                            : t._rollingBack
                            ? t.reverse()
                            : t.play();
                        };
                        t._handlers.push({ element: e, event: "mouseenter", handler: i }),
                          e.addEventListener("mouseenter", i);
                        var o = function () {
                          switch (n.hover) {
                            case "freeze":
                              return t.pause();
                            case "reset":
                              return t.stop();
                            case "reverse":
                              if ((t.reverse(), t._running)) return;
                              return t.play();
                            case "none":
                            default:
                              return;
                          }
                        };
                        return (
                          t._handlers.push({
                            element: e,
                            event: "mouseleave",
                            handler: o,
                          }),
                          void e.addEventListener("mouseleave", o)
                        );
                      }
                      if ("scroll" === n.start) {
                        var u = new ht(e, n.scroll || 25, function (e) {
                          e ? (t.reachedToEnd() ? t.restart() : t.play()) : t.pause();
                        });
                        return void t._handlers.push({
                          callback: function () {
                            return u.destruct();
                          },
                        });
                      }
                      if ("programmatic" === n.start) return;
                      t.play();
                    })(i, n, r),
                    (function (t, e, n) {
                      var r;
                      "function" == typeof Event
                        ? (r = new Event("ready"))
                        : (r = document.createEvent("Event")).initEvent("ready", !0, !0);
                      if ((t.dispatchEvent(r), !n || !n.length)) return;
                      n.forEach(function (t) {
                        return e.ready(t);
                      });
                    })(n, n.svgatorPlayer, l);
                },
              },
            ]
          ),
          u
        );
      })(ct);
    return ye.init(), ye;
  });
  (function (s, i, o, w, d, a, b) {
    (a =
      Array.from(d.querySelectorAll("svg#" + i.root)).filter(
        (n) => !n.svgatorPlayer
      )[0] || {}).svgatorPlayer = {
      ready: (function (a) {
        b = [];
        return function (c) {
          return c ? (b.push(c), a.svgatorPlayer) : b;
        };
      })(a),
    };
    w[o] = w[o] || {};
    w[o][s] = w[o][s] || [];
    w[o][s].push(i);
  })(
    "91c80d77",
    {
      root: "edEvCAwTnKp1",
      version: "2022-05-04",
      animations: [
        {
          elements: {
            edEvCAwTnKp3: {
              transform: {
                data: { t: { x: -4714.899414, y: -2899.244873 } },
                keys: {
                  o: [
                    { t: 0, v: { x: 2533.899414, y: -626.755127, type: "corner" } },
                    { t: 20000, v: { x: -1934.300586, y: 1918.574873, type: "corner" } },
                  ],
                },
              },
            },
            edEvCAwTnKp165: {
              opacity: [
                { t: 400, v: 0 },
                { t: 600, v: 1 },
                { t: 2500, v: 1 },
                { t: 2700, v: 0 },
              ],
            },
            edEvCAwTnKp1026: {
              opacity: [
                { t: 3200, v: 0 },
                { t: 3400, v: 1 },
                { t: 4700, v: 1 },
                { t: 4900, v: 0 },
              ],
            },
            edEvCAwTnKp1037: {
              opacity: [
                { t: 3200, v: 0 },
                { t: 3400, v: 1 },
                { t: 4700, v: 1 },
                { t: 4900, v: 0 },
              ],
            },
            edEvCAwTnKp1048: {
              opacity: [
                { t: 8600, v: 0 },
                { t: 8800, v: 1 },
                { t: 10300, v: 1 },
                { t: 10500, v: 0 },
              ],
            },
            edEvCAwTnKp1069: {
              opacity: [
                { t: 10600, v: 0 },
                { t: 10800, v: 1 },
                { t: 12300, v: 1 },
                { t: 12500, v: 0 },
              ],
            },
            edEvCAwTnKp1093: {
              opacity: [
                { t: 5600, v: 0 },
                { t: 5800, v: 1 },
                { t: 7400, v: 1 },
                { t: 7600, v: 0 },
              ],
            },
            edEvCAwTnKp1146: {
              opacity: [
                { t: 13000, v: 0 },
                { t: 13200, v: 1 },
                { t: 15000, v: 1 },
                { t: 15200, v: 0 },
              ],
            },
            edEvCAwTnKp1187: {
              opacity: [
                { t: 16100, v: 0 },
                { t: 16300, v: 1 },
                { t: 17700, v: 1 },
                { t: 18000, v: 0 },
              ],
            },
            edEvCAwTnKp1192: {
              opacity: [
                { t: 18200, v: 0 },
                { t: 18400, v: 1 },
                { t: 19800, v: 1 },
                { t: 20000, v: 0 },
              ],
            },
            edEvCAwTnKp1196: {
              opacity: [
                { t: 400, v: 0 },
                { t: 600, v: 1 },
                { t: 2500, v: 1 },
                { t: 2700, v: 0 },
                { t: 3200, v: 0 },
                { t: 3400, v: 1 },
                { t: 4700, v: 1 },
                { t: 4900, v: 0 },
                { t: 5600, v: 0 },
                { t: 5800, v: 1 },
                { t: 7400, v: 1 },
                { t: 7600, v: 0 },
                { t: 8600, v: 0 },
                { t: 8800, v: 1 },
                { t: 10300, v: 1 },
                { t: 10500, v: 0 },
                { t: 10600, v: 0 },
                { t: 10800, v: 1 },
                { t: 12300, v: 1 },
                { t: 12500, v: 0 },
                { t: 13000, v: 0 },
                { t: 13200, v: 1 },
                { t: 15000, v: 1 },
                { t: 15200, v: 0 },
                { t: 16100, v: 0 },
                { t: 16300, v: 1 },
                { t: 17700, v: 1 },
                { t: 18000, v: 0 },
                { t: 18200, v: 0 },
                { t: 18400, v: 1 },
                { t: 19810, v: 1 },
                { t: 20000, v: 0 },
              ],
            },
            edEvCAwTnKp1197: {
              opacity: [
                { t: 10600, v: 0 },
                { t: 10800, v: 1 },
                { t: 12300, v: 1 },
                { t: 12500, v: 0 },
              ],
            },
            edEvCAwTnKp1200: {
              opacity: [
                { t: 13000, v: 0 },
                { t: 13200, v: 1 },
                { t: 15000, v: 1 },
                { t: 15200, v: 0 },
              ],
            },
            edEvCAwTnKp1203: {
              opacity: [
                { t: 400, v: 0 },
                { t: 600, v: 1 },
                { t: 2500, v: 1 },
                { t: 2700, v: 0 },
              ],
            },
            edEvCAwTnKp1206: {
              opacity: [
                { t: 18200, v: 0 },
                { t: 18400, v: 1 },
                { t: 19800, v: 1 },
                { t: 20000, v: 0 },
              ],
            },
            edEvCAwTnKp1209: {
              opacity: [
                { t: 16100, v: 0 },
                { t: 16300, v: 1 },
                { t: 17700, v: 1 },
                { t: 18000, v: 0 },
              ],
            },
            edEvCAwTnKp1212: {
              opacity: [
                { t: 8600, v: 0 },
                { t: 8800, v: 1 },
                { t: 10300, v: 1 },
                { t: 10500, v: 0 },
              ],
            },
            edEvCAwTnKp1215: {
              opacity: [
                { t: 5600, v: 0 },
                { t: 5800, v: 0.99 },
                { t: 7400, v: 0.99 },
                { t: 7600, v: 0 },
              ],
            },
            edEvCAwTnKp1218: {
              opacity: [
                { t: 3200, v: 0 },
                { t: 3400, v: 1 },
                { t: 4700, v: 1 },
                { t: 4900, v: 0 },
              ],
            },
          },
          s:
            "MDYA2MWI2NWRZOLWZiMGFkOWNhTZmE0TGFhYTlBKNWQ3NTZkTjTZiNmI2YjZiNFjc1ZDlmRGE0SYWRhMDllYWZRFYTRhYWE5TFUU1ZDc1NmM2NJzVkYTRhZmEwSYWQ5Y2FmYTRXhYWE5YWU1ZDDc1NmI2N1Q1ZLGExYTRPYTdhSNzVkNzU2YzYE3NWQ5Y2E3YWBZhMGFkYTk5YY2FmYTA1ZDc1LYTE5Y2E3YWVJhMDY3NWRhZWEFiYTBhMDlmNKWQ3NTZiNjk2OZTcwNjc1ZGENxYWJhZTVkNzSU2YzZiNmJiOFA|",
        },
      ],
      options: "MDNAxMDgySzI5NA2E3YjY4Nzk3TYjI5NDEyOTcWzNzY2ODZiMjOk4NA|",
    },
    "__SVGATOR_PLAYER__",
    window,
    document
  );
});
</script>
